export default {
  "12313": "",
  "123123": "",
  "77777777": "",
  "language.name": "Deutsch",
  "system.dataScreen": "Datenbildschirm",
  "product.PleaseEnter": "Bitte geben Sie den Produktnamen ein",
  "product.PleaseEnterTheProductSerialNumber": "Bitte geben Sie die Produkt-Serienummer ein",
  "product.PleaseEnterSubmodelNumber": "Bitte geben Sie die Untermodellnummer ein",
  "product.PleaseenterTheSubmodelSerialNumber": "Bitte geben Sie die Seriennummer des Untermodells ein",
  "product.PleaseSelectTheDeviceType": "Bitte wählen Sie den Gerätetyp",
  "product.PleaseSelectDevelopmentType": "Bitte wählen Sie die Entwicklungsart",
  "product.management": "Produkt",
  "product.name": "Produktserie",
  "product.reset": "Zurücksetzen",
  "product.search": "Suche",
  "product.ApplicationList": "Anwendungsliste",
  "product.newProduct": "Neues Produkt",
  "product.editName": "Produkt bearbeiten",
  "product.DetailSetting": "Detaileinstellungen",
  "product.delete": "Löschen",
  "product.serialNumber": "Seriennummer",
  "product.deviceType": "Gerätetyp",
  "product.RandDtype": "Forschungs- und Entwicklungstyp",
  "product.subType": "Untertyp",
  "product.updateTime": "Aktualisierungszeit",
  "product.operation": "Operation",
  "product.shippingMarket": "Versandmarkt",
  "product.deviceList": "Geräteliste (Versandprotokoll)",
  "product.parameterManagement": "Parameterverwaltung",
  "product.updataManagement": "Aktualisierungsverwaltung",
  "product.ParentDevice": "Elterngerät",
  "product.AssociatedPowerStationState": "Zugehöriger Kraftwerkszustand",
  "product.ImportDeviceList": "Geräteliste importieren",
  "product.PlantDetails": "Details des Kraftwerks",
  "product.OwningPowerStation": "Zugehöriges Kraftwerk",
  "product.parameterName": "Parametername",
  "product.ParameterClass": "Parameterklasse",
  "product.ParameterSettingType": "Parametereinstellungstyp",
  "product.ParameterOperationType": "Parameterbedienungstyp",
  "product.ImportParameter": "Parameter importieren",
  "product.OwningUpperLevelParameterCategory": "Zugehörige obere Parameterkategorisierung",
  "product.WhetherYoSupportBatchRead": "Ob Batchlesung unterstützt wird",
  "product.value": "Wert",
  "product.scope": "Bereich",
  "product.unit": "Einheit",
  "product.explain": "Erklärung",
  "product.remark": "Anmerkung",
  "product.fileName": "Dateiname",
  "product.fileAddress": "Dateipfad",
  "product.versionNumber": "Versionsnummer",
  "product.ProductOfOwnership": "zugehöriges Produkt",
  "product.ProductDetailsSettings": "Balkon 1.0 - Produkt-Detaileinstellungen",
  "product.QueryResultList": "Abfrageergebnisliste",
  "product.AddFirmware": "Firmware hinzufügen",
  "product.NewParameter": "Neuer Parameter",
  "product.datalog": "Datensammler",
  "product.Inverter": "Wechselrichter",
  "product.storage": "Speicher",
  "product.battery": "Batterie",
  "product.socket": "Steckdose",
  "product.DownloadTemplate": "Vorlage herunterladen",
  "product.nation": "Land",
  "product.agent": "Agent",
  "product.expirationDate": "Qualitätsgarantiezeitraum",
  "product.UpdateTime": "Aktualisierungszeit",
  "product.LastWeek": "Letzte Woche",
  "product.LastMonth": "Letzten Monat",
  "product.LastThreeMonths": "In den letzten drei Monaten",
  "product.parameterType": "Parametertyp",
  "product.ProtocolAddress": "Adresse im Parameterprotokoll",
  "product.stepSize": "Schritt",
  "product.PleaseEnterAParameterName": "Bitte geben Sie den Parameternamen ein",
  "product.parameterCoding": "Parameterkodierung",
  "product.PleaseEnterTheParameterCode": "Bitte geben Sie den Parametercode ein",
  "product.ParameterDataType": "Parameter-Datentyp",
  "product.PleaseEnterTheAddressInTheParameterProtocol": "Bitte geben Sie die Adresse in das Parameterprotokoll ein",
  "product.blockEncoding": "Gruppenkodierung",
  "product.PleaseEnterABlockCode": "Bitte geben Sie den Gruppencode ein",
  "product.GroupName": "Gruppenname",
  "product.PleaseEnterAGroupName": "Bitte geben Sie den Gruppennamen ein",
  "product.PleaseEnterTheUnit": "Bitte geben Sie den Mindestwert ein",
  "product.decimalPoint": "Dezimalstelle",
  "product.PleaseEnterTheDecimalPoint": "Bitte geben Sie die Dezimalstelle ein",
  "product.leastValue": "Mindestwert",
  "product.maximumValue": "Höchstwert",
  "product.PleaseEnterTheMaximumValue": "Bitte geben Sie den Maximalwert ein",
  "product.PleaseEnterTheStepSize": "Bitte geben Sie die Schrittgröße ein",
  "product.addEquipment": "Neue Ausrüstung hinzufügen",
  "product.equipment": "Ausrüstung",
  "product.remove": "entfernen",
  "product.sort": "sortieren",
  "product.PleaseEnterTheOrder": "Bitte sortieren",
  "product.PleaseEnterTheParameterSettingType": "Bitte geben Sie den Typ der Parametereinstellung ein",
  "product.PleaseSelectAFolderPath": "Bitte Ordnerpfad auswählen",
  "product.ReturnToSuperior": "Zurück zum Vorgesetzten",
  "product.PleaseEnterTheVersionNumber": "Bitte geben Sie die Versionsnummer ein",
  "product.firmwareSpecification": "Firmware Beschreibung",
  "product.PleaseEnterFirmwareDescription": "Bitte geben Sie die Firmwarebeschreibung ein",
  "product.FileName": "Dateiname",
  "product.DeviceType": "Gerätetyp",
  "product.FileAddress": "Dateiadresse",
  "product.time": "Betriebszeit",
  "sidebar.default": "Navigationsseite",
  "sidebar.home": "Datenübersicht",
  "sidebar.endbenutzer": "Benutzer",
  "sidebar.plant": "Szenenmanagement",
  "sidebar.plant_plant": "Anlage",
  "sidebar.device": "Gerät",
  "sidebar.datalog": "Collector-Liste",
  "sidebar.inverter": "Wechselrichterliste",
  "sidebar.sotrage": "Liste der Energiespeicher",
  "sidebar.socket": "Liste der Steckdosen",
  "sidebar.battery": "Batterieliste",
  "sidebar.agent": "Agentenverwaltung",
  "sidebar.systematicSupply": "Sendungsprotokoll",
  "sidebar.firmware": "Firmware-Liste",
  "sidebar.firmware_up": "Firmware-Upload",
  "sidebar.firmware_log": "Upgrade-Datensatz",
  "sidebar.system": "Protokoll",
  "sidebar.system_datalog_log": "Sammelprotokoll",
  "sidebar.system_log": "Betriebsprotokoll",
  "sidebar.system_tongxun": "Kommunikationsprotokoll",
  "sidebar.system_app": "App Version",
  "sidebar.personal": "Benutzerinformationen",
  "sidebar.logout": "Konto beenden",
  "sidebar.organizationalManagement": "Organisation",
  "sidebar.auth_manage": "Berechtigung",
  "sidebar.workorder": "Arbeitsauftrag",
  "shipment.shippingManagement": "Lieferservice",
  "shipment.shippingManagementTemplage": "Importvorlage für Versandverwaltung",
  "login.email": "Postfach",
  "login.password": "Passwort",
  "login.remember": "E-Mail und Passwort merken",
  "login.rememberAccount": "Konto und Passwort merken",
  "login.enteremail": "Bitte geben Sie Ihre E-Mail-Adresse ein",
  "login.enterpassword": "Bitte geben Sie ein Passwort ein",
  "login.enterAccount": "Bitte geben Sie E-Mail oder Telefonnummer ein",
  "login.correctAccount": "Bitte geben Sie eine gültige E-Mail oder Telefonnummer ein",
  "login.accountPlaceholder": "Bitte geben Sie E-Mail oder Telefonnummer ein",
  "login.accountNumber": "Kontonummer",
  "login.system": "Haier Smart Energy Management System",
  "login.read": "Lesen und zustimmen",
  "login.userAgreement": "Nutzungsvereinbarung",
  "login.privacyPolicy": "Datenschutzerklärung",
  "login.temporarilyDisagree": "Vorläufig nicht zustimmen",
  "login.agreeAndAccept": "Zustimmen und akzeptieren",
  "login.retrievePassword": "Passwort abrufen",
  "login.verCode": "Prüfcode",
  "login.newPassword": "Neues Passwort",
  "login.sendverCode": "Bestätigungscode senden",
  "login.greenLife": "Innovative, saubere energie hilft, ein grüneres leben zu schaffen",
  "login.welcome": "Willkommen zum hai-energiewolke",
  "login.downloadApp": "App herunterladen",
  "login.sure": "Bestätigen",
  "home.echarts1.title": "Registrierter Benutzer",
  "home.echarts1.subhead": "Gesamtzahl der heute hinzugefügten neuen Benutzer",
  "home.echarts2.title": "Benutzer anmelden",
  "home.echarts2.subhead": "Die heutige Anmeldung/Gesamtzahl der Benutzer",
  "home.echarts3.title": "Agent hinzufügen",
  "home.echarts3.subhead": "Die heutige Anmeldung/Gesamtzahl der Agenten",
  "home.echarts4.title": "Szene hinzufügen",
  "home.echarts4.subhead": "Neue Szenen/Gesamtzahl der hinzugefügten Szenen",
  "home.echarts4.title_plant": "Kraftwerk hinzufügen",
  "home.echarts4.subhead_plant": "Neu hinzugefügte Kraftwerke/Gesamtzahl der Kraftwerke",
  "home.echarts5.title": "Sammler hinzufügen",
  "home.echarts5.subhead": "Neue Kollektoren/Gesamtzahl der hinzugefügten Kollektoren",
  "home.echarts6.title": "Gerät hinzufügen",
  "home.echarts6.subhead": "Neu hinzugefügte Geräte/Gesamtzahl der Geräte",
  "End_user.input_email": "Bitte geben Sie die E-Mail-Adresse des Benutzers ein",
  "End_user.btn_search": "Suche",
  "End_user.btn_add": "hinzufügen zu",
  "End_user.btn_delete": "löschen",
  "End_user.btn_binding": "Bindung",
  "End_user.add_station": "Szene hinzufügen",
  "End_user.lable_StationName": "Name der Szene",
  "End_user.lable_StationType": "Szenentyp",
  "End_user.lable_PVCapacity": "Solarzellenkapazität",
  "End_user.lable_InstalltionDate": "Installationsdatum",
  "End_user.lable_Country": "Land",
  "End_user.lable_City": "Stadt",
  "End_user.lable_Address": "Adresse",
  "End_user.lable_TimeZone": "Zeitzone",
  "End_user.lable_Energyprice": "Preis pro Energieeinheit",
  "End_user.lable_IncomeUnit": "Einkommenseinheit",
  "End_user.input_StationName": "Bitte geben Sie den Szenennamen ein",
  "End_user.input_StationType": "Bitte wählen Sie Typ",
  "End_user.input_PVCapacity": "Bitte geben Sie die Batteriekapazität ein",
  "End_user.input_InstalltionDate": "Bitte wählen Sie das Installationsdatum aus",
  "End_user.input_Country": "Bitte wählen Sie ein Land",
  "End_user.input_City": "Bitte wählen Sie eine Stadt",
  "End_user.input_Address": "Bitte geben Sie die Adresse ein",
  "End_user.input_TimeZone": "Bitte wählen Sie eine Zeitzone",
  "End_user.input_Energyprice": "Bitte geben Sie den Einzelpreis ein",
  "End_user.input_IncomeUnit": "Einkommenseinheit auswählen",
  "End_user.max_20": "Die maximale Anzahl von Zeichen darf 20 nicht überschreiten",
  "End_user.max_5": "Die maximale Anzahl von Zeichen darf 5 nicht überschreiten",
  "End_user.max_8": "Die maximale Anzahl an Zeichen darf 8 nicht überschreiten",
  "End_user.format": "Bitte geben Sie das richtige Format ein",
  "End_user.close": "schließen",
  "End_user.submit": "Absenden",
  "End_user.title_delete": "Löschen?",
  "End_user.no": "nein",
  "End_user.yes": "Ja",
  "End_user.Bingding_Agent": "Bindemittel",
  "End_user.Agent_Code": "Agent:",
  "End_user.please_select": "Bitte wählen",
  "plant.input_email": "Bitte geben Sie die E-Mail-Adresse des Benutzers ein",
  "plant.search": "Suche",
  "plant.edit": "bearbeiten",
  "plant.delete": "löschen",
  "plant.edit_plant": "Szene bearbeiten",
  "plant.input_station": "Bitte geben Sie den Szenennamen ein",
  "plant.lable_StationName": "Name der Szene",
  "plant.lable_StationType": "Szenentyp",
  "plant.lable_PVCapacity": "Solarzellenkapazität",
  "plant.lable_InstalltionDate": "Installationsdatum",
  "plant.lable_Country": "Land",
  "plant.lable_City": "Stadt",
  "plant.lable_Address": "Adresse",
  "plant.lable_TimeZone": "Zeitzone",
  "plant.lable_Energyprice": "Preis pro Energieeinheit",
  "plant.lable_IncomeUnit": "Einkommenseinheit",
  "plant.input_StationName": "Bitte geben Sie den Szenennamen ein",
  "plant.input_StationType": "Bitte wählen Sie Typ",
  "plant.input_PVCapacity": "Bitte geben Sie die Batteriekapazität ein",
  "plant.input_InstalltionDate": "Bitte wählen Sie das Installationsdatum aus",
  "plant.input_Country": "Bitte wählen Sie ein Land",
  "plant.input_City": "Bitte wählen Sie eine Stadt",
  "plant.input_Address": "Bitte geben Sie die Adresse ein",
  "plant.input_TimeZone": "Bitte wählen Sie eine Zeitzone",
  "plant.input_Energyprice": "Bitte geben Sie den Einzelpreis ein",
  "plant.input_IncomeUnit": "Einkommenseinheit auswählen",
  "plant.max_20": "Die maximale Anzahl von Zeichen darf 20 nicht überschreiten",
  "plant.max_5": "Die maximale Anzahl von Zeichen darf 5 nicht überschreiten",
  "plant.max_8": "Die maximale Anzahl an Zeichen darf 8 nicht überschreiten",
  "plant.format": "Bitte geben Sie das richtige Format ein",
  "plant.close": "schließen",
  "plant.submit": "Absenden",
  "plant.title_delete": "Löschen?",
  "plant.no": "nein",
  "plant.yes": "Ja",
  "plant.powerGeneration": "Stromerzeugung",
  "plant.powerConsumption": "Stromverbrauch",
  "plant.spontaneousSelfUse": "Eigenstromverbrauch",
  "plant.selfSufficient": "Selbstversorgung",
  "plant.photovoltaicPowerGeneration": "Photovoltaik-Leistung",
  "plant.electricPowerConsumption": "Stromverbrauchsleistung",
  "plant.spontaneousSelfUsePower": "Eigenstromleistung",
  "plant.buyPowers": "Stromkaufleistung",
  "plant.sellPowers": "Stromverkaufleistung",
  "plant.selfSufficientPower": "Selbstversorgungsleistung",
  "plant.batterySOC": "SOC der Speicherbatterie",
  "plant.storageChargingPower": "Ladeleistung der Speicherbatterie",
  "plant.storageDischargePower": "Entladeleistung der Speicherbatterie",
  "plant.co2emissionReduction": "CO2-Einsparung",
  "plant.plantPowerGeneration": "Kumulierte Stromerzeugung der Anlage",
  "plant.equivalentTreePlanting": "Äquivalente Anzahl gepflanzter Bäume",
  "plant.saveStandardCoal": "Einsparung an Standardkohle",
  "plant.today": "Heute",
  "plant.month": "Diesen Monat",
  "plant.year": "Aktuelles Jahr",
  "plant.total": "Kumulativ",
  "datalog.email": "Bitte geben Sie Ihre E-Mail-Adresse ein",
  "datalog.datalogSn": "Bitte geben Sie die Seriennummer des Kollektors ein",
  "datalog.search": "Suche",
  "datalog.Version": "Versionsnummer",
  "datalog.setting": "einrichten",
  "datalog.upgrade": "Upgrade",
  "datalog.delete": "löschen",
  "datalog.title_datalog": "Collector-Einstellungen",
  "datalog.span_info": "Informationen",
  "datalog.span_datalog": "Seriennummer des Sammlers:",
  "datalog.span_name": "Alias:",
  "datalog.span_time": "Aktualisierungszeit:",
  "datalog.span_firmware": "Signal/Firmware Version:",
  "datalog.span_order": "Befehl",
  "datalog.span_settingdns": "Domänenname festlegen",
  "datalog.span_inputsetting": "Bitte geben Sie den Domainnamen ein",
  "datalog.span_upgrade": "Upgrade Collector",
  "datalog.span_reset": "Starten Sie den Collector neu",
  "datalog.span_setup": "erweiterte Einstellung",
  "datalog.span_param": "Parameter",
  "datalog.span_value": "Wert",
  "datalog.btn_setup": "erweiterte Einstellung",
  "datalog.btn_setting": "einrichten",
  "datalog.btn_settingdns": "Domänenname festlegen",
  "datalog.btn_upgrade": "Upgrade",
  "datalog.btn_reset": "Neustart",
  "datalog.btn_read": "lesen",
  "datalog.btn_close": "Abbrechen",
  "datalog.methods_version": "Versionsupdates erkennen?",
  "datalog.no": "nein",
  "datalog.yes": "Ja",
  "datalog.methods_delete": "Löschen?",
  "datalog.methods_rereset": "Neustart?",
  "datalog.methodes_inputDns": "Bitte geben Sie den Domainnamen ein",
  "datalog.methodes_DNS": "Möchten Sie diesen Domainnamen festlegen?",
  "sotrage.select": "Bitte wählen",
  "sotrage.email": "Bitte geben Sie Ihre E-Mail-Adresse ein",
  "sotrage.datalogSn": "Bitte geben Sie die Seriennummer des Kollektors ein",
  "sotrage.deviceSn": "Bitte geben Sie die Seriennummer des Gerätes ein",
  "sotrage.search": "Suche",
  "sotrage.sotrage": "Einstellungen der Energiespeicherung",
  "device.select": "Bitte wählen",
  "device.email": "Bitte geben Sie Ihre E-Mail-Adresse ein",
  "device.datalogSn": "Bitte geben Sie die Seriennummer des Kollektors ein",
  "device.deviceSn": "Bitte geben Sie die Seriennummer des Gerätes ein",
  "device.search": "Suche",
  "device.title": "Wechselrichtereinstellungen",
  "device.setting": "einrichten",
  "device.setting_inverte": "Wechselrichterparameter einstellen",
  "device.input_start_address": "Adresse des Startregisters",
  "device.input_ent_address": "Registeradresse beenden",
  "device.input_setting_value": "Bitte geben Sie den Einstellwert ein",
  "device.read_data": "Registerdaten lesen:",
  "device.input_start_read": "Adresse des Startregisters",
  "device.input_end_read": "Registeradresse beenden",
  "device.btn_address": "Adresse festlegen",
  "device.btn_value": "Parameter festlegen",
  "device.btn_read": "lesen",
  "device.btn_close": "zurück",
  "device.selet_data": "Datum auswählen",
  "device.workMode": "Arbeitsmodus",
  "device.alarmInfo": "Alarminformationen",
  "device.countryStandard": "Nationale Standards",
  "device.runningStatus": "Betriebszustand",
  "device.inverterTemp": "Wechselrichtertemperatur(℃)",
  "device.dcdcTemp": "Batterietemperatur (℃)",
  "device.mpptTemp": "MPPT-Temperatur(℃)",
  "device.drmStatus": "DRM-Status",
  "device.version": "Version",
  "device.communicationEquipment": "Kommunikationsgerät",
  "device.basicInfo": "Grundlegende Informationen",
  "device.productName": "Produktname",
  "device.productType": "Produkttyp",
  "device.productModel": "Produktmodell",
  "device.softVersion": "Softwareversion",
  "device.softUpdateTime": "Zeitpunkt der Softwareaktualisierung",
  "device.plant": "Kraftwerk",
  "device.installer": "Installateur",
  "device.installPerson": "Monteur",
  "device.deviceRegisterDate": "Registrierungsdatum des Geräts",
  "device.ownerEmail": "Besitzer E-Mail",
  "device.ownerReceiveTime": "Besitzer Empfangszeit",
  "device.ownerFamily": "Besitzerfamilie",
  "device.versionInfo": "Versionsinformationen",
  "device.searchSn": "Bitte geben Sie die SN ein, um zu suchen",
  "device.user": "Benutzer",
  "device.userReceiveDate": "Empfangsdatum des Benutzers",
  "device.yuan": "Quelle: Photovoltaik",
  "device.totalPower": "Gesamtleistung",
  "device.todayPowerGeneration": "Heutige Stromerzeugung",
  "device.dataGateway": "Datengateway",
  "device.optimizer": "Optimierer",
  "device.chu": "Speicher: Speicherbatterie",
  "device.power": "Leistung",
  "device.todayChargingCapacity": "Lademenge heute",
  "device.todayDischargingCapacity": "Entlademenge heute",
  "device.he": "Last: Stromverbrauchslast",
  "device.todayElectricityConsumption": "Stromverbrauch heute",
  "device.totalElectricityConsumption": "Kumulativer Stromverbrauch",
  "device.wang": "Netz: Netzseite",
  "device.totalFrequency": "Gesamtfrequenz",
  "device.buyPowers": "Stromkauf",
  "device.sellPowers": "Stromverkauf",
  "device.more": "Mehr",
  "device.readWrite": "Direktes Lese-/Schreibwerkzeug",
  "device.chargeAndDisChargeSetting": "Lade-/Entladeeinstellungen",
  "device.mutipleSave": "Massensendung",
  "device.mutipleRead": "Massenlesen",
  "device.deviceSnisExist": "Bitte bestätigen Sie, ob die Geräte-SN vorhanden ist",
  "device.saveSuccess": "Der Parameterbefehl wurde gesendet. Bitte aktualisieren Sie die Seite oder klicken Sie auf die Schaltfläche [Lesen], um zu bestätigen, ob die Parameter wirksam sind.",
  "device.saveFail": "Parameter senden fehlgeschlagen",
  "device.getParamsSuccess": "Parameter erfolgreich abgerufen",
  "device.getParamsFail": "Parameter abrufen fehlgeschlagen",
  "device.operationalDataAnalysis": "Betriebsdatenanalyse",
  "device.pleaseSelect": "Bitte wählen Sie den linken Datenpunkt",
  "device.maxFour": "Die Einheit kann nicht mehr als 4 sein",
  "device.maxFourOrTwenty": "Maximal 4 Typen oder 20 Optionen erlaubt",
  "device.protocolDirectives": "Protokollbefehl",
  "device.dateRangeError": "Der Datumsbereich sollte innerhalb von 3 Tagen liegen",
  "device.noDeviceDetail": "Keine Gerätedetails verfügbar",
  "device.address": "Registeradresse",
  "device.faultClearing": "Fehlerbehebung",
  "device.chargeSetting": "Ladeeinstellung",
  "device.dischargeSetting": "Entladeeinstellung",
  "battery.select": "Bitte wählen",
  "battery.email": "Bitte geben Sie Ihre E-Mail-Adresse ein",
  "battery.datalogSn": "Bitte geben Sie die Seriennummer des Kollektors ein",
  "battery.deviceSn": "Bitte geben Sie die Seriennummer des Gerätes ein",
  "battery.search": "Suche",
  "socket.title": "Socket einrichten",
  "socket.setting": "einrichten",
  "socket.span": "Es wurden mehrere Registeradressen festgelegt, und es müssen auch mehrere Werte festgelegt werden. Festlegen von Werten, durch die z.B. getrennt werden soll (1, 2, 3)",
  "socket.setting_device": "Wechselrichterparameter einstellen:",
  "socket.startaddress": "Adresse des Startregisters",
  "socket.stopaddress": "Registeradresse beenden",
  "socket.value": "Bitte geben Sie den Einstellwert ein",
  "socket.readdata": "Registerdaten lesen:",
  "socket.setting_address": "Adresse festlegen",
  "socket.setting_value": "Parameter festlegen",
  "socket.read": "lesen",
  "socket.return": "zurück",
  "agent.close": "Abbrechen",
  "agent.submit": "Absenden",
  "agent.input_email": "Bitte geben Sie Ihre E-Mail-Adresse ein",
  "agent.search": "Suche",
  "agent.add_agent": "Agent hinzufügen",
  "agent.import_device": "Geräte importieren",
  "agent.edit": "bearbeiten",
  "agent.title": "Agent hinzufügen",
  "agent.email": "Postfach",
  "agent.password": "Passwort",
  "agent.phone": "Telefonnummer",
  "agent.company": "Firma",
  "agent.language": "Sprache",
  "agent.address": "Adresse",
  "agent.input_password": "Bitte geben Sie ein Passwort ein",
  "agent.input_phone": "Bitte geben Sie Ihre Telefonnummer ein",
  "agent.input_company": "Bitte wählen Sie ein Unternehmen",
  "agent.input_language": "Bitte Sprache eingeben",
  "agent.input_address": "Bitte geben Sie die Adresse ein",
  "agent.relus_email": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  "agent.title_edit": "Bearbeitungsagent",
  "agent.title_device": "Upload",
  "agent.span": "Beispiel: Exklusives Formular",
  "agent.btn_upload": "Upload",
  "agent.delete": "löschen",
  "agent.agent_delete": "Löschmittel?",
  "ship.starttime": "Startzeit",
  "ship.endtime": "Endzeit",
  "ship.deviceSn": "Bitte geben Sie die Seriennummer des Gerätes ein",
  "ship.select": "Bitte wählen Sie ein Unternehmen",
  "ship.search": "Suche",
  "Firmware.file_name": "Bitte geben Sie den Dateinamen ein",
  "Firmware.search": "Suche",
  "Firmware.add": "hinzufügen zu",
  "Firmware.delete": "löschen",
  "Firmware.title": "Firmware-Upload",
  "Firmware.select_folder": "Ordner auswählen:",
  "Firmware.select_folder_type": "Bitte wählen Sie Ordnertyp",
  "Firmware.craete_folder": "Einen neuen Ordner erstellen",
  "Firmware.folder_path": "Ordnerpfad:",
  "Firmware.folder_name": "Dateiname:",
  "Firmware.input_folder_name": "Dateiname eingeben",
  "Firmware.create": "Ordner erstellen",
  "Firmware.listed_files": "Dateiliste:",
  "Firmware.import_folder": "Datei importieren",
  "Firmware.uplad_folder": "Dateien hochladen",
  "Firmware.close": "zurück",
  "Upgrade.starttime": "Startzeit",
  "Upgrade.endtime": "Endzeit",
  "Upgrade.deviceSn": "Bitte geben Sie die Seriennummer des Gerätes ein",
  "Upgrade.type": "Bitte wähle einen Typ aus",
  "Upgrade.search": "Suche",
  "Upgrade.datalog": "Sammler",
  "Upgrade.Inverter": "Wechselrichter",
  "Upgrade.Control": "Controller",
  "datalogs_logs.starttime": "Startzeit",
  "datalogs_logs.endtime": "Endzeit",
  "datalogs_logs.deviceSn": "Bitte geben Sie die Seriennummer des Gerätes ein",
  "datalogs_logs.Version": "Bitte geben Sie die Version ein",
  "datalogs_logs.search": "Suche",
  "Logs.starttime": "Startzeit",
  "Logs.endtime": "Endzeit",
  "Logs.deviceSn": "Bitte geben Sie die Seriennummer des Gerätes ein",
  "Logs.type": "Bitte wählen Sie Typ",
  "Logs.search": "Suche",
  "Special.starttime": "Startzeit",
  "Special.endtime": "Endzeit",
  "Special.deviceSn": "Bitte geben Sie die Seriennummer des Gerätes ein",
  "Special.datalogSn": "Bitte geben Sie die Seriennummer des Kollektors ein",
  "Special.type": "Bitte wählen Sie Typ",
  "Special.search": "Suche",
  "Special.save": "Konservierung",
  "Special.Examples": "Beispiel: (2305210230,2305210139)",
  "App.System_Config": "Systemkonfiguration",
  "App.APP_Version": "Version der App",
  "App.Android_Version": "Android Version:",
  "App.IOS_Version": "IOS Version:",
  "App.APP_Type": "App-Typ:",
  "App.New_Version": "Neue Version",
  "App.update_content": "Update Beschreibung: (geteilt durch \"/n\")",
  "App.Whether_update": "Ist es Pflicht zu aktualisieren",
  "App.no": "nein",
  "App.yes": "Ja",
  "App.submit": "Absenden",
  "Tips.app_submit": "Sind Sie sicher, die Informationen zu ändern?",
  "Tips.firmware_delete": "Sind Sie sicher, dass Sie löschen?",
  "Tips.firmware_deleteCDN": "Dateien aus CDN löschen?",
  "Tips.yes": "Ja",
  "Tips.no": "nein",
  "global.DataDetails": "Daten Details",
  "global.device": "Wechselrichtereinstellungen",
  "global.device_data": "Wechselrichterparameter einstellen:",
  "global.storage": "Einstellungen der Energiespeicherung",
  "global.storage_data": "Parameter der Energiespeicherung festlegen",
  "global.battery": "Batterieeinstellungen",
  "global.battery_data": "Batterieparameter einstellen",
  "global.socket": "Socket einrichten",
  "global.socket_data": "Socket-Parameter festlegen",
  "btn.setting_address": "Adresse festlegen",
  "btn.close": "zurück",
  "btn.submit": "Absenden",
  "btn.Setting_parameters": "Parameter festlegen",
  "btn.Reading": "lesen",
  "btn.search": "Suche",
  "btn.add": "hinzufügen zu",
  "btn.import": "Importieren",
  "btn.download": "Download Beispiel",
  "btn.edit": "bearbeiten",
  "btn.login": "Anmelden",
  "btn.export": "Export",
  "form.addShip": "Versandausrüstung hinzufügen",
  "form.editShip": "Versandausrüstung bearbeiten",
  "form.import": "Geräteinformationen importieren",
  "form.shipSN": "Seriennummer der Sendung",
  "form.agent": "Agent",
  "form.networkCall": "Gibt an, ob ein Callback des Verteilungsnetzwerks ausgeführt werden soll",
  "form.warrantyPeriod": "Garantiezeit",
  "form.shiptime": "Lieferzeit",
  "form.shiptype": "Art der Verbringung",
  "form.classify": "Klassifizierung",
  "form.file": "Ziehen Sie die Datei hierher oder klicken Sie auf Hochladen",
  "form.edit_plant": "Szene bearbeiten",
  "form.input_station": "Bitte geben Sie den Szenennamen ein",
  "form.lable_StationName": "Name der Szene",
  "form.lable_StationType": "Szenentyp",
  "form.input_StationName": "Bitte geben Sie den Szenennamen ein",
  "form.edit_plant_plant": "Kraftwerk bearbeiten",
  "form.input_station_plant": "Bitte geben Sie den Namen des Kraftwerks ein",
  "form.lable_StationName_plant": "Name des Kraftwerks",
  "form.lable_StationType_plant": "Art des Kraftwerks",
  "form.input_StationName_plant": "Bitte geben Sie den Namen des Kraftwerks ein",
  "placeholder.select": "Bitte wählen",
  "placeholder.choiceCountry": "Bitte wählen Sie ein Land",
  "placeholder.choiceTimezone": "Bitte wählen Sie eine Zeitzone",
  "placeholder.enterEmail": "Bitte geben Sie Ihre E-Mail-Adresse ein",
  "placeholder.enterPhone": "Bitte geben Sie Ihre Telefonnummer ein",
  "placeholder.verificationCode": "Bitte geben Sie den Bestätigungscode ein",
  "placeholder.enterPassword": "Bitte geben Sie ein 6-20 stelliges Passwort ein",
  "placeholder.confirmPassword": "Bitte Passwort bestätigen",
  "placeholder.readAndAgree": "Ich habe gelesen und stimme zu",
  "placeholder.search": "Suche",
  "placeholder.searchPlantName": "Suche nach dem Namen des Kraftwerks",
  "placeholder.searchDeviceName": "Nach Gerätenamen suchen",
  "placeholder.searchDataloggerName": "Nach Collector-Namen suchen",
  "placeholder.enterPlantName": "Bitte geben Sie den Namen des Kraftwerks ein",
  "placeholder.enterPlantType": "Bitte geben Sie den Typ des Kraftwerks ein",
  "placeholder.enterPVCapacity": "Bitte PV-Kapazität eingeben",
  "placeholder.choiceInstallationDate": "Bitte wählen Sie das Installationsdatum aus",
  "placeholder.enterPlantAddress": "Bitte geben Sie die Adresse des Kraftwerks ein",
  "placeholder.enterOldPassword": "Bitte geben Sie altes Passwort ein",
  "placeholder.enterNewPassword": "Bitte geben Sie ein neues Passwort ein",
  "placeholder.enterConfirmPassword": "Bitte bestätigen Sie das neue Passwort",
  "placeholder.enter": "Geben Sie {scope}ein",
  "placeholder.country": "Land",
  "placeholder.city": "Stadt",
  "placeholder.scanCodeAddPlant": "Bitte scannen Sie den Code, um ein Kraftwerk hinzuzufügen!",
  "placeholder.currentNoPlant": "Es gibt derzeit keine Kraftwerke, bitte klicken Sie zum Hinzufügen!",
  "placeholder.selectRepeatTime": "Bitte wählen Sie eine Wiederholungszeit",
  "placeholder.enterDatalogger": "Bitte geben Sie die Seriennummer des Kollektors ein",
  "placeholder.enterDeviceSN": "Bitte geben Sie die Seriennummer des Gerätes ein",
  "setting.general.needGreat": "Muss größer sein als",
  "setting.general.needSmall": "Muss weniger sein als",
  "setting.general.gapScope": "Das Intervall zwischen den Eingabeparametern ist",
  "setting.general.valScope": "Der Bereich der Eingangsparameter ist",
  "setting.socket.switchStatus": "Steckdosenschalter",
  "setting.socket.repetition": "Wiederholungszeit",
  "setting.socket.enableOrNot": "Ist es aktiviert?",
  "setting.socket.monday": "Montag",
  "setting.socket.tuesday": "Dienstag",
  "setting.socket.wednesday": "Mittwoch",
  "setting.socket.thursday": "Donnerstag",
  "setting.socket.friday": "Freitag",
  "setting.socket.saturday": "Samstag",
  "setting.socket.sunday": "Sonntag",
  "setting.type3.dischargeScheduleMode": "Zeitgesteuerter Entladungsmodus",
  "setting.type3.timeDischarge": "Zeitliche Entladung",
  "setting.type3.workingDay": "Wochentag",
  "setting.type3.weekend": "Wochenende",
  "setting.type3.pureLightControlMode": "Modus für reines Licht",
  "setting.type3.stopDischarge": "SOC Low-End Stop Entladung Einstellwert",
  "setting.type3.chargeTransferDischarge": "SOC volle Ladung zur Entladung des Sollwertes",
  "setting.type3.batterySOCSetting": "SOC-Einstellung der Batterie",
  "setting.type3.lowBatteryAlam": "Low End Alarm Einstellwert für Batterie SOC",
  "setting.type3.lowBatteryShutdown": "Einstellwert für Low End Stop Entladung für Batterie SOC",
  "setting.type3.systemSetting": "Systemeinstellungen",
  "setting.type3.systemWorkMode": "Systemarbeitsmodus",
  "setting.type3.restoreFactory": "Werkseinstellungen wiederherstellen",
  "setting.type3.loadMode": "Lademodus",
  "setting.type3.timingDischarge": "Zeitgesteuerter Entladungsmodus",
  "setting.type3.DCOutputNormallyClosed": "Gleichstromausgang normal closed mode",
  "setting.type3.DCOutputNormallyOpen": "Gleichstromausgang normal open mode",
  "setting.type3.ForcedPowerProtection": "Obligatorischer Stromschutzmodus",
  "setting.type3.mode": "Muster",
  "setting.type3.startTime": "Startzeit",
  "setting.type3.stopTime": "Endzeit",
  "setting.type3.onlyAddThree": "Bis zu 21-Timer hinzufügen",
  "setting.type3.startCompareEnd": "Die Startzeit des Timers kann nur kleiner sein als die Endzeit",
  "setting.type3.confirmClose": "Bist du sicher, dass du das beenden willst?",
  "setting.type6.countryCode": "Ländercode",
  "setting.type6.poweradjppm": "Regelleistung des Wechselrichters",
  "setting.type6.enaINVTR": "Ein-/Ausschalten aus der Ferne",
  "setting.type6.enaSysProtIF_selfCheck": "Selbsttest der Systemschutzschnittstelle",
  "setting.type6.enaRestoretodefault": "Standardwerte wiederherstellen",
  "setting.type6.UV_resopnseTime": "{num} Ansprechzeit der Unterspannung",
  "setting.type6.UF_resopnseTime": "{num} Niveau-Unterfrequenz-Ansprechzeit",
  "setting.type6.OV_resopnseTime": "{num} Ansprechzeit der Überspannung",
  "setting.type6.OF_resopnseTime": "{num} Ansprechzeit der Übertaktung",
  "setting.type6.open": "offen",
  "setting.type6.recover": "Rückgewinnung",
  "setting.type6.noHave": "nichts",
  "setting.type6.activePowerSwitch": "Aktiver Netzschalter",
  "setting.type6.activePowerPermillage": "Prozentsatz der aktiven Leistung pro Tausend",
  "setting.type7.paramterSetting": "Parametereinstellungen",
  "setting.type7.batteryVoltage": "Batteriespannung",
  "setting.type7.batteryCapacity": "Batteriekapazität",
  "setting.type7.PVChargingCurrent": "Photovoltaik-Ladestrom",
  "setting.type7.overVoltage": "Überspannung",
  "setting.type7.chargingLimitVoltage": "Ladegrenzspannung",
  "setting.type7.increaseChargeReturnVoltage": "Erhöhen Sie die Laderücklaufspannung",
  "setting.type7.overDischargeVoltage": "Überladungsspannung",
  "setting.type7.stopchangeCurrent": "Ladestrom stoppen",
  "setting.type7.inverter485Address": "485 Adresse",
  "setting.type7.passwordValue": "Benutzerkennwort",
  "setting.type7.inputPassword": "Passworteingabe",
  "setting.type7.recordFaultCodes": "Fehlercodes aufzeichnen",
  "setting.type7.isOpen": "Ein-/Ausschaltregelung",
  "setting.type7.equalizingChargeCmd": "Sofort aufladen und ausbalancieren",
  "setting.type7.reset": "Steuerung zurücksetzen",
  "setting.type7.factory": "Werkseinstellungen wiederherstellen",
  "setting.type7.clearAlarm": "Den aktuellen Alarm löschen",
  "setting.type7.clearHistory": "Verlauf löschen",
  "setting.type7.generatorSwitchCmd": "Generatorumschaltung",
  "setting.type7.nowTimeStr": "aktuelle Zeit",
  "setting.type7.setVal.reset": "Zurücksetzen",
  "setting.type7.setVal.recover": "Rückgewinnung",
  "setting.type7.setVal.clearAlarm": "Warnung löschen",
  "setting.type7.setVal.clearHistory": "Verlauf löschen",
  "setting.type7.setVal.toggle": "Schalter",
  "setting.type8.systemSwitch": "Systemschalter",
  "setting.type10.modeSelect": "Muster",
  "setting.type10.standbyMode": "Sicherungsmodus",
  "setting.type10.PureOffGrid": "Reiner Startmodus außerhalb des Rasters",
  "setting.type10.energyNet": "Ausgabeeinstellungen für das Netz",
  "setting.type10.inverter0": "Wechselrichter zur Ergänzung der Energie zur lokalen Last",
  "setting.type10.inverter1": "Wechselrichter zur Stromerzeugung für das Stromnetz",
  "setting.type10.inverter2": "Wechselrichter auf lokale Last mit CT",
  "setting.type10.inverter3": "Wechselrichter auf lokale Last oder Smart Socket und Smart Meter",
  "setting.type10.chargePriority": "Priorität der Erhebung",
  "setting.type10.PVPriority": "Priorität der Photovoltaik",
  "setting.type10.utilityPriority": "Vorrang für Netzstrom",
  "setting.type10.hybridModel": "Gemischte Gebühren",
  "setting.type10.PVOnly": "Nur Photovoltaik laden",
  "setting.type10.batteryLowAlarm": "Warnpunkt für niedrigen Batteriestand",
  "setting.type10.batteryLowShutdown": "Abschaltpunkt bei schwacher Batterieleistung",
  "setting.type10.batteryFull": "Voll aufgeladener Abschaltpunkt der Batterie",
  "setting.type10.ACCharging": "Ladezeit",
  "setting.type10.startTime": "Startzeit",
  "setting.type10.endTime": "Endzeit",
  "setting.type10.forcedDischarge": "Entladezeit",
  "setting.type10.phaseGridSide": "Gitterseite",
  "setting.type10.power": "Phasenaktivität",
  "setting.type10.current": "Phasenstrom",
  "setting.type10.gridConnectionStandard": "Netzstandard",
  "setting.type10.baudRate": "485 Baudrate",
  "setting.type10.disable": "Nicht aktivieren",
  "setting.type10.enable": "Aktivieren",
  "setting.type10.ApprovalStandards": "Zertifizierungsstandards",
  "setting.type10.antiRefluxPower": "Gegenstromleistung",
  "setting.type10.antiRefluxSet": "Anti-Rückstrom aktivieren",
  "setting.type10.batFullSocSet": "Beurteilungswert der Batteriesättigung (%)",
  "setting.type10.auxSourceSet": "Hilfsquellenschalter",
  "setting.type10.timeSharingGridConnectedDischarge": "Zeitteilungsnetz angeschlossene Entladung",
  "setting.type10.timeSharingGridConnection": "Einstellung der Netzverbindung zur Zeitfreigabe",
  "setting.type10.outputPower": "Ausgangsleistung",
  "setting.type10.onlyAddThree": "Addieren bis {num} Timer",
  "setting.type10.productModelNumber": "Produktmodell",
  "setting.type10.PleaseTurnOnThe_PCS_switchFirst": "Bitte schalten Sie zuerst den Schalter ein.",
  "setting.type10.ThereIs_a_conflictInTheChargingAndDischargingTime": "Es gibt einen Konflikt in der Lade- und Entladezeit",
  "setting.type10.ChargeDischargeTimeSetting": "Einstellung der Lade- und Entladezeit",
  "setting.type11.switchPCS": "Ein-/Ausschaltregelung",
  "setting.type11.functionSwitch": "Funktionsschalter",
  "setting.type11.maxChargeVol": "Maximale Ladespannung (V)",
  "setting.type11.onGridMinDischargeVol": "Mindestentladungsspannung für den Netzanschluss (V)",
  "setting.type11.offGridOutputVol": "Netzausgangsspannung (V)",
  "setting.type11.maxChargeCur": "Maximale Ladeleistung",
  "setting.type11.onGridMaxDischargeCur": "Maximaler Entladestrom für den Netzanschluss (A)",
  "setting.type11.offGridMaxDisChargeCur": "Maximaler Entladestrom außerhalb des Netzes (A)",
  "setting.type11.minSocBMS": "MindestSOC der BMS (%)",
  "setting.type11.minSocDischarge": "Minimum SOC (%) für intelligente Entladung",
  "setting.type11.maxSocDischarge": "Intelligente Entladung SOC (%)",
  "setting.type11.timeStr": "Ausrüstungszeit",
  "setting.type11.timerSetting": "Timereinstellung {num}",
  "setting.type11.chargeStartTime1": "Ladezeit 1",
  "setting.type11.chargeLongTime1": "Ladedauer 1",
  "setting.type11.chargeTimeMaxSOC1": "Maximaler SOC (%) während des Ladezeitraums 1",
  "setting.type11.chargeTimeCurrent1": "Ladezeit 1 Ladestrom (A)",
  "setting.type11.dischargeStartTime1": "Startzeit 1",
  "setting.type11.dischargeLongTime1": "Einleitungsdauer 1",
  "setting.type11.dischargeTimeMaxSOC1": "Minimum SOC (%) während des Entlastungszeitraums 1",
  "setting.type11.dischargeTimeCurrent1": "Entladungszeit 1 Entladungsstrom (A)",
  "setting.type11.chargeStartTime2": "Ladezeit 2",
  "setting.type11.chargeLongTime2": "Ladedauer 2",
  "setting.type11.chargeTimeMaxSOC2": "SOC-Höchstbetrag während des Entgeltzeitraums 2 (%)",
  "setting.type11.chargeTimeCurrent2": "Ladezeit 2 Ladestrom (A)",
  "setting.type11.dischargeStartTime2": "Startzeit 2",
  "setting.type11.dischargeLongTime2": "Entladungsdauer 2",
  "setting.type11.dischargeTimeMaxSOC2": "MindestSOC (%) während des Entlastungszeitraums 2",
  "setting.type11.dischargeTimeCurrent2": "Entladungszeit 2 Entladungsstrom (A)",
  "setting.type11.chargeStartTime3": "Ladezeit 3",
  "setting.type11.chargeLongTime3": "Ladedauer 3",
  "setting.type11.chargeTimeMaxSOC3": "SOC-Höchstbetrag während des Entgeltzeitraums 3 (%)",
  "setting.type11.chargeTimeCurrent3": "Ladezeit 3 Ladestrom (A)",
  "setting.type11.dischargeStartTime3": "Startzeit 3",
  "setting.type11.dischargeLongTime3": "Entladungsdauer 3",
  "setting.type11.dischargeTimeMaxSOC3": "MindestSOC (%) während des Entlastungszeitraums 3",
  "setting.type11.dischargeTimeCurrent3": "Entladungszeitraum 3 Entladungsstrom (A)",
  "setting.type11.chargeStartTime4": "Ladezeit 4",
  "setting.type11.chargeLongTime4": "Ladedauer 4",
  "setting.type11.chargeTimeMaxSOC4": "SOC-Höchstbetrag während des Entgeltzeitraums 4 (%)",
  "setting.type11.chargeTimeCurrent4": "Ladezeit 4 Ladestrom (A)",
  "setting.type11.dischargeStartTime4": "Startzeit 4",
  "setting.type11.dischargeLongTime4": "Entladungsdauer 4",
  "setting.type11.dischargeTimeMaxSOC4": "MindestSOC (%) während des Entlastungszeitraums 4",
  "setting.type11.dischargeTimeCurrent4": "Entladungszeit 4 Entladungsstrom (A)",
  "setting.type11.functionSwitchObj.val1": "Intelligenter Modus",
  "setting.type11.functionSwitchObj.val2": "Timer-Modus",
  "setting.type11.functionSwitchObj.val3": "Spontaner Selbstgebrauch",
  "setting.type12.LEDSwitch": "LED Schalter",
  "setting.type12.LEDSpeed": "LED-Geschwindigkeit",
  "setting.type12.LEDEffect": "LED-Effekt",
  "setting.type12.LEDBrightness": "LED-Helligkeit",
  "setting.type12.dataColor": "Farbliche Darstellung der Daten",
  "setting.type12.LED1Color": "LED1 Farbe",
  "setting.type12.LED2Color": "LED2 Farbe",
  "setting.type12.LED3Color": "LED3 Farbe",
  "setting.type12.buzzerAlarm": "Alarmsignal",
  "setting.type12.overLoadToBypass": "Überlastung zu umgehen",
  "setting.type12.lcdRestartPage": "LCD ohne Operation Recovery Hauptschnittstelle",
  "setting.type12.overloadReset": "Neustart der Überlastung",
  "setting.type12.overloadTemperature": "Neustart bei Übertemperatur",
  "setting.type12.backLightOn": "LCD ohne Hintergrundbeleuchtung",
  "setting.type12.inputSourceChangeAlarm": "Alarm zur Änderung der Eingangsquelle",
  "setting.type12.faultCodeRecord": "Fehleraufzeichnung der Kommunikationssoftware",
  "setting.type12.solarFeedToGird": "Solarenergie-Leernetzanschluss",
  "setting.type12.switchOptions": "Optionen wechseln",
  "setting.type12.batteryParam": "Batterieparameter",
  "setting.type12.outputParam": "Ausgabeparameter",
  "setting.type12.ratedOutputVol": "Nennausgangsspannung",
  "setting.type12.ratedOutputFreq": "Nennfrequenz des Ausgangs",
  "setting.type12.inputVolRange": "Eingangsspannungsbereich",
  "setting.type12.outPutSourcePriority": "Priorität der Ausgabequelle",
  "setting.type12.batType": "Batterietyp",
  "setting.type12.batUnderVol": "Batterieabschaltspannung",
  "setting.type12.batBulkVol": "Konstante Ladespannung der Batterie",
  "setting.type12.batFloatVol": "Ladespannung des Schwimmers",
  "setting.type12.maxChargingCur": "Maximaler Ladestrom",
  "setting.type12.maxAcChargingCur": "Maximaler AC-Ladestrom",
  "setting.type12.chargeSourcePriority": "Priorität der Ladequelle",
  "setting.type12.batReChargeVol": "Ladespannung wiederherstellen",
  "setting.type12.batFullRestoreDischargeVol": "Entladespannung wiederherstellen",
  "setting.type12.solarSupplyPriority": "Vorrang der Solarstromversorgung",
  "setting.type12.resetPvStorage": "PV-Statistikdaten zurücksetzen",
  "setting.type12.countryRegulations": "Nationale Vorschriften",
  "setting.type12.acChargeStartTime": "Startzeit des Betriebs des Kommunikationsladegeräts",
  "setting.type12.acChargeEndTime": "Stoppzeit des Betriebs des Kommunikationsladegeräts",
  "setting.type12.acSupplyStartTime": "Startzeit der Wechselstromversorgung",
  "setting.type12.acSupplyEndTime": "Stoppzeit der Wechselstromversorgung",
  "setting.type12.restoreFactorySet": "Werkseinstellungen wiederherstellen",
  "setting.type12.parallelMode": "Parallelmodus",
  "setting.type12.bulkChargeVol": "CV Ladespannung",
  "setting.type12.batEquSet": "Batterieausgleichsfunktion",
  "setting.type12.batEquTime": "Durchschnittliche Ladezeit der Batterie (min)",
  "setting.type12.batEquDay": "Durchschnittliches Ladeintervall der Batterie Tage (d)",
  "setting.type12.batEquChargeVol": "Durchschnittliche Ladespannung der Batterie (V)",
  "setting.type12.batEquTimeout": "Batterieausgleich Timeout (min)",
  "setting.type12.equInfoSet": "Ausgewogene Informationseinstellung",
  "setting.type12.val.slow": "langsam",
  "setting.type12.val.medium": "in",
  "setting.type12.val.fast": "schnell",
  "setting.type12.val.low": "niedrig",
  "setting.type12.val.high": "hoch",
  "setting.type12.val.powerCycle": "Leistungszyklus",
  "setting.type12.val.powerRotation": "Leistungsdrehung",
  "setting.type12.val.additionalPower": "Zusätzliche Leistung",
  "setting.type12.val.powerUnchanged": "Leistung bleibt unverändert",
  "setting.type12.val.solarPowerInput": "Solarenergie",
  "setting.type12.val.batteryCapacity": "Prozentsatz der Batteriekapazität",
  "setting.type12.val.percentageLoad": "Prozentsatz der Belastung",
  "setting.type12.val.energySource": "Energiequelle",
  "setting.type12.val.batteryStatus": "Status des Ladens und Entladens der Batterie",
  "setting.type12.val.blue": "blau",
  "setting.type12.val.cyan": "Blaue Farbe",
  "setting.type12.val.green": "grün",
  "setting.type12.val.pink": "Rosa",
  "setting.type12.val.purple": "Lila;",
  "setting.type12.val.orange": "orange",
  "setting.type12.val.yellow": "gelb",
  "setting.type12.val.white": "weiß",
  "setting.type12.val.inputOvlRange1": "APL-Modus (90-280V)",
  "setting.type12.val.inputOvlRange2": "USV-Modus (170-280V)",
  "setting.type12.val.outputSource1": "Solarenergie ->Öffentliche ->Batterie",
  "setting.type12.val.outputSource2": "Solarenergie ->Batterie ->Öffentliche Nutzung",
  "setting.type12.val.chargeSourcePriority1": "Priorität der Photovoltaik",
  "setting.type12.val.chargeSourcePriority2": "Photovoltaik und Netzstrom",
  "setting.type12.val.chargeSourcePriority3": "Nur Photovoltaik",
  "setting.type12.val.solarSupplyPriority1": "Batterieladegerät",
  "setting.type12.val.solarSupplyPriority2": "LadenBatterie-Hilfsprogramm",
  "setting.type12.val.countryRegulations1": "Indien",
  "setting.type12.val.countryRegulations2": "Deutschland",
  "setting.type12.val.countryRegulations3": "Südamerika",
  "setting.type12.val.parallelMode1": "Keine Parallelmaschine",
  "setting.type12.val.parallelMode2": "Einphasiger Parallelbetrieb",
  "setting.type12.val.outPutSourcePriority1": "Vorrang für Netzstrom",
  "setting.type12.val.outPutSourcePriority2": "Vorrang der Solarenergie",
  "setting.type12.val.outPutSourcePriority3": "Solarenergie ->Batterie ->Netzstrom",
  "setting.ops15.invSwitch": "Wechselrichterschalter",
  "setting.ops15.workMode": "Arbeitsmodus",
  "setting.ops15.workMode1": "Vorrang des Futtermittelnetzes",
  "setting.ops15.workMode2": "Off-Grid-Modus",
  "setting.ops15.workMode3": "Spontane Selbstanwendung",
  "setting.ops15.invTime": "Umrichterzeit",
  "setting.ops15.batType": "Batterietyp",
  "setting.ops15.batType1": "Keine Batterie",
  "setting.ops15.batType2": "Universelle Lithium-Batterie",
  "setting.ops15.batType3": "Bleisäurebatterie",
  "setting.ops15.batType4": "Lithiumbatterie",
  "setting.ops15.timingTime": "Zeitliche Zeit",
  "setting.ops15.offGirdSoc": "Über Entlastung SOC (%)",
  "setting.ops15.optimizeRevenue": "Umsatz optimieren",
  "setting.type19.totalActivePower": "Wirkkraft",
  "setting.type19.offgridSettings": "Off-Grid Einstellung",
  "setting.type19.gridConnectedControlMode": "Steuerung mit Netzanschluss",
  "setting.type19.offGridControlMode": "Off-Grid Steuerung",
  "setting.type19.offgrid.gridNet": "Netzverbindung",
  "setting.type19.offgrid.offNet": "Off Grid",
  "setting.type22.parameterScope": "Parameterbereich",
  "setting.type22.ACStartVoltage": "Einstellung der Startspannung/Frequenz",
  "setting.type22.highVoltage": "Hochspannung des Wechselstrom-Anlaufs",
  "setting.type22.lowVoltage": "Wechselstrom-Anlauf Niederspannung",
  "setting.type22.pvStartLowVol": "PV-Anlauf Niederspannung",
  "setting.type22.acUnderVol1": "Wechselstrom-Unterspannung erster Ordnung (V)",
  "setting.type22.acOverVol1": "Wechselstrom-Überspannung erster Ordnung (V)",
  "setting.type22.acUnderVolTime1": "Wechselstrom-Unterspannungszeit erster Ordnung",
  "setting.type22.acOverVolTime1": "Wechselstrom-Überspannungszeit erster Ordnung",
  "setting.type22.acUnderVol2": "Wechselstrom-Unterspannung zweiter Ordnung (V)",
  "setting.type22.acOverVol2": "Wechselstrom-Überspannung zweiter Ordnung (V)",
  "setting.type22.acUnderVolTime2": "Wechselstrom-Unterspannungszeit zweiter Ordnung",
  "setting.type22.acOverVolTime2": "Wechselstrom-Überspannungszeit zweiter Ordnung",
  "setting.type22.startDelayTime": "Startverzögerung",
  "setting.type22.restartDelayTime": "Verzögerungszeit für den Neustart",
  "setting.type22.ACStartFrequency": "Überspannung/Unterspannung/Frequenzeinstellung",
  "setting.type22.highFrequency": "Hochfrequenzstart",
  "setting.type22.lowFrequency": "AC-Anlauf Niederfrequenz",
  "setting.type22.acUnderFrequency1": "AC-Unterfrequenz erster Ordnung (Hz)",
  "setting.type22.acOverFrequency1": "AC-Überfrequenz erster Ordnung (Hz)",
  "setting.type22.acUnderFrequencyTime1": "AC-Unterfrequenzzeit erster Ordnung",
  "setting.type22.acOverFrequencyTime1": "AC Overfrequency First Order Time (s)",
  "setting.type22.acUnderFrequency2": "AC-Unterfrequenz zweiter Ordnung (Hz)",
  "setting.type22.acOverFrequency2": "AC-Überfrequenz zweiter Ordnung (Hz)",
  "setting.type22.acUnderFrequencyTime2": "AC-Unterfrequenzzeit zweiter Ordnung",
  "setting.type22.acOverFrequencyTime2": "AC Overfrequency Second Order Time (s)",
  "setting.type22.systemSetting": "Einstellungen für Geräteinformationen",
  "setting.type22.SNset": "Einstellung der Seriennummer",
  "setting.type22.reactiveControlMode": "Wirkleistungsregelung",
  "setting.type22.inputMode": "Eingabemodus",
  "setting.type22.startSolpe": "Anfangsneigung",
  "setting.type22.restartSolpe": "Steigung neu starten",
  "setting.type22.reactivePercentage": "Prozentsatz der Reaktivität",
  "setting.type22.activePercentage": "Verdienstanteil",
  "setting.type22.shutdown": "Fernschalter",
  "setting.type22.functionSelect": "Funktionsauswahl",
  "setting.type22.manufacturer": "Hersteller",
  "setting.type22.setFunctionSelect.val1": "verbieten",
  "setting.type22.setFunctionSelect.val2": "Anti-Rückfluss-Maßnahmen aktivieren",
  "setting.type22.setManufacturer.val1": "Yingweiten",
  "setting.type22.setManufacturer.val2": "Skyworth",
  "setting.type22.reactiveControlModeChoice.val1": "Regelung des Leistungsfaktors",
  "setting.type22.reactiveControlModeChoice.val2": "Regelung der prozentualen Wirkleistung",
  "setting.type22.reactiveControlModeChoice.val3": "Steuerung der QV-Kurve",
  "setting.type22.inputModeChoice.val1": "Eingabeunabhängiger Modus",
  "setting.type22.inputModeChoice.val2": "Parallelmodus eingeben",
  "setting.type22.inputModeChoice.val3": "DC-Quellmodus",
  "title.login": "Anmelden",
  "title.vistorLogin": "Tourist Login",
  "title.createAccount": "Konto erstellen",
  "title.retrievePassword": "Passwort abrufen",
  "title.userAgreement": "Nutzungsvereinbarung",
  "title.privacyPolicy": "Datenschutzvereinbarung",
  "title.phone": "Telefon",
  "title.addPlant": "Kraftwerk hinzufügen",
  "title.editPlant": "Kraftwerk bearbeiten",
  "title.accountInfo": "Kontoinformationen",
  "title.changePassword": "Passwort ändern",
  "title.message": "Benachrichtigungen",
  "title.systemMessage": "Systemmeldung",
  "title.faultMessage": "Fehlermeldung",
  "title.deviceMessage": "Gerätenachricht",
  "title.aboutUs": "über",
  "title.device": "Ausrüstung",
  "title.datalogger": "Sammler",
  "title.setting": "einrichten",
  "title.socketSetting": "Socket einrichten",
  "title.addSchedule": "Timer hinzufügen",
  "title.editSchedule": "Timer bearbeiten",
  "title.repetitionTime": "Wiederholungszeit",
  "title.addDatalogger": "Gerät hinzufügen",
  "title.connectWifi": "Verbindungsroute",
  "title.distributionNetworkStatus": "Status des Verteilnetzes",
  "title.language": "Sprache",
  "title.selectCountry": "Land auswählen",
  "title.selectCity": "Stadt auswählen",
  "bar.home": "Startseite",
  "bar.energy": "Analyse",
  "bar.plant": "Kraftwerk",
  "bar.user": "Benutzer",
  "bar.endpoint": "Terminal",
  "bar.mine": "mein",
  "bar.my": "mein",
  "button.logOut": "abmelden",
  "button.rememberMe": "Passwort für das Konto speichern",
  "button.forgetPassword": "Passwort vergessen",
  "button.register": "registrieren",
  "button.ok": "Bestätigen",
  "button.send": "senden",
  "button.auto": "automatisch",
  "button.cancle": "Abbrechen",
  "button.yes": "Ja",
  "button.close": "schließen",
  "button.refresh": "Aktualisieren",
  "button.next": "nächster Schritt",
  "button.redistributionNetwork": "Reorganisation des Vertriebsnetzes",
  "button.upload": "Upload",
  "button.confirm": "Bestätigen",
  "button.edit": "bearbeiten",
  "button.delete": "löschen",
  "button.save": "Konservierung",
  "button.allReady": "Alle gelesen",
  "button.selectAll": "Alle auswählen",
  "button.deselectAll": "Alle Auswahl abbrechen",
  "button.unsubscribe": "Konto löschen",
  "button.later": "Später",
  "button.upgrade": "zu aktualisieren",
  "button.unfollow": "Folgen abbrechen",
  "button.add": "hinzufügen zu",
  "subtitle.NeedMoreHelp": "Mehr Hilfe",
  "subtitle.VisitSupportCenter": "Durchsuchen Sie die offizielle Website für weitere Hilfe",
  "subtitle.energyFlowDiagram": "Energieflussdiagramm",
  "subtitle.selectTimezone": "Zeitzone auswählen",
  "subtitle.selectPlantType": "Kraftwerkstyp auswählen",
  "subtitle.selectInstallationDate": "Installationsdatum auswählen",
  "subtitle.selectCurrency": "Währung auswählen",
  "subtitle.selectDateType": "Datumsart auswählen",
  "subtitle.selectDeviceType": "Gerätetyp auswählen",
  "subtitle.socketBluetooth": "Sockel Bluetooth",
  "subtitle.log": "Journal",
  "subtitle.all": "ganz",
  "subtitle.online": "on-line",
  "subtitle.offline": "offline",
  "subtitle.normal": "normal",
  "subtitle.abnormal": "anormal",
  "subtitle.on": "offen",
  "subtitle.off": "schließen",
  "subtitle.todayEnergy": "Der heutige Stromverbrauch",
  "subtitle.totalEnergy": "Stromverbrauch insgesamt",
  "subtitle.totalRevenue": "Gesamteinkommen",
  "subtitle.plantImage": "Kraftwerksbilder",
  "subtitle.plantName": "Name des Kraftwerks",
  "subtitle.plantType": "Art des Kraftwerks",
  "subtitle.PVCapacity": "PV-Kapazität",
  "subtitle.installationDate": "Installationsdatum",
  "subtitle.plantAddress": "Adresse des Kraftwerks",
  "subtitle.revenue": "Einkommen",
  "subtitle.timeZone": "Zeitzone",
  "subtitle.updatePhone": "Telefonnummer aktualisieren",
  "subtitle.solar": "Photovoltaik",
  "subtitle.grid": "Stromnetz",
  "subtitle.battery": "Batterie",
  "subtitle.home": "Last",
  "subtitle.load": "Last",
  "subtitle.socket": "Sockel",
  "subtitle.today": "Tag",
  "subtitle.day": "Tag",
  "subtitle.month": "Monat",
  "subtitle.year": "Jahr",
  "subtitle.total": "insgesamt",
  "subtitle.time": "Zeit",
  "subtitle.Co2": "Kohlendioxid",
  "subtitle.coal": "Kohle",
  "subtitle.deforestation": "Bäume",
  "subtitle.parameter": "Parameter",
  "subtitle.schedule": "Timer",
  "subtitle.countdown": "Countdown",
  "subtitle.socketSwitch": "Steckdosenschalter",
  "subtitle.currency": "Währung",
  "subtitle.energyPrice": "Strompreis",
  "subtitle.storagePlant": "Energiespeicherkraftwerk",
  "subtitle.on-GridPlant": "Netzgekoppeltes Kraftwerk",
  "subtitle.photo": "Kopfportrait",
  "subtitle.email": "Postfach",
  "subtitle.account": "Konto",
  "subtitle.version": "Ausgabe",
  "subtitle.officalWebsite": "Offizielle Website",
  "subtitle.SN": "Seriennummer",
  "subtitle.wifiSignal": "WiFi-Signal",
  "subtitle.lastSync": "Endlich synchronisiert",
  "subtitle.switch": "Schalter",
  "subtitle.happening": "In Bearbeitung",
  "subtitle.restored": "Wiedererlangt",
  "subtitle.details": "Details",
  "subtitle.warn": "Alarm geben",
  "subtitle.fault": "Fehler",
  "subtitle.status": "Zustand",
  "subtitle.level": "Grad",
  "subtitle.deviceType": "Gerätetyp",
  "subtitle.alarmStartTime": "Startzeit des Alarms",
  "subtitle.alarmEndTime": "Endzeit des Alarms",
  "subtitle.solution": "auflösend",
  "subtitle.noSolution": "Bitte schlagen Sie zur Fehlerbehebung im Benutzerhandbuch nach oder wenden Sie sich an den Kundendienst.",
  "subtitle.loginIn": "Einloggen",
  "subtitle.checkVersion": "Nach Updates suchen",
  "subtitle.versionUpgrade": "Versionsupdate",
  "subtitle.alarmName": "Alarmname",
  "subtitle.messageDetail": "Nachrichtendetails",
  "subtitle.todayConsumption": "Der heutige Stromverbrauch",
  "subtitle.totalConsumption": "Energieverbrauch",
  "subtitle.dataloggerSN": "Seriennummer des Sammelgeräts",
  "subtitle.configurationGuidance": "Konfigurationsanleitung",
  "subtitle.guideVideo": "Leitfaden Video",
  "subtitle.manualInstuction": "Leitfaden",
  "subtitle.manualInstuction4G": "4G Leitfaden",
  "subtitle.manualInstuctionMasterControl": "Master Control Manual",
  "subtitle.masterControlConfiguration": "Hauptleitungsnetz",
  "subtitle.defaultConfiguration": "Standardverteilungsnetz",
  "subtitle.findEmail": "Abruf von E-Mails",
  "subtitle.findPhone": "Abruf von Mobiltelefonen",
  "subtitle.family": "Familie",
  "subtitle.agent": "Agent",
  "subtitle.endUsers": "Endbenutzer",
  "subtitle.deviceManagement": "Gerät",
  "subtitle.deviceSN": "Seriennummer der Ausrüstung",
  "subtitle.firmwareVersion": "Firmware Version",
  "subtitle.alias": "Alias",
  "subtitle.information": "Informationen",
  "subtitle.domainName": "Domainname",
  "subtitle.restartdatalogger": "Starten Sie den Collector neu",
  "subtitle.value": "Wert",
  "subtitle.customizable": "kundenspezifisch",
  "subtitle.ready": "lesen",
  "subtitle.deviceDetails": "Gerätedetails",
  "subtitle.startAddress": "Adresse des Startregisters",
  "subtitle.endAddress": "Registeradresse beenden",
  "subtitle.settingParam": "Parameter festlegen",
  "subtitle.tariffType": "Art des Strompreises",
  "subtitle.fixed": "fest",
  "subtitle.timeshare": "Zeiteinteilung",
  "subtitle.addTime": "Zeit hinzufügen",
  "subtitle.notAllDay": "Nicht den ganzen Tag",
  "subtitle.dealer": "Distributor",
  "subtitle.dealerNumber": "Händler-ID",
  "subtitle.toggle": "Schalter",
  "subtitle.basicParam": "Grundlegende Parameter",
  "subtitle.realTimeParam": "Parameter in Echtzeit",
  "subtitle.export": "Export",
  "subtitle.localDebug": "Near End Debugging",
  "subtitle.environmentalBenefit": "Umweltnutzen",
  "subtitle.mode": "Modus",
  "subtitle.manuallyAdd": "Manuelles Hinzufügen",
  "subtitle.AttachTheDevice": "Aufhängegeräte",
  "subtitle.ammeter": "Wattstundenmesser",
  "subtitle.FeederPowerOnTheSameDay": "Tägliche Stromversorgung des Netzes",
  "subtitle.BatterySOC": "Batterie SOC",
  "subtitle.DailyChargingCapacityOfTheBattery": "Tägliche Ladekapazität der Batterie",
  "subtitle.DailyPowerConsumption": "Täglicher Stromverbrauch",
  "subtitle.CumulativePowerGeneration": "Akkumulierte Stromerzeugung",
  "subtitle.total2": "insgesamt",
  "subtitle.run": "Funktion",
  "subtitle.StopIt": "Hör auf damit.",
  "subtitle.Optimizer": "Optimierer",
  "subtitle.DataGateways": "Daten-Gateway",
  "subtitle.dataType": "Datentyp",
  "subtitle.Model": "Modell",
  "subtitle.TheAmountOfElectricityGeneratedToday": "Heutige Stromerzeugung",
  "subtitle.CurrentPower": "Stromleistung",
  "subtitle.AllOptimizerWorkingStatus": "Alle Bearbeitungszustände des Optimierers",
  "subtitle.WhenClosedAllOptimizersStopWorking": "Nach dem Herunterfahren funktionieren alle Optimierer nicht mehr",
  "subtitle.TheDataGatewayRestarts": "Neustart des Daten-Gateways",
  "subtitle.Reboot": "Neustart",
  "subtitle.Restarting": "Neustart im Gange",
  "subtitle.HardwareVersionNumber": "Hardwareversionsnummer",
  "subtitle.SoftwareVersionNumber": "Versionsnummer der Software",
  "subtitle.OutputPower": "Ausgangsleistung",
  "subtitle.OutputVoltage": "Ausgangsspannung",
  "subtitle.OutputCurrent": "Ausgangsstrom",
  "subtitle.InputPower": "Eingangsleistung",
  "subtitle.InputVoltage": "Eingangsspannung",
  "subtitle.InputCurrent": "Eingangsstrom",
  "subtitle.OperationalStatus": "Betriebszustand",
  "subtitle.temperature": "Temperatur(℃)",
  "subtitle.DeviceAddress": "Adresse der Ausrüstung",
  "subtitle.FeederMode": "Feed-Netzwerkmodus",
  "subtitle.StandbyMode": "Sicherungsmodus",
  "subtitle.Off-gridMode": "Off-Grid-Modus",
  "subtitle.TimedChargingAndDischarging": "Zeitgesteuertes Laden und Entladen",
  "subtitle.WorkingModeSettings": "Einstellung des Arbeitsmodus",
  "subtitle.DeviceInformation": "Ausrüstungsinformationen",
  "subtitle.HMISoftwareVersion": "Version der HMI-Software",
  "subtitle.DSPSoftwareVersion": "DSP-Softwareversion",
  "subtitle.ChargeAndDischargeTimePeriodSetting": "Einstellung der Lade- und Entladezeit",
  "subtitle.ChargingPeriod": "Ladezeit",
  "subtitle.DischargeTimePeriod": "Entladungszeitraum",
  "subtitle.BatteryMinimumSOC(%)": "Minimum SOC der Batterie (%)",
  "subtitle.BatteryOvervoltageMethod(V)": "Wert der Batterieüberspannungsmethode (V)",
  "subtitle.BatteryUndervoltageThreshold(A)": "Batterieunterspannungsschwelle (A)",
  "subtitle.ChargingCurrentLimit(A)": "Ladestrombegrenzung (A)",
  "subtitle.DischargeCurrentLimit(A)": "Entladestrombegrenzung (A)",
  "subtitle.Off-GridDischargeMinimumSOC(%)": "Minimum SOC (%) für netzunabhängige Entladung",
  "subtitle.Off-Grid-2-DischargeMinmumSOC(%)": "Off Grid 2 Entladung Minimum SOC (%)",
  "subtitle.Off-grid-2-DischargeMinimumBatteryVoltage(V)": "Minimale Batteriespannung für netzunabhängige 2-Entladung (V)",
  "subtitle.Auto-replenishment": "Automatische Leistungsauffüllung",
  "subtitle.BatteryBMSActivationCommand": "Batterie BMS Aktivierungsbefehl",
  "subtitle.ForcedFullCharge": "Vollständige Ladung erzwungen",
  "subtitle.ForceCharge2": "Pflichterhebung 2",
  "subtitle.ForceCharge1": "Pflichterhebung 1",
  "subtitle.DischargeEnabled": "Entladung aktivieren",
  "subtitle.ChargingEnabled": "Laden aktivieren",
  "subtitle.NumberOfOptimizers": "Anzahl der Optimierer",
  "subtitle.TheNameOfTheDevice": "Name der Ausrüstung",
  "subtitle.GeneralSettings": "Allgemeine Einstellungen",
  "subtitle.Anti-backflowSwitch": "Gegenstromschalter",
  "subtitle.ReflowPowerLimit(W)": "Grenzwert der Rückflussleistung (W)",
  "subtitle.OptimizerNumber": "Optimierungsnummer",
  "subtitle.reset": "Zurücksetzen",
  "subtitle.areYouSure": "Sind Sie sicher, dass Sie zurücksetzen möchten",
  "subtitle.PhysicalView": "Physische Ansicht",
  "subtitle.LogicalView": "Logische Ansicht",
  "subtitle.LayoutDrawing": "Layout",
  "tip.noData": "Zur Zeit keine Daten verfügbar",
  "tip.base.maxDistance": "am weitesten",
  "tip.base.minDistance": "in letzter Zeit",
  "tip.base.maxSize": "maximal",
  "tip.base.minSize": "Minimum",
  "tip.request.loading": "Laden läuft",
  "tip.request.netWork": "Netzwerkverbindung fehlgeschlagen, bitte überprüfen Sie das Netzwerk",
  "tip.request.connectServerFail": "Konnte keine Verbindung zum Server herstellen",
  "tip.request.requestTimeout": "Zeitüberschreitung anfordern",
  "tip.validate.choiceCountry": "Bitte wählen Sie zuerst ein Land aus",
  "tip.validate.country": "Land kann nicht leer sein, bitte Land auswählen",
  "tip.validate.timeZone": "Zeitzone kann nicht leer sein, bitte wählen Sie eine Zeitzone",
  "tip.validate.email": "E-Mail Format Fehler, bitte geben Sie eine korrekte E-Mail Adresse ein",
  "tip.validate.verification": "Bitte senden Sie zuerst den Verifizierungscode",
  "tip.validate.verificationError": "Verifizierungscode Fehler, bitte geben Sie einen gültigen Verifizierungscode ein",
  "tip.validate.passwordFormTip": "Bitte geben Sie ein Passwort ein, das aus 6-20 Ziffern und Buchstaben besteht",
  "tip.validate.passwordError": "Passwort Formatfehler, bitte geben Sie ein Passwort bestehend aus 6-20 Ziffern von Zahlen und Buchstaben ein",
  "tip.validate.passwordError2": "Bitte geben Sie ein gültiges Passwort ein (das Passwort sollte keine Sonderzeichen, Symbole oder Leerzeichen enthalten)",
  "tip.validate.validatePassword": "Die beiden eingegebenen Passwörter stimmen nicht überein. Bitte überprüfen und erneut eingeben",
  "tip.validate.confirmAgreement": "Bitte lesen Sie zuerst die Datenschutzerklärung und stimmen Sie dieser zu.",
  "tip.validate.plantName": "Der Name des Kraftwerks darf nicht leer sein. Bitte geben Sie den Namen des Kraftwerks ein.",
  "tip.validate.plantType": "Kraftwerkstyp kann nicht leer sein, bitte wählen Sie Kraftwerkstyp",
  "tip.validate.pvCapacity": "Die Solarzellenkapazität kann nicht leer sein, bitte geben Sie die Batteriekapazität ein",
  "tip.validate.installationDate": "Installationsdatum kann nicht leer sein, bitte wählen Sie Installationsdatum",
  "tip.validate.city": "Stadt kann nicht leer sein, bitte wählen Sie eine Stadt",
  "tip.validate.incomeunit": "Währung kann nicht leer sein, bitte Währung auswählen",
  "tip.validate.energyPrice": "Der Strompreis kann nicht leer sein, bitte geben Sie den Strompreis ein",
  "tip.validate.firstChoiceCountry": "Bitte wählen Sie zuerst ein Land aus",
  "tip.validate.oldPassword": "Altes Passwort kann nicht leer sein, bitte geben Sie altes Passwort ein",
  "tip.validate.newPassword": "Das neue Passwort kann nicht leer sein, bitte geben Sie das neue Passwort ein",
  "tip.validate.confirmPassword": "Passwort bestätigen kann nicht leer sein, bitte Passwort bestätigen",
  "tip.validate.passwordNotMatch": "Die beiden Passworteingaben sind inkonsistent. Bitte überprüfen und bestätigen Sie vor dem Absenden",
  "tip.validate.SN1": "Die Seriennummer kann nicht leer sein",
  "tip.validate.SN2": "Die Seriennummer muss 10-stellig lang sein",
  "tip.validate.noSocketTimer": "Derzeit ist kein Socket Timer verfügbar. Bitte klicken Sie, um ihn hinzuzufügen",
  "tip.validate.cameraPermission": "Die App benötigt Kameraberechtigungen zum Scannen und Hinzufügen von Collectors",
  "tip.validate.searchingState": "Suche nach Bluetooth, bitte nicht erneut klicken",
  "tip.validate.notInTheScope": "Die Eingabeparameter liegen nicht im angegebenen Bereich",
  "tip.validate.enterDecimal": "Muss {num} Dezimal- oder Ganzzahl-Ziffern eingeben",
  "tip.validate.integer": "Muss eine ganze Zahl sein",
  "tip.validate.phone": "Mobiltelefonnummer unterstützt nur chinesisches Festland, bitte verwenden Sie E-Mail, um andere abzurufen",
  "tip.validate.can`tEmpty": "{param} kann nicht leer sein",
  "tip.validate.dealerSope": "Der Dealer Nummernbereich beträgt 6-8 Ziffern",
  "tip.validate.firstChoicePlant": "Bitte wählen Sie zuerst das Kraftwerk aus",
  "tip.log.permissionOpen": "Stellen Sie sicher, dass Standort- und Bluetooth-Berechtigungen aktiviert sind",
  "tip.log.openBluetoothSystem": "Bluetooth-Einstellungen öffnen",
  "tip.log.openIosBtSystem": "Bitte starten Sie den Bluetooth-Schalter neu",
  "tip.log.openLocationSystem": "Standorteinstellungen öffnen",
  "tip.log.bluetoothAuthorization": "APP Bluetooth Autorisierung nicht aktiviert",
  "tip.log.locationAuthorization": "APP-Standortautorisierung nicht aktiviert",
  "tip.log.searchSurroundingDevicesPermission": "Unberechtigte Suche nach Geräten in der Nähe",
  "tip.log.bluetoothNotPermission": "Bluetooth nicht eingeschaltet",
  "tip.log.locationNotPermission": "Positionierung nicht aktiviert",
  "tip.log.bluetoothPermission": "Bluetooth aktiviert",
  "tip.log.locationPermission": "Positionierung aktiviert",
  "tip.log.bluetoothException": "Bluetooth abnormale Trennung, bestätigen Sie bitte, dass Bluetooth des Geräts eingeschaltet ist und stellen Sie dann die Verbindung wieder her",
  "tip.log.listeningFailure": "Änderungen des Funktionswertes sind fehlgeschlagen, bitte verbinden Sie sich erneut mit Bluetooth",
  "tip.log.communicationException": "Bluetooth Kommunikation ist anormal, bitte verbinden Sie sich wieder mit Bluetooth",
  "tip.log.reconnect": "Bluetooth-Wiederverbindung",
  "tip.log.connectFail": "Bluetooth-Verbindung fehlgeschlagen",
  "tip.log.connect": "Bluetooth verbinden",
  "tip.log.bluetoothService": "Bitte aktivieren Sie Bluetooth-Dienst",
  "tip.log.locationService": "Bitte aktivieren Sie Standortdienste",
  "tip.log.notsupport": "Die aktuelle Plattform unterstützt den Aufruf der Bluetooth-Funktion",
  "tip.log.locationNotTurnOn": "Standort nicht aktiviert, kann nicht nach Bluetooth suchen",
  "tip.log.init": "Bluetooth-Initialisierung",
  "tip.log.searching": "Suche nach Bluetooth",
  "tip.log.searchFail": "Es wurden keine Geräte gefunden. Stellen Sie bitte sicher, dass das Bluetooth des Geräts eingeschaltet ist, und klicken Sie dann auf Aktualisieren.",
  "tip.log.stopSearch": "Stoppen Sie die Suche nach umgebendem Bluetooth",
  "tip.log.stopSearchFail": "Beenden der Suche nach umgebendem Bluetooth fehlgeschlagen",
  "tip.log.connectSuccess": "Bluetooth-Verbindung erfolgreich",
  "tip.log.setMTUsSuccess": "Erfolgreich eingestellte maximale Übertragungseinheit",
  "tip.log.setMTUsFail": "Einstellung der maximalen Übertragungseinheit fehlgeschlagen",
  "tip.log.closeSuccess": "Bluetooth-Verbindung getrennt",
  "tip.log.closeFail": "Die Bluetooth-Verbindung konnte nicht getrennt werden",
  "tip.log.wifiLoadFail": "Laden der WiFi-Liste fehlgeschlagen, bitte manuell eingeben",
  "tip.log.bluetoothAbnormal": "Bluetooth-Verbindung anormal, Versuch, die Verbindung wiederherzustellen",
  "tip.log.getBluetoothServiceSuccess": "Erfolgreich erhaltener Bluetooth-Gerätedienst",
  "tip.log.getBluetoothServiceFail": "Abrufen des Bluetooth-Gerätedienstes fehlgeschlagen",
  "tip.log.getFeatureValuesSucess": "Erfolgreich alle Funktionswerte im angegebenen Dienst des Bluetooth-Geräts erhalten",
  "tip.log.getFeatureValuesFail": "Abrufen aller Funktionswerte aus dem angegebenen Dienst des Bluetooth-Geräts fehlgeschlagen",
  "tip.log.subscriptionEigenvalueSuccess": "Die Benachrichtigungsfunktion für Änderungen des Funktionswertes von Bluetooth-Geräten mit geringem Stromverbrauch wurde aktiviert, Feature-Werte abonnieren",
  "tip.log.subscriptionEigenvalueFail": "Aktivieren der Benachrichtigungsfunktion, wenn sich der Funktionswert von Bluetooth-Geräten mit geringem Stromverbrauch ändert, Abonnementfunktionswert fehlgeschlagen ist",
  "tip.log.monitoringSuccess": "Erfolgreiche Überwachung des Funktionswertwechsels von Bluetooth-Geräten mit geringem Stromverbrauch",
  "tip.log.monitoringFail": "Fehler beim Überwachen des Feature-Value-Change-Ereignisses von Bluetooth-Geräten mit geringem Stromverbrauch",
  "tip.log.CRC": "CRC-Überprüfung fehlgeschlagen",
  "tip.log.queryWiFi": "WiFi-Liste erfolgreich abgefragt",
  "tip.log.queryWiFiState": "Erfolgreich ausgegebener WiFi-Listenabfragebefehl",
  "tip.log.wifiConenct": "Verbindungsstatus für Routing wird abgefragt",
  "tip.log.wifiFail": "Bitte überprüfen Sie das Router-Konto und das Passwort und versuchen Sie erneut die Verbindung herzustellen",
  "tip.log.connectWiFiSuccess": "Router-Verbindung erfolgreich",
  "tip.log.connectWiFiFail": "Router-Verbindung fehlgeschlagen",
  "tip.log.routerAccount": "Fehler beim Router-Konto",
  "tip.log.routerPassword": "Fehler beim Router-Kennwort",
  "tip.log.gettingIP": "Abrufen der IP-Adresse des Routers",
  "tip.log.getIPFail": "Abrufen der Router-IP fehlgeschlagen",
  "tip.log.queryServerState": "Der Befehl zur Abfrage des Interaktionsstatus zwischen Gerät und Server wurde erfolgreich ausgegeben",
  "tip.log.server03": "Es gibt 03 Datenaustausch",
  "tip.log.server04": "Es gibt 04 Datenaustausch",
  "tip.log.heartbeat": "Wechselwirkung von Herzschlagdaten",
  "tip.log.noInteraction": "Keine Dateninteraktion",
  "tip.log.bluetoothCommunication": "Bluetooth-Kommunikation wurde etabliert",
  "tip.log.connectWiFi": "WLAN verbinden",
  "tip.log.getWiFiList": "WiFi-Liste abfragen",
  "tip.log.wifiName": "WiFi Name kann nicht leer sein, bitte wählen oder geben Sie 2.4WiFi",
  "tip.log.wifiPasword": "WLAN kann nicht leer sein, bitte Passwort eingeben",
  "tip.log.wifiPasswordError": "WLAN-Kennwort kann keine Sonderzeichen enthalten (ǎǐò•♢ ∝ ℃ usw.)",
  "tip.log.masterControlId": "Die Haupt-Kontroll-ID kann nicht leer sein, bitte geben Sie die ID ein",
  "tip.addDatalogger.noSearchDevice": "Das Gerät kann nicht gefunden werden. Stellen Sie bitte sicher, dass das Bluetooth des Geräts eingeschaltet ist.",
  "tip.addDatalogger.searchAroundBluetooth": "Umfangreiches Bluetooth-Netzwerk ist verfügbar",
  "tip.addDatalogger.scan": "Scannen Sie den QR-Code oder geben Sie die Seriennummer des Kollektors unter dem QR-Code manuell ein.",
  "tip.addDatalogger.connectBluetoothFail": "Bluetooth-Verbindung fehlgeschlagen, scannen Sie bitte den QR-Code oder geben Sie die Seriennummer des Kollektors unter dem QR-Code ein, bevor Sie die Verbindung erneut herstellen.",
  "tip.connectWifi.tip1": "Geräte für den Anschluss an das Netzwerk konfigurieren",
  "tip.connectWifi.tip": "Bitte wählen Sie 2.4G WiFi",
  "tip.connectWifi.devicePower": "Leistung der Ausrüstung",
  "tip.connectWifi.enterSSID": "Bitte geben Sie das Router-Konto ein",
  "tip.connectWifi.enterPassword": "Bitte geben Sie das Router-Passwort ein",
  "tip.connectWifi.masterId": "Bitte geben Sie die Haupt-Kontroll-ID ein",
  "tip.connectWifi.commandSetFail": "Befehlseinstellung fehlgeschlagen, bitte verbinden Sie sich erneut mit dem Collector",
  "tip.configurationState.connecting": "Verbindung läuft",
  "tip.configurationState.connectFail": "Verbindung fehlgeschlagen",
  "tip.configurationState.connectSuccess": "Verbindung erfolgreich",
  "tip.configurationState.wait": "Einen Moment bitte",
  "tip.configurationState.addDeviceSuccess": "Gerät erfolgreich hinzugefügt",
  "tip.home.today": "Tägliche Stromerzeugung",
  "tip.home.month": "Monatliche Stromerzeugung",
  "tip.home.year": "Jährliche Stromerzeugung",
  "tip.home.total": "Stromerzeugung insgesamt",
  "tip.home.homePower": "Haushaltslast insgesamt",
  "tip.home.socketPower": "Sockelbelastung",
  "tip.home.off-gridPower": "Netzlast",
  "tip.home.acPower": "Netzstrom",
  "tip.home.on-gridPower": "Netzanschluss",
  "tip.home.others": "andere",
  "tip.home.latestVersion": "Es ist bereits die neueste Version",
  "tip.home.frontEndLoad": "Frontlast",
  "tip.home.backEndLoad": "Netzlast",
  "tip.energy.choiceDate": "Die aktuellen Daten sind nur verfügbar",
  "tip.energy.explain": "erklären",
  "tip.energy.tip1.load": "Die von der Last verbrauchte Energie",
  "tip.energy.tip1.solar": "Umwandlung von Solarenergie in elektrische Energie für Batterieladung oder Laststromversorgung",
  "tip.energy.tip1.grid": "Akkumulierte Energie, die an das Stromnetz verkauft wird",
  "tip.energy.tip1.battery": "Akkumulierte elektrische Energie, die zum Laden der Batterie verwendet wird",
  "tip.energy.tip2": "#NAME?",
  "tip.energy.tip3.title": "Standards zur Berechnung der Sozialbeiträge",
  "tip.energy.tip3.title2": "1kWh entspricht:",
  "tip.energy.tip3.Co2": "Verringerung der Kohlendioxidemissionen:",
  "tip.energy.tip3.coal": "Ersparen Sie den Einsatz von Standardkohle:",
  "tip.energy.tip3.deforestation": "Schutz der Bäume:",
  "tip.plant.comprehensive": "Umfassende Sortierung",
  "tip.plant.totalEnergyMax": "Der höchste Gesamtstromverbrauch",
  "tip.plant.totalEnergyMin": "Niedrigster Gesamtstromverbrauch",
  "tip.plant.realTimePower": "Strom in Echtzeit",
  "tip.plant.pvcapacityMax": "Die höchste PV-Kapazität",
  "tip.plant.pvcapacityMin": "PV-Kapazität ist die niedrigste",
  "tip.plant.installationDateMax": "Das längste Installationsdatum",
  "tip.plant.installationDateMin": "Letztes Installationsdatum",
  "tip.plant.paramChoice": "Parameterauswahl",
  "tip.plant.filter": "Bildschirm",
  "tip.plant.addVisitor": "Besucher hinzufügen",
  "tip.plant.tip": "Tipps",
  "tip.plant.visitorTip": "Kann nur mit registrierten Benutzern geteilt werden",
  "tip.plant.name": "Name",
  "tip.plant.permission": "Zuständigkeit",
  "tip.plant.read-write": "Lesen und Schreiben",
  "tip.plant.onlyread": "schreibgeschützt",
  "tip.plant.visitor": "Besucher",
  "tip.plant.unfollow": "Bist du sicher, dass du dieses Kraftwerk nicht mehr verfolgen willst?",
  "tip.device.power": "Leistung",
  "tip.device.type": "Typ",
  "tip.device.updateTime": "Aktualisierungszeit",
  "tip.device.powerOnTime": "Einschalten",
  "tip.device.todayEnergy": "Der heutige Stromverbrauch",
  "tip.device.signal": "Signalintensität",
  "tip.device.deliveryWarning": "Entschuldigung, dieses Gerät wurde an Endbenutzer geliefert und kann nicht gelöscht werden. Sie können zuerst zur Kraftwerksverwaltung gehen, die Lieferung zurückziehen und dann das Gerät löschen.",
  "common.ok": "OK",
  "tip.delDevice": "Sind Sie sicher, dass Sie dieses {Gerät} löschen möchten?",
  "tip.currentNoDevice": "Derzeit sind keine Geräte verfügbar",
  "tip.currentNoDatalog": "Derzeit ist kein Kollektor verfügbar",
  "tip.messageInfo.storage": "Energiespeicherung",
  "tip.messageInfo.inverter": "Wechselrichter",
  "tip.messageInfo.microInverter": "Mikrorückwärts",
  "tip.userLocation": "Standort des Benutzers",
  "tip.ops.setDomainName": "Sind Sie sicher, dass Sie diesen Domainnamen einrichten möchten?",
  "tip.ops.restartDatalogger": "Sind Sie sicher, dass Sie den Collector neu starten möchten?",
  "tip.opsLog.addUser": "Endbenutzer hinzufügen",
  "tip.opsLog.bindSuccess": "Bindung erfolgreich",
  "tip.opsLog.selectDate": "Datum auswählen",
  "tip.opsLog.start": "Start",
  "tip.opsLog.end": "Ende",
  "tip.opsLog.upgrade": "Upgrade",
  "tip.opsLog.operation": "Betrieb",
  "tip.opsLog.communication": "Kommunikation",
  "tip.opsLog.type": "Typ",
  "tip.opsLog.content": "Inhalt",
  "tip.opsLog.control": "Controller",
  "tip.opsLog.command": "Befehlstyp",
  "tip.opsLog.reset": "Zurücksetzen",
  "tip.opsLog.serverTime": "Serverzeit",
  "tip.opsLog.inverter": "Intervall",
  "tip.opsLog.bindAgent": "Bindender Händler",
  "tip.opsLog.deleteDeviceSN": "Bitte bestätigen Sie, ob Sie es löschen möchten?",
  "tip.opsLog.recordLog": "Geräte, die protokolliert werden müssen",
  "tip.setting.productModelNumberRelevancyOn-gridPower": "Die netzgekoppelte Wirkleistung darf die Maximalleistung des ausgewählten Produktmodells nicht überschreiten",
  "productEquipment.productModelNumber": "Produktmodell",
  "productEquipment.warnMessage": "Alarminformationen",
  "productEquipment.customInstruction": "Benutzerdefinierte Anweisungen",
  "productEquipment.firmwareUpdate": "Firmware-Update",
  "productEquipment.historicalData": "historische Daten",
  "productEquipment.linkageInformation": "Verbindungsinformationen",
  "systemAuthority.systemSettings": "Systemeinstellungen",
  "systemAuthority.authorityManagement": "Berechtigung",
  "systemAuthority.accountManagement": "Rolle",
  "systemAuthority.Disabled": "Deaktivieren",
  "systemAuthority.enable": "Aktivieren",
  "org.ChangeSupplier": "Lieferanten wechseln",
  "weather.clearSky": "Klarer Himmel",
  "weather.fewClouds": "Ein paar Wolken",
  "weather.scatteredClouds": "Verstreute Wolken",
  "weather.brokenClouds": "Wolkig",
  "weather.overcastClouds": "Bedeckter Himmel",
  "weather.lightRain": "Leichter Regen",
  "weather.moderateRain": "Mäßiger Regen",
  "weather.heavyRain": "Starker Regen",
  "weather.thunderstormWithLightRain": "Gewitter mit leichtem Regen",
  "weather.thunderstormWithRain": "Gewitter mit Regen",
  "weather.thunderstormWithHeavyRain": "Gewitter mit starkem Regen",
  "weather.lightSnow": "Leichter Schneefall",
  "weather.snow": "Schnee",
  "weather.heavySnow": "Starker Schneefall",
  "weather.sleet": "Schneeregen",
  "weather.showerRain": "Regenschauer",
  "weather.lightShowerRain": "Leichte Regenschauer",
  "weather.heavyShowerRain": "Starke Regenschauer",
  "weather.mist": "Nebel",
  "weather.smoke": "Rauch",
  "weather.haze": "Dunst",
  "weather.dust": "Staub",
  "weather.fog": "Nebel",
  "weather.sand": "Sand",
  "weather.ash": "Asche",
  "weather.squall": "Sturmbö",
  "weather.tornado": "Tornado",
  "zh-CN": "Chinesisch",
  "en-US": "Englisch",
  "de-DE": "Deutsch",
  "fr-FR": "Französisch",
  "it-IT": "Italienisch",
  "uk-UA": "Ukrainisch",
  "th-TH": "Thailändisch",
  "nl-NL": "Niederländisch",
  "language.management": "Mehrsprachig",
  "sidebar.roleManagement": "Rolle",
  "user.userEmail": "Benutzer-E-Mail",
  "user.agentCode": "Agenten-Code",
  "user.phoneModel": "Telefonmodell",
  "user.phoneOs": "Telefon-Betriebssystem",
  "user.appVersion": "App-Version",
  "user.country": "Land",
  "user.createTime": "Erstellungszeit",
  "user.loginTime": "Anmeldezeit",
  "shipment.MdmCode": "MDM-Code",
  "product.createProduct": "Produkt erstellen",
  "shipment.MaterialCode": "MDM-Materialcode",
  "product.deviceSubclass": "Gerätetyp",
  "shipment.supplier": "Lieferant",
  "product.networkingMode": "Netzwerkmodus",
  "product.productImage": "Produktbild",
  "product.bluetoothIcon": "Bluetooth-Symbol",
  "product.uploadOneBluetoothIcon": "Es kann nur ein Bluetooth-Symbol hochgeladen werden",
  "product.UploadUpTo9Photos": "Bis zu 9 Fotos hochladen",
  "product.PleaseUploadNoBackground": "Bitte laden Sie Gerätebilder ohne Hintergrund hoch",
  "product.havePublished": "Veröffentlicht",
  "product.inDevelopment": "In Entwicklung",
  "shipment.haierSn": "Haier SN",
  "shipment.category": "Kategorie",
  "shipment.devType": "Entwicklungstyp",
  "log.operationEmail": "Betriebs-E-Mail",
  "log.deviceSn": "Geräte-SN",
  "log.opType": "Betriebsart",
  "log.opTime": "Betriebszeit",
  "log.operator": "Bedienungsperson",
  "log.operationDescription": "Betriebsbeschreibung",
  "log.content": "Betriebsinhalt",
  "log.params": "Parameter",
  "bTerminal.correlationDeleteTheDevice": "Wenn dieses Gerät gelöscht wird, werden die damit verbundenen Geräte ebenfalls gleichzeitig gelöscht. Möchten Sie wirklich löschen?",
  "role.action": "Aktion",
  "role.add.select.menu": "Bitte wählen Sie Menüressourcen",
  "role.addRole": "Rolle hinzufügen",
  "role.addTip": "Unterstützt die Berechtigungskonfiguration für Web- und B-Seite APP-Benutzer, aber nicht für C-Seite APP-Benutzer.",
  "role.applySuccess": "Einreichung erfolgreich",
  "role.appPermissions": "APP-Menüberechtigungen",
  "role.base": "Grundinformationen",
  "role.edit": "Bearbeiten",
  "role.exist": "Der Charakter existiert bereits",
  "role.info": "Details",
  "role.name": "Rollenname",
  "role.no": "Rollenummer",
  "role.not.empty": "Rolleninformationen können nicht leer sein",
  "role.per.user": "Jedem Benutzer kann nur eine Rolle zugewiesen werden",
  "role.permissions": "Datenberechtigungen",
  "role.status": "Rollenstatus",
  "role.submit": "Einreichen",
  "role.type": "Rollenart",
  "role.typeTip": "Installationsadministrator: Standardrolle für den Leiter der Installationsorganisation, es gibt nur eine im gesamten System. Installationsrolle: Rollen, die der Leiter der Installationsorganisation Mitarbeitern zuweisen kann, es können mehrere sein. Plattformrolle: Rollen, die von allen außer Installateuren genutzt werden können.",
  "role.updateTime": "Aktualisierungszeit",
  "role.webPermissions": "Web-Menüberechtigungen",
  "shipment.PleaseEnterMaterialCode": "Bitte geben Sie den MDM-Materialcode ein",
  "product.PleaseEnterSupplier": "Bitte geben Sie den Lieferanten ein",
  "common.reset": "Zurücksetzen",
  "common.confirm": "Bestätigen",
  "common.cancel": "Abbrechen",
  "common.save": "Konservierung",
  "common.delete": "löschen",
  "common.add": "Neu hinzugefügt",
  "common.edit": "bearbeiten",
  "common.update": "Aktualisieren",
  "common.submit": "Absenden",
  "common.tip": "erinnern",
  "common.success": "Erfolg",
  "common.fail": "fehlschlagen",
  "common.password": "Passwort",
  "common.handleFail": "Operation fehlgeschlagen",
  "common.required": "Erforderlich",
  "common.environmentChange": "Kontoumgebung geändert, Bestätigung erforderlich zum Aktualisieren des Kontos oder erneuten Anmelden",
  "common.noPermissions": "Noch keine Inhalte, bitte Administrator zur Konfiguration kontaktieren~",
  "plant.plantName": "Kraftwerksname",
  "plant.country": "Land/Region",
  "plant.installer": "Installateur",
  "plant.installPerson": "Monteur",
  "plant.plantOverview": "Übersicht des Kraftwerks",
  "plant.deviceList": "Geräteliste",
  "device.operationMonitoring": "Betriebsüberwachung",
  "device.parameterControl": "Parametersteuerung",
  "device.Fault&Alarm": "Fehler und Alarm",
  "device.dynamicPriceTip": "Der KI-Modus für dieses Gerät wurde vom Hausbesitzer aktiviert, Sie können diesen Parameter nicht speichern.",
  "device.paramRangeErrorDefault": "Parameterbereichsfehler, der Eingabebereich sollte ",
  "device.paramRangeError": "Parameterbereichsfehler",
  "plant.dataUpdate": "Datenaktualisierung",
  "plant.pleaseSelectDate": "Bitte wählen Sie ein Datum aus",
  "validate.requiredFormat": "Bitte geben Sie das Format entsprechend dem Beispiel ein",
  "plant.addStation": "Pflanze hinzufügen",
  "product.ProtocolCode": "IoT-Produkt-ID",
  "product.IoIDandPlatformSource": "IoT-Produkt-ID und Plattformquelle",
  "product.productIdCannotRepeat": "Produkt-ID darf nicht doppelt sein",
  "product.deviceTypeAccess.maxAddRows": "Es konnen maximal 2 Eintrage hinzugefugt werden",
  "product.accessPlatformCannotRepeat": "Plattformquelle darf nicht doppelt vorkommen",
  "product.productId": "Produkt-ID",
  "product.powerType": "Stromversorgung",
  "product.power": "Nennleistung kW",
  "system.taskCenter": "Aufgaben-Center",
  "task.name": "Aufgabenname",
  "task.type": "Aufgabentyp",
  "task.status": "Status",
  "task.createDate": "Erstellungsdatum",
  "task.progress": "Fortschritt",
  "task.view": "Anzeigen",
  "task.stop": "Stoppen",
  "task.stopConfirm": "Möchten Sie die Aufgabe wirklich stoppen?",
  "task.stopSuccess": "Aufgabe erfolgreich gestoppt",
  "task.stopFail": "Aufgabe konnte nicht gestoppt werden",
  "task.confirm": "Bestätigen",
  "task.cancel": "Abbrechen",
  "task.mutipleSearch": "Stapelsuche",
  "task.mutipleSend": "Stapelsendung",
  "task.taskDetail": "Aufgabendetails",
  "task.equipmentList": "Geräteliste",
  "task.fileLimit": "Nur xls/xlsx-Dateien können hochgeladen werden",
  "task.reChoose": "Liste leeren und neu auswählen",
  "task.tip": "Datei hierher ziehen, oder",
  "task.upload": "Klicken zum Hochladen",
  "task.templateDownload": "Vorlage herunterladen",
  "task.mutipleHandleParams": "Stapelverarbeitungsparameter",
  "common.previousStep": "Vorheriger Schritt",
  "task.requiredProductModel": "Bitte wählen Sie ein Produktmodell aus",
  "task.requiredEquipmentList": "Bitte laden Sie die Geräteliste hoch",
  "task.equipmentListTip": "Die Tabellendaten sind leer oder der Upload ist fehlgeschlagen, bitte überprüfen",
  "task.requiredParameter": "Bitte wählen Sie einen Parameter aus",
  "task.writeValue": "Wert schreiben",
  "task.progressRate": "Fertigstellungsgrad",
  "task.readTime": "Lesezeit",
  "task.sendTime": "Sendezeit",
  "task.mutipleSearchTemplate": "Stapelsuchvorlage",
  "task.mutipleSendTemplate": "Stapelsendevorlage",
  "task.uploadSuccess": "Hochladen erfolgreich",
  "task.sendSuccess": "Aufgabe erfolgreich erstellt",
  "task.inProgress": "In Bearbeitung",
  "task.completed": "Abgeschlossen",
  "task.failed": "Fehlgeschlagen",
  "task.success": "Erfolgreich",
  "system.configureImport": "Konfigurationsimport",
  "product.DeviceHlepInstructions": "Gerätshilfe",
  "product.addDeviceHlepInstructions": "Gerätshilfe hinzufügen",
  "product.deviceInstallationGuideFirst": "Bitte laden Sie Geräteinstallationsanleitungsbilder hoch, um Installateure Schritt für Schritt durch Installation und APP-Operationen zu führen.",
  "product.deviceInstallationGuideSecond": "Es wird empfohlen, Anweisungen für den Eintritt in den Geräte-Netzwerkkonfigurationsmodus, SN-QR-Code-Position, Standorterstellung, Gerätehinzufügung, Bluetooth-Operationen, Schnellkonfiguration usw. einzuschließen.",
  "product.mdnTip": "Erste 9 Ziffern der Haier SN",
  "Firmware.secretType": "Verschlüsselungsmethode",
  "common.copySuccess": "Kopieren erfolgreich",
  "bTerminal.ModifyTheNameOfTheDevice": "Gerätenamen ändern",
  "bTerminal.changeFailed": "Änderung fehlgeschlagen",
  "bTerminal.OnlyWithin100Characters": "Beschränkt auf 100 Zeichen oder weniger in Chinesisch, Englisch und Zahlen",
  "bTerminal.OnlyWithin30Characters": "Beschränkt auf 30 Zeichen oder weniger in Chinesisch, Englisch und Zahlen",
  "bTerminal.rename": "Umbenennen",
  "sidebar.prefill": "Bewertungen & Feedback",
  "paramters.basicInformation": "Grundinformationen",
  "paramters.DCSide": "Gleichstromseite",
  "paramters.ACSide": "Wechselstromseite",
  "paramters.stringCurrent": "String-Strom",
  "paramters.moreParamters": "Weitere Informationen",
  "paramters.debugInformation": "Debug-Informationen",
  "paramters.current": "Strom",
  "paramters.voltage": "Spannung",
  "paramters.power": "Leistung",
  "paramters.init": "Initialisierung",
  "paramters.wait": "Warten",
  "paramters.normal": "Normal",
  "paramters.abnormal": "Fehler",
  "paramters.burn": "Einbrennen",
  "system.reportCenter": "Berichtszentrum",
  "system.reportMonth": "Monatsbericht",
  "system.reportYear": "Jahresbericht",
  "system.selfServiceReport": "Selbstbedienung",
  "system.selfServiceReport.hour": "Stunde",
  "system.selfServiceReport.selectPlant": "Bitte Kraftwerk auswählen",
  "system.selfServiceReport.selectYear": "Jahr auswählen",
  "system.selfServiceReport.metricSelection": "Indikatorauswahl",
  "system.selfServiceReport.required": "Erforderlich",
  "system.selfServiceReport.startTimeCannotBeLater": "Die Startzeit darf nicht später als die Endzeit sein",
  "system.selfServiceReport.fieldIsRequired": "{field} ist erforderlich",
  "system.selfServiceReport.hourTimeTooltipLine1": "Stunde steht für die 1-stündige Periode ab dieser vollen Stunde",
  "system.selfServiceReport.hourTimeTooltipLine2": "(z. B. 15:00 = 15:00–15:59)",
  "report.exportAll": "Alle exportieren",
  "report.installedCapacity": "Installierte Leistung",
  "report.capacityErrorTip": "Der Filterbereich für die installierte Leistung ist ungültig",
  "report.exportFailed": "Export fehlgeschlagen, bitte versuchen Sie es später erneut",
  "report.firstChoiceTime": "Bitte wählen Sie zuerst ein Datum aus, bevor Sie exportieren",
  "placeholder.selectScope": "Bitte wählen Sie {scope}",
  "register.accountVerification": "Kontoverifizierung",
  "register.companyRegistration": "Firmenregistrierung",
  "register.staffRegistration": "Mitarbeiterregistrierung",
  "register.companyInfo": "Geben Sie unten Firmeninformationen an",
  "register.companyFullName": "Vollständiger Firmenname",
  "register.installationCountryNotice": "Bitte wählen Sie sorgfältig das Land aus, in dem der Installateur registriert ist. Sie können das System nicht außerhalb des Registrierungsbereichs installieren.",
  "register.detailAddress": "Detaillierte Adresse",
  "register.postalCode": "Postleitzahl",
  "register.contactName": "Kontaktname",
  "register.contactInfo": "Kontakt-Telefon oder E-Mail",
  "register.applyJoinCompany": "Antrag auf Firmenbeitritt",
  "register.companyCodeInfo": "Bitte füllen Sie den Firmencode und persönliche Informationen aus, um einem registrierten Unternehmen beizutreten",
  "register.registrationCode": "Firmenregistrierungscode",
  "register.codeHint": "Code kann durch Kontaktaufnahme mit dem Unternehmensadministrator erhalten werden",
  "register.realName": "Name",
  "register.accountVerificationInfo": "Wählen Sie eine der folgenden Methoden zur Kontoregistrierung",
  "register.emailRegistration": "E-Mail-Registrierung",
  "register.sixDigitCode": "6-stelliger Bestätigungscode",
  "register.getVerificationCode": "Bestätigungscode erhalten",
  "register.resendAfterSeconds": "Nach {seconds}s erneut senden",
  "register.resendAfterMinutes": "Nach {minutes}min erneut senden",
  "register.resendAfterMinutesSeconds": "Nach {minutes}min{seconds}s erneut senden",
  "register.password6to20": "6-20 Zeichen Passwort",
  "register.password8to20": "8-20 Zeichen Passwort",
  "register.phoneNumber": "Telefonnummer",
  "register.phoneRegistration": "Telefonregistrierung",
  "register.optionalEmail": "Optional: E-Mail-Adresse",
  "register.previousPage": "Vorherige Seite",
  "register.goToLogin": "Zur Anmeldung",
  "register.completeRegistration": "Registrierung abschließen",
  "register.accountAlreadyRegistered": "Diese E-Mail oder Telefonnummer ist bereits registriert. Bitte anmelden oder eine andere verwenden.",
  "register.emailAlreadyRegistered": "Diese E-Mail ist bereits registriert. Bitte melden Sie sich direkt an oder verwenden Sie ein anderes Konto.",
  "register.phoneAlreadyRegistered": "Diese Telefonnummer ist bereits registriert. Bitte melden Sie sich direkt an oder verwenden Sie ein anderes Konto.",
  "register.companyAlreadyRegistered": "Firma '{companyName}' ist bereits registriert",
  "register.companyExistOptions": "Sie können zurückkehren, um den Firmennamen zu ändern, oder beantragen, dieser Firma beizutreten",
  "register.returnToModify": "Zurück zum Ändern",
  "register.companyRegisteredApplyJoin": "Beitritt beantragen",
  "register.companyRegisteredApplyJoinFull": "Unternehmen bereits registriert? Antrag auf Beitritt",
  "register.validation.selectCountry": "Bitte wählen Sie Land/Region",
  "register.validation.selectCity": "Bitte wählen Sie Stadt",
  "register.validation.enterDetailAddress": "Bitte geben Sie detaillierte Adresse ein",
  "register.validation.enterCorrectPostalCode": "Bitte geben Sie korrektes Postleitzahlenformat ein",
  "register.validation.enterContactName": "Bitte geben Sie Kontaktname ein",
  "register.validation.enterRegistrationCode": "Bitte geben Sie Firmenregistrierungscode ein",
  "register.validation.enterYourName": "Bitte geben Sie Ihren Namen ein",
  "register.validation.enterPassword": "Bitte geben Sie Passwort ein",
  "register.validation.passwordLength": "Passwortlänge muss 6-20 Zeichen betragen",
  "register.validation.passwordLength8to20": "Passwortlänge muss 8-20 Zeichen betragen",
  "register.validation.passwordComplexity": "Passwort muss mindestens drei verschiedene Zeichentypen enthalten (Zahlen, Großbuchstaben, Kleinbuchstaben, Sonderzeichen)",
  "register.validation.enterPasswordAgain": "Bitte geben Sie das Passwort erneut ein",
  "register.validation.passwordMismatch": "Die beiden Passwörter stimmen nicht überein",
  "register.validation.correctPhoneFormat": "Bitte geben Sie korrektes Telefonnummernformat ein",
  "register.validation.correctPhoneOrEmailFormat": "Bitte geben Sie korrektes Telefonnummer- oder E-Mail-Format ein",
  "register.validation.correctEmailFormat": "Bitte geben Sie korrektes E-Mail-Format ein",
  "register.validation.enterVerificationCode": "Bitte geben Sie Bestätigungscode ein",
  "register.validation.sixDigitNumber": "Bestätigungscode muss 6 Ziffern haben",
  "register.validation.enterCompanyName": "Bitte geben Sie Firmennamen ein",
  "register.validation.companyRegisteredChooseAction": "Firma bereits registriert, bitte wählen Sie eine Aktion",
  "register.message.searchCompanyFailed": "Firmensuche fehlgeschlagen",
  "register.message.checkCompanyStatusFailed": "Überprüfung des Firmenstatus fehlgeschlagen",
  "register.message.getCityListFailed": "Abrufen der Städteliste fehlgeschlagen",
  "register.message.companyRegisteredChooseAction": "Firma bereits registriert, bitte wählen Sie eine Aktion",
  "register.message.completeCompanyInfo": "Bitte vervollständigen Sie die Firmeninformationen",
  "register.message.completeStaffInfo": "Bitte vervollständigen Sie die Mitarbeiterinformationen",
  "register.message.enterEmailFirst": "Bitte geben Sie zuerst die E-Mail-Adresse ein",
  "register.message.correctEmailFormat": "Bitte geben Sie korrektes E-Mail-Format ein",
  "register.message.verificationCodeSent": "Bestätigungscode gesendet an: {contact}",
  "register.message.sendVerificationCodeFailed": "Senden des Bestätigungscodes fehlgeschlagen",
  "register.message.enterPhoneFirst": "Bitte geben Sie zuerst die Telefonnummer ein",
  "register.message.correctPhoneFormat": "Bitte geben Sie korrektes Telefonnummernformat ein",
  "register.message.completeAccountInfoAndFixErrors": "Bitte vervollständigen Sie die Kontoinformationen und beheben Sie Fehler",
  "register.message.companyRegistrationSuccess": "Firmenregistrierung erfolgreich!",
  "register.message.companyRegistrationFailed": "Firmenregistrierung fehlgeschlagen",
  "register.message.staffRegistrationSuccess": "Mitarbeiterregistrierung erfolgreich!",
  "register.message.staffRegistrationFailed": "Mitarbeiterregistrierung fehlgeschlagen",
  "register.message.phoneRegistrationNotAvailable": "Die Registrierung per Telefonnummer ist derzeit nicht verfügbar. Bitte bleiben Sie dran.",
  "register.tooltip.title": "Wie finde ich den Firmen-Registrierungscode?",
  "register.tooltip.appPathTitle": "1. In der App",
  "register.tooltip.appPathDesc": "Öffnen Sie Benutzer -> Avatar antippen -> Kontoinformationen, um den Firmen-Registrierungscode anzuzeigen.",
  "register.tooltip.webPathTitle": "2. Im Web-Backend",
  "register.tooltip.webPathDesc": "Gehen Sie zu Organisationsverwaltung -> Organisationsinformationen, um den Firmen-Registrierungscode anzuzeigen.",
  "registerAccomplish.applicationComplete": "Antrag abgeschlossen",
  "registerAccomplish.congratulations": "Herzlichen Glückwunsch, Sie haben die Registrierung abgeschlossen.",
  "registerAccomplish.companyRegisterCodeIs": "Ihr Unternehmensregistrierungscode lautet",
  "registerAccomplish.certificationRequired": "Sie müssen zum Zertifizierungszentrum gehen, um sich zu authentifizieren, andernfalls können Sie keine Geräte aktivieren.",
  "registerAccomplish.greenChannelInfo": "Für besondere Notfallsituationen in Abteilungen können Sie den grünen Kanal wählen, um eine temporäre Berechtigung zur Geräteaktivierung für 2 Monate zu erhalten, damit die Vor-Ort-Installation nicht verzögert wird.",
  "registerAccomplish.certificationCenter": "Zertifizierungszentrum",
  "registerAccomplish.greenChannel": "Grüner Kanal",
  "registerAccomplish.returnToLogin": "Zurück zur Anmeldeseite",
  "registerAccomplish.useHaierEnergyApp": "Sie können die Haier Energy APP verwenden, um Geräte hinzuzufügen.",
  "registerAccomplish.applyingGreenChannel": "Sie beantragen den grünen Kanal",
  "registerAccomplish.greenChannelDescription1": "Dieser Kanal ist nur für einige besondere Notfallsituationen gedacht, um Verzögerungen bei der Vor-Ort-Installation zu vermeiden und Geräte zu aktivieren.",
  "registerAccomplish.greenChannelDescription2": "Die über diesen Kanal erhaltenen Kontoberechtigungen sind temporäre Berechtigungen, und die Gültigkeitsdauer für die Geräteaktivierung beträgt 2 Monate.",
  "registerAccomplish.greenChannelDescription3": "Sie müssen innerhalb von 2 Monaten zum Zertifizierungszentrum gehen, um die Authentifizierung abzuschließen und permanente Berechtigung zur Geräteaktivierung zu erhalten.",
  "registerAccomplish.confirmSubmit": "Bestätigen und Einreichen",
  "registerAccomplish.returnToPrevious": "Zurück zur vorherigen Seite",
  "registerAccomplish.applicationSubmittedSuccessfully": "Ihr Antrag wurde erfolgreich eingereicht!",
  "registerAccomplish.missingAgentIdParameter": "AgentId-Parameter fehlt, kann nicht für grünen Kanal beantragen",
  "registerAccomplish.greenChannelApplicationSuccess": "Grüner Kanal Antrag erfolgreich!",
  "registerAccomplish.greenChannelApplicationFailed": "Grüner Kanal Antrag fehlgeschlagen",
  "registerAccomplish.enterSystem": "System betreten",
  "registerAccomplish.pleaseLoginFirst": "Bitte melden Sie sich zuerst an",
  "org.phoneNumber": "Telefonnummer",
  "org.certificationStatus": "Zertifizierungsstatus",
  "org.permission": "Berechtigung",
  "org.accountSource": "Kontenquelle",
  "org.certificationStatusTip": "Derzeit nur für die Berechtigung zum Hinzufügen von Geräten in der Haier Energy App",
  "org.unauthenticated": "Nicht authentifiziert",
  "org.authenticated": "Authentifiziert",
  "org.noNeedToAuthenticate": "Keine Authentifizierung erforderlich",
  "org.unauthorized": "Nicht autorisiert",
  "org.authorized": "Autorisiert",
  "org.temporaryAuthorization": "Temporäre Autorisierung",
  "org.remainingDays": "Verbleibende Tage: {scope} Tage",
  "org.allocated": "Zugewiesen",
  "org.registered": "Registriert",
  "org.authorization": "Autorisierung",
  "org.addressDetail": "Adressdetails",
  "org.postalCode": "Postleitzahl",
  "org.accountSwitch": "Kontenwechsel",
  "org.viewAccountInfo": "Kontoinformationen anzeigen",
  "org.baseInfo": "Grundinformationen",
  "org.certificationInfo": "Zertifizierungsinformationen",
  "org.restDays": "Verbleibende Tage",
  "org.applyTime": "Antragszeit",
  "org.certificationTime": "Zertifizierungszeit",
  "org.registerCode": "Registrierungscode",
  "org.registrationTip": "Beim Registrieren können Sie den Unternehmensregistrierungscode eingeben, um die Mitgliedschaft im Unternehmen zu beantragen.",
  "org.authenticationTip": "Dieses Konto wurde deaktiviert und kann nicht autorisiert werden.",
  "org.authenticationTip2": "Dieses Konto wurde bereits autorisiert oder hat eine temporäre Autorisierung, die noch nicht abgelaufen ist. Eine erneute Autorisierung ist nicht möglich.",
  "org.temporaryAuthorizationTip": "Die Autorisierung ist temporär und beträgt standardmäßig 3 Monate.",
  "org.temporaryAuthorizationSuccess": "Autorisierung erfolgreich",
  "report.allSelect": "Alle auswählen",
  "report.compare": "Vergleichen",
  "report.energy": "Wirkleistung",
  "report.ipv": "DC-Strom",
  "report.vpv": "DC-Spannung",
  "report.fac": "Wechselstromfrequenz",
  "report.vac": "Wechselspannung",
  "report.iac": "Wechselstrom",
  "report.temperature": "Innentemperatur",
  "report.str_cur": "Strangstrom",
  "report.inverterCompare": "Wechselrichtervergleich",
  "report.inverterCompareTip": "Bereits zur Liste hinzugefügt, bitte nicht erneut hinzufügen",
  "report.pleaseChooseInverter": "Bitte wählen Sie einen Wechselrichter aus",
  "report.pleaseChooseCompare": "Bitte wählen Sie die Vergleichsparameter aus",
  "report.compareItem": "Vergleichsparameter",
  "system.inverterCompare": "Wechselrichterparametervergleich",
  "shipment.deviceSource": "Versandquelle",
  "shipment.shippingCustomer": "Versandkunde",
  "shipment.customerContact": "Kundenkontakt",
  "shipment.tag": "Tag",
  "shipment.addTag": "Tag hinzufügen",
  "shipment.editTag": "Tag bearbeiten",
  "shipment.tagContent": "Tag-Inhalt",
  "shipment.tagColor": "Tag-Farbe",
  "placeholder.selectShippingCustomer": "Bitte wählen Sie den Versandkunden aus",
  "placeholder.enterCustomerContact": "Bitte geben Sie den Kundenkontakt ein",
  "placeholder.selectTag": "Bitte wählen Sie ein Tag aus",
  "placeholder.enterTagContent": "Bitte geben Sie den Tag-Inhalt ein",
  "placeholder.noResult": "Keine passenden Tags",
  "validation.enterTagContent": "Bitte geben Sie den Tag-Inhalt ein",
  "validation.selectTagColor": "Bitte wählen Sie die Tag-Farbe aus",
  "shipment.operationRecordTitle": "Historique des opérations",
  "shipment.boundUserWarning": "Cet appareil est déjà associé à un utilisateur, le client d'expédition ne peut pas être modifié.",
  "shipment.batchBoundUserWarning": "Вибачте, вибрані пристрої містять пристрої, які вже прив'язані до користувачів, клієнта відвантаження неможливо оновити масово.",
  "shipment.uploadEquipmentListRequired": "Veuillez téléverser le fichier de la liste des équipements",
  "shipment.errorDataTipTitle": "Alerte de données anormales",
  "shipment.downloadImportResult": "Télécharger le résultat de l'import",
  "shipment.downloading": "Téléchargement...",
  "shipment.noFailedDataToDownload": "Aucune donnée en échec à télécharger",
  "shipment.deleteTagConfirm": "Êtes-vous sûr de vouloir supprimer l'étiquette \"{tagName}\" ?",
  "common.addSuccess": "Ajout réussi",
  "common.editSuccess": "Modification réussie",
  "product.basicProperties": "Grundlegende Eigenschaften",
  "product.specialProperties": "Spezielle Eigenschaften",
  "product.platformRelated": "Plattformbezogen",
  "product.maxPvChannels": "Maximal unterstützte PV-Strings",
  "product.componentManufacturer": "Modulhersteller",
  "product.componentType": "Modultyp",
  "product.ratedPower": "Nennleistung",
  "product.mppVoltage": "MPP-Spannung",
  "product.mppCurrent": "MPP-Strom",
  "product.openCircuitVoltage": "Leerlaufspannung",
  "product.shortCircuitCurrent": "Kurzschlussstrom",
  "product.maxPowerTempCoeff": "Temperaturkoeffizient der Maximalleistung",
  "product.openVoltageTempCoeff": "Temperaturkoeffizient der Leerlaufspannung",
  "product.shortCurrentTempCoeff": "Temperaturkoeffizient des Kurzschlussstroms",
  "product.componentEfficiency": "Nominale Modulwirkungsgrad",
  "product.firstYearDegradation": "Erstes Jahr Degradation",
  "product.annualDegradation": "Jährliche Degradation",
  "product.fillFactor": "Füllfaktor",
  "product.placeholder.range_0_9999_2dp": "0-9999, bis zu 2 Dezimalstellen",
  "product.placeholder.range_0_99_2dp": "0-99, bis zu 2 Dezimalstellen",
  "product.placeholder.range_0_999_2dp": "0-999, bis zu 2 Dezimalstellen",
  "product.placeholder.range_neg1_1_2dp": "-1 bis 1, bis zu 2 Dezimalstellen",
  "product.rule.range_0_9999_2dp": "Zahl zwischen 0-9999, bis zu 2 Dezimalstellen",
  "product.rule.range_0_99_2dp": "Zahl zwischen 0-99, bis zu 2 Dezimalstellen",
  "product.rule.range_0_999_2dp": "Zahl zwischen 0-999, bis zu 2 Dezimalstellen",
  "product.rule.range_neg1_1_2dp": "Zahl zwischen -1 und 1, bis zu 2 Dezimalstellen",
  "product.ivScanSupport": "Unterstützt IV-Kurvenscan",
  "system.intelligentDiagnosis": "Intelligente Diagnose",
  "system.ivline": "IV-Kennlinie",
  "subtitle.ivlineCreate": "Scan-Aufgabe",
  "diagnosis.diagnosisTime": "Diagnosis Time",
  "diagnosis.faultQuantity": "Fault Quantity",
  "diagnosis.scanCompleteTime": "Scan Complete Time",
  "diagnosis.scanProgress": "Scan Progress",
  "diagnosis.newTask": "New Task",
  "diagnosis.deleteTask": "Delete Task",
  "diagnosis.deleteTaskSuccess": "Task deleted successfully",
  "diagnosis.closeAll": "Clear All",
  "diagnosis.startScan": "Start Scan",
  "diagnosis.pleaseChooseInverter": "Please select inverter",
  "diagnosis.stringSetting": "String Setting",
  "diagnosis.taskSetting": "Task Setting",
  "diagnosis.batchComponentSetting": "Batch Component Setting",
  "diagnosis.componentType": "Component Type",
  "diagnosis.maxPower": "Maximum Power (Pmax)",
  "diagnosis.bestWorkingVoltage": "Optimum Operating Voltage (Vmpp)",
  "diagnosis.bestWorkingCurrent": "Optimum Operating Current (Impp)",
  "diagnosis.openCircuitVoltage": "Open Circuit Voltage (Voc)",
  "diagnosis.shortCircuitCurrent": "Short Circuit Current (Isc)",
  "diagnosis.maxPowerTemperatureCoefficient": "Temperature Coefficient of Maximum Power",
  "diagnosis.openCircuitVoltageTemperatureCoefficient": "Temperature Coefficient of Open Circuit Voltage",
  "diagnosis.shortCircuitCurrentTemperatureCoefficient": "Temperature Coefficient of Short Circuit Current",
  "diagnosis.nominalComponentConversionEfficiency": "Nominal Component Conversion Efficiency",
  "diagnosis.firstYearDecayRate": "First-Year Degradation Rate",
  "diagnosis.yearlyDecayRate": "Annual Degradation Rate",
  "diagnosis.fillFactor": "Fill Factor",
  "diagnosis.componentManufacturer": "Component Manufacturer",
  "diagnosis.componentAmount": "Component Quantity",
  "diagnosis.capacity": "String Capacity",
  "diagnosis.stringAmount": "String Count (pcs)",
  "diagnosis.inverterSerialNumber": "Inverter Serial Number",
  "diagnosis.totalCapacity": "Total String Capacity",
  "diagnosis.pleaseFillInAllItems": "Incomplete fields, please check",
  "diagnosis.moreParamters": "More Parameters",
  "diagnosis.envParam": "Environmental Parameters",
  "diagnosis.startTask": "Start Task",
  "diagnosis.startTaskSuccess": "Task started successfully",
  "diagnosis.start": "Start",
  "diagnosis.noDevice": "No device found",
  "register.contactAdminForCode": "Bitte wenden Sie sich an Ihren Unternehmensadministrator, um den Unternehmensregistrierungscode zu erhalten",
  "register.provideCompanyInfoBelow": "Bitte geben Sie unten die Unternehmensinformationen an",
  "login.success": "Login erfolgreich",
  "flowData.existingInvTip": "Hinweis:\nExistierender INV > 0 bedeutet, dass die Solaranlage Strom erzeugt;\nExistierender INV < 0 bedeutet, dass der Wechselrichter Strom verbraucht.",
  "flowData.alert": "Der aktuelle Wert Existing INV < 0 zeigt an, dass der externe Wechselrichter Leistung verbraucht.",
  "dialog.confirm": "Ich verstehe",
  "paramters.deviceTotalInformation": "Gesamtgeräteinformation",
  "paramters.innerInverter": "Interner Wechselrichter",
  "paramters.outerInverter": "Externer Wechselrichter",
  "paramters.outerInverterFromPvSide": "Von Zähler der PV-Seite",
  "paramters.activePower": "Wirkleistung",
  "paramters.apparentPower": "Scheinleistung",
  "paramters.reactivePower": "Blindleistung",
  "paramters.powerFactor": "Leistungsfaktor",
  "paramters.phaseA": "Phase A",
  "paramters.phaseB": "Phase B",
  "paramters.phaseC": "Phase C",
  "paramters.charge": "Laden",
  "paramters.discharge": "Entladen",
  "paramters.sell": "Strom verkaufen",
  "paramters.buy": "Strom kaufen",
  "bw_param_ctrl_group_WorkMode": "Betriebsmodus",
  "bw_param_ctrl_name_GRID_Meter_negate": "GRID_Meter_negate",
  "bw_param_ctrl_name_GridBreake": "Netzschalter",
  "bw_param_ctrl_name_BBSOC_lx1": "SOC für L1 Power-Off",
  "bw_param_ctrl_name_BBSOC_lx2": "SOC für L2 Power-Off",
  "bw_param_ctrl_name_BBSOC_lx3": "SOC für L3 Power-Off",
  "bw_param_ctrl_option_ON": "EIN",
  "bw_param_ctrl_name_Systemmode": "Systemmodus",
  "bw_param_ctrl_name_UPSReserveSoc": "UPS-Reserve-SOC",
  "bw_param_ctrl_option_OFF": "AUS",
  "bw_param_ctrl_option_B5": "Einphasiges 5-kW-Modell",
  "bw_param_ctrl_name_DispatchActivepower": "Aktive Einspeiseleistung",
  "bw_param_ctrl_option_withoutBattery": "Ohne Batterie",
  "bw_param_ctrl_name_InvSub": "Inv unter",
  "bw_param_ctrl_name_MAXFeedintogridpercent": "MAX Einspeisung im Netzprozent",
  "bw_param_ctrl_option_T4": "Dreiphasiges 4-kW-Modell",
  "bw_param_ctrl_option_T5": "Dreiphasiges 5-kW-Modell",
  "bw_param_ctrl_option_T6": "Dreiphasiges 6-KW-Modell",
  "bw_param_ctrl_option_T8": "Dreiphasiges 8-kW-Modell",
  "bw_param_ctrl_option_S3": "Einphasen-Energiespeicher 3kW-Modell",
  "bw_param_ctrl_option_S5": "Einphasige Energiespeicherung 5Kw-Modell",
  "bw_param_ctrl_option_S6": "Einphasen-Energiespeicher 6Kw-Modell",
  "bw_param_ctrl_option_S8": "Einphasige Energiespeicherung 8Kw Modell",
  "bw_param_ctrl_option_Grid&PV useCT": "Netz&PV mit Stromwandler",
  "bw_param_ctrl_note_MAXFeedintogridpercent": "Verhältnis der maximalen Einspeisleistung zur installierten PV-Kapazität (einschließlich aller an den PV-Wechselrichter und den Energiespeicher angeschlossenen PV-Kapazität)",
  "bw_param_ctrl_option_Grid&PVUseMeter": "Netz&PV mit Zähler",
  "bw_param_ctrl_note_PVCapacityofGridInverter": "Insgesamt installierte PV-Kapazität mit Energiespeicher-Wechselrichter verbunden",
  "bw_param_ctrl_option_T10": "Dreiphasiges 10-kW-Modell",
  "bw_param_ctrl_name_DispatchReactivepower": "Blindleistungssteuerung",
  "bw_param_ctrl_name_Grid_Regulation": "Netzregelung",
  "bw_param_ctrl_option_Enablecharge&dischargeTimePeriodControl": "Lade/Entlade-Zeitsteuerung aktivieren",
  "bw_param_ctrl_name_Timeperiodcontrolflag": "Zeitsteuerungs-Flag",
  "bw_param_ctrl_note_BatteryReady": "Standardmäßig ist die Batterieverbindung \"mit Batterie\". Wenn keine Batterie angeschlossen ist (d.h. der Wechselrichter ist an PV angeschlossen, aber nicht an Batteriemodule), wählen Sie \"ohne Batterie\" aus, oder das Gerät wird nach einer Batterie suchen, die nicht vorhanden ist und in den Fehlermodus eintritt.",
  "bw_param_ctrl_option_withBattery": "Mit Batterie",
  "bw_param_ctrl_name_PV_Meter_negate": "PV_Meter_negate",
  "bw_param_ctrl_option_OnlyEnableDischargeTimePeriodControl": "Only Enable discharge Time period control",
  "bw_param_ctrl_name_EMSReset": "Ems Reset",
  "bw_param_ctrl_name_FactoryReset": "Fabrikneustart",
  "bw_param_ctrl_name_DSPReset": "Dsp-Reset",
  "bw_param_ctrl_group_RemoteReset": "Remote Zurücksetzen",
  "bw_param_ctrl_option_FactoryReset": "Zurücksetzen",
  "bw_param_ctrl_option_DSPReset": "Zurücksetzen",
  "bw_param_ctrl_option_EMSReset": "Zurücksetzen",
  "bw_param_ctrl_group_BackupBox": "Backup Box",
  "bw_param_ctrl_name_BBPrio_lx1": "L1 Strategie Priorität",
  "bw_param_ctrl_name_BBPrio_lx2": "Priorität der L2-Strategie",
  "bw_param_ctrl_name_BBPrio_lx3": "Priorität der L3-Strategie",
  "bw_param_ctrl_note_BBSOC_lx3": "Der SOC der Priorität 3 muss höher sein als der SOC der Priorität 1 und der SOC der Priorität 2.",
  "bw_param_ctrl_note_BBSOC_lx1": "Der SOC von Priorität 1 muss der min.SOC von L1, L2 und L3 sein.",
  "bw_param_ctrl_note_BBSOC_lx2": "Der SOC von Priorität 2 muss höher sein als der SOC mit Priorität 1.",
  "bw_param_ctrl_option_1": "1",
  "bw_param_ctrl_option_3": "3",
  "bw_param_ctrl_option_2": "2",
  "bw_param_ctrl_name_BBLoadEnable": "Backup-Box aktivieren",
  "bw_param_ctrl_name_MeterCTSelect": "Zählertransformator-Auswahl",
  "bw_param_ctrl_option_GridUse CT&PVUseMeter": "Netz mit CT, PV mit Zähler",
  "bw_param_ctrl_name_ChargeCutSoc": "Ladestopp-SOC",
  "bw_param_ctrl_option_HybridMode": "Hybridmodus",
  "bw_param_ctrl_name_PVCapacityStorage": "PV-Speicherkapazität",
  "bw_param_ctrl_name_DispatchTime": "Einsatzsteuerungszeit",
  "bw_param_ctrl_name_DispatchStart": "Einsatzsteuerung Start",
  "bw_param_ctrl_name_UPSreserveenable": "UPS-Reserve aktivieren",
  "bw_param_ctrl_option_selfuse": "Eigenverbrauch",
  "bw_param_ctrl_option_DCMode": "DC-Modus",
  "bw_param_ctrl_name_PVCapacityofGridInverter": "PV-Kapazität des Netzwechselrichters",
  "bw_param_ctrl_name_RTC": "RTC",
  "bw_param_ctrl_option_Normal": "Normal",
  "bw_param_ctrl_group_SystemInfo": "Systeminformationen",
  "bw_param_ctrl_note_Systemmode": "DC: 1. Neu installiertes PV-System mit hybridem Energiespeicher-Wechselrichter, der direkt an PV-Panels angeschlossen wird. 2. Batteriesystem ohne PV-Wechselrichter, der direkt an das Netz angeschlossen wird und nur vom Netz aufgeladen wird\n\nAC: Nachrüstung des PV-Systems, das einen PV-Wechselrichter enthält, der an PV-Panels und das Netz angeschlossen wird. Panels können nicht direkt an den hybriden Energiespeicher-Wechselrichter angeschlossen werden.\n\nHybrid: Das gesamte System umfasst einen PV-Wechselrichter, der an das Netz angeschlossen wird, und einen Hybrid-Energiespeicher-Wechselrichter, der direkt an PV-Panels angeschlossen wird.",
  "bw_param_ctrl_group_GridMeterSettings": "Netzzählereinstellungen",
  "bw_param_ctrl_option_Forced charging and discharging": "Erzwungenes Laden/Entladen",
  "bw_param_ctrl_note_ChargeCutSoc": "Die obere Grenze der Batterie SOC Ladung.",
  "bw_param_ctrl_option_OnlyEnableChargeTimeperiod control": "Nur Ladezeitsteuerung aktivieren",
  "bw_param_ctrl_option_Disable": "Deaktivieren",
  "bw_param_ctrl_group_BatterySettings": "Batterieeinstellungen",
  "bw_param_ctrl_name_BatteryReady": "Batteriebereitschaft",
  "bw_param_ctrl_option_GridUse Meter&PVUseCT": "Netz mit Zähler, PV mit CT",
  "bw_param_ctrl_name_DispatchSOC": "Einsatzsteuerungs-SOC",
  "bw_param_ctrl_option_Disable TimePeriodControl": "Zeitsteuerung deaktivieren",
  "bw_param_ctrl_option_Enable": "Aktivieren",
  "bw_param_ctrl_option_TOU": "TOU (Zeitvariable Tarife)",
  "bw_param_ctrl_name_ChargeTimeSlot1": "Ladezeitfenster 1",
  "bw_param_ctrl_name_ChargeTimeSlot2": "Ladezeitfenster 2",
  "bw_param_ctrl_note_Timeperiodcontrolflag": "Die Lade- und Entladeeinstellungen treten erst in Kraft, wenn der Modus \"TOU\" ausgewählt ist.",
  "bw_param_ctrl_group_GridSafetyConfig": "Netzsicherheitskonfig",
  "bw_param_ctrl_group_SystemConfig": "Systemkonfiguration",
  "bw_param_ctrl_option_ACMode": "AC-Modus",
  "bw_param_ctrl_option_Reverse": "Invertiert",
  "bw_param_ctrl_option_NotEnabledChargeSetting": "Die Lade-/Entladefunktion ist nicht aktiviert",
  "bw_param_ctrl_group_Charge&DischargeSettings": "Lade/Entlade-Einstellungen",
  "bw_param_ctrl_name_DispatchMode": "Einsatzsteuerungsmodus",
  "bw_param_ctrl_note_GridBreake": "Bitte wählen Sie nach den tatsächlichen Spezifikationen des Schalters auf der Netzseite des Wechselrichters. Wenn die Spezifikation falsch ausgefüllt ist, kann dies dazu führen, dass der Leistungsschalter auslöst.",
  "bw_param_ctrl_note_PVCapacityStorage": "Insgesamt installierte PV-Kapazität, die an den PV-Wechselrichter angeschlossen ist",
  "bw_param_ctrl_name_DischargeTimeSlot2": "Entladezeitfenster 2",
  "bw_param_ctrl_name_DischargeTimeSlot1": "Entladezeitfenster 1",
  "bw_param_ctrl_group_GridDispatch": "Netzeinspeisesteuerung",
  "jl_param_ctrl_group_OnOff": "Wechselrichter Ein/Aus",
  "jl_param_ctrl_name_OnOff": "Wechselrichter Ein/Aus",
  "jl_param_ctrl_option_PowerOFF": "Ausschalten",
  "jl_param_ctrl_option_PowerON": "Einschalten",
  "product.multipleLanguage": "Mehrsprachige Einstellungen des Thing-Modells",
  "product.multipleLanguageNote": "Mehrsprachige Begriffsbibliothek des Thing-Modells",
  "product.entryCode": "Begriffscode",
  "product.entryValue": "Begriffswert",
  "product.endpoint": "Endpunkt",
  "product.module": "Modul",
  "product.tag": "Tag",
  "product.editLanguage": "Mehrsprachigkeit bearbeiten",
  "product.addLanguage": "Mehrsprachigkeit hinzufügen",
  "product.maintainInfo": "Wartungsinformationen",
  "product.statusChangeSuccess": "Status erfolgreich geändert",
  "product.statusChangeFail": "Statusänderung fehlgeschlagen",
  "product.syncIotI18n": "Qingluo IoT-Modell-Einträge synchronisieren",
  "product.confirmSyncIotI18n": "Möchten Sie die Qingluo IoT-Modell-Einträge wirklich synchronisieren?",
  "button.sync": "Mehrsprachiges Paket synchronisieren",
  "plant.withdrawDelivery": "Lieferung zurückziehen",
  "plant.deliverUser": "Benutzer übergeben",
  "plant.withdrawDeliveryTip": "Nach dem Zurückziehen der Lieferung kann der Endnutzer dieses Kraftwerk nicht mehr verwalten. Bitte vorsichtig vorgehen.",
  "plant.undelivered": "Nicht übergeben",
  "plant.deliverManage": "Übergabe-Verwaltung",
  "plant.email_format_error": "E-Mail-Formatfehler",
  "plant.deliverUserTip": "Hinweis: Nutzer können sich bei Haier Energy mit ihrer E-Mail anmelden und die installierten Geräte über die App überwachen und steuern.",
  "plant.enterUserAccount": "Bitte Benutzerkonto eingeben",
  "plant.deliverUserTipUnified": "Hinweis: Nutzer können sich bei Haier Energy mit Telefonnummer oder E-Mail anmelden und die installierten Geräte über die App überwachen und steuern.",
  "plant.placeholderPhoneOrEmail": "Telefonnummer oder E-Mail eingeben",
  "plant.phoneOrEmailFormatError": "Bitte gültige Telefonnummer oder E-Mail eingeben",
  "plant.deliverSuccess": "Übergabe erfolgreich",
  "plant.known": "Verstanden",
  "plant.notRegistered": "Nicht registriert",
  "plant.noPermission": "Sie haben keine Berechtigung, die Übergabe zurückzuziehen. Nur Plattform-Superadmins und Installateur-Admins dürfen dies tun.",
  "plant.scanQRCode": "Bitte lassen Sie den Eigentümer den untenstehenden QR-Code scannen",
  "plant.qrCodeExpireTip": "Dieser Autorisierungscode wird nach erfolgreichem Empfang ungültig.",
  "plant.transferMethod": "Übergabemethode",
  "plant.transferRecord": "Übergabeprotokoll",
  "plant.operationTime": "Zeitpunkt der Operation",
  "plant.operator": "Bediener",
  "plant.transferType": "Übergabetyp",
  "plant.userIdentifier": "Benutzerkennung",
  "plant.transferResult": "Übergabeergebnis",
  "plant.totalRecordCount": "Insgesamt {count} Einträge",
  "device.Yield": "Yield",
  "device.ExistingINV": "Existing INV",
  "sidebar.dictManage": "Wörterbuchverwaltung",
  "subtitle.dictData": "Wörterbuchdaten",
  "dict.dictname": "Wörterbuchbezeichnung",
  "dict.dictnameen": "Wörterbuchschlüssel",
  "dict.dictdataname": "Datenbezeichnung",
  "dict.dictdatavalue": "Datenwert",
  "dict.i18nCode": "Sprachcode",
  "dict.dictsort": "Sortierreihenfolge",
  "dict.addDict": "Wörterbuch hinzufügen",
  "dict.addDictData": "Wörterbucheintrag hinzufügen",
  "dict.editDict": "Wörterbuch bearbeiten",
  "dict.editDictData": "Wörterbucheintrag bearbeiten",
  "device.otaTabTip": "Hinweis: Nach Abschluss des Upgrades ist das Gerät kurzzeitig offline. Bitte starten Sie das Gerät neu.",
  "product.accessPlatform": "Plattformquelle",
  "product.valueFilter": "Leerer Begriffswert",
  "setting.type22.restrictCounterCurrent.val1": "Gesamtleistung dreiphasig begrenzen",
  "setting.type22.restrictCounterCurrent.val2": "Einphasige Leistung begrenzen",
  "setting.type22.disable": "Deaktivieren",
  "setting.type22.enable": "Aktivieren",
  "setting.type22.meterSelect.str": "Stonray-Zähler",
  "setting.type22.meterSelect.df": "Dongfan-Zähler",
  "setting.type22.meterSelect.dh": "Donghong-Zähler",
  "setting.type22.meterSelect.zt": "Chint-Zähler",
  "setting.type22.meterSelect.yb": "Yeebon",
  "setting.type22.meterSelect.yz": "Ingeteam",
  "setting.type22.meterSelect.nky": "Nengkongyun-Smartmeter",
  "workorder.searchCreateTime": "Erstellungszeit",
  "workorder.statusAll": "Alle",
  "workorder.statusPending": "Ausstehend",
  "workorder.statusCompleted": "Abgeschlossen",
  "workorder.statusClosed": "Geschlossen",
  "workorder.no": "Arbeitsauftrag Nr.",
  "workorder.tableDescription": "Beschreibung",
  "workorder.plant": "Anlage",
  "workorder.device": "Gerät",
  "workorder.tableStatus": "Status",
  "workorder.owner": "Verantwortliche Person",
  "workorder.handler": "Bearbeiter",
  "workorder.handledTime": "Bearbeitungszeit",
  "workorder.creator": "Ersteller",
  "workorder.createTime": "Erstellungszeit",
  "workorder.timeTooltip": "Zeit in der Zeitzone des Werks",
  "workorder.tableAction": "Aktion",
  "workorder.actionDetails": "Details",
  "workorder.actionHandle": "Bearbeiten",
  "workorder.actionCancel": "Stornieren",
  "workorder.createTitle": "Arbeitsauftrag erstellen",
  "workorder.description": "Fehlerbeschreibung",
  "workorder.images": "Fehlerbilder",
  "workorder.handleTitle": "Arbeitsauftrag bearbeiten",
  "workorder.group": "Bearbeitungsinformationen",
  "workorder.feedback": "Bearbeitungsrückmeldung",
  "workorder.handleimages": "Bearbeitungsbilder",
  "workorder.detailsTitle": "Arbeitsauftragsdetails",
  "workorder.detailsGroup": "Arbeitsauftragsinformationen",
  "workorder.uploadSuccess": "Hochladen erfolgreich",
  "workorder.uploadNums": "Maximal 3 Bilder erlaubt",
  "workorder.uploadFormatTip": "Ungültiges Dateiformat. Bitte laden Sie Dateien im JPG-, JPEG- oder PNG-Format hoch",
  "workorder.uploadFormat": "Bitte laden Sie Dateien im PNG/JPG/JPEG-Format mit maximal 5 MB hoch",
  "workorder.uploadImage": "Hochladen",
  "workorder.cancelTip": "Das Stornieren dieses Arbeitsauftrags schließt ihn automatisch. Fortfahren?",
  "workorder.basicInformation": "Grundinformationen",
  "common.networkUnstable": "Die Netzwerkverbindung ist verloren gegangen. Bitte überprüfen Sie Ihre Netzwerkeinstellungen",
  "common.networkFull": "Das Internet ist wieder so voll wie die Sonne",
  "common.networkSlow": "Das aktuelle Netzwerk ist langsam. Bitte warten Sie geduldig oder überprüfen Sie die Netzwerkeinstellungen",
  "common.requestTimeout": "Zeitüberschreitung bei der Anfrage. Bitte überprüfen Sie das Netzwerk oder versuchen Sie es später erneut",
  "priceConfig.currentEffectivePrice": "Aktueller gültiger Tarif",
  "priceConfig.currencyUnitLabel": "Währungseinheit:",
  "priceConfig.addPrice": "Tarif hinzufügen",
  "priceConfig.effectiveTimeLabel": "Gültigkeitszeitraum",
  "priceConfig.powerPrice": "Energiepreis",
  "priceConfig.additionalFees": "Zusätzliche Gebühren",
  "priceConfig.lastUpdateTime": "Zuletzt aktualisiert",
  "priceConfig.lastUpdateTimeLabel": "Zuletzt aktualisiert",
  "priceConfig.emptyCurrent": "Derzeit kein gültiger Tarif. Klicken Sie auf die Schaltfläche, um zu konfigurieren.",
  "priceConfig.emptyUpcoming": "Kein anstehender Tarif",
  "priceConfig.upcomingTitle": "Anstehender Tarif",
  "priceConfig.copyPriceTitle": "Tarif kopieren",
  "priceConfig.deletePriceTitle": "Tarif löschen",
  "priceConfig.deleteConfirmText": "Bitte bestätigen Sie das Löschen des folgenden Tarifs",
  "priceConfig.otherPrice": "Weitere Gebühren",
  "priceConfig.deleteWarning": "Wenn dieser Tarif aktuell gültig ist, beeinflusst dies die Ertragsberechnung und die Ausführung der KI-Strategie.",
  "priceConfig.priceTypeLabel": "Tariftyp",
  "priceConfig.timeOfUse": "Zeitzonen",
  "priceConfig.dynamic": "Dynamisch",
  "priceConfig.timeOfUsePrice": "Zeitzonen-Tarif",
  "priceConfig.dynamicPrice": "Dynamischer Tarif",
  "priceConfig.effectiveDatePlaceholder": "Bitte wählen Sie ein Gültigkeitsdatum",
  "priceConfig.copyEffectiveDatePlaceholder": "Bitte wählen Sie ein Gültigkeitsdatum",
  "priceConfig.nextStep": "Weiter",
  "priceConfig.buyPriceTitle": "Bezugs­tarif",
  "priceConfig.feedInPriceTitle": "Einspeise­tarif",
  "priceConfig.addTimePeriod": "Zeitintervall hinzufügen",
  "priceConfig.electricitySurchargeTitle": "Energiezuschlag",
  "priceConfig.electricitySurchargeTooltip": "Zusätzliche Gebühr pro gekaufter kWh.",
  "priceConfig.fixedFeeTitle": "Grundgebühr",
  "priceConfig.fixedFeeTooltip": "Fester Grundpreis pro Abrechnungszeitraum, der sich nicht mit Verbrauch oder Leistung ändert.",
  "priceConfig.hasFeeYes": "Ja",
  "priceConfig.countryLabel": "Land",
  "priceConfig.secondaryRegionLabel": "Region (Stufe 2)",
  "priceConfig.secondaryRegionPlaceholder": "Bitte Region (Stufe 2) wählen",
  "priceConfig.currencyUnitPlaceholder": "Bitte Währungseinheit wählen",
  "priceConfig.powerMarketLabel": "Strommarkt",
  "priceConfig.powerMarketPlaceholder": "Bitte Strommarkt wählen",
  "priceConfig.electricitySurchargePlaceholder": "Max. 7 Ganzziffern, 8 Dezimalstellen, ≥ 0",
  "priceConfig.fixedFeePlaceholder": "Max. 7 Ganzziffern, 8 Dezimalstellen, ≥ 0",
  "priceConfig.priceInputPlaceholder": "Strompreis eingeben (max. 7 Ganzziffern, 8 Dezimalstellen, ≥ 0)",
  "priceConfig.timePlaceholder": "Zeit auswählen",
  "priceConfig.selectEffectiveTimeTip": "Bitte Gültigkeitszeitraum wählen",
  "priceConfig.selectPriceTypeTip": "Bitte Tariftyp wählen",
  "priceConfig.selectCountryTip": "Bitte Land wählen",
  "priceConfig.selectSecondaryRegionTip": "Bitte Region (Stufe 2) wählen",
  "priceConfig.selectCurrencyUnitTip": "Bitte Währungseinheit wählen",
  "priceConfig.selectPowerMarketTip": "Bitte Strommarkt wählen",
  "priceConfig.electricitySurchargeInputTip": "Bitte Energiezuschlag eingeben (max. 7 Ganzziffern, 8 Dezimalstellen, ≥ 0)",
  "priceConfig.electricitySurchargeRangeTip": "Energiezuschlag: höchstens 7 Ganzziffern, 8 Dezimalstellen, ≥ 0",
  "priceConfig.fixedFeeInputTip": "Bitte Grundgebühr eingeben (max. 7 Ganzziffern, 8 Dezimalstellen, ≥ 0)",
  "priceConfig.fixedFeeRangeTip": "Grundgebühr: höchstens 7 Ganzziffern, 8 Dezimalstellen, ≥ 0",
  "priceConfig.buyTimeFullDayTip": "Zeitintervalle des Bezugs­tarifs müssen 24 Stunden abdecken",
  "priceConfig.feedInTimeFullDayTip": "Zeitintervalle des Einspeise­tarifs müssen 24 Stunden abdecken",
  "priceConfig.buyTimeNoOverlapTip": "Zeitintervalle des Bezugs­tarifs dürfen sich nicht überschneiden",
  "priceConfig.feedInTimeNoOverlapTip": "Zeitintervalle des Einspeise­tarifs dürfen sich nicht überschneiden",
  "priceConfig.loadFail": "Tarifdaten konnten nicht geladen werden",
  "priceConfig.copySelectPriceTip": "Kein Tarif ausgewählt, Kopieren nicht möglich",
  "priceConfig.copyMissingPlantTip": "Anlageninformationen fehlen, Kopieren des Tarifs nicht möglich",
  "priceConfig.copySuccess": "Erfolgreich kopiert",
  "priceConfig.copyFail": "Kopieren fehlgeschlagen",
  "priceConfig.networkTimeout": "Netzwerk-Timeout. Bitte versuchen Sie es erneut, sobald die Netzwerkverbindung wiederhergestellt ist.",
  "priceConfig.copyUnsupportedTip": "Dieser Tariftyp kann nicht kopiert werden",
  "priceConfig.deleteSelectPriceTip": "Kein Tarif ausgewählt",
  "priceConfig.deleteIdMissingTip": "Tarif-ID konnte nicht ermittelt werden, Löschen fehlgeschlagen",
  "priceConfig.deleteSuccess": "Erfolgreich gelöscht",
  "priceConfig.deleteFail": "Löschen fehlgeschlagen",
  "priceConfig.missingPlantInfoTip": "Anlageninformationen fehlen",
  "priceConfig.confirmGiveUpCreateTip": "Möchten Sie das Anlegen dieses Tarifs wirklich verwerfen?",
  "priceConfig.confirmGiveUpEditTip": "Möchten Sie das Bearbeiten dieses Tarifs wirklich verwerfen?",
  "priceConfig.pageTitleAdd": "Tarif hinzufügen",
  "priceConfig.pageTitleEdit": "Tarif bearbeiten",
  "priceConfig.pageTitleView": "Tarif anzeigen",
  "priceConfig.createSuccess": "Erfolgreich erstellt",
  "priceConfig.editSuccess": "Erfolgreich bearbeitet",
  "priceConfig.saveFail": "Speichern fehlgeschlagen",
  "priceConfig.dateRangePermanent": "{start} bis unbefristet",
  "priceConfig.dateRange": "{start} bis {end}",
  "priceConfig.routeTitle": "Strompreis",
  "priceConfig.priceLabel": "Preis",
  "priceConfig.surchargeLabel": "Zuschlag",
  "priceConfig.fixedFeeLabel": "Grundgebühr",
  "button.copy": "Kopieren",
  "common.view": "Anzeigen",
  "screen.platform": "Plattform für Energiemanagement",
  "plantScreen.title": "Kraftwerksverwaltung",
  "plantScreen.DailyElectricityGenerated": "Tägliche Stromerzeugung",
  "plantScreen.DailyElectricityUsed": "Täglicher Stromverbrauch",
  "plantScreen.DailyElectricityPurchased": "Täglicher Stromzukauf",
  "plantScreen.DailyElectricitySold": "Täglicher Stromverkauf",
  "plantScreen.ChargingStatus": "Ladestatus",
  "plantScreen.BatteryLevel": "Batteriestand",
  "plantScreen.PhotovoltaicStatus": "PV-Status",
  "plantScreen.GridStatus": "Netzstatus",
  "plantScreen.Charging": "Laden",
  "plantScreen.Discharging": "Entladen",
  "plantScreen.Generating": "Erzeugung",
  "plantScreen.Idle": "Leerlauf",
  "plantScreen.pvIDLE": "Keine Erzeugung",
  "plantScreen.BuyingElectricity": "Strom kaufen",
  "plantScreen.SellingElectricity": "Strom verkaufen",
  "plantScreen.netdead": "Inselbetrieb",
  "plantScreen.day": "Tag",
  "plantScreen.month": "Monat",
  "plantScreen.year": "Jahr",
  "plantScreen.life": "Gesamt",
  "plantScreen.BatterySOC": "Batterie-SOC",
  "plantScreen.PowerAnalysis": "Leistungsanalyse",
  "plantScreen.EquivalentRevenue": "Äquivalenter Ertrag",
  "plantScreen.EnergyAnalysis": "Energieanalyse",
  "plantScreen.SocialContribution": "Gesellschaftlicher Beitrag",
  "plantScreen.Photovoltaic": "Photovoltaik",
  "plantScreen.Grid": "Stromnetz",
  "plantScreen.Battery": "Batterie",
  "plantScreen.Load": "Last",
  "plantScreen.Daily": "Täglich",
  "plantScreen.Monthly": "Monatlich",
  "plantScreen.Yearly": "Jährlich",
  "plantScreen.Cumulative": "Kumulativ",
  "plantScreen.Unit": "Einheit",
  "plantScreen.ElectricityGeneration": "Stromerzeugung",
  "plantScreen.ElectricityConsumption": "Stromverbrauch",
  "plantScreen.ChartSet.explain": "Hinweis: Leistung > 0 = Entladung; Leistung < 0 = Ladung.",
  "plantScreen.ChartSet.Self-consumption": "Eigenverbrauch",
  "plantScreen.ChartSet.GridElectricity": "Netzeinspeisung",
  "plantScreen.ChartSet.Self-Sufficiency": "Autarkie",
  "plantScreen.ChartSet.PurchasedElectricity": "Zugekaufter Strom",
  "plantScreen.ChartSet.PVPower": "PV-Leistung",
  "plantScreen.ChartSet.ConsumptionPower": "Verbrauchsleistung",
  "plantScreen.ChartSet.BatterySOC": "Batterie-SOC",
  "plantScreen.ChartSet.BatteryChargingPower": "Batterieladeleistung",
  "plantScreen.ChartSet.BatteryDischargingPower": "Batterieentladeleistung",
  "plantScreen.ProtectedForest": "Geschützter Wald",
  "plantScreen.CO2Emission": "CO2-Emission",
  "plantScreen.Media": "Kohle",
  "plant.EquivalentBenefit.GridView": "Äquivalenter Ertrag = Eigenverbrauch * Bezugspreis + Netzeinspeisung * Verkaufspreis",
  "plant.MonitoringScreen": "Überwachungsbildschirm",
  "plantScreen.ChartSet.explainPower": "Hinweis: Netzleistung > 0 = Strom verkaufen; Netzleistung < 0 = Strom kaufen.",
  "cookie.necessary": "Unbedingt erforderliche Cookies",
  "cookie.performance": "Leistungs-Cookies",
  "cookie.functional": "Funktionale Cookies",
  "cookie.targeting": "Targeting-Cookies",
  "cookie.necessaryExplain": "Diese Cookies sind für den Betrieb der Website unbedingt erforderlich und können in unseren Systemen nicht ausgeschaltet werden. Sie werden in der Regel nur als Reaktion auf von Ihnen durchgeführte Aktionen gesetzt, die eine Dienstleistungsanforderung darstellen, wie z.B. das Festlegen Ihrer Datenschutzeinstellungen, das Anmelden oder das Ausfüllen von Formularen. Sie können Ihren Browser so einstellen, dass diese Cookies blockiert oder Sie darüber benachrichtigt werden. Einige Teile der Website funktionieren dann jedoch möglicherweise nicht. Diese Cookies speichern keine personenbezogenen Daten.",
  "cookie.performanceExplain": "Diese Cookies ermöglichen es uns, Besuche und Verkehrsquellen zu zählen, damit wir die Leistung unserer Website messen und verbessern können. Sie helfen uns zu erfahren, welche Seiten am beliebtesten und welche am wenigsten beliebt sind, und zu sehen, wie sich Besucher auf der Website bewegen. Alle von diesen Cookies gesammelten Informationen werden aggregiert und sind daher anonym. Wenn Sie diese Cookies nicht zulassen, können wir nicht wissen, wann Sie unsere Website besucht haben, und können ihre Leistung nicht überwachen.",
  "cookie.functionalExplain": "Diese Cookies ermöglichen es der Website, erweiterte Funktionalität und Personalisierung bereitzustellen. Sie können von uns oder von Drittanbietern gesetzt werden, deren Dienste wir zu unseren Seiten hinzugefügt haben. Wenn Sie diese Cookies nicht zulassen, funktionieren einige oder alle dieser Dienste möglicherweise nicht richtig.",
  "cookie.targetingExplain": "Diese Cookies können über unsere Website von unseren Werbepartnern gesetzt werden. Sie können von diesen Unternehmen verwendet werden, um ein Profil Ihrer Interessen zu erstellen und Ihnen relevante Werbung auf anderen Websites anzuzeigen. Sie speichern keine direkten personenbezogenen Daten, sondern basieren auf der eindeutigen Identifizierung Ihres Browsers und Internetgeräts. Wenn Sie diese Cookies nicht zulassen, werden Sie weniger gezielte Werbung erhalten.",
  "cookie.necessaryAccount": "ID-Verifizierung",
  "cookie.necessaryAccountExplain": "Wird verwendet, um den Anmeldestatus des Benutzers aufrechtzuerhalten. Es ist eine Kernfunktion der Website-Authentifizierung und Sitzungsverwaltung. Ohne dieses Cookie werden möglicherweise Benutzerkonten auf besuchten Seiten nicht korrekt angezeigt.",
  "cookie.sessionManagement": "Sitzungsverwaltung",
  "cookie.sessionManagementExplain": "Wird verwendet, um Benutzersitzungen eindeutig zu identifizieren und wichtige Funktionen wie den Anmeldestatus des Benutzers, Warenkorbinhalte und Formulardaten aufrechtzuerhalten.",
  "cookie.userInfo": "Benutzerinformationen",
  "cookie.userInfoExplain": "Wird verwendet, um Geschäftskennzahlen wie Seitenaufrufe (PV) und eindeutige Besucher (UV) zu verfolgen, Systemverkehr und Benutzerinteraktion zu analysieren, um die Priorisierung von Funktionen und die Übereinstimmung mit Kernanforderungen zu optimieren.",
  "cookie.deviceInfo": "Geräteinformationen",
  "cookie.deviceInfoExplain": "Basierend auf verschiedenen Betriebssystemen, Gerätemodellen und Browsertypen löst es Layout- und Kompatibilitätsprobleme über verschiedene Endgeräte hinweg und optimiert Anpassungsfunktionen für unterschiedliche Geräte.",
  "cookie.pageInfo": "Seiteninformationen",
  "cookie.pageInfoExplain": "Zeichnet Seitenzugriffspfade, API-Anfragen und Ressourcenladezeiten auf, um Leistungsengpässe, Anforderungsfehler und Codefehler zu identifizieren und das Entwicklungsteam bei der schnellen Behebung von Problemen zu unterstützen.",
  "cookie.networkInfo": "Netzwerkinformationen",
  "cookie.networkInfoExplain": "Analysiert den geografischen Standort und Netzwerke von Internetdienstanbietern (ISPs), um böswilligen Zugriff und abnormalen Datenverkehr zu identifizieren und die Effizienz der Inhaltsbereitstellung für Cloud-Dienstanbieter zu optimieren.",
  "cookie.userPreference": "Oberflächeneinstellungen",
  "cookie.userPreferenceExplain": "Wird nur verwendet, um Benutzeroberflächeneinstellungen zur Verbesserung der Benutzererfahrung aufzuzeichnen. Es ist keine Kernfunktion, die für den Betrieb der Website erforderlich ist.",
  "cookie.longTerm": "Langfristig",
  "cookie.duration180": "180 Tage",
  "cookie.durationSession": "Session",
  "cookie.bannerExplain": "Um Ihr Surferlebnis zu optimieren, verwenden wir Cookies hauptsächlich zur Aufzeichnung des Anmeldestatus, zum Speichern Ihrer Einstellungen und zur Anpassung an Ihre Surfgewohnheiten. Wenn Sie auf 'Alle akzeptieren' klicken, stimmen Sie unserer Cookie-Richtlinie zu.",
  "cookie.acceptNecessary": "Nur notwendige",
  "cookie.openPreferences": "Einstellungen",
  "cookie.acceptAll": "Alle akzeptieren",
  "cookie.cookieSet": "Cookie-Einstellungen",
  "cookie.cookieSetExplain": "Für weitere Informationen siehe",
  "cookie.cookiePolicy": "Cookie-Richtlinie",
  "cookie.cookieCategory": "Cookie-Kategorie",
  "cookie.cookieName": "Cookie-Name",
  "cookie.cookieDescription": "Zweck",
  "cookie.cookieDuration": "Gültigkeitsdauer",
  "cookie.cookieSwitch": "Schalter",
  "cookie.savePreferences": "Einstellungen speichern",
  "cookie.preferencesTitle": "Cookie-Einstellungen",
  "cookie.cookiePolicyText": "Cookie-Richtlinie",
  "common.currentVersion": "Aktuelle Version",
  "common.versionUpdateNotice": "Version aktualisierungsbenachrichtigung",
  "common.later": "Später",
  "common.immediateUpdate": "Sofort aktualisieren",
  "sidebar.policyConfig": "Richtlinienkonfiguration",
  "common.addScope": "{scope} hinzufügen",
  "editor.header.title": "Überschrift",
  "editor.header.text": "Absatz",
  "editor.fontSize.title": "Schriftgröße",
  "editor.fontSize.default": "Standardschriftgröße",
  "editor.fontFamily.title": "Schriftart",
  "editor.fontFamily.default": "Standardschriftart",
  "editor.bold": "Fett",
  "editor.italic": "Kursiv",
  "editor.underline": "Unterstrichen",
  "editor.through": "Durchgestrichen",
  "editor.code": "Inline-Code",
  "editor.sub": "Tiefgestellt",
  "editor.sup": "Hochgestellt",
  "editor.clearStyle": "Formatierung löschen",
  "editor.color.color": "Textfarbe",
  "editor.color.bgColor": "Hintergrundfarbe",
  "editor.color.default": "Standardfarbe",
  "editor.color.clear": "Farbe löschen",
  "editor.bulletedList": "Aufzählungszeichenliste",
  "editor.numberedList": "Nummerierte Liste",
  "editor.todo": "To-Do-Liste",
  "editor.todo.title": "To-Do",
  "editor.emotion.title": "Emoticons",
  "editor.justifyLeft": "Links ausrichten",
  "editor.justifyRight": "Rechts ausrichten",
  "editor.justifyCenter": "Zentriert",
  "editor.justifyJustify": "Blocksatz",
  "editor.indent": "Einzug erhöhen",
  "editor.delIndent": "Einzug verringern",
  "editor.lineHeight.title": "Zeilenhöhe",
  "editor.lineHeight.default": "Standardzeilenhöhe",
  "editor.blockquote": "Zitat",
  "editor.link.insert": "Link einfügen",
  "editor.link.text": "Linktext",
  "editor.link.url": "Link-URL",
  "editor.link.unLink": "Link entfernen",
  "editor.link.edit": "Link bearbeiten",
  "editor.link.view": "Link anzeigen",
  "editor.image.netImage": "Webbild",
  "editor.image.delete": "Bild löschen",
  "editor.image.edit": "Bild bearbeiten",
  "editor.image.viewLink": "Link anzeigen",
  "editor.image.src": "Bild-URL",
  "editor.image.desc": "Bildbeschreibung",
  "editor.image.link": "Bildlink",
  "editor.video.insert": "Video einfügen",
  "editor.video.delete": "Video löschen",
  "editor.video.uploadVideo": "Video hochladen",
  "editor.video.insertVideo": "Video einfügen",
  "editor.video.videoSrc": "Video-URL",
  "editor.video.videoSrcPlaceHolder": "Bitte Video-URL eingeben",
  "editor.video.videoPoster": "Video-Vorschaubild",
  "editor.video.videoPosterPlaceHolder": "Bitte Vorschaubild-URL eingeben",
  "editor.video.ok": "OK",
  "editor.video.editSize": "Größe ändern",
  "editor.video.width": "Breite",
  "editor.video.height": "Höhe",
  "editor.table.header": "Tabelle",
  "editor.table.insertTable": "Tabelle einfügen",
  "editor.table.deleteTable": "Tabelle löschen",
  "editor.table.insertRow": "Zeile einfügen",
  "editor.table.deleteRow": "Zeile löschen",
  "editor.table.insertCol": "Spalte einfügen",
  "editor.table.deleteCol": "Spalte löschen",
  "editor.table.widthAuto": "Automatische Breite",
  "editor.table.widthFixed": "Feste Breite",
  "editor.codeBlock.title": "Codeblock",
  "editor.divider": "Trennlinie",
  "editor.emotion": "Emoticons",
  "editor.insertFormula": "Formel einfügen",
  "editor.fullScreen": "Vollbild",
  "editor.undo": "Rückgängig",
  "editor.redo": "Wiederholen",
  "editor.delete": "Löschen",
  "editor.enter": "Eingabe",
  "editor.ok": "OK",
  "editor.cancel": "Abbrechen",
  "editor.uploadImgMaxSize": "Max. Bildgröße",
  "editor.uploadImgMaxSizeErr": "Bildgröße überschreitet das Limit",
  "editor.uploadImgMaxLength": "Max. Bilder",
  "editor.uploadImgMaxLengthErr": "Anzahl der Bilder überschreitet das Limit",
  "editor.uploadVideoMaxSize": "Max. Videogröße",
  "editor.uploadVideoMaxSizeErr": "Videogröße überschreitet das Limit",
  "editor.placeholder": "Bitte Inhalt eingeben...",
  "UserHome.plantFlow.load": "Last",
  "UserHome.plantFlow.grid": "Netz",
  "UserHome.plantFlow.battery": "Batterie",
  "UserHome.plantFlow.pv": "PV",
  "plant.running.status.alarm": "Alarm",
  "end.web": "web",
  "test.label_G_P_C_L2": "puissance L2",
  "device.offline": "Gerät offline",
  "solid.snake.msf.test": "",
  "bigboss.shaed.test": "",
  "ywt.60419.AllowCounterCurrentPower": "Erlaubte Rückflussleistung",
  "ywt.60419.internalharderror0": "Keine Anomalie",
  "ywt.60419.loadDropMode": "Leistungsreduzierung Modus",
  "ywt.60419.loadDropMode11": "Einzelne Maschine Rückflussschutz Leistungsreduzierung",
  "ywt.60419.meterCommQuality": "Kommunikationsqualität des Stromzählers",
  "ywt.60419.meterRPower": "Leistung des Stromzählers Phase R",
  "ywt.60419.meterSelect": "Stromzählerauswahl",
  "ywt.60419.meterSPower": "Leistung des Stromzählers Phase S",
  "ywt.60419.meterTPower": "T-Phasen-Leistung des Stromzählers",
  "ywt.60419.multiReverseFlowEnable": "Mehrfachschutz gegen Rückfluss aktivieren",
  "ywt.60419.restrictCounterCurrent": "Rückflussbegrenzungsmethode",
  "ywt.60419.singleReverseFlowEnable": "Einzelschutz gegen Rückfluss aktivieren",
  "bw_param_ctrl_group_ParallelSetting": "Parallel-Einstellungen",
  "bw_param_ctrl_group_SpecialSetting": "Spezialeinstellungen",
  "bw_param_ctrl_name_PhaseOrderResume": "Phasenfolge Wiederherstellung",
  "bw_param_ctrl_note_ParallelModeSetting": "Einstellung, ob der Wechselrichter im Parallelbetrieb eine Master- oder Slave-Einheit ist.",
  "bw_param_ctrl_option_host": "Master im Parallelmodus",
  "bw_param_ctrl_option_PhaseOrderResume": "Zurücksetzen",
  "bw_param_ctrl_option_single": "Kein Parallelmodus (Einzelmodus)",
  "bw_param_ctrl_option_Slave": "Slave im Parallelmodus",
  "0X3809-F-0607": "PV-Klemmen-Temperaturschutzfehler",
  "0X3809-F-1103": "Relais-Selbsttest-Anomalie",
  "0X3809-F-3112": "Netzspannungsphasensynchronisationsfehler",
  "0X3809-F-3113": "Netzphasenfolgeanomalie",
  "0X3809-S-0101": "1. Überprüfen Sie, ob die Anschlüsse der PV-Module in Ordnung sind und ob die Module beschädigt sind, Staub auf der Oberfläche haben oder verschattet sind.\n2. Überprüfen Sie, ob die PV-Module korrekt angeschlossen sind und ob ihre Spannungsspezifikation über dem Betriebsspannungsbereich des Wechselrichters liegt.\n3. Überprüfen Sie, ob ein Kurzschluss in den PV-Modulen vorliegt.",
  "0X3809-S-0102": "1. Überprüfen Sie, ob die Anschlüsse der PV-Module in Ordnung sind und ob die Module beschädigt sind, Staub auf der Oberfläche haben oder verschattet sind.\n2. Überprüfen Sie, ob die PV-Module korrekt angeschlossen sind und ob ihre Spannungsspezifikation über dem Betriebsspannungsbereich des Wechselrichters liegt.\n3. Überprüfen Sie, ob ein Kurzschluss in den PV-Modulen vorliegt.",
  "0X3809-S-0103": "1. Überprüfen Sie, ob die Anschlüsse der PV-Module in Ordnung sind und ob die Module beschädigt sind, Staub auf der Oberfläche haben oder verschattet sind.\n2. Überprüfen Sie, ob die PV-Module korrekt angeschlossen sind und ob ihre Spannungsspezifikation über dem Betriebsspannungsbereich des Wechselrichters liegt.\n3. Überprüfen Sie, ob ein Kurzschluss in den PV-Modulen vorliegt.",
  "0X3809-S-0301": "1. Tritt häufig am frühen Morgen auf; überprüfen Sie bitte die Sauberkeit der PV-Moduloberfläche.\n2. Überprüfen Sie, ob die PV-Module korrekt angeschlossen sind und ob ihre Spannungsspezifikationen den Betriebsspannungsbereich des Wechselrichters überschreiten.\n3. Bitte starten Sie den Wechselrichter neu. Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an Ihren Händler.",
  "0X3809-S-0302": "1. Tritt häufig am frühen Morgen auf; überprüfen Sie bitte die Sauberkeit der PV-Moduloberfläche.\n2. Überprüfen Sie, ob die PV-Module korrekt angeschlossen sind und ob ihre Spannungsspezifikationen den Betriebsspannungsbereich des Wechselrichters überschreiten.\n3. Bitte starten Sie den Wechselrichter neu. Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an Ihren Händler.",
  "0X3809-S-0303": "1. Tritt häufig am frühen Morgen auf; überprüfen Sie bitte die Sauberkeit der PV-Moduloberfläche.\n2. Überprüfen Sie, ob die PV-Module korrekt angeschlossen sind und ob ihre Spannungsspezifikationen den Betriebsspannungsbereich des Wechselrichters überschreiten.\n3. Bitte starten Sie den Wechselrichter neu. Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an Ihren Händler.",
  "0X3809-S-0304": "1. Tritt häufig am frühen Morgen auf; überprüfen Sie bitte die Sauberkeit der PV-Moduloberfläche.\n2. Überprüfen Sie, ob die PV-Module korrekt angeschlossen sind und ob ihre Spannungsspezifikationen den Betriebsspannungsbereich des Wechselrichters überschreiten.\n3. Bitte starten Sie den Wechselrichter neu. Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an Ihren Händler.",
  "0X3809-S-0501": "Bitte starten Sie den Wechselrichter neu. Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an Ihren Händler.",
  "0X3809-S-0502": "Bitte starten Sie den Wechselrichter neu. Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an Ihren Händler.",
  "0X3809-S-0503": "Bitte starten Sie den Wechselrichter neu. Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an Ihren Händler.",
  "0X3809-S-0504": "Bitte starten Sie den Wechselrichter neu. Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an Ihren Händler.",
  "0X3809-S-0505": "Bitte starten Sie den Wechselrichter neu. Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an Ihren Händler.",
  "0X3809-S-0506": "Bitte starten Sie den Wechselrichter neu. Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an Ihren Händler.",
  "0X3809-S-0507": "Bitte starten Sie den Wechselrichter neu. Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an Ihren Händler.",
  "0X3809-S-0508": "Bitte starten Sie den Wechselrichter neu. Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an Ihren Händler.",
  "0X3809-S-0601": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob der Kühlkörper-Luftkanal verstopft ist\n3. Starten Sie den Wechselrichter nach dem Abkühlen neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler",
  "0X3809-S-0602": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob der Kühlkörper-Luftkanal verstopft ist\n3. Starten Sie den Wechselrichter nach dem Abkühlen neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler",
  "0X3809-S-0603": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob der Kühlkörper-Luftkanal verstopft ist\n3. Starten Sie den Wechselrichter nach dem Abkühlen neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler",
  "0X3809-S-0604": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob der Kühlkörper-Luftkanal verstopft ist\n3. Starten Sie den Wechselrichter nach dem Abkühlen neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler",
  "0X3809-S-0605": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob der Kühlkörper-Luftkanal verstopft ist\n3. Starten Sie den Wechselrichter nach dem Abkühlen neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler",
  "0X3809-S-0606": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob der Kühlkörper-Luftkanal verstopft ist\n3. Starten Sie den Wechselrichter nach dem Abkühlen neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler",
  "0X3809-S-0607": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob der Kühlkörper-Luftkanal verstopft ist\n3. Starten Sie den Wechselrichter nach dem Abkühlen neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler",
  "0X3809-S-0701": "1. Überprüfen Sie, ob ein Erdschluss am Modul vorliegt.\n2. Überprüfen Sie auf lockere Verbindungen im DC-Stromkreis.\n3. Wenn keine Probleme im DC-Stromkreis festgestellt werden, schalten Sie den Strom für 5 Minuten aus und schalten Sie ihn dann wieder ein. Wenn das Problem weiterhin besteht, wenden Sie sich an Ihren Händler.",
  "0X3809-S-0801": "1. Treiberschaltungsfehler.\n2. Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich an Ihren Händler.",
  "0X3809-S-0901": "1. Steuerplatine defekt\n2. Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler",
  "0X3809-S-0902": "1. Steuerplatine defekt\n2. Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler",
  "0X3809-S-0903": "1. Steuerplatine defekt\n2. Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler",
  "0X3809-S-0904": "1. Steuerplatine defekt\n2. Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler",
  "0X3809-S-0905": "1. Steuerplatine defekt\n2. Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler",
  "0X3809-S-0906": "1. Steuerplatine defekt\n2. Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler",
  "0X3809-S-0907": "1. Steuerplatine defekt\n2. Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler",
  "0X3809-S-1001": "1. Wenn es gelegentlich auftritt, kann dies auf gelegentliche externe Leitungsstörungen zurückzuführen sein. Ein Neustart des Wechselrichters stellt den normalen Betrieb wieder her.\n2. Wenn es häufig auftritt oder über einen längeren Zeitraum nicht behoben werden kann, überprüfen Sie bitte, ob die Erdung des Photovoltaik-Strings zuverlässig ist.",
  "0X3809-S-1002": "1. Wenn es gelegentlich auftritt, kann dies auf gelegentliche externe Leitungsstörungen zurückzuführen sein. Ein Neustart des Wechselrichters stellt den normalen Betrieb wieder her.\n2. Wenn es häufig auftritt oder über einen längeren Zeitraum nicht behoben werden kann, überprüfen Sie bitte, ob die Erdung des Photovoltaik-Strings zuverlässig ist.",
  "0X3809-S-1003": "1. Wenn es gelegentlich auftritt, kann dies auf gelegentliche externe Leitungsstörungen zurückzuführen sein. Ein Neustart des Wechselrichters stellt den normalen Betrieb wieder her.\n2. Wenn es häufig auftritt oder über einen längeren Zeitraum nicht behoben werden kann, überprüfen Sie bitte, ob die Erdung des Photovoltaik-Strings zuverlässig ist.",
  "0X3809-S-1004": "1. Wenn es gelegentlich auftritt, kann dies auf gelegentliche externe Leitungsstörungen zurückzuführen sein. Ein Neustart des Wechselrichters stellt den normalen Betrieb wieder her.\n2. Wenn es häufig auftritt oder über einen längeren Zeitraum nicht behoben werden kann, überprüfen Sie bitte, ob die Erdung des Photovoltaik-Strings zuverlässig ist.",
  "0X3809-S-1101": "1. Überprüfen Sie, ob der Erdungsleiter auf der AC-Seite unter Spannung steht.\n2. Interner Relaisfehler.\n3. Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler.",
  "0X3809-S-1102": "1. Überprüfen Sie, ob der Erdungsleiter auf der AC-Seite unter Spannung steht.\n2. Interner Relaisfehler.\n3. Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler.",
  "0X3809-S-1103": "1. Überprüfen Sie, ob der Erdungsleiter auf der AC-Seite unter Spannung steht.\n2. Interner Relaisfehler.\n3. Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler.",
  "0X3809-S-1201": "1. Interner Lüfter beschädigt\n2. Lüfterdetektionsschaltungsfehler\n3. Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler",
  "0X3809-S-1901": "Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler.",
  "0X3809-S-1902": "Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler.",
  "0X3809-S-1903": "Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler.",
  "0X3809-S-1904": "Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler.",
  "0X3809-S-1905": "Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler.",
  "0X3809-S-1906": "Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler.",
  "0X3809-S-1907": "Schalten Sie den Wechselrichter aus und starten Sie ihn neu. Wenn keine Wiederherstellung erfolgt, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3101": "1. Überprüfen Sie, ob im Verteilerkasten ein Leistungsschalter ausgelöst hat.\n2. Messen Sie, ob die tatsächliche Spannung den Bereich des Wechselrichters überschreitet.\n3. Wenn die Spannung außerhalb des Bereichs liegt, können Sie die Über- und Unterspannungsschutzeinstellungen des Wechselrichters anpassen.",
  "0X3809-S-3102": "1. Überprüfen Sie, ob im Verteilerkasten ein Leistungsschalter ausgelöst hat.\n2. Messen Sie, ob die tatsächliche Spannung den Bereich des Wechselrichters überschreitet.\n3. Wenn die Spannung außerhalb des Bereichs liegt, können Sie die Über- und Unterspannungsschutzeinstellungen des Wechselrichters anpassen.",
  "0X3809-S-3103": "1. Überprüfen Sie, ob im Verteilerkasten ein Leistungsschalter ausgelöst hat.\n2. Messen Sie, ob die tatsächliche Spannung den Bereich des Wechselrichters überschreitet.\n3. Wenn die Spannung außerhalb des Bereichs liegt, können Sie die Über- und Unterspannungsschutzeinstellungen des Wechselrichters anpassen.",
  "0X3809-S-3104": "1. Überprüfen Sie, ob im Verteilerkasten ein Leistungsschalter ausgelöst hat.\n2. Messen Sie, ob die tatsächliche Spannung den Bereich des Wechselrichters überschreitet.\n3. Wenn die Spannung außerhalb des Bereichs liegt, können Sie die Über- und Unterspannungsschutzeinstellungen des Wechselrichters anpassen.",
  "0X3809-S-3105": "1. Überprüfen Sie, ob im Verteilerkasten ein Leistungsschalter ausgelöst hat.\n2. Messen Sie, ob die tatsächliche Spannung den Bereich des Wechselrichters überschreitet.\n3. Wenn die Spannung außerhalb des Bereichs liegt, können Sie die Über- und Unterspannungsschutzeinstellungen des Wechselrichters anpassen.",
  "0X3809-S-3106": "1. Überprüfen Sie, ob im Verteilerkasten ein Leistungsschalter ausgelöst hat.\n2. Messen Sie, ob die tatsächliche Spannung den Bereich des Wechselrichters überschreitet.\n3. Wenn die Spannung außerhalb des Bereichs liegt, können Sie die Über- und Unterspannungsschutzeinstellungen des Wechselrichters anpassen.",
  "0X3809-S-3107": "1. Überprüfen Sie, ob im Verteilerkasten ein Leistungsschalter ausgelöst hat.\n2. Messen Sie, ob die tatsächliche Spannung den Bereich des Wechselrichters überschreitet.\n3. Wenn die Spannung außerhalb des Bereichs liegt, können Sie die Über- und Unterspannungsschutzeinstellungen des Wechselrichters anpassen.",
  "0X3809-S-3108": "1. Überprüfen Sie, ob im Verteilerkasten ein Leistungsschalter ausgelöst hat.\n2. Messen Sie, ob die tatsächliche Spannung den Bereich des Wechselrichters überschreitet.\n3. Wenn die Spannung außerhalb des Bereichs liegt, können Sie die Über- und Unterspannungsschutzeinstellungen des Wechselrichters anpassen.",
  "0X3809-S-3109": "1. Überprüfen Sie, ob im Verteilerkasten ein Leistungsschalter ausgelöst hat.\n2. Messen Sie, ob die tatsächliche Spannung den Bereich des Wechselrichters überschreitet.\n3. Wenn die Spannung außerhalb des Bereichs liegt, können Sie die Über- und Unterspannungsschutzeinstellungen des Wechselrichters anpassen.",
  "0X3809-S-3110": "1. Überprüfen Sie, ob im Verteilerkasten ein Leistungsschalter ausgelöst hat.\n2. Messen Sie, ob die tatsächliche Spannung den Bereich des Wechselrichters überschreitet.\n3. Wenn die Spannung außerhalb des Bereichs liegt, können Sie die Über- und Unterspannungsschutzeinstellungen des Wechselrichters anpassen.",
  "0X3809-S-3111": "1. Überprüfen Sie, ob im Verteilerkasten ein Leistungsschalter ausgelöst hat.\n2. Messen Sie, ob die tatsächliche Spannung den Bereich des Wechselrichters überschreitet.\n3. Wenn die Spannung außerhalb des Bereichs liegt, können Sie die Über- und Unterspannungsschutzeinstellungen des Wechselrichters anpassen.",
  "0X3809-S-3112": "1. Überprüfen Sie, ob im Verteilerkasten ein Leistungsschalter ausgelöst hat.\n2. Messen Sie, ob die tatsächliche Spannung den Bereich des Wechselrichters überschreitet.\n3. Wenn die Spannung außerhalb des Bereichs liegt, können Sie die Über- und Unterspannungsschutzeinstellungen des Wechselrichters anpassen.",
  "0X3809-S-3113": "1. Überprüfen Sie, ob im Verteilerkasten ein Leistungsschalter ausgelöst hat.\n2. Messen Sie, ob die tatsächliche Spannung den Bereich des Wechselrichters überschreitet.\n3. Wenn die Spannung außerhalb des Bereichs liegt, können Sie die Über- und Unterspannungsschutzeinstellungen des Wechselrichters anpassen.",
  "0X3809-S-3301": "1. Überprüfen Sie das Stromnetz auf lose Verbindungen.\n2. Passen Sie den Frequenzbereich entsprechend an.",
  "0X3809-S-3302": "1. Überprüfen Sie das Stromnetz auf lose Verbindungen.\n2. Passen Sie den Frequenzbereich entsprechend an.",
  "0X3809-S-3303": "1. Überprüfen Sie das Stromnetz auf lose Verbindungen.\n2. Passen Sie den Frequenzbereich entsprechend an.",
  "0X3809-S-3304": "1. Überprüfen Sie das Stromnetz auf lose Verbindungen.\n2. Passen Sie den Frequenzbereich entsprechend an.",
  "0X3809-S-3305": "1. Überprüfen Sie das Stromnetz auf lose Verbindungen.\n2. Passen Sie den Frequenzbereich entsprechend an.",
  "0X3809-S-3306": "1. Überprüfen Sie das Stromnetz auf lose Verbindungen.\n2. Passen Sie den Frequenzbereich entsprechend an.",
  "0X3809-S-3701": "Überprüfen Sie, ob der Wechselrichter manuell ausgeschaltet wurde.",
  "0X3809-S-3801": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3802": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3803": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3804": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3805": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3806": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3807": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3808": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3809": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3810": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3811": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3812": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3813": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3814": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3815": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3816": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3817": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3818": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3819": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3820": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3901": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3902": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3903": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3904": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3905": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3906": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3907": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3908": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3909": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3910": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3911": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3912": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3913": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3914": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3915": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3916": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3917": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3918": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3919": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-3920": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-4101": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-4201": "Überprüfen Sie, ob die N-PE-Spannung abnormal ist",
  "0X3809-S-4301": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3809-S-4401": "Bitte schalten Sie den Wechselrichter aus und trennen Sie die Ein-/Ausgangsschalter. Starten Sie den Wechselrichter nach 5 Minuten neu. Wenn der Fehler nicht behoben wird, wenden Sie sich bitte an den Händler.",
  "0X3807-F-02": "PV2-Kurzschlussalarm",
  "0X3807-F-03": "PV-Niederspannungsalarm",
  "0X3807-S-0101": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob sich der Lüfter normal dreht\n3. Starten Sie den Wechselrichter neu; falls keine Wiederherstellung erfolgt, ersetzen Sie bitte den Lüfter",
  "0X3807-S-0102": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob sich der Lüfter normal dreht\n3. Starten Sie den Wechselrichter neu; falls keine Wiederherstellung erfolgt, ersetzen Sie bitte den Lüfter",
  "0X3807-S-0103": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob sich der Lüfter normal dreht\n3. Starten Sie den Wechselrichter neu; falls keine Wiederherstellung erfolgt, ersetzen Sie bitte den Lüfter",
  "0X3807-S-0104": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob sich der Lüfter normal dreht\n3. Starten Sie den Wechselrichter neu; falls keine Wiederherstellung erfolgt, ersetzen Sie bitte den Lüfter",
  "0X3807-S-0105": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob sich der Lüfter normal dreht\n3. Starten Sie den Wechselrichter neu; falls keine Wiederherstellung erfolgt, ersetzen Sie bitte den Lüfter",
  "0X3807-S-0106": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob sich der Lüfter normal dreht\n3. Starten Sie den Wechselrichter neu; falls keine Wiederherstellung erfolgt, ersetzen Sie bitte den Lüfter",
  "0X3807-S-0107": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob sich der Lüfter normal dreht\n3. Starten Sie den Wechselrichter neu; falls keine Wiederherstellung erfolgt, ersetzen Sie bitte den Lüfter",
  "0X3807-S-0108": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob sich der Lüfter normal dreht\n3. Starten Sie den Wechselrichter neu; falls keine Wiederherstellung erfolgt, ersetzen Sie bitte den Lüfter",
  "0X3807-S-0109": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob sich der Lüfter normal dreht\n3. Starten Sie den Wechselrichter neu; falls keine Wiederherstellung erfolgt, ersetzen Sie bitte den Lüfter",
  "0X3807-S-0110": "1. Prüfen Sie, ob der Lüfter durch Fremdkörper blockiert ist\n2. Prüfen Sie, ob sich der Lüfter normal dreht\n3. Starten Sie den Wechselrichter neu; falls keine Wiederherstellung erfolgt, ersetzen Sie bitte den Lüfter",
  "0X3807-S-0401": "Überprüfen Sie, ob die Zählerverkabelung falsch ist.",
  "0X3807-S-0402": "Überprüfen Sie, ob die Zählerverkabelung falsch ist.",
  "0X3807-S-0404": "Überprüfen Sie, ob die Zählerverkabelung falsch ist.",
  "0X3807-S-0408": "Überprüfen Sie, ob die Zählerverkabelung falsch ist.",
  "0X3807-S-0416": "Überprüfen Sie, ob die Zählerverkabelung falsch ist.",
  "0X3807-S-0500": "1. Wenn es gelegentlich auftritt, kann dies auf eine vorübergehende Netzstörung zurückzuführen sein. Der Wechselrichter wird nach der Normalisierung des Netzes wieder normal arbeiten.\n2. Wenn dieser Fehler häufig gemeldet wird, überprüfen Sie bitte, ob das Netz abnormal ist.",
  "0X3807-S-0601": "Überprüfen Sie nach dem Ausschalten, ob die Modulspannung normal ist. Wenn ein Neustart das Problem nicht behebt, deutet dies auf einen internen Fehler des Wechselrichters hin.",
  "0X3807-S-02": "Überprüfen Sie nach dem Ausschalten, ob die Modulspannung normal ist. Wenn ein Neustart das Problem nicht behebt, deutet dies auf einen internen Fehler des Wechselrichters hin.",
  "0X3807-S-03": "Überprüfen Sie nach dem Ausschalten, ob die Modulspannung normal ist. Wenn ein Neustart das Problem nicht behebt, deutet dies auf einen internen Fehler des Wechselrichters hin.",
  "In Alarm": "Im Alarmzustand",
  "device.category.energyStorageCabinet": "Energiespeicherschrank",
  "device.category.commercialRobot": "Gewerblicher Roboter",
  "device.category.pvinverter": "Photovoltaikwechselrichter",
  "collector.upgrade.progress": "Fortschritt beim Sammler-Upgrade",
  "device.upgrade.progress": "Fortschritt der Geräteaktualisierung",
  "failed.to.obtain.firmware": "Firmware konnte nicht abgerufen werden",
  "file.CRC.check.failed": "CRC-Prüfung der Datei fehlgeschlagen",
  "burning.timed.out": "Brennvorgang zeitüberschritten",
  "burning.failed": "Brennvorgang fehlgeschlagen",
  "shujvabng": "Datenstick (Bumai)",
  "paramSet.select.dataError.tip": "Die Option ist nicht die optimale Option, bitte setzen Sie sie zurück.",
  "ywt.60419.pbusVol": "PBUS Spannung",
  "bw_param_qqq": "Einstellung des Parallelbetriebsmodus",
  "paramSet.dateTime.title.month": "M",
  "ywt.60419.invRTemp": "INV Modul R Temperatur(℃)",
  "ywt.60419.rGridPower": "Netzverbundleistung der Phase R",
  "ywt.60419.sGridVol": "S Netzphasenspannung",
  "paramSet.dateTime.title.year": "J",
  "50500_0x7572-C-15": "Ausfall des Kühlkörpers bei hohen Temperaturen",
  "50500_0x7572-C-14": "ARC-Fehler",
  "ywt.60419.btDspDebugInfo8": "BT DSP Debugging Information 8",
  "ywt.60419.btDspDebugInfo7": "BT DSP Debugging Information 7",
  "ywt.60419.btDspDebugInfo6": "BT DSP Debugging Information 6",
  "ywt.60419.sPhaseDci": "DCI- S-Phase ",
  "50500_0x756F-S-6": "DC / DC-Softstart-Fehler\n 1. Überprüfen Sie die Batteriesicherung;\n 2. Starten Sie neu und prüfen Sie, ob es normal ist;\n 3. Suchen Sie Hilfe bei uns, wenn Sie nicht in den noarmalen Zustand zurückkehren können",
  "50500_0x756F-S-7": "INV Relay Fault 1.Confirm that the wiring between each device is correct\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-S-4": "EEPROM Read Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-S-5": "EEPROM Write Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.internalharderror1": "Anomalie des externen FLASH",
  "ywt.60419.internalharderror3": "Anomalie beim Schreiben des EEPROM",
  "50500_0x756F-S-8": "Auxiliary power supply failure\n1. Wait for minutes then check;\n2. Remove wifi plug or other communicator;\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.internalharderror2": "Anomalie beim Lesen des EEPROM",
  "50500_0x756F-S-9": "Ausfall der Hilfsstromversorgung\n 1. Warten Sie minutenlang und überprüfen Sie dann;\n 2. Entfernen Sie den WLAN-Stecker oder einen anderen Kommunikator;\n 3. Suchen Sie Hilfe bei uns, wenn Sie nicht in den noarmalen Zustand zurückkehren können",
  "ywt.60419.armDebugInfo7": "ARM Debugging Information 7",
  "ywt.60419.internalharderror4": "Selbsttestfehler des GFCI",
  "ywt.60419.armDebugInfo5": "ARM Debugging Information 5",
  "ywt.60419.armDebugInfo6": "ARM Debugging Information 6",
  "50500_0x756F-S-2": "GFCI Device Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.armDebugInfo3": "ARM Debugging Information 3",
  "ywt.60419.armDebugInfo4": "ARM Debugging Information 4",
  "ywt.60419.armDebugInfo1": "ARM Debugging Information 1",
  "ywt.60419.armDebugInfo2": "ARM Debugging Information 2",
  "50500_0x756F-C-6": "DC / DC _ Softsart _ Fehler",
  "50500_0x756F-C-9": "AuxPowerBoard _ Fehler",
  "ywt.60419.deratedPower": "Ableitungsleistung",
  "50500_0x7570-F-14": "Soft _ Start _ Fehlgeschlagen",
  "50500_0x7570-F-12": "Parallel _ CANBus _ Fehler",
  "50500_0x756F-C-13": "Änderung des Arbeitsmodus",
  "ywt.60419.todayPvEnergy": "Tägliche Stromerzeugung",
  "ywt.60419.btDspDebugInfo1": "BT DSP Debugging Information 1",
  "ywt.60419.invSTemp": "INV Modul S Temperatur(℃)",
  "ywt.60419.btDspDebugInfo5": "BT DSP Debugging Information 5",
  "ywt.60419.btDspDebugInfo4": "BT DSP Debugging Information 4",
  "ywt.60419.btDspDebugInfo3": "BT DSP Debugging Information 3",
  "ywt.60419.btDspDebugInfo2": "BT DSP Debugging Information 2",
  "ywt.60419.dcInsulationImpedance": "DC-Isolationsimpedanz",
  "test.label_G_P_C_L1": "Gen L1 puissance",
  "ywt.60419.internalHardwareError": "Interner Hardwarefehler der Maschine",
  "ywt.60419.versionStr": "Versionsnummer",
  "test.label_G_P_C_L5": "Gen L2 Voltage",
  "common.50500.xnl_RTparam_name_G_P_V_L2": "Gen L2 Voltage",
  "test.label_G_P_C_L4": "Gen L1 Voltage",
  "common.50500.xnl_RTparam_name_G_P_V_L3": "Gen L3 Voltage",
  "test.label_G_P_C_L3": "génération L3 Power",
  "common.50500.xnl_RTparam_name_G_P_V_L1": "Gen L1 Voltage",
  "test.label_G_P_C_L6": "Gen L3 Voltage",
  "ywt.60419.envTemp": "Umgebungstemperatur(℃)",
  "bw_param_ctrl_name_ParallelSetting": "Paralleler Status",
  "ywt.60419.rGridVol": "R Netzphasenspannung",
  "ywt.60419.scanStatus": "I/V-Scanstatus",
  "ywt.60419.groupStrCurrent1": "String 1 Strom",
  "ywt.60419.invTTemp": "INV Modul T Temperatur(℃)",
  "ywt.60419.groupStrCurrent2": "Strom der Reihe 2",
  "ywt.60419.groupStrCurrent5": "String 5 Strom",
  "ywt.60419.groupStrCurrent6": "Strom der Reihe 6",
  "ywt.60419.groupStrCurrent3": "String 3 Strom",
  "ywt.60419.groupStrCurrent4": "Strom der Reihe 4",
  "ywt.60419.groupStrCurrent9": "String 9 Strom",
  "ywt.60419.groupStrCurrent7": "String 7 Strom",
  "ywt.60419.groupStrCurrent8": "Strom der Reihe 8",
  "ywt.60419.pvInputVol2": "PV2 Eingangsspannung",
  "ywt.60419.pvInputVol1": "PV1 Eingangsspannung",
  "ywt.60419.pvPower2": "PV-Leistung 2",
  "ywt.60419.pvPower1": "PV-Leistung 1",
  "ywt.60419.pvPower8": "PV-Leistung 8",
  "ywt.60419.pvPower7": "PV-Leistung 7",
  "ywt.60419.pvPower9": "PV-Leistung 9",
  "50500_0x7571-S-10": "1.Confirm that the wiring between each device is correct\n2. Check the AC voltage is in the range of standard voltage in specification;\n3.Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.pvPower4": "PV-Leistung 4",
  "50500_0x7571-S-15": "Netzfrequenz außerhalb des Bereichs\n 1. Prüfen Sie, ob die Frequenz im Bereich der Spezifikation liegt oder nicht;\n 2. Prüfen Sie, ob die Wechselstromkabel fest und korrekt angeschlossen sind;\n 3. Suchen Sie Hilfe von uns, wenn nicht zurück zu normalen Zustand gehen kann.",
  "ywt.60419.pvPower3": "PV-Leistung 3",
  "ywt.60419.pvPower6": "PV-Leistung 6",
  "50500_0x7571-S-13": "Fehler der Backup-Batterie. \n 1. Prüfen Sie die Batteriekapazität;\n 2. Überprüfen Sie die Verbindung zwischen Batterien und Wechselrichtern;\n 3. Wenn sich der Wechselrichter nach der Lastreduzierung nicht wieder normalisieren kann, wenden Sie sich an uns",
  "ywt.60419.pvPower5": "PV-Leistung 5",
  "50500_0x7571-S-14": "Netzfrequenz außerhalb des Bereichs\n 1. Prüfen Sie, ob die Frequenz im Bereich der Spezifikation liegt oder nicht;\n 2. Prüfen Sie, ob die Wechselstromkabel fest und korrekt angeschlossen sind;\n 3. Suchen Sie Hilfe von uns, wenn nicht zurück zu normalen Zustand gehen kann.",
  "50500_0x7570-C-14": "Soft _ Start _ Fehlgeschlagen",
  "50500_0x7570-C-12": "Parallel _ CANBus _ Fehler",
  "ywt.60419.pvInputVol9": "PV9 Eingangsspannung",
  "ywt.60419.pvInputVol8": "PV8 Eingangsspannung",
  "ywt.60419.pvInputVol7": "PV7 Eingangsspannung",
  "ywt.60419.pvInputVol6": "PV6 Eingangsspannung",
  "ywt.60419.pvInputVol5": "PV5 Eingangsspannung",
  "ywt.60419.pvInputVol4": "PV4 Eingangsspannung",
  "ywt.60419.pvInputVol3": "PV3 Eingangsspannung",
  "ywt.60419.pvChargeTime": "Stromerzeugungszeit",
  "ywt.60419.invDspDebugInfo1": "INV DSP Debugging Information 1",
  "ywt.60419.invDspDebugInfo2": "INV DSP Debugging Information 2",
  "ywt.60419.invDspDebugInfo3": "INV DSP Debugging Information 3",
  "ywt.60419.invDspDebugInfo4": "INV DSP Debugging Information 4",
  "ywt.60419.invDspDebugInfo5": "INV DSP Debugging Information 5",
  "ywt.60419.invDspDebugInfo6": "INV DSP Debugging Information 6",
  "ywt.60419.invDspDebugInfo7": "INV DSP Debugging Information 7",
  "ywt.60419.invDspDebugInfo8": "INV DSP Debugging Information 8",
  "ywt.60419.workStatus0": "Initialisierung",
  "ywt.60419.workStatus1": "Warten auf",
  "ywt.60419.workStatus2": "Netzanschluss",
  "ywt.60419.workStatus3": "Fehler",
  "ywt.60419.workStatus4": "Programmierung",
  "ywt.60419.workStatus5": "Netzunabhängig",
  "ywt.60419.rPhaseDci": "DCI- R-Phase ",
  "50500_0x756F-F-13": "Änderung des Arbeitsmodus",
  "50500_0x756F-F-12": "Batt Mode Changed",
  "common.50500.xnl_RTparam_name_G_P_C_L2": "puissance L2",
  "common.50500.xnl_RTparam_name_G_P_C_L1": "Gen L1 puissance",
  "common.50500.xnl_RTparam_name_G_P_C_L3": "génération L3 Power",
  "paramSet.dateTime.title.hour": "H",
  "ywt.60419.tOnGridCurrent": "Stromanschlussstrom in T-Phase",
  "ywt.60419.tGridPower": "Netzverbundleistung der Phase T",
  "ywt.60419.trGridVol": "TR Netzleitungsspannung",
  "paramSet.dateTime.title.minute": "Min",
  "ywt.60419.loadPower": "Lastleistung",
  "50500_0x7572-S-15": "Die Temperatur des Kühlkörpers ist zu hoch\n 1. Prüfen Sie, ob die Temperatur der Arbeitsumgebung zu hoch ist;\n 2. Schalten Sie den Wechselrichter für 10 Minuten aus und starten Sie ihn neu;\n 3. Suchen Sie Hilfe von uns, wenn nicht zurück zu normalen Zustand gehen kann.",
  "50500_0x7572-S-14": "1. Die ARC-Fehlererkennung ist nur für den US-Markt geeignet;\n 2. Überprüfen Sie den Kabelanschluss des PV-Moduls und beheben Sie den Fehler;\n 3. Suchen Sie Hilfe von uns, wenn nicht zurück zu normalen Zustand gehen kann.",
  "ywt.60419.tPhaseDci": "DCI- T-Phase ",
  "50500_0x7572-S-13": "1.Confirm that the load is appropriate\n2.Ensure sufficient PV energy and Reduce the load appropriately\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-S-12": "1.Confirm that the wiring between each device is correct\n2. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.pvPower11": "PV-Leistung 11",
  "50500_0x7572-S-11": "1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.pvPower10": "PV-Leistung 10",
  "50500_0x7572-S-10": "Batt Shutdown Fault\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-F-8": "AC _ Aktiv _ Batt _ Fehler",
  "50500_0x7570-F-9": "Die DC-Sammelschiene ist unsymmetrisch",
  "ywt.60419.reactivePower": "Blindleistung ",
  "50500_0x7570-F-0": "Aktiv _ Batterie _ Halten",
  "50500_0x7570-F-1": "AC-Überstromfehler der Hardware",
  "50500_0x7570-F-3": "DC-Überstromfehler der Hardware",
  "50500_0x7570-F-5": "Tz _ EmergSStop _ Fehler",
  "50500_0x7570-F-6": "AC-Leckstrom ist transient über Strom",
  "50500_0x7570-F-7": "Impedanzausfall der DC-Isolierung",
  "ywt.60419.rsGirdVol": "RS Netzleitungsspannung",
  "ywt.60419.rOnGridCurrent": "Stromanschlussstrom in R-Phase",
  "ywt.60419.pvInputVol11": "PV11 Eingangsspannung",
  "ywt.60419.pvInputVol10": "PV10 Eingangsspannung",
  "ywt.60419.pvInputVol12": "PV12 Eingangsspannung",
  "50500_0x7571-F-13": "bcakup _ Batterie _ Fehler",
  "50500_0x7571-F-14": "AC über Frequenz",
  "50500_0x7571-F-15": "AC niedrigere Frequenz",
  "50500_0x7570-S-3": "Gleichstromseite über Stromfehler\n 1. Prüfen Sie den Anschluss des PV-Moduls und den Anschluss der Batterie;\n 2. Schalten Sie den DC-Schalter und den AC-Schalter aus und warten Sie dann eine Minute, dann schalten Sie den DC / AC-Schalter wieder ein;\n 3. Suchen Sie Hilfe von uns, wenn nicht zurück zu normalen Zustand gehen kann.",
  "50500_0x7570-S-5": "Bitten Sie uns um Hilfe. Dieser Misserfolg tritt kaum auf.",
  "50500_0x7570-S-6": "Leckstromfehler\n 1. Überprüfen Sie das Kabel von PV-Modul und Wechselrichter;\n 2. Wechselrichter neu starten;\n 3. Suchen Sie Hilfe von uns, wenn nicht zurück zu normalen Zustand gehen kann.",
  "50500_0x7570-S-7": "Der PV-Isolationswiderstand ist zu niedrig\n 1. Prüfen Sie, ob der Anschluss von PV-Paneelen und Wechselrichter fest und korrekt ist;\n 2. Prüfen Sie, ob das PE-Kabel des Wechselrichters mit Masse verbunden ist;\n 3. Suchen Sie Hilfe von uns, wenn nicht zurück zu normalen Zustand gehen kann.",
  "50500_0x7570-S-8": "AC_Active_Batt_Fault\n1.Check the battery fuse;\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-S-9": "1. Bitte warten Sie eine Weile und prüfen Sie, ob es normal ist;\n 2. Wenn immer noch gleich, schalten Sie den DC-Schalter und den AC-Schalter aus und warten Sie eine Minute und schalten Sie dann den DC / AC-Schalter ein;\n 3. Suchen Sie Hilfe von uns, wenn nicht zurück zu normalen Zustand gehen kann.",
  "ywt.60419.totalPvEnergy": "Gesamte Stromerzeugung",
  "50500_0x7570-S-0": "1.Check  insulation in the battery pack.\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-S-1": "AC-Seite über Stromfehler\n 1. Bitte prüfen Sie, ob die Notlastleistung und die allgemeine Lastleistung innerhalb des Bereichs liegen;\n 2. Starten Sie neu und prüfen Sie, ob es normal ist;\n 3. Suchen Sie Hilfe von uns, wenn nicht zurück zu normalen Zustand gehen kann.",
  "50500_0x7570-C-3": "DC-Überstromfehler der Hardware",
  "50500_0x7570-C-5": "Tz _ EmergSStop _ Fehler",
  "50500_0x7570-C-6": "AC-Leckstrom ist transient über Strom",
  "50500_0x7570-C-7": "Impedanzausfall der DC-Isolierung",
  "50500_0x7570-C-8": "AC _ Aktiv _ Batt _ Fehler",
  "50500_0x7570-C-9": "Die DC-Sammelschiene ist unsymmetrisch",
  "50500_0x7571-C-8": "Parallel _ system _ Stop",
  "50500_0x7571-C-9": "AC-Leitung Niederspannung",
  "50500_0x7571-C-6": "DCLLC _ Over _ Current",
  "50500_0x7571-C-7": "Batt _ Over _ Strom",
  "50500_0x756F-S-12": "Batt Mode Changed\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-C-4": "DCLLC _ Soft _ Over _ Cur",
  "50500_0x7571-C-5": "Battery OV ",
  "50500_0x7570-C-0": "Aktiv _ Batterie _ Halten",
  "50500_0x756F-S-14": "INV OCP \n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-C-1": "AC-Überstromfehler der Hardware",
  "50500_0x7571-C-2": "Kein AC-Netz",
  "50500_0x756F-S-13": "Arbeitsmodus des Wechselrichters geändert\n 1. Warten Sie eine Minute und prüfen Sie;\n 2. Suchen Sie Hilfe bei uns, wenn Sie nicht in den normalen Zustand zurückkehren können.",
  "paramSet.dateTime.title.second": "Sek",
  "50500_0x7571-S-8": "Im Parallelsystem aufgrund anderer Wechselrichterfehler.\n 1. Warten Sie minutenlang und überprüfen Sie dann alle Wechselrichter in diesem Parallelsystem;\n 2. Wenn der Wechselrichter nicht in den Normalzustand zurückkehren kann, zeichnen Sie die Fehlercodes aller Wechselrichter auf und wenden Sie sich dann an uns.",
  "50500_0x7571-S-7": "1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-6": "1.Confirm that the wiring between each device is correct\n2.Confirm that the PV voltage is not too low\n3.Confirm that the load is appropriate\n4.Confirm that the device parameter settings are correct\n5.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-5": "1.Confirm if the battery specifications match our device\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-4": "DCLLC_Soft_Over_Cur\n1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-2": "Kein Dienstprogramm\n 1. Bitte bestätigen Sie, dass das Gitter verloren gegangen ist oder nicht;\n 2. Prüfen Sie, ob der Netzanschluss gut ist oder nicht;\n 3. Prüfen Sie, ob der Schalter zwischen Wechselrichter und Netz eingeschaltet ist oder nicht;\n 4. Suchen Sie Hilfe von uns, wenn nicht zurück zu normalen Zustand gehen kann.",
  "ywt.60419.groupStrCurrent23": "String 23 Strom",
  "ywt.60419.groupStrCurrent22": "Strom der Reihe 22",
  "ywt.60419.groupStrCurrent21": "String 21 Strom",
  "ywt.60419.groupStrCurrent20": "Strom der Reihe 20",
  "ywt.60419.pvInputCurrent9": "PV9 Eingangsstrom",
  "ywt.60419.stGirdVol": "ST Netzleitungsspannung",
  "ywt.60419.sGridPower": "Netzanschlusspower der Phase S",
  "50500_0x7571-F-5": "Battery OV ",
  "50500_0x7571-F-6": "DCLLC _ Over _ Current",
  "50500_0x7571-F-4": "DCLLC _ Soft _ Over _ Cur",
  "ywt.60419.groupStrCurrent19": "String 19 Strom",
  "ywt.60419.groupStrCurrent18": "Strom der Reihe 18",
  "50500_0x7571-F-2": "Kein AC-Netz",
  "ywt.60419.groupStrCurrent17": "String 17 Strom",
  "ywt.60419.groupStrCurrent16": "Strom der Reihe 16",
  "ywt.60419.groupStrCurrent15": "String 15 Strom",
  "ywt.60419.groupStrCurrent14": "Strom der Reihe 14",
  "ywt.60419.groupStrCurrent13": "String 13 Strom",
  "ywt.60419.groupStrCurrent12": "Strom der Reihe 12",
  "ywt.60419.groupStrCurrent11": "String 11 Strom",
  "50500_0x7571-F-9": "AC-Leitung Niederspannung",
  "ywt.60419.groupStrCurrent10": "Strom der Reihe 10",
  "50500_0x7571-F-7": "Batt _ Over _ Strom",
  "50500_0x7571-F-8": "Parallel _ system _ Stop",
  "ywt.60419.pvInputCurrent7": "PV7 Eingangsstrom",
  "ywt.60419.leakCurrent": "Leckstrom",
  "ywt.60419.pvInputCurrent8": "PV8 Eingangsstrom",
  "ywt.60419.pvInputCurrent5": "PV5 Eingangsstrom",
  "ywt.60419.pvInputCurrent6": "PV6 Eingangsstrom",
  "ywt.60419.pvInputCurrent3": "PV3 Eingangsstrom",
  "ywt.60419.pvInputCurrent4": "PV4 Eingangsstrom",
  "ywt.60419.pvInputCurrent1": "PV1 Eingangsstrom",
  "ywt.60419.pvInputCurrent2": "PV2 Eingangsstrom",
  "ywt.60419.scanPercentage": "Prozentsatz des I/V-Scans",
  "ywt.60419.powerFactor": "Leistungsfaktor",
  "ywt.60419.loadDropMode10": "ATE-Einstellungsabschwächung",
  "ywt.60419.loadDropMode12": "Abschwächung zur Mehrmaschinen-Rückflussverhinderung",
  "ywt.60419.loadDropMode13": "Überfrequenz-Abschwächung",
  "ywt.60419.onGridCountdown": "Countdown bis zum Netzanschluss",
  "50500_0x7572-S-6": "PV Volt High Fault \n1. Check whether PV voltage is normal;\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-5": "DC Volt Low Fault\n1.Check whether PV voltage is normal;\n2.Check whether battery voltage is normal;\n3.Confirm that the wiring between each device is correct\n4. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-8": "Batt Over Load Fault\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-S-7": "Batteriespannung niedrig\n 1. Prüfen Sie, ob die Batteriespannung zu niedrig ist;\n 2. Wenn die Batteriespannung zu niedrig ist, laden Sie die Batterie mit PV oder Grid auf;\n 3. Suchen Sie Hilfe von uns, wenn nicht zurück zu normalen Zustand gehen kann.",
  "50500_0x7572-S-2": "GFCI Consistent Frault",
  "50500_0x7572-S-1": "Grid Volt Consistent Fault\n1. Check whether grid voltage is normal;\n2. Check whether AC cables are firmly and correctly connected;\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-3": "Inter Comm Fault\n1.Confirm that the wiring between each device is correct\n2. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-9": "1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.radiatorTemp": "Heizkörpertemperatur(℃)",
  "50500_0x7572-C-7": "DC-Sammelschienenspannung ist zu niedrig",
  "ywt.60419.rsGridFrequency": "RS-Netzfrequenz",
  "50500_0x7572-S-0": "INV Volt Consistent Fauit\n1. Check whether grid voltage is normal;\n2. Check whether AC cables are firmly and correctly connected;\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-C-9": "BMS-KommunikationsfehlerBMS",
  "ywt.60419.loadDropMode3": "Wechselrichter-Abschwächung",
  "ywt.60419.loadDropMode2": "BST-Abschwächung bei hoher Temperatur",
  "ywt.60419.loadDropMode1": "Abschwächung bei hoher Spannung",
  "ywt.60419.loadDropMode0": "Keine Abschwächung（",
  "50500_0x756F-F-9": "AuxPowerBoard _ Fehler",
  "ywt.60419.loadDropMode9": "AC-Hochspannungs-Abschwächung",
  "ywt.60419.loadDropMode8": "Laststeigungs-Abschwächung",
  "ywt.60419.loadDropMode7": "Blindleistungs-Abschwächung",
  "ywt.60419.loadDropMode6": "MPPT-Reset-Abschwächung",
  "ywt.60419.loadDropMode5": "PF-Abschwächung",
  "ywt.60419.loadDropMode4": "Umgebungstemperatur-Abschwächung",
  "50500_0x756F-F-2": "GFCI Device Fault",
  "50500_0x7570-S-12": "Dies gilt nur für Wechselrichter, die im Parallelbetrieb arbeiten\n 1. Überprüfen Sie die Paralleleinstellung gemäß den Anweisungen;\n 2. Überprüfen Sie den Anschluss des CANBus;\n 3. Suchen Sie Hilfe bei uns",
  "50500_0x756F-F-4": "EEPROM Read Fault",
  "50500_0x7570-S-14": "Soft_Start_Failed\n1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3.Confirm that the battery level is not too low\n4. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-F-6": "DC / DC _ Softsart _ Fehler",
  "50500_0x756F-F-5": "EEPROM Write Fault",
  "50500_0x7571-C-15": "AC niedrigere Frequenz",
  "ywt.60419.activePower": "Wirkleistung",
  "50500_0x7570-S-11": "Parallel Set Faut \n1.Confirm that the device parameter settings are correct\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-C-14": "AC über Frequenz",
  "50500_0x7570-S-10": "Bus Volt unbanlence\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-F-7": "INV Relay Fault",
  "50500_0x7571-C-13": "bcakup _ Batterie _ Fehler",
  "paramSet.dateTime.title.day": "T",
  "50500_0x7572-F-14": "ARC-Fehler",
  "50500_0x7572-F-15": "Ausfall des Kühlkörpers bei hohen Temperaturen",
  "50500_0x7572-F-7": "DC-Sammelschienenspannung ist zu niedrig",
  "50500_0x7572-F-9": "BMS-KommunikationsfehlerBMS",
  "ywt.60419.meterPower": "Gesamtleistung des Stromzählers",
  "paramSet.input.dataError.tip": "Der Wert liegt nicht im angemessenen Bereich, bitte setzen Sie ihn zurück.",
  "ywt.60419.workStatus": "Betriebszustand des Wechselrichters",
  "ywt.60419.tGridVol": "T Netzphasenspannung",
  "ywt.60419.sOnGridCurrent": "Stromanschlussstrom in S-Phase",
  "ywt.60419.nbusVol": "NBUS Spannung",
  "ywt.60419.pvInputCurrent10": "PV10 Eingangsstrom",
  "ywt.60419.pvInputCurrent11": "PV11 Eingangsstrom",
  "ywt.60419.pvInputCurrent12": "PV12 Eingangsstrom",
  "current.collector.upgrade.progress": "Der aktuelle Upgrade-Fortschritt des Sammlers beträgt",
  "CSP Plant": "Solarthermisches Kraftwerk",
  "platformType.android": "Android",
  "platformType.ios": "IOS",
  "NC2022": "New Caledonia_NC2022",
  "EN50549_IE": "EU_EN50549_IE",
  "PR_240VAC": "PR_240VAC",
  "VDE0126_GR": "France_VDE0126_GR",
  "PPDS": "Czechia_PPDS",
  "NCRFG": "Poland_NCRFG",
  "NF50549_1": "France_NF50549_1",
  "RESERVE_SFAY_E": "China_NBT32004",
  "50901.ctrl_ESS_Advanced_Config-System.grid_ct_reverse_enable": "Grid CT Umkehrfreigabe",
  "50901.ctrl_ESS_Advanced_Config-System.pv_ct_reverse_enable": "PV CT Umkehrfreigabe",
  "50901.ctrl_ESS_Advanced_Config-System.grid_meter_ratio": "Grid CT Zähler Übersetzungsverhältnis Einstellung",
  "50901.ctrl_ESS_Advanced_Config-System.pv_meter_ratio": "PV CT Zähler Übersetzungsverhältnis Einstellung",
  "50901.ctrl_Config-Grid Profile.country": " Land / Netzstandardland",
  "50901.ctrl_Device.meterConfiguration": "Zählerkonfiguration",
  "50901.ctrl_WorkMode.workMode": "EMS Betriebsmodus",
  "50901.ctrl_ESS_Advanced_Config-System": "Erweiterte Konfiguration - System",
  "50901.ctrl_Config-Grid Profile": "Konfiguration - Netzparameter",
  "50901.ctrl_Device": "Steuerung_Gerät",
  "50901.ctrl_WorkMode": "Arbeitsmodus / Betriebsmodus",
  "connect.type.wifi": "WLAN",
  "connect.type.lan": "LAN",
  "50901.ctrl_WorkModeSetting": "Einstellung des Arbeitsmodus",
  "50901.ctrl_WorkMode-Backup": "Betriebsmodus - Backup",
  "50901.ctrl_WorkMode-economic": "Betriebsmodus - Ökonomisch",
  "50901.ctrl_WorkMode-forceCharge": "Betriebsmodus - Erzwingtes Aufladen",
  "50901.ctrl_WorkMode-forceDischarge": "Betriebsmodus - Erzwingte Entladung",
  "50901.ctrl_WorkMode-peakMeter": "Betriebsmodus - Spitzenzähler",
  "50901.ctrl_WorkMode-Selfuse": "Betriebsmodus - Eigenverbrauch",
  "50901.ctrl_WorkMode-TOU": "Betriebsmodus - TOU",
  "50901.ctrl_WorkMode-TOU.touModeReserveSoc.desc": "TOU-Modus - Reservierter SOC",
  "50901.ctrl_Device.meterConfiguration.desc": "Beschreibung der Zählerkonfiguration",
  "50901.ctrl_Config-Grid Profile.country.desc": "Beschreibung des Landes / Netzzuordnungstandardslandes",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.1": "Aktivieren ",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.1": "Aktivieren ",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.1": "Aktivieren ",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.1": "Aktivieren ",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.1": "Aktivieren ",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.1": "Aktivieren ",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.1": "Aktivieren ",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange26.1": "Aktivieren ",
  "50901.ctrl_Device.meterConfiguration.0": "Kein Zählertyp",
  "50901.ctrl_Device.meterConfiguration.1": "Konfigurieren des Netzseitigen Zählers",
  "50901.ctrl_Device.meterConfiguration.2": "Konfigurieren des PV-Zählers",
  "50901.ctrl_Device.meterConfiguration.3": "Konfigurieren des Netzseitigen + PV-Zählers",
  "Do_not_connect": "Nicht verbinden",
  "connect.type.Do.not.connect": "Nicht verbinden",
  "platformType.web": "Web",
  "50901.Backup": "Backup / Reserve",
  "50901.Battery": "Batterie",
  "50901.ClockSetting": "Uhreinstellung",
  "50901.Connection": "Kommunikationsverbindung",
  "50901.ctrl_Config": "Kommunikationsverbindungssteuerung",
  "50901.ctrl_Config.Device.checkTime.desc": "Beschreibung Gerätezeit",
  "50901.ctrl_Dry_Contact": "Trockenkontakt Einstellung",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.chargingPileRatedCurrent.desc": "Nennstrom EV-Ladestation",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.homeInletBreakerRatedCurrent.desc": "Nennstrom Hauptsicherung",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.desc": "Zeitgesteuerter Modus - Batterie-SOC aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStartSoc.desc": "Zeitgesteuerter Modus - Batterie Start-SOC",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStopSoc.desc": "Zeitgesteuerter Modus - Batterie Stopp-SOC",
  "50901.ctrl_ESS_Advanced_Config": "Erweiterte Konfiguration",
  "50901.ctrl_Safety": "Sicherheitsvorschriften",
  "50901.ctrl_WorkMode.TOU.touModeReserveSoc.desc": "TOU-Modus reservierter SOC",
  "50901.DCI": "Dc-Trennung",
  "50901.Device": "Gerät",
  "50901.economic": "Wirtschaftsmodus / Ökonomischer Modus",
  "50901.EPS": "Notstromversorgung",
  "50901.forceCharge": "Zwangsladung",
  "50901.forceDischarge": "Zwangsentladung",
  "50901.FRT": "Frequenz-Durchschlagsvermögen / Frt",
  "50901.FW": "Frequenzdrift",
  "50901.Gateway": "Gateway",
  "50901.Generator": "Generator",
  "50901.Grid Profile": "Netzparameter",
  "50901.otaHttpUrl.otaHttpUrl.desc": "Beschreibung Upgrade-Befehl",
  "50901.peakMeter": "Spitzenmessung",
  "50901.PV": "Chint Einphasig",
  "50901.RCD": "Fehlerstromschutz",
  "50901.real_time.copy_dspVersionMainUVersion.desc": "Beschreibung Dsp-Version (Haupt-U-Version)",
  "50901.real_time.dTSReset.desc": "Beschreibung Daten-Stick-Reset",
  "50901.real_time.数据分析_AC光伏功率.tag": "Ac Pv-Wirkleistung",
  "50901.real_time.数据分析_AC光伏无功功率.tag": "Ac Pv-Blindleistung",
  "50901.real_time.数据分析_AC光伏有功功率.tag": "Ac Pv-Scheinleistung / Wirkleistung",
  "50901.real_time.数据分析_AC光伏电压.tag": "Ac Pv-Spannung",
  "50901.real_time.数据分析_AC光伏电流.tag": "Ac Pv-Strom",
  "50901.real_time.数据分析_EPS功率.tag": "Eps-Leistung",
  "50901.real_time.数据分析_EPS电压.tag": "Eps-Spannung",
  "50901.real_time.数据分析_EPS电流.tag": "Eps-Strom",
  "50901.real_time.数据分析_单体SOC.tag": "Zellen-SOC",
  "50901.real_time.数据分析_发电机功率.tag": "Generatorleistung",
  "50901.real_time.数据分析_发电机电压.tag": "Generatorspannung",
  "50901.real_time.数据分析_发电机电流.tag": "Generatorstrom",
  "50901.real_time.数据分析_混逆光伏功率.tag": "Hybrid-Wechselrichter Pv-Leistung",
  "50901.real_time.数据分析_混逆光伏电压.tag": "Hybrid-Wechselrichter Pv-Spannung",
  "50901.real_time.数据分析_混逆光伏电流.tag": "Hybrid-Wechselrichter Pv-Strom",
  "50901.real_time.数据分析_电池包.tag": "Batteriepaket",
  "50901.real_time.数据分析_电网功率.tag": "Netzleistung",
  "50901.real_time.数据分析_电网电压.tag": "Netzspannung",
  "50901.real_time.数据分析_电网电流.tag": "Netzstrom",
  "50901.RPC": "Nein",
  "50901.RR": "Änderungsrate",
  "50901.RT": "Bedeutung Des Enumerationswerts 0",
  "50901.Settings": "Arbeitsmodus / Betriebsmodus",
  "50901.Settings-Load_Control": "Laststeuerung",
  "50901.Settings-Manual_Control": "Bedeutung Des Enumerationswerts 0",
  "50901.Switch": "Modusumschaltung",
  "50901.System": "Bedeutung Des Enumerationswerts 0",
  "50901.VRT": "Bedeutung Des Enumerationswerts 0",
  "50901.VW": "Spannungsdrift",
  "50901.ctrl_Config.Device.networkingType.desc": "Beschreibung Netzanschlusstyp",
  "50901.fault.arcFault.desc": "Beschreibung Störlichtbogenfehler",
  "50901.fault.arcSelfTestFault.desc": "Beschreibung Störlichtbogen-Selbsttestfehler",
  "50901.fault.armCommunicationFault.desc": "Beschreibung ARM-Kommunikationsfehler",
  "50901.fault.auxiliaryPowerAbnormality.desc": "Beschreibung Hilfsstromversorgung anomal",
  "50901.Fault.batteryCapacityAbnormality.desc": "Beschreibung Batteriekapazität anomal",
  "50901.Fault.batteryFault.desc": "Beschreibung Batteriefehler",
  "50901.Fault.batteryForceChargeRequest.desc": "Beschreibung Batterie-Zwangsladeanforderung",
  "50901.Fault.bmsCanCommunicationAbnormality.desc": "Beschreibung BMS-CAN-Kommunikation anomal",
  "50901.fault.busbarAbnormality.desc": "Beschreibung DC-Zwischenkreis anomal",
  "50901.fault.cmpssBiasCalculationError.desc": "Beschreibung CMPSS-Offset-Berechnungsfehler",
  "50901.fault.comparatorFault.desc": "Beschreibung Komparatorfehler",
  "50901.fault.driveAbnormality.desc": "Beschreibung Ansteuerung anomal",
  "50901.Fault.dspPwrCommunicationAbnormality.desc": "Beschreibung DSP-Stromversorgungskommunikation anomal",
  "50901.Fault.dspSafCommunicationAbnormality.desc": "Beschreibung DSP-Sicherheitskommunikation anomal",
  "50901.Fault.dtsCommunicationAbnormality.desc": "Beschreibung DTS-Kommunikation anomal",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.desc": "Beschreibung DTU1 RS485-Kommunikation anomal",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.desc": "Beschreibung DTU2 RS485-Kommunikation anomal",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.desc": "Beschreibung DTU3 RS485-Kommunikation anomal",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.desc": "Beschreibung DTU4 RS485-Kommunikation anomal",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.desc": "Beschreibung DTU5 RS485-Kommunikation anomal",
  "50901.fault.e2rpomFault.desc": "Beschreibung EEPROM-Fehler",
  "50901.fault.emergencyStopSwitchStatus.desc": "Beschreibung Not-Aus",
  "50901.fault.epsOverload.desc": "Beschreibung EPS-Überlast",
  "50901.fault.epsRelayProtection.desc": "Beschreibung EPS-Relais-Schutz",
  "50901.fault.epsVoltageAbnormality.desc": "Beschreibung EPS-Spannung anomal",
  "50901.Fault.evCharger1CommunicationAbnormality.desc": "Beschreibung EV-Ladestation 1 Kommunikation anomal",
  "50901.Fault.evCharger1Fault.desc": "Beschreibung Fehler Ladestation 1",
  "50901.Fault.evCharger2CommunicationAbnormality.desc": "Beschreibung EV-Ladestation 2 Kommunikation anomal",
  "50901.Fault.evCharger2Fault.desc": "Beschreibung Fehler Ladestation 2",
  "50901.fault.fanFault.desc": "Beschreibung Lüfterfehler",
  "50901.Fault.fanSpeedAbnormality.desc": "Beschreibung Lüfterdrehzahl anomal",
  "50901.fault.fiveVoltPowerSupplyFault.desc": "Beschreibung Fehler 5V-Stromversorgung",
  "50901.fault.flashCommunicationFault.desc": "Beschreibung Flash-Speicher Kommunikationsfehler",
  "50901.fault.frequencyVariationRateOutOfRange.desc": "Beschreibung Frequenzänderungsrate überschritten",
  "50901.fault.genAbnormality.desc": "Beschreibung Generator anomal",
  "50901.fault.genOverload.desc": "Beschreibung Generatorüberlast",
  "50901.fault.genPortOvercurrent.desc": "Beschreibung Generatoranschluss Überstrom",
  "50901.fault.genRelayAFault.desc": "Beschreibung Generator A Relaisfehler",
  "50901.fault.genRelayBFault.desc": "Beschreibung Generator B Relaisfehler",
  "50901.fault.gridCurrentDcOffsetOutOfRange.desc": "Beschreibung Netzstrom DC-Offset überschritten",
  "50901.fault.gridMeter.desc": "Beschreibung Netz-Zähler Kommunikationsfehler",
  "50901.Fault.gridMeterCommunicationAbnormality.desc": "Beschreibung Netz-Zähler Kommunikation anomal",
  "50901.Fault.gridMeterTypeError.desc": "Beschreibung Netz-Zähler Typfehler",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.desc": "Beschreibung Inselspannung DC-Offset überschritten",
  "50901.fault.gridOverfrequency.desc": "Beschreibung Netzfrequenz zu hoch / Überfrequenz",
  "50901.fault.gridOvervoltage.desc": "Beschreibung Netzspannung zu hoch / Überspannung",
  "50901.fault.gridPortOvercurrent.desc": "Beschreibung Netzanschluss Überstrom",
  "50901.fault.gridPowerOutage.desc": "Beschreibung Netzausfall",
  "50901.fault.gridRelayProtection.desc": "Beschreibung Netzrelais-Schutz",
  "50901.fault.gridUnderfrequency.desc": "Beschreibung Netzfrequenz zu niedrig / Unterfrequenz",
  "50901.fault.gridUndervoltage.desc": "Beschreibung Netzspannung zu niedrig / Unterspannung",
  "50901.fault.gridVoltageAbnormality.desc": "Beschreibung Netzspannung anomal",
  "50901.Fault.hmidCommunicationAbnormality.desc": "Beschreibung HMI-Kommunikation anomal",
  "50901.Fault.hmidMachineFault.desc": "Beschreibung HMI-Gerätefehler",
  "50901.fault.insulationFault.desc": "Beschreibung Isolationsfehler",
  "50901.fault.interruptOverflow.desc": "Beschreibung Interrupt-Überlauf",
  "50901.fault.inverterCanCommunicationFailed.desc": "Beschreibung Wechselrichter CAN-Kommunikationsfehler",
  "50901.fault.inverterCommunicationFailed.desc": "Beschreibung Wechselrichter Kommunikationsfehler",
  "50901.fault.kmRelayFault.desc": "Beschreibung KM-Relaisfehler",
  "50901.fault.lineToEarthFault.desc": "Beschreibung Erdschluss (Phase-Erde)",
  "50901.fault.loadRelayAFault.desc": "Beschreibung Last A Relaisfehler",
  "50901.fault.loadRelayBFault.desc": "Beschreibung Last B Relaisfehler",
  "50901.fault.lowAmbientTemperature.desc": "Beschreibung Umgebungstemperatur zu niedrig",
  "50901.Fault.lowDtuVersion.desc": "Beschreibung DTU-Version zu niedrig",
  "50901.fault.machineTypeMismatch.desc": "Beschreibung Gerätemodell nicht passend",
  "50901.Fault.masterSlaveCommunicationAbnormality.desc": "Beschreibung Master-Slave-Kommunikation anomal",
  "50901.fault.meterWiringAbnormality.desc": "Beschreibung Zählerverdrahtung anomal",
  "50901.fault.microelectronicFault.desc": "Beschreibung Mikroelektronikfehler",
  "50901.fault.neutralWireNotConnected.desc": "Beschreibung Neutralleiter nicht angeschlossen",
  "50901.fault.neutralWireToEarthFault.desc": "Beschreibung Neutralleiter-Erde-Fehler",
  "50901.fault.overTemperature.desc": "Beschreibung Übertemperatur",
  "50901.fault.overtemperatureAlarm.desc": "Beschreibung Überhitzungsalarm",
  "50901.fault.pllLockFailed.desc": "Beschreibung PLL-Synchronisationsfehler",
  "50901.fault.preSynchronizationFailed.desc": "Beschreibung Fehler bei Vor-Synchronisation",
  "50901.fault.pvFault.desc": "Beschreibung PV-Fehler",
  "50901.Fault.pvMeterCommunicationAbnormality.desc": "Beschreibung PV-Zähler Kommunikation anomal",
  "50901.Fault.pvMeterTypeError.desc": "Beschreibung PV-Zähler Typfehler",
  "50901.fault.pvPortOvercurrent.desc": "Beschreibung PV-Anschluss Überstrom",
  "50901.fault.pvRelayAbFault.desc": "Beschreibung PV-AB-Relaisfehler",
  "50901.fault.pvVoltageExceedingBusVoltage.desc": "Beschreibung PV-Spannung überschreitet Zwischenkreisspannung",
  "50901.fault.rcdFault.desc": "Beschreibung RCD-Fehler (Fehlerstromschutzschalter)",
  "50901.fault.rcdSelfTestFault.desc": "Beschreibung RCD-Selbsttestfehler",
  "50901.fault.reconnectionFailed.desc": "Beschreibung Wiederverbindungsfehler",
  "50901.fault.samplingBiasAbnormality.desc": "Beschreibung Abtast-Offset anomal",
  "50901.fault.shutDown.desc": "Beschreibung Systemabschaltung",
  "50901.Fault.slaveWrongBatteryConnection.desc": "Beschreibung Slave-Batterie Anschlussfehler",
  "50901.fault.smartloadPortOvercurrent.desc": "Beschreibung Smart-Load-Anschluss Überstrom",
  "50901.fault.spiCommunicationFault.desc": "Beschreibung SPI-Kommunikationsfehler",
  "50901.Fault.sustainedNegativeLoad.desc": "Beschreibung Anhaltende negative Last",
  "50901.fault.temperatureAbnormality.desc": "Beschreibung Temperatur anomal",
  "50901.fault.tenMinuteOvervoltage.desc": "Beschreibung 10-Minuten-Überspannung",
  "50901.fault.threePointThreeVoltPowerSupplyFault.desc": "Beschreibung Fehler 3.3V-Stromversorgung",
  "50901.fault.twelveVoltPowerSupplyFault.desc": "Beschreibung Fehler 12V-Stromversorgung",
  "50901.fault.versionMismatch.desc": "Beschreibung Versionskonflikt / Version nicht passend",
  "50901.fault.wiringAbnormality.desc": "Beschreibung Verdrahtung anomal",
  "50901.real_time.12vAuxiliaryVoltageSampling.desc": "Beschreibung 12V Hilfsspannungsabtastung",
  "50901.real_time.12vOutputVoltageSampling.desc": "Beschreibung 12V Ausgangsspannungsabtastung",
  "50901.real_time.3_3vAuxiliaryVoltageSampling.desc": "Beschreibung 3.3V Hilfsspannungsabtastung",
  "50901.real_time.5vAuxiliaryVoltageSampling.desc": "Beschreibung 5V Hilfsspannungsabtastung",
  "50901.real_time.afciVersion.desc": "Beschreibung AFCI-Version",
  "50901.real_time.ambientTemperatureSampling.desc": "Beschreibung Umgebungstemperaturabtastung",
  "50901.real_time.appSoftwareVersion.desc": "Beschreibung APP-Softwareversion",
  "50901.real_time.batteryChargePower.desc": "Beschreibung Batterie kumulierte Ladekapazität",
  "50901.real_time.batteryConnectionStatus.desc": "Beschreibung Batterie-Anschlussstatus",
  "50901.real_time.batteryCurrent.desc": "Beschreibung Batteriestrom",
  "50901.real_time.batteryDailyChargeEnergy.desc": "Beschreibung Batterie tägliche Ladekapazität",
  "50901.real_time.batteryDailyDischargeEnergy.desc": "Beschreibung Batterie tägliche Entladekapazität",
  "50901.real_time.batteryDischargePower.desc": "Beschreibung Batterie kumulierte Entladekapazität",
  "50901.real_time.batteryModuleNum.desc": "Beschreibung Batterie-Zellenanzahl (Reihenschaltung pro Modul)",
  "50901.real_time.batteryPower.desc": "Beschreibung Batterieleistung (Laden/Entladen)",
  "50901.real_time.batteryPowerWholeSystem.desc": "Beschreibung Batterie-Gesamtleistung (Gesamtsystem)",
  "50901.real_time.batterySoc.desc": "Beschreibung Batterie-SOC",
  "50901.real_time.batteryToLoadPower.desc": "Beschreibung Batteriezufuhr zur Last / Batterie-zu-Last Leistung",
  "50901.real_time.batterytotCap.desc": "Beschreibung Batterie Gesamtinstallierte Kapazität",
  "50901.real_time.batteryType_04.desc": "Beschreibung Batterietyp",
  "50901.real_time.batteryVoltage.desc": "Beschreibung Batteriespannung",
  "50901.real_time.batteryWorkingStatus.desc": "Beschreibung Batteriestatus",
  "50901.real_time.bootSoftwareVersion.desc": "Beschreibung Bootloader-Softwareversion",
  "50901.real_time.communicationStickHardwareVersion.desc": "Beschreibung Kommunikationsstick Hardwareversion",
  "50901.real_time.communicationStickSn.desc": "Beschreibung Kommunikationsstick SN",
  "50901.real_time.communicationStickSoftwareVersion.desc": "Beschreibung Kommunikationsstick Softwareversion",
  "50901.real_time.dailyBatteryToLoadEnergy.desc": "Beschreibung Heute Batterie-zu-Last Energie",
  "50901.real_time.dailyExportEnergyToGrid.desc": "Beschreibung Heute Verkaufsenergie",
  "50901.real_time.dailyGridToLoadEnergy.desc": "Beschreibung Heute Netz-zu-Last Energie",
  "50901.real_time.dailyImportEnergyFromGrid.desc": "Beschreibung Heute Bezugsenergie",
  "50901.real_time.dailyPvToBatteryEnegry.desc": "Beschreibung Heute PV-zu-Batterie Energie",
  "50901.real_time.dailyPvToGridEnegry.desc": "Beschreibung Heute PV-zu-Netz Energie",
  "50901.real_time.dailyPvToLoadEnegry.desc": "Beschreibung Heute PV-zu-Last Energie",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.desc": "Beschreibung DRM-Status (für Australien/Deutschland/Österreich)",
  "50901.real_time.dspVersionAuxiliaryUVersion.desc": "Beschreibung DSP-Version (Hilfs-U-Version)",
  "50901.real_time.externalFanSpeed1.desc": "Beschreibung Äußere Lüfterdrehzahl 1",
  "50901.real_time.externalFanSpeed2.desc": "Beschreibung Äußere Lüfterdrehzahl 2",
  "50901.real_time.externalFanSpeed3.desc": "Beschreibung Äußere Lüfterdrehzahl 3",
  "50901.real_time.externalFanSpeed4.desc": "Beschreibung Äußere Lüfterdrehzahl 4",
  "50901.real_time.firmwareBuildTimeDateHour.desc": "Beschreibung Firmware-Erstellungszeit (Tag/Stunde)",
  "50901.real_time.firmwareBuildTimeYearMonth.desc": "Beschreibung Firmware-Erstellungszeit (Jahr & Monat)",
  "50901.real_time.firmwareCrc.desc": "Beschreibung Firmware-CRC",
  "50901.real_time.firmwareEndAddressHigh.desc": "Beschreibung Firmware-Endadresse (Hoch)",
  "50901.real_time.firmwareEndAddressLow.desc": "Beschreibung Firmware-Endadresse (Niedrig)",
  "50901.real_time.firmwareInformationCrc.desc": "Beschreibung Firmware-Info-CRC",
  "50901.real_time.firmwareStartAddressHigh.desc": "Beschreibung Firmware-Startadresse (Hoch)",
  "50901.real_time.firmwareStartAddressLow.desc": "Beschreibung Firmware-Startadresse (Niedrig)",
  "50901.real_time.generatorCurrentA.desc": "Beschreibung Generator Phase A Strom",
  "50901.real_time.generatorCurrentB.desc": "Beschreibung Generator Phase B Strom",
  "50901.real_time.generatorCurrentC.desc": "Beschreibung Generator Phase C Strom",
  "50901.real_time.generatorDailyYield.desc": "Beschreibung Generator Tageserzeugung",
  "50901.real_time.generatorPower.desc": "Beschreibung Generatorleistung",
  "50901.real_time.generatorPowerA.desc": "Beschreibung Generator Phase A Leistung",
  "50901.real_time.generatorPowerB.desc": "Beschreibung Generator Phase B Leistung",
  "50901.real_time.generatorPowerC.desc": "Beschreibung Generator Phase C Leistung",
  "50901.real_time.generatorTotalYield.desc": "Beschreibung Generator kumulierte Erzeugung",
  "50901.real_time.gridBuyPower.desc": "Beschreibung Kumulierte Bezugsenergie",
  "50901.real_time.gridCurrentA.desc": "Beschreibung Netzseite Phase A Strom",
  "50901.real_time.gridCurrentB.desc": "Beschreibung Netzseite Phase B Strom",
  "50901.real_time.gridCurrentC.desc": "Beschreibung Netzseite Phase C Strom",
  "50901.real_time.gridMeasurementOfRadiatorTemperature.desc": "Beschreibung Netzseite Kühlkörpertemperatur",
  "50901.real_time.gridMeterSerialNumber.desc": "Beschreibung Netzseite Zähler Seriennummer",
  "50901.real_time.gridPower.desc": "Beschreibung Netzseite Leistung",
  "50901.real_time.gridPowerA.desc": "Beschreibung Netzseite Phase A Leistung",
  "50901.real_time.gridPowerB.desc": "Beschreibung Netzseite Phase B Leistung",
  "50901.real_time.gridPowerC.desc": "Beschreibung Netzseite Phase C Leistung",
  "50901.real_time.gridPowerFactor.desc": "Beschreibung Netzseite Leistungsfaktor",
  "50901.real_time.gridPowerFactorA.desc": "Beschreibung Netzseite Phase A Leistungsfaktor",
  "50901.real_time.gridPowerFactorB.desc": "Beschreibung Netzseite Phase B Leistungsfaktor",
  "50901.real_time.gridPowerFactorC.desc": "Beschreibung Netzseite Phase C Leistungsfaktor",
  "50901.real_time.gridPowerWholeSystem.desc": "Beschreibung Netz Gesamtleistung (Gesamtsystem)",
  "50901.real_time.gridReactivePower.desc": "Beschreibung Netzseite Blindleistung",
  "50901.real_time.gridReactivePowerA.desc": "Beschreibung Netzseite Phase A Blindleistung",
  "50901.real_time.gridReactivePowerB.desc": "Beschreibung Netzseite Phase B Blindleistung",
  "50901.real_time.gridReactivePowerC.desc": "Beschreibung Netzseite Phase C Blindleistung",
  "50901.real_time.gridSellPower.desc": "Beschreibung Kumulierte Verkaufsenergie",
  "50901.real_time.gridTotalFrequency.desc": "Beschreibung Netzseite Frequenz",
  "50901.real_time.gridVoltageA.desc": "Beschreibung Netzseite Phase A Spannung",
  "50901.real_time.gridVoltageB.desc": "Beschreibung Netzseite Phase B Spannung",
  "50901.real_time.gridVoltageC.desc": "Beschreibung Netzseite Phase C Spannung",
  "50901.real_time.hoymilesSerialNumber.desc": "Beschreibung Hoymiles Seriennummer",
  "50901.real_time.internalFanSpeed1.desc": "Beschreibung Innere Lüfterdrehzahl 1",
  "50901.real_time.internalFanSpeed2.desc": "Beschreibung Innere Lüfterdrehzahl 2",
  "50901.real_time.internalFanSpeed3.desc": "Beschreibung Innere Lüfterdrehzahl 3",
  "50901.real_time.inverterHardwareVersion.desc": "Beschreibung Wechselrichter Hardwareversion",
  "50901.real_time.inverterModelNumber.desc": "Beschreibung Wechselrichter Modellnummer",
  "50901.real_time.inverterSideRadiatorTemperature.desc": "Beschreibung Wechselrichter Seite Kühlkörpertemperatur",
  "50901.real_time.inverterTemp.desc": "Beschreibung Wechselrichter Innere Betriebstemperatur",
  "50901.real_time.loadEnergy.desc": "Beschreibung Last Täglicher Energieverbrauch",
  "50901.real_time.loadPowerWholeSystem.desc": "Beschreibung Last Gesamtleistung (Gesamtsystem)",
  "50901.real_time.macAddr.desc": "Beschreibung MAC-Adresse",
  "50901.real_time.materType.desc": "Beschreibung Zählertyp",
  "50901.real_time.maxCellSoc.desc": "Beschreibung Maximaler Zellen-SOC",
  "50901.real_time.maxCellSocCellId.desc": "Beschreibung Maximaler Zellen-SOC entsprechender Index",
  "50901.real_time.maxCellTemperature.desc": "Beschreibung Maximale Zellentemperatur",
  "50901.real_time.maxCellTemperatureCellId.desc": "Beschreibung Maximale Zellentemperatur entsprechender Index",
  "50901.real_time.maxCellVoltage.desc": "Beschreibung Maximale Zellenspannung",
  "50901.real_time.maxCellVoltageCellId.desc": "Beschreibung Maximale Zellenspannung entsprechender Index",
  "50901.real_time.MaxChargeCurrent.desc": "Beschreibung Maximaler Ladestrom",
  "50901.real_time.MaxDisChargeCurrent.desc": "Beschreibung Maximaler Entladestrom",
  "50901.real_time.meterFlag.desc": "Beschreibung Zähler-Flag",
  "50901.real_time.minCellSoc.desc": "Beschreibung Minimaler Zellen-SOC",
  "50901.real_time.minCellSocCellId.desc": "Beschreibung Minimaler Zellen-SOC entsprechender Index",
  "50901.real_time.minCellTemperature.desc": "Beschreibung Minimale Zellentemperatur",
  "50901.real_time.minCellTemperatureCellId.desc": "Beschreibung Minimale Zellentemperatur entsprechender Index",
  "50901.real_time.minCellVoltage.desc": "Beschreibung Minimale Zellenspannung",
  "50901.real_time.minCellVoltageCellId.desc": "Beschreibung Minimale Zellenspannung entsprechender Index",
  "50901.real_time.mpptTemp.desc": "Beschreibung PV-Seite Kühlkörpertemperatur",
  "50901.real_time.numberOfChargingAndDischargingCyclesOfBatteryPack.desc": "Beschreibung Batteriepaket Lade-/Entladezyklus Anzahl",
  "50901.real_time.oemModelName.desc": "Beschreibung OEM Modellname",
  "50901.real_time.oemSerialNumber.desc": "Beschreibung OEM Seriennummer",
  "50901.real_time.packCurrent.desc": "Beschreibung Batteriepaket Strom",
  "50901.real_time.packNum.desc": "Beschreibung Parallelanzahl (Anzahl Batteriepakete)",
  "50901.real_time.packPower.desc": "Beschreibung Batteriepaket Leistung",
  "50901.real_time.packSoc.desc": "Beschreibung Batteriepaket SOC",
  "50901.real_time.packSoh.desc": "Beschreibung Batteriepaket SOH",
  "50901.real_time.packVoltage.desc": "Beschreibung Batteriepaket Spannung",
  "50901.real_time.powerGeneration.desc": "Beschreibung PV kumulierte Erzeugung",
  "50901.real_time.pv1RealTimePower.desc": "Beschreibung PV1 Ist-Leistung",
  "50901.real_time.pv2RealTimePower.desc": "Beschreibung PV2 Ist-Leistung",
  "50901.real_time.pv3RealTimePower.desc": "Beschreibung PV3 Ist-Leistung",
  "50901.real_time.pv4RealTimePower.desc": "Beschreibung PV4 Ist-Leistung",
  "50901.real_time.pvDailyYield.desc": "Beschreibung PV Tageserzeugung",
  "50901.real_time.pvMeterConnectionStatus.desc": "Beschreibung PV-Zähler Verbindungsstatus",
  "50901.real_time.pvMeterCurrentA.desc": "Beschreibung PV-Zähler Phase A Strom",
  "50901.real_time.pvMeterCurrentB.desc": "Beschreibung PV-Zähler Phase B Strom",
  "50901.real_time.pvMeterCurrentC.desc": "Beschreibung PV-Zähler Phase C Strom",
  "50901.real_time.pvMeterDailyYield.desc": "Beschreibung Externer Wechselrichter Tageserzeugung",
  "50901.real_time.pvMeterFrequency.desc": "Beschreibung PV-Zähler Frequenz",
  "50901.real_time.pvMeterPhaseAActivePower.desc": "Beschreibung PV-Zähler Phase A Wirkleistung",
  "50901.real_time.pvMeterPhaseAPowerFactor.desc": "Beschreibung PV-Zähler Phase A Leistungsfaktor",
  "50901.real_time.pvMeterPhaseAReactivePower.desc": "Beschreibung PV-Zähler Phase A Blindleistung",
  "50901.real_time.pvMeterPhaseBActivePower.desc": "Beschreibung PV-Zähler Phase B Wirkleistung",
  "50901.real_time.pvMeterPhaseBPowerFactor.desc": "Beschreibung PV-Zähler Phase B Leistungsfaktor",
  "50901.real_time.pvMeterPhaseBReactivePower.desc": "Beschreibung PV-Zähler Phase B Blindleistung",
  "50901.real_time.pvMeterPhaseCActivePower.desc": "Beschreibung PV-Zähler Phase C Wirkleistung",
  "50901.real_time.pvMeterPhaseCPowerFactor.desc": "Beschreibung PV-Zähler Phase C Leistungsfaktor",
  "50901.real_time.pvMeterPhaseCReactivePower.desc": "Beschreibung PV-Zähler Phase C Blindleistung",
  "50901.real_time.pvMeterPower.desc": "Beschreibung PV-Zähler Leistung",
  "50901.real_time.pvMeterPowerA.desc": "Beschreibung PV-Zähler Phase A Leistung",
  "50901.real_time.pvMeterPowerB.desc": "Beschreibung PV-Zähler Phase B Leistung",
  "50901.real_time.pvMeterPowerC.desc": "Beschreibung PV-Zähler Phase C Leistung",
  "50901.real_time.pvMeterSerialNumber.desc": "Beschreibung PV-Zähler Seriennummer",
  "50901.real_time.pvMeterTotalYield.desc": "Beschreibung Externer Wechselrichter kumulierte Erzeugung",
  "50901.real_time.pvMeterVoltageA.desc": "Beschreibung PV-Zähler Phase A Spannung",
  "50901.real_time.pvMeterVoltageB.desc": "Beschreibung PV-Zähler Phase B Spannung",
  "50901.real_time.pvMeterVoltageC.desc": "Beschreibung PV-Zähler Phase C Spannung",
  "50901.real_time.pvPower.desc": "Beschreibung PV-Leistung",
  "50901.real_time.pvPowerWholeSystem.desc": "Beschreibung PV Gesamtleistung (Gesamtsystem)",
  "50901.real_time.pvToBatteryPower.desc": "Beschreibung PV-zu-Batterie Leistung",
  "50901.real_time.pvToGridPower.desc": "Beschreibung PV-zu-Netz Leistung",
  "50901.real_time.pvToLoadPower.desc": "Beschreibung PV-zu-Last Leistung",
  "50901.real_time.relayStatus.desc": "Beschreibung Relaisstatus",
  "50901.real_time.relaySupplyVoltageSampling.desc": "Beschreibung Relais-Stromversorgungsspannungsabtastung",
  "50901.real_time.rssi.desc": "Beschreibung Signalstärke",
  "50901.real_time.soh.desc": "Beschreibung SOH",
  "50901.real_time.ssid.desc": "Beschreibung SSID",
  "50901.real_time.totalBatteryToLoadEnergy.desc": "Beschreibung Kumulierte Batterie-zu-Last Energie",
  "50901.real_time.totalGridToLoadEnergy.desc": "Beschreibung Kumulierte Netz-zu-Last Energie",
  "50901.real_time.totalLoadEnergy.desc": "Beschreibung Last kumulierter Energieverbrauch",
  "50901.real_time.totalPvToBatteryEnegry.desc": "Beschreibung Kumulierte PV-zu-Batterie Energie",
  "50901.real_time.totalPvToGridEnegry.desc": "Beschreibung Kumulierte PV-zu-Netz Energie",
  "50901.real_time.totalPvToLoadEnegry.desc": "Beschreibung Kumulierte PV-zu-Last Energie",
  "50901.warning.batteryHighVoltageAlarm.desc": "Beschreibung Batterie Überspannungsalarm",
  "50901.warning.batteryLowVoltageAlarm.desc": "Beschreibung Batterie Unterspannung",
  "50901.warning.batteryPackChargeHighVoltageAlarm.desc": "Beschreibung Batteriepaket Lade-Überspannungsalarm",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.desc": "Beschreibung Batteriepaket Entlade-Unterspannungsalarm",
  "50901.warning.canCommunicationTimeout.desc": "Beschreibung CAN-Kommunikations-Timeout",
  "50901.warning.chargeHighTemperatureAlarm.desc": "Beschreibung Lade-Hochtemperaturalarm",
  "50901.warning.chargeLowTemperatureAlarm.desc": "Beschreibung Lade-Niedrigtemperaturalarm",
  "50901.warning.dischargeHighTemperatureAlarm.desc": "Beschreibung Entlade-Hochtemperaturalarm",
  "50901.warning.dischargeLowTemperatureAlarm.desc": "Beschreibung Entlade-Niedrigtemperaturalarm",
  "50901.warning.hardwareProtection.desc": "Beschreibung Hardware-Schutz",
  "50901.warning.inputOvervoltageAlarm.desc": "Beschreibung Eingangs-Überspannungsalarm",
  "50901.warning.lowBatteryEnergy.desc": "Beschreibung Batteriekapazität zu niedrig",
  "50901..absoluteTime.desc": "Beschreibung Absolute Zeit",
  "50901..batteryHealing.desc": "Beschreibung Batterie-Wiederherstellung",
  "50901..connectionRouterStatus.desc": "Beschreibung Router-Verbindungsstatus",
  "50901..connectionServerStatus.desc": "Beschreibung Cloud-Dienst Verbindungsstatus",
  "50901..dfs.desc": "Beschreibung Fähigkeitssatz / Capability Set",
  "50901..dspVersionMainUVersion.desc": "Beschreibung DSP-Version (Haupt-U-Version)",
  "50901..timeZone.desc": "Beschreibung Zeitzone",
  "50901.ctrl_Config.ClockSetting.ClockSetting.desc": "Beschreibung Uhreinstellung",
  "50901.ctrl_Config.ClockSetting.clockSetting_day.desc": "Beschreibung Uhreinstellung - Tag",
  "50901.ctrl_Config.ClockSetting.clockSetting_hour.desc": "Beschreibung Uhreinstellung - Stunde",
  "50901.ctrl_Config.ClockSetting.clockSetting_minute.desc": "Beschreibung Uhreinstellung - Minute",
  "50901.ctrl_Config.ClockSetting.clockSetting_month.desc": "Beschreibung Uhreinstellung - Monat",
  "50901.ctrl_Config.ClockSetting.clockSetting_second.desc": "Beschreibung Uhreinstellung - Sekunde",
  "50901.ctrl_Config.ClockSetting.clockSetting_weekday.desc": "Beschreibung Uhreinstellung - Wochentag",
  "50901.ctrl_Config.ClockSetting.clockSetting_year.desc": "Beschreibung Uhreinstellung - Jahr",
  "50901.ctrl_Config.Device.masterSlave.desc": "Beschreibung Master/Slave",
  "50901.ctrl_Config.Gateway.ambientTemperatureThreshold.desc": "Beschreibung Umgebungstemperatur-Schwelle",
  "50901.ctrl_Config.Gateway.boardAmbientTemperatureThreshold.desc": "Beschreibung Leiterplatten-Umgebungstemperatur-Schwelle",
  "50901.ctrl_Config.Gateway.gatewayCommunicationAddress.desc": "Beschreibung Gateway-Kommunikationsadresse",
  "50901.ctrl_WorkMode.Backup.backupSoc.desc": "Beschreibung Reservierter SOC",
  "50901.ctrl_WorkMode.economic.economicModeSoc.desc": "Beschreibung Wirtschaftsmodus SOC",
  "50901.ctrl_WorkMode.economic.economyModeDateNumber.desc": "Beschreibung Wirtschaftsmodus Datumsindex",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour1.desc": "Beschreibung Abschnitt 1 Spitzenstartzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour2.desc": "Beschreibung Abschnitt 1 Spitzenstartzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute1.desc": "Beschreibung Abschnitt 1 Spitzenstartzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute2.desc": "Beschreibung Abschnitt 1 Spitzenstartzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour1.desc": "Beschreibung Abschnitt 1 Spitzenstoppzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour2.desc": "Beschreibung Abschnitt 1 Spitzenstoppzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute1.desc": "Beschreibung Abschnitt 1 Spitzenstoppzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute2.desc": "Beschreibung Abschnitt 1 Spitzenstoppzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section1StartDay.desc": "Beschreibung Abschnitt 1 Starttag",
  "50901.ctrl_WorkMode.economic.section1StartMonth.desc": "Beschreibung Abschnitt 1 Startmonat",
  "50901.ctrl_WorkMode.economic.section1StopDay.desc": "Beschreibung Abschnitt 1 Stopptag",
  "50901.ctrl_WorkMode.economic.section1StopMonth.desc": "Beschreibung Abschnitt 1 Stoppmonat",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour1.desc": "Beschreibung Abschnitt 1 Nebenzeiten Startzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour2.desc": "Beschreibung Abschnitt 1 Nebenzeiten Startzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute1.desc": "Beschreibung Abschnitt 1 Nebenzeiten Startzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute2.desc": "Beschreibung Abschnitt 1 Nebenzeiten Startzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour1.desc": "Beschreibung Abschnitt 1 Nebenzeiten Stoppzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour2.desc": "Beschreibung Abschnitt 1 Nebenzeiten Stoppzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute1.desc": "Beschreibung Abschnitt 1 Nebenzeiten Stoppzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute2.desc": "Beschreibung Abschnitt 1 Nebenzeiten Stoppzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.desc": "Beschreibung Abschnitt 1 Wochenbereich 1",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.desc": "Beschreibung Abschnitt 1 Wochenbereich 2",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour1.desc": "Beschreibung Abschnitt 2 Spitzenstartzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour2.desc": "Beschreibung Abschnitt 2 Spitzenstartzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute1.desc": "Beschreibung Abschnitt 2 Spitzenstartzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute2.desc": "Beschreibung Abschnitt 2 Spitzenstartzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour1.desc": "Beschreibung Abschnitt 2 Spitzenstoppzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour2.desc": "Beschreibung Abschnitt 2 Spitzenstoppzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute1.desc": "Beschreibung Abschnitt 2 Spitzenstoppzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute2.desc": "Beschreibung Abschnitt 2 Spitzenstoppzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2StartDay.desc": "Beschreibung Abschnitt 2 Starttag",
  "50901.ctrl_WorkMode.economic.section2StartMonth.desc": "Beschreibung Abschnitt 2 Startmonat",
  "50901.ctrl_WorkMode.economic.section2StopDay.desc": "Beschreibung Abschnitt 2 Stopptag",
  "50901.ctrl_WorkMode.economic.section2StopMonth.desc": "Beschreibung Abschnitt 2 Stoppmonat",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour1.desc": "Beschreibung Abschnitt 2 Nebenzeiten Startzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour2.desc": "Beschreibung Abschnitt 2 Nebenzeiten Startzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute1.desc": "Beschreibung Abschnitt 2 Nebenzeiten Startzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute2.desc": "Beschreibung Abschnitt 2 Nebenzeiten Startzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour1.desc": "Beschreibung Abschnitt 2 Nebenzeiten Stoppzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour2.desc": "Beschreibung Abschnitt 2 Nebenzeiten Stoppzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute1.desc": "Beschreibung Abschnitt 2 Nebenzeiten Stoppzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute2.desc": "Beschreibung Abschnitt 2 Nebenzeiten Stoppzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.desc": "Beschreibung Abschnitt 2 Wochenbereich 1",
  "50901.ctrl_WorkMode.economic.section2WeekRange2.desc": "Beschreibung Abschnitt 2 Wochenbereich 2",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour1.desc": "Beschreibung Abschnitt 3 Spitzenstartzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour2.desc": "Beschreibung Abschnitt 3 Spitzenstartzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute1.desc": "Beschreibung Abschnitt 3 Spitzenstartzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute2.desc": "Beschreibung Abschnitt 3 Spitzenstartzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour1.desc": "Beschreibung Abschnitt 3 Spitzenstoppzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour2.desc": "Beschreibung Abschnitt 3 Spitzenstoppzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute1.desc": "Beschreibung Abschnitt 3 Spitzenstoppzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute2.desc": "Beschreibung Abschnitt 3 Spitzenstoppzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section3StartDay.desc": "Beschreibung Abschnitt 3 Starttag",
  "50901.ctrl_WorkMode.economic.section3StartMonth.desc": "Beschreibung Abschnitt 3 Startmonat",
  "50901.ctrl_WorkMode.economic.section3StopDay.desc": "Beschreibung Abschnitt 3 Stopptag",
  "50901.ctrl_WorkMode.economic.section3StopMonth.desc": "Beschreibung Abschnitt 3 Stoppmonat",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour1.desc": "Beschreibung Abschnitt 3 Nebenzeiten Startzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour2.desc": "Beschreibung Abschnitt 3 Nebenzeiten Startzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute1.desc": "Beschreibung Abschnitt 3 Nebenzeiten Startzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute2.desc": "Beschreibung Abschnitt 3 Nebenzeiten Startzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour1.desc": "Beschreibung Abschnitt 3 Nebenzeiten Stoppzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour2.desc": "Beschreibung Abschnitt 3 Nebenzeiten Stoppzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute1.desc": "Beschreibung Abschnitt 3 Nebenzeiten Stoppzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute2.desc": "Beschreibung Abschnitt 3 Nebenzeiten Stoppzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.desc": "Beschreibung Abschnitt 3 Wochenbereich 1",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.desc": "Beschreibung Abschnitt 3 Wochenbereich 2",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour1.desc": "Beschreibung Abschnitt 4 Spitzenstartzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour2.desc": "Beschreibung Abschnitt 4 Spitzenstartzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute1.desc": "Beschreibung Abschnitt 4 Spitzenstartzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute2.desc": "Beschreibung Abschnitt 4 Spitzenstartzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour1.desc": "Beschreibung Abschnitt 4 Spitzenstoppzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour2.desc": "Beschreibung Abschnitt 4 Spitzenstoppzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute1.desc": "Beschreibung Abschnitt 4 Spitzenstoppzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute2.desc": "Beschreibung Abschnitt 4 Spitzenstoppzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section4StartDay.desc": "Beschreibung Abschnitt 4 Starttag",
  "50901.ctrl_WorkMode.economic.section4StartMonth.desc": "Beschreibung Abschnitt 4 Startmonat",
  "50901.ctrl_WorkMode.economic.section4StopDay.desc": "Beschreibung Abschnitt 4 Stopptag",
  "50901.ctrl_WorkMode.economic.section4StopMonth.desc": "Beschreibung Abschnitt 4 Stoppmonat",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour1.desc": "Beschreibung Abschnitt 4 Nebenzeiten Startzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour2.desc": "Beschreibung Abschnitt 4 Nebenzeiten Startzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute1.desc": "Beschreibung Abschnitt 4 Nebenzeiten Startzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute2.desc": "Beschreibung Abschnitt 4 Nebenzeiten Startzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour1.desc": "Beschreibung Abschnitt 4 Nebenzeiten Stoppzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour2.desc": "Beschreibung Abschnitt 4 Nebenzeiten Stoppzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute1.desc": "Beschreibung Abschnitt 4 Nebenzeiten Stoppzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute2.desc": "Beschreibung Abschnitt 4 Nebenzeiten Stoppzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.desc": "Beschreibung Abschnitt 4 Wochenbereich 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.desc": "Beschreibung Abschnitt 4 Wochenbereich 2",
  "50901.ctrl_WorkMode.forceCharge.forceChargeSoc.desc": "Beschreibung Zwangslade-SOC",
  "50901.ctrl_WorkMode.forceCharge.maximumChargePower.desc": "Beschreibung Maximale Ladeleistung",
  "50901.ctrl_WorkMode.forceDischarge.forceDischargeSoc.desc": "Beschreibung Zwangsentladungs-SOC",
  "50901.ctrl_WorkMode.forceDischarge.maximumDischargePower.desc": "Beschreibung Maximale Entladeleistung",
  "50901.ctrl_WorkMode.peakMeter.peakMeterPower.desc": "Beschreibung Spitzenzähler Leistung",
  "50901.ctrl_WorkMode.peakMeter.peakMeterSoc.desc": "Beschreibung Spitzenzähler SOC",
  "50901.ctrl_WorkMode.Selfuse.selfUsedSoc.desc": "Beschreibung Eigenverbrauchs-SOC",
  "50901.ctrl_WorkMode.Switch.workMode.desc": "Beschreibung EMS Arbeitsmodus / Betriebsmodus",
  "50901.ctrl_WorkMode.TOU.timeOfUseRange.desc": "Beschreibung TOU-Modus Zeitbereich",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndH.desc": "Beschreibung Nutzungszeit Zeit1 Ladeende - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndMin.desc": "Beschreibung Nutzungszeit Zeit1 Ladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgPower.desc": "Beschreibung Ladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartH.desc": "Beschreibung Nutzungszeit Zeit1 Ladestart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartMin.desc": "Beschreibung Nutzungszeit Zeit1 Ladestart - Min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStopSoc.desc": "Beschreibung Lade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndH.desc": "Beschreibung Nutzungszeit Zeit1 Entladeende - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndMin.desc": "Beschreibung Nutzungszeit Zeit1 Entladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgPower.desc": "Beschreibung Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartH.desc": "Beschreibung Nutzungszeit Zeit1 Entladestart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartMin.desc": "Beschreibung Nutzungszeit Zeit1 Entladestart - Min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStopSoc.desc": "Beschreibung Entlade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndH.desc": "Beschreibung Nutzungszeit Zeit2 Ladeende - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndMin.desc": "Beschreibung Nutzungszeit Zeit2 Ladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgPower.desc": "Beschreibung Ladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartH.desc": "Beschreibung Nutzungszeit Zeit2 Ladestart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartMin.desc": "Beschreibung Nutzungszeit Zeit2 Ladestart - Min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStopSoc.desc": "Beschreibung Lade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndH.desc": "Beschreibung Nutzungszeit Zeit2 Entladeende - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndMin.desc": "Beschreibung Nutzungszeit Zeit2 Entladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgPower.desc": "Beschreibung Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartH.desc": "Beschreibung Nutzungszeit Zeit2 Entladestart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartMin.desc": "Beschreibung Nutzungszeit Zeit2 Entladestart - Min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStopSoc.desc": "Beschreibung Entlade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndH.desc": "Beschreibung Nutzungszeit Zeit3 Ladeende - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndMin.desc": "Beschreibung Nutzungszeit Zeit3 Ladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgPower.desc": "Beschreibung Ladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartH.desc": "Beschreibung Nutzungszeit Zeit3 Ladestart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartMin.desc": "Beschreibung Nutzungszeit Zeit3 Ladestart - Min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStopSoc.desc": "Beschreibung Lade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndH.desc": "Beschreibung Nutzungszeit Zeit3 Entladeende - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndMin.desc": "Beschreibung Nutzungszeit Zeit3 Entladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgPower.desc": "Beschreibung Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartH.desc": "Beschreibung Nutzungszeit Zeit3 Entladestart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartMin.desc": "Beschreibung Nutzungszeit Zeit3 Entladestart - Min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStopSoc.desc": "Beschreibung Entlade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndH.desc": "Beschreibung Nutzungszeit Zeit4 Ladeende - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndMin.desc": "Beschreibung Nutzungszeit Zeit4 Ladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgPower.desc": "Beschreibung Ladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartH.desc": "Beschreibung Nutzungszeit Zeit4 Ladestart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartMin.desc": "Beschreibung Nutzungszeit Zeit4 Ladestart - Min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStopSoc.desc": "Beschreibung Lade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndH.desc": "Beschreibung Nutzungszeit Zeit4 Entladeende - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndMin.desc": "Beschreibung Nutzungszeit Zeit4 Entladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgPower.desc": "Beschreibung Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartH.desc": "Beschreibung Nutzungszeit Zeit4 Entladestart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartMin.desc": "Beschreibung Nutzungszeit Zeit4 Entladestart - Min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStopSoc.desc": "Beschreibung Entlade-Abschaltleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndH.desc": "Beschreibung Nutzungszeit Zeit5 Ladeende - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndMin.desc": "Beschreibung Nutzungszeit Zeit5 Ladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgPower.desc": "Beschreibung Ladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartH.desc": "Beschreibung Nutzungszeit Zeit5 Ladestart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartMin.desc": "Beschreibung Nutzungszeit Zeit5 Ladestart - Min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStopSoc.desc": "Beschreibung Lade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndH.desc": "Beschreibung Nutzungszeit Zeit5 Entladeende - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndMin.desc": "Beschreibung Nutzungszeit Zeit5 Entladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgPower.desc": "Beschreibung Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartH.desc": "Beschreibung Nutzungszeit Zeit5 Entladestart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartMin.desc": "Beschreibung Nutzungszeit Zeit5 Entladestart - Min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStopSoc.desc": "Beschreibung Entlade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndH.desc": "Beschreibung Nutzungszeit Zeit6 Ladeende - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndMin.desc": "Beschreibung Nutzungszeit Zeit6 Ladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgPower.desc": "Beschreibung Ladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartH.desc": "Beschreibung Nutzungszeit Zeit6 Ladestart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartMin.desc": "Beschreibung Nutzungszeit Zeit6 Ladestart - Min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStopSoc.desc": "Beschreibung Lade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndH.desc": "Beschreibung Nutzungszeit Zeit6 Entladeende - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndMin.desc": "Beschreibung Nutzungszeit Zeit6 Entladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgPower.desc": "Beschreibung Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartH.desc": "Beschreibung Nutzungszeit Zeit6 Entladestart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartMin.desc": "Beschreibung Nutzungszeit Zeit6 Entladestart - Min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStopSoc.desc": "Beschreibung Entlade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndH.desc": "Beschreibung Nutzungszeit Zeit7 Ladeende - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndMin.desc": "Beschreibung Nutzungszeit Zeit7 Ladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgPower.desc": "Beschreibung Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartH.desc": "Beschreibung Nutzungszeit Zeit7 Ladestart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartMin.desc": "Beschreibung Nutzungszeit Zeit7 Ladestart - Min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStopSoc.desc": "Beschreibung Entlade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndH.desc": "Beschreibung Nutzungszeit Zeit7 Entladeende - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndMin.desc": "Beschreibung Nutzungszeit Zeit7 Entladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgPower.desc": "Beschreibung Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartH.desc": "Beschreibung Nutzungszeit Zeit7 Entladestart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartMin.desc": "Beschreibung Nutzungszeit Zeit7 Entladestart - Min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStopSoc.desc": "Beschreibung Entlade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndH.desc": "Beschreibung Nutzungszeit Zeit8 Ladeende - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndMin.desc": "Beschreibung Nutzungszeit Zeit8 Ladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgPower.desc": "Beschreibung Ladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartH.desc": "Beschreibung Nutzungszeit Zeit8 Ladestart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartMin.desc": "Beschreibung Nutzungszeit Zeit8 Ladestart - Min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStopSoc.desc": "Beschreibung Lade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndH.desc": "Beschreibung Nutzungszeit Zeit8 Entladeende - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndMin.desc": "Beschreibung Nutzungszeit Zeit8 Entladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgPower.desc": "Beschreibung Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartH.desc": "Beschreibung Nutzungszeit Zeit8 Entladestart - H",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartMin.desc": "Beschreibung Nutzungszeit Zeit8 Entladestart - Min",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStopSoc.desc": "Beschreibung Entlade-Abschaltkapazität",
  "50901.real_time.bmsSoftwareVersion.desc": "Beschreibung BMS-Version - Software",
  "50901.real_time.commAddress10Slave9.desc": "Beschreibung Kommunikationsadresse 10 (Slave 9)",
  "50901.real_time.commAddress1Master.desc": "Beschreibung Kommunikationsadresse 1 (Master)",
  "50901.real_time.commAddress2Slave1.desc": "Beschreibung Kommunikationsadresse 2 (Slave 1)",
  "50901.real_time.commAddress3Slave2.desc": "Beschreibung Kommunikationsadresse 3 (Slave 2)",
  "50901.real_time.commAddress3Slave3.desc": "Beschreibung Kommunikationsadresse 4 (Slave 3)",
  "50901.real_time.commAddress4Slave4.desc": "Beschreibung Kommunikationsadresse 5 (Slave 4)",
  "50901.real_time.commAddress6Slave6.desc": "Beschreibung Kommunikationsadresse 6 (Slave 5)",
  "50901.real_time.commAddress7Slave6.desc": "Beschreibung Kommunikationsadresse 7 (Slave 6)",
  "50901.real_time.commAddress8Slave7.desc": "Beschreibung Kommunikationsadresse 8 (Slave 7)",
  "50901.real_time.commAddress9Slave8.desc": "Beschreibung Kommunikationsadresse 9 (Slave 8)",
  "50901.real_time.epsCurrentA.desc": "Beschreibung EPS-Seite Phase A Strom",
  "50901.real_time.epsCurrentB.desc": "Beschreibung EPS-Seite Phase B Strom",
  "50901.real_time.epsCurrentC.desc": "Beschreibung EPS-Seite Phase C Strom",
  "50901.real_time.epsPower.desc": "Beschreibung EPS-Seite Leistung",
  "50901.real_time.epsPowerA.desc": "Beschreibung EPS-Seite Phase A Leistung",
  "50901.real_time.epsPowerB.desc": "Beschreibung EPS-Seite Phase B Leistung",
  "50901.real_time.epsPowerC.desc": "Beschreibung EPS-Seite Phase C Leistung",
  "50901.real_time.epsVoltageA.desc": "Beschreibung EPS-Seite Phase A Spannung",
  "50901.real_time.epsVoltageB.desc": "Beschreibung EPS-Seite Phase B Spannung",
  "50901.real_time.epsVoltageC.desc": "Beschreibung EPS-Seite Phase C Spannung",
  "50901.real_time.essAccessPoint.desc": "Beschreibung ESS-Zugangspunkt",
  "50901.real_time.generatorConnectionStatus.desc": "Beschreibung Generator-Verbindungsstatus",
  "50901.real_time.generatorVoltageA.desc": "Beschreibung Generator Phase A Spannung",
  "50901.real_time.generatorVoltageB.desc": "Beschreibung Generator Phase B Spannung",
  "50901.real_time.generatorVoltageC.desc": "Beschreibung Generator Phase C Spannung",
  "50901.real_time.invAcFrequency.desc": "Beschreibung Wechselrichter AC-Ausgangsfrequenz",
  "50901.real_time.inverCombinedActivePower.desc": "Beschreibung Wechselrichter AC-Ausgangsleistung",
  "50901.real_time.invRatedPower.desc": "Beschreibung Nennleistung",
  "50901.real_time.invRunningtime.desc": "Beschreibung INV-Betriebszeit (Hoymiles: Normale Betriebszeit)",
  "50901.real_time.machineSnMaster.desc": "Beschreibung Master-Einheit SN",
  "50901.real_time.machineSnSlave1.desc": "Beschreibung Slave 1 SN",
  "50901.real_time.machineSnSlave2.desc": "Beschreibung Slave 2 SN",
  "50901.real_time.machineSnSlave3.desc": "Beschreibung Slave 3 SN",
  "50901.real_time.machineSnSlave4.desc": "Beschreibung Slave 4 SN",
  "50901.real_time.machineSnSlave5.desc": "Beschreibung Slave 5 SN",
  "50901.real_time.machineSnSlave6.desc": "Beschreibung Slave 6 SN",
  "50901.real_time.machineSnSlave7.desc": "Beschreibung Slave 7 SN",
  "50901.real_time.machineSnSlave8.desc": "Beschreibung Slave 8 SN",
  "50901.real_time.machineSnSlave9.desc": "Beschreibung Slave 9 SN",
  "50901.real_time.numberOfUnits.desc": "Beschreibung Einheitenanzahl",
  "50901.real_time.phaseAOfInverterActivePower.desc": "Beschreibung Wechselrichter AC-Seite Phase A Leistung",
  "50901.real_time.phaseAOfInverterSideCurrent.desc": "Beschreibung Wechselrichter AC-Seite Phase A Strom",
  "50901.real_time.phaseAOfInverterSideVoltage.desc": "Beschreibung Wechselrichter AC-Seite Phase A Spannung",
  "50901.real_time.phaseBOfInverterActivePower.desc": "Beschreibung Wechselrichter AC-Seite Phase B Leistung",
  "50901.real_time.phaseBOfInverterSideCurrent.desc": "Beschreibung Wechselrichter AC-Seite Phase B Strom",
  "50901.real_time.phaseBOfInverterSideVoltage.desc": "Beschreibung Wechselrichter AC-Seite Phase B Spannung",
  "50901.real_time.phaseCOfInverterActivePower.desc": "Beschreibung Wechselrichter AC-Seite Phase C Leistung",
  "50901.real_time.phaseCOfInverterSideCurrent.desc": "Beschreibung Wechselrichter AC-Seite Phase C Strom",
  "50901.real_time.phaseCOfInverterSideVoltage.desc": "Beschreibung Wechselrichter AC-Seite Phase C Spannung",
  "50901.real_time.pv1Current.desc": "Beschreibung PV1 Strom",
  "50901.real_time.pv1Power.desc": "Beschreibung PV1 Leistung",
  "50901.real_time.pv1Voltage.desc": "Beschreibung PV1 Spannung",
  "50901.real_time.pv2Current.desc": "Beschreibung PV2 Strom",
  "50901.real_time.pv2Power.desc": "Beschreibung PV2 Leistung",
  "50901.real_time.pv2Voltage.desc": "Beschreibung PV2 Spannung",
  "50901.real_time.pv3Current.desc": "Beschreibung PV3 Strom",
  "50901.real_time.pv3Power.desc": "Beschreibung PV3 Leistung",
  "50901.real_time.pv3Voltage.desc": "Beschreibung PV3 Spannung",
  "50901.real_time.pv4Current.desc": "Beschreibung PV4 Strom",
  "50901.real_time.pv4Power.desc": "Beschreibung PV4 Leistung",
  "50901.real_time.pv4Voltage.desc": "Beschreibung PV4 Spannung",
  "50901.real_time.pvConnectionStatus.desc": "Beschreibung PV-Verbindungsstatus",
  "50901.real_time.serviceEntranceBreakerCurrent.desc": "Beschreibung Stromeingangsspeisepunkt / Service Entrance Strom",
  "50901.real_time.workStatus.desc": "Beschreibung Betriebsstatus",
  "50901..antiIslandingEnable.desc": "Beschreibung Anti-Islanding aktivieren",
  "50901..apcEn.desc": "Beschreibung APC aktivieren",
  "50901..apcPwrLmt.desc": "Beschreibung APC-Leistungsgrenze",
  "50901..apcRamp.desc": "Beschreibung APC-Anstiegsrate / Rampe",
  "50901..drmEnable.desc": "Beschreibung DRM aktivieren",
  "50901..fixPfTr.desc": "Beschreibung FixPF_Tr Zeit",
  "50901..functionCode.desc": "Beschreibung Funktionscode",
  "50901..fwDelayTime.desc": "Beschreibung FW-Verzögerungszeit",
  "50901..fwOverFdroop.desc": "Beschreibung FW Überfrequenz-Droop-Koeffizient",
  "50901..fwUnderFdroop.desc": "Beschreibung FW Unterfrequenz-Droop-Koeffizient",
  "50901..gcfExportHardTime.desc": "Beschreibung GCF Export-Hartlimit-Zeit",
  "50901..gcfGenerationHardLimitRatio.desc": "Beschreibung GCF Erzeugungs-Hartlimit-Verhältnis",
  "50901..gcfGenerationHardTime.desc": "Beschreibung GCF Erzeugungs-Hartlimit-Zeit",
  "50901..gcfGenerationSoftLimitRatio.desc": "Beschreibung GCF Erzeugungs-Weichlimit-Verhältnis",
  "50901..gcfImportHardTime.desc": "Beschreibung GCF Bezugs-Hartlimit-Zeit",
  "50901..gcfImportLimitRatio.desc": "Beschreibung GCF Bezugs-Limit-Verhältnis",
  "50901..gcfReconnectionTime.desc": "Beschreibung GCF Wiederverbindungszeit",
  "50901..gridLevel2LimitTimeScale.desc": "Beschreibung Netz sekundäre Grenzwert-Zeitskala",
  "50901..permitEnable.desc": "Beschreibung Genehmigung / Erlaubnis aktivieren",
  "50901..phaseOrderInverseDisable.desc": "Beschreibung Phasenfolge umkehrt deaktivieren",
  "50901..pqFuncCode.desc": "Beschreibung PQ-Funktionscode",
  "50901..pqP1.desc": "Beschreibung PQ_P1",
  "50901..pqP2.desc": "Beschreibung PQ_P2",
  "50901..pqP3.desc": "Beschreibung PQ_P3",
  "50901..pqP4.desc": "Beschreibung PQ_P4",
  "50901..pqP5.desc": "Beschreibung PQ_P5",
  "50901..pqP6.desc": "Beschreibung PQ_P6",
  "50901..pqQ1.desc": "Beschreibung PQ_Q1",
  "50901..pqQ2.desc": "Beschreibung PQ_Q2",
  "50901..pqQ3.desc": "Beschreibung PQ_Q3",
  "50901..pqQ4.desc": "Beschreibung PQ_Q4",
  "50901..pqQ5.desc": "Beschreibung PQ_Q5",
  "50901..pqQ6.desc": "Beschreibung PQ_Q6",
  "50901..pqTr.desc": "Beschreibung PQ_Tr Zeit",
  "50901..relayU16NlineRlyTestDis.desc": "Beschreibung Relais N Test deaktivieren",
  "50901..rpaP1.desc": "Beschreibung RPA_P1",
  "50901..rpaP2.desc": "Beschreibung RPA_P2",
  "50901..rpaQ1.desc": "Beschreibung RPA_Q1",
  "50901..rpaQ2.desc": "Beschreibung RPA_Q2",
  "50901..vvTr.desc": "Beschreibung VV_Tr Zeit",
  "50901..wattRegulationPriority.desc": "Beschreibung Watt-Priorität",
  "50901..wpfTr.desc": "Beschreibung WPF_Tr Zeit",
  "50901.ctrl_Config.Battery.absorptionVoltage.desc": "Beschreibung Absorptionsspannung",
  "50901.ctrl_Config.Battery.batteryCapacity.desc": "Beschreibung BMS-Kapazität",
  "50901.ctrl_Config.Battery.endChargeVoltage.desc": "Beschreibung Ladeschlussspannung",
  "50901.ctrl_Config.Battery.endOfChargeCurrent.desc": "Beschreibung Ladestromende",
  "50901.ctrl_Config.Battery.equalizationChargeTimeout.desc": "Beschreibung Ausgleichsladung Timeout",
  "50901.ctrl_Config.Battery.equalizationEnable.desc": "Beschreibung Ausgleich aktivieren",
  "50901.ctrl_Config.Battery.equalizationIntervalDays.desc": "Beschreibung Ausgleichsintervall Tage",
  "50901.ctrl_Config.Battery.equalizationTime.desc": "Beschreibung Ausgleichszeit",
  "50901.ctrl_Config.Battery.equalizationVoltage.desc": "Beschreibung Ausgleichsspannung",
  "50901.ctrl_Config.Battery.floatVoltage.desc": "Beschreibung Erhaltungsspannung",
  "50901.ctrl_Config.Battery.initialResistance.desc": "Beschreibung Anfangswiderstand",
  "50901.ctrl_Config.Battery.maximumChargeLimit.desc": "Beschreibung Maximaler Ladestrom/-leistung Grenzwert",
  "50901.ctrl_Config.Battery.maximumDischargeLimit.desc": "Beschreibung Maximaler Entladestrom/-leistung Grenzwert",
  "50901.ctrl_Config.Battery.temperatureCorrectionFactor.desc": "Beschreibung Temperaturkorrekturkoeffizient",
  "50901.ctrl_Config.Connection.dtu_comm_enable.desc": "Beschreibung DTU-Kommunikation aktivieren",
  "50901.ctrl_Config.Device.arcFaultClear.desc": "Beschreibung Lichtbogenfehler löschen",
  "50901.ctrl_Config.Device.batActivate.desc": "Beschreibung Batterieaktivierung",
  "50901.ctrl_Config.Device.batteryBalancing.desc": "Beschreibung Batteriebalancierung",
  "50901.ctrl_Config.Device.clearFault.desc": "Beschreibung Fehler löschen",
  "50901.ctrl_Config.Device.parallelNetworking.desc": "Beschreibung Parallelbetrieb Netzwerk",
  "50901.ctrl_Config.Device.restartSystem.desc": "Beschreibung Systemneustart",
  "50901.ctrl_Config.Device.restoreDefault.desc": "Beschreibung Standardwerte wiederherstellen",
  "50901.ctrl_Config.Device.selfTest.desc": "Beschreibung Selbsttest",
  "50901.ctrl_Config.Device.systemPowerOnOff.desc": "Beschreibung System Ein/Aus",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndH.desc": "Beschreibung Generatorsteuerung - Ladeendezeit - H",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndMin.desc": "Beschreibung Generatorsteuerung - Ladeendezeit - Minute",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartH.desc": "Beschreibung Generatorsteuerung - Ladestartzeit - H",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartMin.desc": "Beschreibung Generatorsteuerung - Ladestartzeit - Minute",
  "50901.ctrl_Dry_Contact.Generator.generatorCloseBatteryCapacity.desc": "Beschreibung Generator-Abschalt-Batteriekapazität",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.desc": "Beschreibung Generatorbetriebsart / Modus",
  "50901.ctrl_Dry_Contact.Generator.generatorOpenBatteryCapacity.desc": "Beschreibung Generator-Start-Batteriekapazität",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.desc": "Beschreibung Generator Übungsmodus Frequenz",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.desc": "Beschreibung Generator Übungsmodus",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeRunningTime.desc": "Beschreibung Generator Übungsmodus Laufzeit",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartH.desc": "Beschreibung Generator Übungsmodus Startzeit - Stunde",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartMin.desc": "Beschreibung Generator Übungsmodus Startzeit - Minute",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.desc": "Beschreibung Generator Übungsmodus Startzeit",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndH.desc": "Beschreibung Standby-Zeit 1 Ende - H",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndMin.desc": "Beschreibung Standby-Zeit 1 Ende - Minute",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartH.desc": "Beschreibung Standby-Zeit 1 Start - H",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartMin.desc": "Beschreibung Standby-Zeit 1 Start - Minute",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndH.desc": "Beschreibung Standby-Zeit 2 Ende - H",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndMin.desc": "Beschreibung Standby-Zeit 2 Ende - Minute",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartH.desc": "Beschreibung Standby-Zeit 2 Start - H",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartMin.desc": "Beschreibung Standby-Zeit 2 Start - Minute",
  "50901.ctrl_Dry_Contact.Generator.quietTimeEnable.desc": "Beschreibung Standby-Zeit Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.desc": "Beschreibung Laststeuerungsmodus",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.desc": "Beschreibung Laststeuerung Montag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.desc": "Beschreibung Laststeuerung Dienstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.desc": "Beschreibung Laststeuerung Mittwoch",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.desc": "Beschreibung Laststeuerung Donnerstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.desc": "Beschreibung Laststeuerung Freitag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.desc": "Beschreibung Laststeuerung Samstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.desc": "Beschreibung Laststeuerung Sonntag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.desc": "Beschreibung Manueller Modus Schalter",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnLoadPower.desc": "Beschreibung Lastmodus Lastleistungsschwelle",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnTime.desc": "Beschreibung Laststeuerung Mindesteinschaltdauer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.offGridProtectionSoc.desc": "Beschreibung Inselmodus Schutz-SOC",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange1.desc": "Beschreibung Zeitbereich 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20.desc": "Beschreibung Montag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.desc": "Beschreibung Dienstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.desc": "Beschreibung Mittwoch",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.desc": "Beschreibung Donnerstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.desc": "Beschreibung Freitag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.desc": "Beschreibung Samstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.desc": "Beschreibung Sonntag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour.desc": "Beschreibung Timer 1 Ende - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_2.desc": "Beschreibung Timer 1 Ende_2 - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_3.desc": "Beschreibung Zeitslot 1 Ende - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute.desc": "Beschreibung Timer 1 Ende - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_2.desc": "Beschreibung Timer 1 Ende_2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_3.desc": "Beschreibung Zeitslot 1 Ende - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min.desc": "Beschreibung Timer 1 Start - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_2.desc": "Beschreibung Timer 1 Start_2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_3.desc": "Beschreibung Zeitslot 1 Start - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour.desc": "Beschreibung Timer 2 Ende - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_2.desc": "Beschreibung Timer 2 Ende_2 - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_3.desc": "Beschreibung Zeitslot 2 Ende - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes.desc": "Beschreibung Timer 2 Ende - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_2.desc": "Beschreibung Timer 2 Ende_2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_3.desc": "Beschreibung Zeitslot 2 Ende - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes.desc": "Beschreibung Timer 2 Start - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_2.desc": "Beschreibung Timer 2 Start_2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_3.desc": "Beschreibung Zeitslot 2 Start - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour.desc": "Beschreibung Timer 1 Start - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_2.desc": "Beschreibung Timer 1 Start_2 - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_3.desc": "Beschreibung Zeitslot 1 Start - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour.desc": "Beschreibung Timer 2 Start - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_2.desc": "Beschreibung Timer 2 Start_2 - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_3.desc": "Beschreibung Zeitslot 2 Start - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.desc": "Beschreibung Montag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.desc": "Beschreibung Dienstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.desc": "Beschreibung Mittwoch",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.desc": "Beschreibung Donnerstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.desc": "Beschreibung Freitag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.desc": "Beschreibung Samstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.desc": "Beschreibung Sonntag",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.desc": "Beschreibung Trockenkontakt Arbeitsmodus",
  "50901.ctrl_ESS_Advanced_Config.Battery.batDischargePowerWhenPartialPeak.desc": "Beschreibung Spitze Batterie Max. Entladeleistung",
  "50901.ctrl_ESS_Advanced_Config.Battery.batGridFeedPowerWhenPeak.desc": "Beschreibung Spitze Netzeinspeiseleistung",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxChargePower.desc": "Beschreibung Batterie Max. Ladeleistung",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxDischargePower.desc": "Beschreibung Batterie Max. Entladeleistung",
  "50901.ctrl_ESS_Advanced_Config.Battery.leadAcidBatReplenishTime.desc": "Beschreibung Blei-Säure-Batterie Wartungszeit",
  "50901.ctrl_ESS_Advanced_Config.Battery.maxSoc.desc": "Beschreibung Maximaler Soc",
  "50901.ctrl_ESS_Advanced_Config.Battery.minSoc.desc": "Beschreibung Minimaler Soc",
  "50901.ctrl_ESS_Advanced_Config.Battery.replenishPower.desc": "Beschreibung Leistungskompensation",
  "50901.ctrl_ESS_Advanced_Config.Battery.rsvdReplenishPower.desc": "Beschreibung Rsvd Reserveleistung",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.desc": "Beschreibung Bypass Deaktivieren",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.desc": "Beschreibung Eps-Modus",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.desc": "Beschreibung Pv-Modus Aktivieren",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_freq.desc": "Beschreibung Generator Frequenzobergrenze",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_volt.desc": "Beschreibung Generator Spannungsobergrenze",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_freq.desc": "Beschreibung Generator Frequenzuntergrenze",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_volt.desc": "Beschreibung Generator Spannungsuntergrenze",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_rated_power.desc": "Beschreibung Generator-zu-Batterie Ladeleistung bei Mehrfach-Parallelbetrieb",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.desc": "Beschreibung Globale Scannen Aktivieren",
  "50901.ctrl_ESS_Advanced_Config.System.gridInPowerLimitationWhenValley.desc": "Beschreibung Netzleistung Begrenzen",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.desc": "Beschreibung Mid / Gateway Aktivieren",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.desc": "Beschreibung Dreiphasen-Ungleichgewicht Aktivieren",
  "50901.ctrl_Safety.DCI.dciEnable.desc": "Beschreibung DCI aktivieren",
  "50901.ctrl_Safety.DCI.lowerLimit.desc": "Beschreibung DCI unterer Grenzstrom",
  "50901.ctrl_Safety.DCI.lowerTime.desc": "Beschreibung DCI untere Grenzzeit",
  "50901.ctrl_Safety.DCI.upperLimit.desc": "Beschreibung DCI oberer Grenzstrom",
  "50901.ctrl_Safety.DCI.upperTime.desc": "Beschreibung DCI obere Grenzzeit",
  "50901.ctrl_Safety.FRT.frtFuncCode.desc": "Beschreibung FRT-Funktionscode",
  "50901.ctrl_Safety.FRT.frtHighLimit1.desc": "Beschreibung Frequenzobergrenze 1",
  "50901.ctrl_Safety.FRT.frtHighLimit1Time.desc": "Beschreibung Frequenzobergrenze 1 Dauer",
  "50901.ctrl_Safety.FRT.frtHighLimit2.desc": "Beschreibung Frequenzobergrenze 2",
  "50901.ctrl_Safety.FRT.frtHighLimit2Time.desc": "Beschreibung Frequenzobergrenze 2 Dauer",
  "50901.ctrl_Safety.FRT.frtHighLimit3.desc": "Beschreibung Frequenzobergrenze 3",
  "50901.ctrl_Safety.FRT.frtHighLimit3Time.desc": "Beschreibung Frequenzobergrenze 3 Dauer",
  "50901.ctrl_Safety.FRT.frtLowLimit1.desc": "Beschreibung Frequenzuntergrenze 1",
  "50901.ctrl_Safety.FRT.frtLowLimit1Time.desc": "Beschreibung Frequenzuntergrenze 1 Dauer",
  "50901.ctrl_Safety.FRT.frtLowLimit2.desc": "Beschreibung Frequenzuntergrenze 2",
  "50901.ctrl_Safety.FRT.frtLowLimit2Time.desc": "Beschreibung Frequenzuntergrenze 2 Dauer",
  "50901.ctrl_Safety.FRT.frtLowLimit3.desc": "Beschreibung Frequenzuntergrenze 3",
  "50901.ctrl_Safety.FRT.frtLowLimit3Time.desc": "Beschreibung Frequenzuntergrenze 3 Dauer",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.desc": "Beschreibung FW Batteriemodus Unterschied aktivieren",
  "50901.ctrl_Safety.FW.fwEnable.desc": "Beschreibung FW aktivieren",
  "50901.ctrl_Safety.FW.fwFuncCode.desc": "Beschreibung FW-Funktionscode",
  "50901.ctrl_Safety.FW.fwOverEndFreq.desc": "Beschreibung FW Überfrequenz Endfrequenz",
  "50901.ctrl_Safety.FW.fwOverStartFreq.desc": "Beschreibung FW Überfrequenz Startfrequenz",
  "50901.ctrl_Safety.FW.fwOverTransFreq.desc": "Beschreibung FW Überfrequenz Übergangsfrequenz",
  "50901.ctrl_Safety.FW.fwRecoveryLowerFrequency.desc": "Beschreibung FW Wiederherstellungsfrequenz untere Grenze",
  "50901.ctrl_Safety.FW.fwRecoveryStableTime.desc": "Beschreibung FW Wiederherstellungs-Stabilisierungszeit",
  "50901.ctrl_Safety.FW.fwRecoveryUpperFrequency.desc": "Beschreibung FW Wiederherstellungsfrequenz obere Grenze",
  "50901.ctrl_Safety.FW.fwTr.desc": "Beschreibung FW_Tr Zeit",
  "50901.ctrl_Safety.FW.fwUnderEndFreq.desc": "Beschreibung FW Unterfrequenz Endfrequenz",
  "50901.ctrl_Safety.FW.fwUnderStartFreq.desc": "Beschreibung FW Unterfrequenz Startfrequenz",
  "50901.ctrl_Safety.FW.fwUnderStopFreq.desc": "Beschreibung FW Unterfrequenz Stoppfrequenz",
  "50901.ctrl_Safety.RCD.continueLimitTime.desc": "Beschreibung RCD Dauerlimit Zeit",
  "50901.ctrl_Safety.RCD.continueLimitValue.desc": "Beschreibung RCD Dauerlimit Strom",
  "50901.ctrl_Safety.RCD.rcdEnable.desc": "Beschreibung RCD aktivieren",
  "50901.ctrl_Safety.RCD.step1LimitTime.desc": "Beschreibung RCD Stufe 1 Limit Zeit",
  "50901.ctrl_Safety.RCD.step1LimitValue.desc": "Beschreibung RCD Stufe 1 Limit Strom",
  "50901.ctrl_Safety.RCD.step2LimitTime.desc": "Beschreibung RCD Stufe 2 Limit Zeit",
  "50901.ctrl_Safety.RCD.step2LimitValue.desc": "Beschreibung RCD Stufe 2 Limit Strom",
  "50901.ctrl_Safety.RCD.step3LimitTime.desc": "Beschreibung RCD Stufe 3 Limit Zeit",
  "50901.ctrl_Safety.RCD.step3LimitValue.desc": "Beschreibung RCD Stufe 3 Limit Strom",
  "50901.ctrl_Safety.RPC.gcfEn.desc": "Beschreibung GCF aktivieren",
  "50901.ctrl_Safety.RPC.gcfFuncCode.desc": "Beschreibung GCF-Funktionscode",
  "50901.ctrl_Safety.RPC.rpcMode.desc": "Beschreibung RP-Modus",
  "50901.ctrl_Safety.RPC.rpcPf.desc": "Beschreibung RPC Leistungsfaktor PF",
  "50901.ctrl_Safety.RPC.rpcReactPowerRatio.desc": "Beschreibung RPC Blindleistungsverhältnis",
  "50901.ctrl_Safety.RPC.rpcTr.desc": "Beschreibung RPC_Tr Zeit",
  "50901.ctrl_Safety.RPC.vvFuncCode.desc": "Beschreibung Volt-Var-Funktionscode",
  "50901.ctrl_Safety.RPC.vvLockIn.desc": "Beschreibung VV Einschaltwert",
  "50901.ctrl_Safety.RPC.vvLockOut.desc": "Beschreibung VV Ausschaltwert",
  "50901.ctrl_Safety.RPC.vvQ1.desc": "Beschreibung Blindleistungs-Sollwert_Q1",
  "50901.ctrl_Safety.RPC.vvQ2.desc": "Beschreibung Blindleistungs-Sollwert_Q2",
  "50901.ctrl_Safety.RPC.vvQ3.desc": "Beschreibung Blindleistungs-Sollwert_Q3",
  "50901.ctrl_Safety.RPC.vvQ4.desc": "Beschreibung Blindleistungs-Sollwert_Q4",
  "50901.ctrl_Safety.RPC.vvV1.desc": "Beschreibung Spannungs-Sollwert_V1",
  "50901.ctrl_Safety.RPC.vvV2.desc": "Beschreibung Spannungs-Sollwert_V2",
  "50901.ctrl_Safety.RPC.vvV3.desc": "Beschreibung Spannungs-Sollwert_V3",
  "50901.ctrl_Safety.RPC.vvV4.desc": "Beschreibung Spannungs-Sollwert_V4",
  "50901.ctrl_Safety.RPC.vvVref.desc": "Beschreibung Volt-Var Referenzwert (Vref)",
  "50901.ctrl_Safety.RPC.vvVrefTr.desc": "Beschreibung Volt-Var Referenzwert Tr Zeit",
  "50901.ctrl_Safety.RPC.wpfFuncCode.desc": "Beschreibung WPF-Funktionscode",
  "50901.ctrl_Safety.RPC.wpfLockIn.desc": "Beschreibung WPF Einschaltwert",
  "50901.ctrl_Safety.RPC.wpfLockOut.desc": "Beschreibung WPF Ausschaltwert",
  "50901.ctrl_Safety.RPC.wpfMinPFOver.desc": "Beschreibung WPF Überlast minimaler PF",
  "50901.ctrl_Safety.RPC.wpfMinPFUnder.desc": "Beschreibung WPF Unterlast minimaler PF",
  "50901.ctrl_Safety.RPC.wpfPowerEndRatio.desc": "Beschreibung WPF Leistungsendeverhältnis",
  "50901.ctrl_Safety.RPC.wpfPowerStartRatio.desc": "Beschreibung WPF Leistungsstartverhältnis",
  "50901.ctrl_Safety.RR.rrFuncCode.desc": "Beschreibung RR-Funktionscode",
  "50901.ctrl_Safety.RR.rrRurNm.desc": "Beschreibung RR_RUR_NM",
  "50901.ctrl_Safety.RR.rrRurSs.desc": "Beschreibung RR_RUR_SS",
  "50901.ctrl_Safety.RT.rtFreqRecoveryHighValue.desc": "Beschreibung RT Frequenzwiederherstellung oberer Grenzwert",
  "50901.ctrl_Safety.RT.rtFreqRecoveryLowValue.desc": "Beschreibung RT Frequenzwiederherstellung unterer Grenzwert",
  "50901.ctrl_Safety.RT.rtFuncCode.desc": "Beschreibung RT-Funktionscode",
  "50901.ctrl_Safety.RT.rtNMTime.desc": "Beschreibung RT_NM Zeit",
  "50901.ctrl_Safety.RT.rtSRTTime.desc": "Beschreibung RT_SRT Zeit",
  "50901.ctrl_Safety.RT.rtVoltRecoveryHighValue.desc": "Beschreibung RT Spannungswiederherstellung oberer Grenzwert",
  "50901.ctrl_Safety.RT.rtVoltRecoveryLowValue.desc": "Beschreibung RT Spannungswiederherstellung unterer Grenzwert",
  "50901.ctrl_Safety.VRT.vrt10MinAvgVoltage.desc": "Beschreibung 10-Minuten-Durchschnittsspannung",
  "50901.ctrl_Safety.VRT.vrtEn.desc": "Beschreibung VRT aktivieren",
  "50901.ctrl_Safety.VRT.vrtFuncCode.desc": "Beschreibung VRT-Funktionscode",
  "50901.ctrl_Safety.VRT.vrtHighLimit.desc": "Beschreibung VRT Hochspannungsschwelle",
  "50901.ctrl_Safety.VRT.vrtLowLimit.desc": "Beschreibung VRT Niederspannungsschwelle",
  "50901.ctrl_Safety.VRT.vrtRecoveryStableTime.desc": "Beschreibung VRT Wiederherstellungs-Stabilisierungszeit",
  "50901.ctrl_Safety.VRT.vrtTransientOverTime.desc": "Beschreibung Momentane Überspannungsdauer",
  "50901.ctrl_Safety.VRT.vrtTransientOverVoltage.desc": "Beschreibung Momentane Überspannungsschwelle",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1.desc": "Beschreibung Spannungsobergrenze 1",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1Time.desc": "Beschreibung Spannungsobergrenze 1 Dauer",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2.desc": "Beschreibung Spannungsobergrenze 2",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2Time.desc": "Beschreibung Spannungsobergrenze 2 Dauer",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3.desc": "Beschreibung Spannungsobergrenze 3",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3Time.desc": "Beschreibung Spannungsobergrenze 3 Dauer",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1.desc": "Beschreibung Spannungsuntergrenze 1",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1Time.desc": "Beschreibung Spannungsuntergrenze 1 Dauer",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2.desc": "Beschreibung Spannungsuntergrenze 2",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2Time.desc": "Beschreibung Spannungsuntergrenze 2 Dauer",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3.desc": "Beschreibung Spannungsuntergrenze 3",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3Time.desc": "Beschreibung Spannungsuntergrenze 3 Dauer",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.desc": "Beschreibung VW Batteriemodus Unterschied aktivieren",
  "50901.ctrl_Safety.VW.vwEnable.desc": "Beschreibung VW aktivieren",
  "50901.ctrl_Safety.VW.vwFuncCode.desc": "Beschreibung VW-Funktionscode",
  "50901.ctrl_Safety.VW.vwOverEndVolt.desc": "Beschreibung VW Überspannung Endspannung",
  "50901.ctrl_Safety.VW.vwOverKPVolt.desc": "Beschreibung VW Überspannung KP-Spannung / Koeffizientenspannung",
  "50901.ctrl_Safety.VW.vwOverStartVolt.desc": "Beschreibung VW Überspannung Startspannung",
  "50901.ctrl_Safety.VW.vwRecoveryLowerVoltage.desc": "Beschreibung VW Wiederherstellungsspannung untere Grenze",
  "50901.ctrl_Safety.VW.vwRecoveryStableTime.desc": "Beschreibung VW Wiederherstellungs-Stabilisierungszeit",
  "50901.ctrl_Safety.VW.vwRecoveryUpperVoltage.desc": "Beschreibung VW Wiederherstellungsspannung obere Grenze",
  "50901.ctrl_Safety.VW.vwTr.desc": "Beschreibung VW_Tr Zeit",
  "50901.ctrl_Safety.VW.vwUnderEndVolt.desc": "Beschreibung VW Unterspannung Endspannung",
  "50901.ctrl_Safety.VW.vwUnderKPVolt.desc": "Beschreibung VW Unterspannung KP-Spannung / Koeffizientenspannung",
  "50901.ctrl_Safety.VW.vwUnderStartVolt.desc": "Beschreibung VW Unterspannung Startspannung",
  "50901.ctrl_Safety_GCF.gcfExportHardLimitRatio.desc": "Beschreibung GCF Export-Hartlimit-Verhältnis",
  "50901.ctrl_Safety_GCF.gcfExportSoftLimitRatio.desc": "Beschreibung GCF Export-Weichlimit-Verhältnis",
  "50901.real_time.BatteryModel.desc": "Beschreibung Batteriemodell",
  "50901.real_time.cfgMultPcsBmsFlag.desc": "Beschreibung BMS-Flag",
  "50901.real_time.inverterSn.desc": "Beschreibung Wechselrichter SN",
  "50901..brightness.desc": "Beschreibung Display-Helligkeit",
  "50901.ctrl_Config.Device.networkingType.1": "Wlan",
  "50901.ctrl_Config.Device.networkingType.2": "Ethernet",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.1": "Aktivieren",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.desc": "Beschreibung Generatoranschluss-Modus",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.desc": "Beschreibung Generatorstandort",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_shutdown_delay.desc": "Beschreibung Generator-Abschaltverzögerung",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_sync_time.desc": "Beschreibung Generator-Synchronisationszeit",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.desc": "Beschreibung Generatortyp",
  "50901.ctrl_ESS_Advanced_Config.Generator.max_run_time.desc": "Beschreibung Maximale Laufzeit",
  "50901.ctrl_ESS_Advanced_Config.Generator.min_run_time.desc": "Beschreibung Minimale Laufzeit",
  "50901.ctrl_ESS_Advanced_Config.Generator.run_protect_threshold.desc": "Beschreibung Betriebsschutzintervall",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.desc": "Beschreibung Netz Ct Rückwärts Aktivieren",
  "50901.ctrl_ESS_Advanced_Config.System.grid_meter_ratio.desc": "Beschreibung Netz Ct Wandler Übersetzungsverhältnis Einstellung",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.desc": "Beschreibung Zählermodell",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.desc": "Beschreibung Pv Ct Rückwärts Aktivieren",
  "50901.ctrl_ESS_Advanced_Config.System.pv_meter_ratio.desc": "Beschreibung Pv Ct Wandler Übersetzungsverhältnis Einstellung",
  "50901.fault.arcFault.00": "Deaktivieren",
  "50901.fault.arcFault.01": "Aktivieren",
  "50901.fault.arcSelfTestFault.00": "Deaktivieren",
  "50901.fault.arcSelfTestFault.01": "Aktivieren",
  "50901.fault.armCommunicationFault.00": "Deaktivieren",
  "50901.fault.armCommunicationFault.01": "Aktivieren",
  "50901.fault.auxiliaryPowerAbnormality.00": "Deaktivieren",
  "50901.fault.auxiliaryPowerAbnormality.01": "Aktivieren",
  "50901.Fault.batteryCapacityAbnormality.00": "Deaktivieren",
  "50901.Fault.batteryCapacityAbnormality.01": "Aktivieren",
  "50901.Fault.batteryFault.00": "Deaktivieren",
  "50901.Fault.batteryFault.01": "Aktivieren",
  "50901.Fault.batteryForceChargeRequest.00": "Deaktivieren",
  "50901.Fault.batteryForceChargeRequest.01": "Aktivieren",
  "50901.Fault.bmsCanCommunicationAbnormality.00": "Deaktivieren",
  "50901.Fault.bmsCanCommunicationAbnormality.01": "Aktivieren",
  "50901.fault.busbarAbnormality.00": "Deaktivieren",
  "50901.fault.busbarAbnormality.01": "Aktivieren",
  "50901.fault.cmpssBiasCalculationError.00": "Deaktivieren",
  "50901.fault.cmpssBiasCalculationError.01": "Aktivieren",
  "50901.fault.comparatorFault.00": "Deaktivieren",
  "50901.fault.comparatorFault.01": "Aktivieren",
  "50901.fault.driveAbnormality.00": "Deaktivieren",
  "50901.fault.driveAbnormality.01": "Aktivieren",
  "50901.Fault.dspPwrCommunicationAbnormality.00": "Deaktivieren",
  "50901.Fault.dspPwrCommunicationAbnormality.01": "Aktivieren",
  "50901.Fault.dspSafCommunicationAbnormality.00": "Deaktivieren",
  "50901.Fault.dspSafCommunicationAbnormality.01": "Aktivieren",
  "50901.Fault.dtsCommunicationAbnormality.00": "Deaktivieren",
  "50901.Fault.dtsCommunicationAbnormality.01": "Aktivieren",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.00": "Deaktivieren",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.01": "Aktivieren",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.00": "Deaktivieren",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.01": "Aktivieren",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.00": "Deaktivieren",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.01": "Aktivieren",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.00": "Deaktivieren",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.01": "Aktivieren",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.00": "Deaktivieren",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.01": "Aktivieren",
  "50901.fault.e2rpomFault.00": "Deaktivieren",
  "50901.fault.e2rpomFault.01": "Aktivieren",
  "50901.fault.emergencyStopSwitchStatus.00": "Deaktivieren",
  "50901.fault.emergencyStopSwitchStatus.01": "Aktivieren",
  "50901.fault.epsOverload.00": "Deaktivieren",
  "50901.fault.epsOverload.01": "Aktivieren",
  "50901.fault.epsRelayProtection.00": "Deaktivieren",
  "50901.fault.epsRelayProtection.01": "Aktivieren",
  "50901.fault.epsVoltageAbnormality.00": "Deaktivieren",
  "50901.fault.epsVoltageAbnormality.01": "Aktivieren",
  "50901.Fault.evCharger1CommunicationAbnormality.00": "Deaktivieren",
  "50901.Fault.evCharger1CommunicationAbnormality.01": "Aktivieren",
  "50901.Fault.evCharger1Fault.00": "Deaktivieren",
  "50901.Fault.evCharger1Fault.01": "Aktivieren",
  "50901.Fault.evCharger2CommunicationAbnormality.00": "Deaktivieren",
  "50901.Fault.evCharger2CommunicationAbnormality.01": "Aktivieren",
  "50901.Fault.evCharger2Fault.00": "Deaktivieren",
  "50901.Fault.evCharger2Fault.01": "Aktivieren",
  "50901.fault.fanFault.00": "Deaktivieren",
  "50901.fault.fanFault.01": "Aktivieren",
  "50901.Fault.fanSpeedAbnormality.00": "Deaktivieren",
  "50901.Fault.fanSpeedAbnormality.01": "Aktivieren",
  "50901.fault.fiveVoltPowerSupplyFault.00": "Deaktivieren",
  "50901.fault.fiveVoltPowerSupplyFault.01": "Aktivieren",
  "50901.fault.flashCommunicationFault.00": "Deaktivieren",
  "50901.fault.flashCommunicationFault.01": "Aktivieren",
  "50901.fault.frequencyVariationRateOutOfRange.00": "Deaktivieren",
  "50901.fault.frequencyVariationRateOutOfRange.01": "Aktivieren",
  "50901.fault.genAbnormality.00": "Deaktivieren",
  "50901.fault.genAbnormality.01": "Aktivieren",
  "50901.fault.genOverload.00": "Deaktivieren",
  "50901.fault.genOverload.01": "Aktivieren",
  "50901.fault.genPortOvercurrent.00": "Deaktivieren",
  "50901.fault.genPortOvercurrent.01": "Aktivieren",
  "50901.fault.genRelayAFault.00": "Deaktivieren",
  "50901.fault.genRelayAFault.01": "Aktivieren",
  "50901.fault.genRelayBFault.00": "Deaktivieren",
  "50901.fault.genRelayBFault.01": "Aktivieren",
  "50901.fault.gridCurrentDcOffsetOutOfRange.00": "Deaktivieren",
  "50901.fault.gridCurrentDcOffsetOutOfRange.01": "Aktivieren",
  "50901.fault.gridMeter.00": "Deaktivieren",
  "50901.fault.gridMeter.01": "Aktivieren",
  "50901.Fault.gridMeterCommunicationAbnormality.00": "Deaktivieren",
  "50901.Fault.gridMeterCommunicationAbnormality.01": "Aktivieren",
  "50901.Fault.gridMeterTypeError.00": "Deaktivieren",
  "50901.Fault.gridMeterTypeError.01": "Aktivieren",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.00": "Deaktivieren",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.01": "Aktivieren",
  "50901.fault.gridOverfrequency.00": "Deaktivieren",
  "50901.fault.gridOverfrequency.01": "Aktivieren",
  "50901.fault.gridOvervoltage.00": "Deaktivieren",
  "50901.fault.gridOvervoltage.01": "Aktivieren",
  "50901.fault.gridPortOvercurrent.00": "Deaktivieren",
  "50901.fault.gridPortOvercurrent.01": "Aktivieren",
  "50901.fault.gridPowerOutage.00": "Deaktivieren",
  "50901.fault.gridPowerOutage.01": "Aktivieren",
  "50901.fault.gridRelayProtection.00": "Deaktivieren",
  "50901.fault.gridRelayProtection.01": "Aktivieren",
  "50901.fault.gridUnderfrequency.00": "Deaktivieren",
  "50901.fault.gridUnderfrequency.01": "Aktivieren",
  "50901.fault.gridUndervoltage.00": "Deaktivieren",
  "50901.fault.gridUndervoltage.01": "Aktivieren",
  "50901.fault.gridVoltageAbnormality.00": "Deaktivieren",
  "50901.fault.gridVoltageAbnormality.01": "Aktivieren",
  "50901.Fault.hmidCommunicationAbnormality.00": "Deaktivieren",
  "50901.Fault.hmidCommunicationAbnormality.01": "Aktivieren",
  "50901.Fault.hmidMachineFault.00": "Deaktivieren",
  "50901.Fault.hmidMachineFault.01": "Aktivieren",
  "50901.fault.insulationFault.00": "Deaktivieren",
  "50901.fault.insulationFault.01": "Aktivieren",
  "50901.fault.interruptOverflow.00": "Deaktivieren",
  "50901.fault.interruptOverflow.01": "Aktivieren",
  "50901.fault.inverterCanCommunicationFailed.00": "Deaktivieren",
  "50901.fault.inverterCanCommunicationFailed.01": "Aktivieren",
  "50901.fault.inverterCommunicationFailed.00": "Deaktivieren",
  "50901.fault.inverterCommunicationFailed.01": "Aktivieren",
  "50901.fault.kmRelayFault.00": "Deaktivieren",
  "50901.fault.kmRelayFault.01": "Aktivieren",
  "50901.fault.lineToEarthFault.00": "Deaktivieren",
  "50901.fault.lineToEarthFault.01": "Aktivieren",
  "50901.fault.loadRelayAFault.00": "Deaktivieren",
  "50901.fault.loadRelayAFault.01": "Aktivieren",
  "50901.fault.loadRelayBFault.00": "Deaktivieren",
  "50901.fault.loadRelayBFault.01": "Aktivieren",
  "50901.fault.lowAmbientTemperature.00": "Deaktivieren",
  "50901.fault.lowAmbientTemperature.01": "Aktivieren",
  "50901.Fault.lowDtuVersion.00": "Deaktivieren",
  "50901.Fault.lowDtuVersion.01": "Aktivieren",
  "50901.fault.machineTypeMismatch.00": "Deaktivieren",
  "50901.fault.machineTypeMismatch.01": "Aktivieren",
  "50901.Fault.masterSlaveCommunicationAbnormality.00": "Deaktivieren",
  "50901.Fault.masterSlaveCommunicationAbnormality.01": "Aktivieren",
  "50901.fault.meterWiringAbnormality.00": "Deaktivieren",
  "50901.fault.meterWiringAbnormality.01": "Aktivieren",
  "50901.fault.microelectronicFault.00": "Deaktivieren",
  "50901.fault.microelectronicFault.01": "Aktivieren",
  "50901.fault.neutralWireNotConnected.00": "Deaktivieren",
  "50901.fault.neutralWireNotConnected.01": "Aktivieren",
  "50901.fault.neutralWireToEarthFault.00": "Deaktivieren",
  "50901.fault.neutralWireToEarthFault.01": "Aktivieren",
  "50901.fault.overTemperature.00": "Deaktivieren",
  "50901.fault.overTemperature.01": "Aktivieren",
  "50901.fault.overtemperatureAlarm.00": "Deaktivieren",
  "50901.fault.overtemperatureAlarm.01": "Aktivieren",
  "50901.fault.pllLockFailed.00": "Deaktivieren",
  "50901.fault.pllLockFailed.01": "Aktivieren",
  "50901.fault.preSynchronizationFailed.00": "Deaktivieren",
  "50901.fault.preSynchronizationFailed.01": "Aktivieren",
  "50901.fault.pvFault.00": "Deaktivieren",
  "50901.fault.pvFault.01": "Aktivieren",
  "50901.Fault.pvMeterCommunicationAbnormality.00": "Deaktivieren",
  "50901.Fault.pvMeterCommunicationAbnormality.01": "Aktivieren",
  "50901.Fault.pvMeterTypeError.00": "Deaktivieren",
  "50901.Fault.pvMeterTypeError.01": "Aktivieren",
  "50901.fault.pvPortOvercurrent.00": "Deaktivieren",
  "50901.fault.pvPortOvercurrent.01": "Aktivieren",
  "50901.fault.pvRelayAbFault.00": "Deaktivieren",
  "50901.fault.pvRelayAbFault.01": "Aktivieren",
  "50901.fault.pvVoltageExceedingBusVoltage.00": "Deaktivieren",
  "50901.fault.pvVoltageExceedingBusVoltage.01": "Aktivieren",
  "50901.fault.rcdFault.00": "Deaktivieren",
  "50901.fault.rcdFault.01": "Aktivieren",
  "50901.fault.rcdSelfTestFault.00": "Deaktivieren",
  "50901.fault.rcdSelfTestFault.01": "Aktivieren",
  "50901.fault.reconnectionFailed.00": "Deaktivieren",
  "50901.fault.reconnectionFailed.01": "Aktivieren",
  "50901.fault.samplingBiasAbnormality.00": "Deaktivieren",
  "50901.fault.samplingBiasAbnormality.01": "Aktivieren",
  "50901.fault.shutDown.00": "Deaktivieren",
  "50901.fault.shutDown.01": "Aktivieren",
  "50901.Fault.slaveWrongBatteryConnection.00": "Deaktivieren",
  "50901.Fault.slaveWrongBatteryConnection.01": "Aktivieren",
  "50901.fault.smartloadPortOvercurrent.00": "Deaktivieren",
  "50901.fault.smartloadPortOvercurrent.01": "Aktivieren",
  "50901.fault.spiCommunicationFault.00": "Deaktivieren",
  "50901.fault.spiCommunicationFault.01": "Aktivieren",
  "50901.Fault.sustainedNegativeLoad.00": "Deaktivieren",
  "50901.Fault.sustainedNegativeLoad.01": "Aktivieren",
  "50901.fault.temperatureAbnormality.00": "Deaktivieren",
  "50901.fault.temperatureAbnormality.01": "Aktivieren",
  "50901.fault.tenMinuteOvervoltage.00": "Deaktivieren",
  "50901.fault.tenMinuteOvervoltage.01": "Aktivieren",
  "50901.fault.threePointThreeVoltPowerSupplyFault.00": "Deaktivieren",
  "50901.fault.threePointThreeVoltPowerSupplyFault.01": "Aktivieren",
  "50901.fault.twelveVoltPowerSupplyFault.00": "Deaktivieren",
  "50901.fault.twelveVoltPowerSupplyFault.01": "Aktivieren",
  "50901.fault.versionMismatch.00": "Deaktivieren",
  "50901.fault.versionMismatch.01": "Aktivieren",
  "50901.fault.wiringAbnormality.00": "Deaktivieren",
  "50901.fault.wiringAbnormality.01": "Aktivieren",
  "50901.real_time.relayStatus.02": "Generator A Einspeisung",
  "50901.real_time.relayStatus.03": "Generator A Einspeisung",
  "50901.real_time.relayStatus.04": "Generator B Einspeisung",
  "50901.real_time.relayStatus.05": "Generator B Einspeisung",
  "50901.real_time.relayStatus.06": "Generator Ab Einspeisung",
  "50901.real_time.relayStatus.07": "Generator Ab Einspeisung",
  "50901.real_time.relayStatus.08": "Kritische Last A Einspeisung",
  "50901.real_time.relayStatus.09": "Kritische Last A Einspeisung",
  "50901.real_time.relayStatus.10": "Kritische Last B Einspeisung",
  "50901.real_time.relayStatus.14": "Reserviert",
  "50901.real_time.relayStatus.15": "Reserviert",
  "50901.warning.batteryHighVoltageAlarm.00": "Deaktivieren",
  "50901.warning.batteryHighVoltageAlarm.01": "Aktivieren",
  "50901.warning.batteryLowVoltageAlarm.00": "Deaktivieren",
  "50901.warning.batteryLowVoltageAlarm.01": "Aktivieren",
  "50901.warning.batteryPackChargeHighVoltageAlarm.00": "Deaktivieren",
  "50901.warning.batteryPackChargeHighVoltageAlarm.01": "Aktivieren",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.00": "Deaktivieren",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.01": "Aktivieren",
  "50901.warning.canCommunicationTimeout.00": "Deaktivieren",
  "50901.warning.canCommunicationTimeout.01": "Aktivieren",
  "50901.warning.chargeHighTemperatureAlarm.00": "Deaktivieren",
  "50901.warning.chargeHighTemperatureAlarm.01": "Aktivieren",
  "50901.warning.chargeLowTemperatureAlarm.00": "Deaktivieren",
  "50901.warning.chargeLowTemperatureAlarm.01": "Aktivieren",
  "50901.warning.dischargeHighTemperatureAlarm.00": "Deaktivieren",
  "50901.warning.dischargeHighTemperatureAlarm.01": "Aktivieren",
  "50901.warning.dischargeLowTemperatureAlarm.00": "Deaktivieren",
  "50901.warning.dischargeLowTemperatureAlarm.01": "Aktivieren",
  "50901.warning.hardwareProtection.00": "Deaktivieren",
  "50901.warning.hardwareProtection.01": "Aktivieren",
  "50901.warning.inputOvervoltageAlarm.00": "Deaktivieren",
  "50901.warning.inputOvervoltageAlarm.01": "Aktivieren",
  "50901.warning.lowBatteryEnergy.00": "Deaktivieren",
  "50901.warning.lowBatteryEnergy.01": "Aktivieren",
  "50901..connectionRouterStatus.0": "Nicht Verbunden",
  "50901..connectionRouterStatus.1": "Verbunden",
  "50901..connectionRouterStatus.3": "Nicht Verbunden",
  "50901..connectionServerStatus.0": "Nicht Verbunden",
  "50901..connectionServerStatus.1": "Verbunden",
  "50901..connectionServerStatus.2": "Verbunden",
  "50901..connectionServerStatus.3": "Nicht Verbunden",
  "50901.ctrl_Config.Battery.equalizationEnable.0": "Nein",
  "50901.ctrl_Config.Battery.equalizationEnable.1": "Ja",
  "50901.ctrl_Config.Connection.dtu_comm_enable.0": "Deaktivieren",
  "50901.ctrl_Config.Connection.dtu_comm_enable.1": "Aktivieren",
  "50901.ctrl_Config.Device.arcFaultClear.0": "Nein",
  "50901.ctrl_Config.Device.arcFaultClear.1": "Ja",
  "50901.ctrl_Config.Device.batActivate.0": "Nein",
  "50901.ctrl_Config.Device.batActivate.1": "Ja",
  "50901.ctrl_Config.Device.batteryBalancing.0": "Nein",
  "50901.ctrl_Config.Device.batteryBalancing.1": "Ja",
  "50901.ctrl_Config.Device.clearFault.0": "Nein",
  "50901.ctrl_Config.Device.clearFault.1": "Ja",
  "50901.ctrl_Config.Device.masterSlave.0": "Einzelgerät",
  "50901.ctrl_Config.Device.masterSlave.1": "Master",
  "50901.ctrl_Config.Device.masterSlave.2": "Slave",
  "50901.ctrl_Config.Device.parallelNetworking.0": "Ungültig",
  "50901.ctrl_Config.Device.parallelNetworking.1": "Vernetzung / Netzwerkbildung",
  "50901.ctrl_Config.Device.parallelNetworking.2": "Netzwerk auflösen",
  "50901.ctrl_Config.Device.restartSystem.0": "Nein",
  "50901.ctrl_Config.Device.restartSystem.1": "Ja",
  "50901.ctrl_Config.Device.restoreDefault.0": "Nein",
  "50901.ctrl_Config.Device.restoreDefault.1": "Ja",
  "50901.ctrl_Config.Device.selfTest.0": "Nein",
  "50901.ctrl_Config.Device.selfTest.1": "Ja",
  "50901.ctrl_Config.Device.systemPowerOnOff.0": "System Anhalten",
  "50901.ctrl_Config.Device.systemPowerOnOff.1": "System Starten",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.0": "Aus",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.1": "Manuell",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.2": "Automatisch",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.0": "Keine",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.1": "Wöchentlich",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.2": "Alle 2 Wochen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.3": "Alle 3 Wochen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.4": "Alle 4 Wochen",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.0": "Nein",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.1": "Ja",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.1": "Manuell",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.2": "Zeitmodus",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.3": "Intelligente Last",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.4": "Inselmodus Intelligente Last",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.5": "Ev-Ladestation",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.0": "Nein",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.1": "Ja",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.0": "Keiner / Kein",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.1": "Erdschluss",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.2": "Laststeuerung",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.3": "Generator",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.0": "Nein",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.1": "Ja",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.0": "Deaktiviert",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.1": "Notstromversorgung (Eps)",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.2": "Unterbrechungsfreie Stromversorgung (Usv)",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.0": "Nein",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.1": "Ja",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.0": "Montag",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.1": "Dienstag",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.2": "Mittwoch",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.3": "Donnerstag",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.4": "Freitag",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.5": "Samstag",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.6": "Sonntag",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.00": "Beschreibung Enum-Wert 0",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.01": "Beschreibung Enum-Wert 1",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.00": "Beschreibung Enum-Wert 0",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.01": "Beschreibung Enum-Wert 2",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.00": "Beschreibung Enum-Wert 0",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.01": "Beschreibung Enum-Wert 2",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.00": "Beschreibung Enum-Wert 0",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.01": "Beschreibung Enum-Wert 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.00": "Beschreibung Enum-Wert 0",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.01": "Beschreibung Enum-Wert 2",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.00": "Beschreibung Enum-Wert 0",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.01": "Beschreibung Enum-Wert 1",
  "50901.real_time.batteryConnectionStatus.00": "Nein",
  "50901.real_time.batteryConnectionStatus.01": "Ja",
  "50901.real_time.BatteryModel.10": "Xin Yi Lv",
  "50901.real_time.BatteryModel.11": "Vestwoods Lv",
  "50901.real_time.BatteryModel.12": "Jk Hv",
  "50901.real_time.BatteryModel.13": "Byd Lv",
  "50901.real_time.BatteryModel.14": "Uz Hv",
  "50901.real_time.BatteryModel.15": "Zetara Lv",
  "50901.real_time.BatteryModel.16": "Feb Hv",
  "50901.real_time.BatteryModel.17": "Pytes Lv",
  "50901.real_time.BatteryModel.18": "Dmegc Lv",
  "50901.real_time.BatteryModel.19": "Weineng Lv",
  "50901.real_time.BatteryModel.2": "Pylon Hv",
  "50901.real_time.BatteryModel.20": "Weineng Hv",
  "50901.real_time.BatteryModel.21": "Gsl Lv",
  "50901.real_time.BatteryModel.22": "Hoy Lv",
  "50901.real_time.BatteryModel.23": "Hoy Hv",
  "50901.real_time.BatteryModel.24": "Feb Lv",
  "50901.real_time.BatteryModel.25": "Uhhome Lv",
  "50901.real_time.BatteryModel.26": "Uhhome Hv",
  "50901.real_time.BatteryModel.27": "Byd Hv",
  "50901.real_time.BatteryModel.28": "Vestwoods Hv",
  "50901.real_time.BatteryModel.29": "Phylion Hv",
  "50901.real_time.BatteryModel.3": "Dyness Lv",
  "50901.real_time.BatteryModel.30": "Hoymiles Lv",
  "50901.real_time.BatteryModel.31": "Pholion Lv",
  "50901.real_time.BatteryModel.32": "Wattsonic Lv",
  "50901.real_time.BatteryModel.33": "Enershare Hv",
  "50901.real_time.BatteryModel.34": "Beghelli Lv",
  "50901.real_time.BatteryModel.35": "Lvtopsun Lv",
  "50901.real_time.BatteryModel.36": "Pytes Hv",
  "50901.real_time.BatteryModel.37": "Lvtopsun Hv",
  "50901.real_time.BatteryModel.38": "Raja Hv",
  "50901.real_time.BatteryModel.39": "Felicity Lv",
  "50901.real_time.BatteryModel.4": "Dyness Hv",
  "50901.real_time.BatteryModel.5": "Sunwoda Lv",
  "50901.real_time.BatteryModel.6": "Uz Lv",
  "50901.real_time.BatteryModel.7": "Soluna Hv",
  "50901.real_time.BatteryModel.8": "Soluna Lv",
  "50901.real_time.BatteryModel.9": "Steltec Lv",
  "50901.real_time.batteryType_04.00": "Keine Batterie",
  "50901.real_time.batteryType_04.01": "Lithium-Batterie",
  "50901.real_time.batteryType_04.02": "Blei-Säure-Batterie",
  "50901.real_time.batteryWorkingStatus.00": "Standby",
  "50901.real_time.batteryWorkingStatus.01": "Laden",
  "50901.real_time.batteryWorkingStatus.02": "Entladen",
  "50901.real_time.cfgMultPcsBmsFlag.00": "Nein",
  "50901.real_time.cfgMultPcsBmsFlag.01": "Ja",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.00": "Leistungsbegrenzung Aufgehoben, Standardmodus",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.01": "Wechselrichterleistung 0, Inselbetrieb",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.02": "Ladeleistung Pc=0, Nicht Inselbetrieb",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.03": "Ladeleistung Pc<50% Pn Nennleistung",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.04": "Ladeleistung Pc<75% Pn Nennleistung && Blindleistung Q=Qmax ±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.05": "Ladeleistung Pc, Keine Begrenzung",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.06": "Entladeleistung P=0, Nicht Inselbetrieb",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.07": "Entladeleistung P<50% Pn Nennleistung",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.08": "Entladeleistung P<75% Pn Nennleistung && Q= -Qmax±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.09": "Entladeleistung P, Keine Begrenzung",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.10": "Ladeleistung Pc<50% Pn Nennleistung --> Ladeleistung Auf 0 Reduziert",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.11": "Ladeleistung Pc<50% Pn Nennleistung && Q=Qmax",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.12": "Entladeleistung P<50% Pn Nennleistung --> Entladeleistung Auf 0 Reduziert",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.13": "Ladeleistung Pc<50% Pn Nennleistung && Q=-Qmax",
  "50901.real_time.materType.0": "Kein Netzzähler",
  "50901.real_time.materType.1": "CHINT Einphasig",
  "50901.real_time.materType.2": "CHINT Einphasig",
  "50901.real_time.materType.3": "CHINT Zweiphasig / Split-Phase",
  "50901.real_time.materType.5": "Messmodul",
  "50901.real_time.materType.6": "Acrel Einzelkreis",
  "50901.real_time.materType.7": "Acrel Doppelkreis",
  "50901.real_time.meterFlag.0": "Offline",
  "50901.real_time.meterFlag.1": "Online",
  "50901.real_time.meterFlag.3": "Gateway-Kommunikation Normal",
  "50901.real_time.meterFlag.4": "Gateway-Kommunikation Unterbrochen",
  "50901.real_time.relayStatus.00": "Km1 Einspeisung",
  "50901.real_time.relayStatus.01": "Km1 Einspeisung",
  "50901.real_time.relayStatus.11": "Kritische Last B Einspeisung",
  "50901.real_time.relayStatus.12": "Reserviert",
  "50901.real_time.relayStatus.13": "Reserviert",
  "50901.real_time.workStatus.00": "Stromversorgungsinitialisierung",
  "50901.real_time.workStatus.01": "Standby-Modus",
  "50901.real_time.workStatus.02": "Netztest",
  "50901.real_time.workStatus.03": "Netzgekoppelter Modus",
  "50901.real_time.workStatus.04": "Fehlermodus",
  "50901.real_time.workStatus.05": "Inselmodus",
  "50901.real_time.workStatus.06": "Bypass-Modus",
  "50901..antiIslandingEnable.0": "Deaktivieren",
  "50901..antiIslandingEnable.1": "Aktivieren",
  "50901..apcEn.0": "Deaktivieren",
  "50901..apcEn.1": "Aktivieren",
  "50901..drmEnable.0": "Deaktivieren",
  "50901..drmEnable.1": "Aktivieren",
  "50901..permitEnable.0": "Deaktivieren",
  "50901..permitEnable.1": "Aktivieren",
  "50901..phaseOrderInverseDisable.00": "Deaktivieren",
  "50901..phaseOrderInverseDisable.01": "Aktivieren",
  "50901..relayU16NlineRlyTestDis.00": "Deaktivieren",
  "50901..relayU16NlineRlyTestDis.01": "Aktivieren",
  "50901.ctrl_Config.Device.checkTime": "Gerätezeit",
  "50901.ctrl_Config.Device.networkingType": "Netzanschlusstyp",
  "50901.ctrl_Config.Grid Profile.country.1": "En_En50549 (Standard)",
  "50901.ctrl_Config.Grid Profile.country.18": "USHECO_Rule14 (Hawaii)",
  "50901.ctrl_Config.Grid Profile.country.27": "Ieee1547_208 (Usa)",
  "50901.ctrl_Config.Grid Profile.country.29": "LX_US_50HZ (USA-Test)",
  "50901.ctrl_Config.Grid Profile.country.30": "Ieee1547_220 (Usa)",
  "50901.ctrl_Config.Grid Profile.country.44": "Us_Miso_208V (Usa)",
  "50901.ctrl_Config.Grid Profile.country.45": "Us_Miso_240V (Usa)",
  "50901.ctrl_Config.Grid Profile.country.9": "Us_Ieee1547 (Usa)",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.chargingPileRatedCurrent": "Nennstrom Ev-Ladestation",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.homeInletBreakerRatedCurrent": "Nennstrom Hauptsicherung",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable": "Zeitgesteuerter Modus - Batterie-Soc Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStartSoc": "Zeitgesteuerter Modus - Batterie Start-Soc",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStopSoc": "Zeitgesteuerter Modus - Batterie Stopp-Soc",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.0": "Verboten",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.1": "Externe Pv",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.2": "Externer Generator",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.3": "Zwangstart",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.4": "Lokale Steuerung",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.0": "Keiner / Kein",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.1": "Generatorseite",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.2": "Netzseite",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.0": "Manuell",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.1": "Di/Do",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.0": "Deaktivieren",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.1": "Aktivieren",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.0": "Kein Zähler Verwendet",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.1": "Einphasenzähler",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.2": "Zweiphasenzähler",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.3": "Dreiphasenzähler",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.4": "Intelligenter Zähler (Hmid)",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.5": "Stromwandler (Ct)",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.6": "Acrel Einphasenzähler",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.7": "Acrel Zweiphasenzähler",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.0": "Deaktivieren",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.1": "Aktivieren",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.0": "Deaktivieren",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.1": "Aktivieren",
  "50901.ctrl_Safety.DCI.dciEnable.0": "Deaktivieren",
  "50901.ctrl_Safety.DCI.dciEnable.1": "Aktivieren",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.0": "Deaktivieren",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.1": "Aktivieren",
  "50901.ctrl_Safety.FW.fwEnable.0": "Deaktivieren",
  "50901.ctrl_Safety.FW.fwEnable.1": "Aktivieren",
  "50901.ctrl_Safety.RCD.rcdEnable.0": "Deaktivieren",
  "50901.ctrl_Safety.RCD.rcdEnable.1": "Aktivieren",
  "50901.ctrl_Safety.RPC.gcfEn.0": "Deaktivieren",
  "50901.ctrl_Safety.RPC.gcfEn.1": "Aktivieren",
  "50901.ctrl_Safety.RPC.rpcMode.00": "Deaktivieren",
  "50901.ctrl_Safety.RPC.rpcMode.01": "Fester Leistungsfaktor, PF-Modus",
  "50901.ctrl_Safety.RPC.rpcMode.02": "Feste Blindleistung, Q-Modus",
  "50901.ctrl_Safety.RPC.rpcMode.03": "PF(P)-Kennlinie, PF(P)-Modus",
  "50901.ctrl_Safety.RPC.rpcMode.04": "W",
  "50901.ctrl_Safety.RPC.rpcMode.05": "PQ",
  "50901.ctrl_Safety.VRT.vrtEn.0": "Deaktivieren",
  "50901.ctrl_Safety.VRT.vrtEn.1": "Aktivieren",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.0": "Deaktivieren",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.1": "Aktivieren",
  "50901.ctrl_Safety.VW.vwEnable.0": "Deaktivieren",
  "50901.ctrl_Safety.VW.vwEnable.1": "Aktivieren",
  "50901.ctrl_WorkMode.TOU.touModeReserveSoc": "Tou-Modus Reservierter Soc",
  "50901.fault.arcFault": "Lichtbogenfehler",
  "50901.fault.arcSelfTestFault": "Lichtbogen-Selbsttestfehler",
  "50901.fault.armCommunicationFault": "ARM-Kommunikationsfehler",
  "50901.fault.auxiliaryPowerAbnormality": "Hilfsstromversorgung anomal",
  "50901.Fault.batteryCapacityAbnormality": "Batteriekapazität Anomal",
  "50901.Fault.batteryFault": "Batteriefehler",
  "50901.Fault.batteryForceChargeRequest": "Batterie-Zwangsladeanforderung",
  "50901.Fault.bmsCanCommunicationAbnormality": "Bms-Can-Kommunikation Anomal",
  "50901.fault.busbarAbnormality": "DC-Zwischenkreis anomal",
  "50901.fault.cmpssBiasCalculationError": "CMPSS-Offset-Berechnungsfehler",
  "50901.fault.comparatorFault": "Komparatorfehler",
  "50901.fault.driveAbnormality": "Ansteuerung anomal",
  "50901.Fault.dspPwrCommunicationAbnormality": "Dsp-Stromversorgungskommunikation Anomal",
  "50901.Fault.dspSafCommunicationAbnormality": "Dsp-Sicherheitskommunikation Anomal",
  "50901.Fault.dtsCommunicationAbnormality": "Dts-Kommunikation Anomal",
  "50901.Fault.dtu1Rs485CommunicationAbnormality": "Dtu1 Rs485-Kommunikation Anomal",
  "50901.Fault.dtu2Rs485CommunicationAbnormality": "Dtu2 Rs485-Kommunikation Anomal",
  "50901.Fault.dtu3Rs485CommunicationAbnormality": "Dtu3 Rs485-Kommunikation Anomal",
  "50901.Fault.dtu4Rs485CommunicationAbnormality": "Dtu4 Rs485-Kommunikation Anomal",
  "50901.Fault.dtu5Rs485CommunicationAbnormality": "Dtu5 Rs485-Kommunikation Anomal",
  "50901.fault.e2rpomFault": "EEPROM-Fehler",
  "50901.fault.emergencyStopSwitchStatus": "Not-Aus",
  "50901.fault.epsOverload": "EPS-Überlast",
  "50901.fault.epsRelayProtection": "EPS-Relais-Schutz",
  "50901.fault.epsVoltageAbnormality": "EPS-Spannung anomal",
  "50901.Fault.evCharger1CommunicationAbnormality": "Ev-Ladestation 1 Kommunikation Anomal",
  "50901.Fault.evCharger1Fault": "Fehler Ladestation 1",
  "50901.Fault.evCharger2CommunicationAbnormality": "Ev-Ladestation 2 Kommunikation Anomal",
  "50901.Fault.evCharger2Fault": "Fehler Ladestation 2",
  "50901.fault.fanFault": "Lüfterfehler",
  "50901.Fault.fanSpeedAbnormality": "Lüfterdrehzahl Anomal",
  "50901.fault.fiveVoltPowerSupplyFault": "Fehler 5V-Stromversorgung",
  "50901.fault.flashCommunicationFault": "Flash-Speicher Kommunikationsfehler",
  "50901.fault.frequencyVariationRateOutOfRange": "Frequenzänderungsrate überschritten",
  "50901.fault.genAbnormality": "Generator anomal",
  "50901.fault.genOverload": "Generatorüberlast",
  "50901.fault.genPortOvercurrent": "Generatoranschluss Überstrom",
  "50901.fault.genRelayAFault": "Generator A Relaisfehler",
  "50901.fault.genRelayBFault": "Generator B Relaisfehler",
  "50901.fault.gridCurrentDcOffsetOutOfRange": "Netzstrom DC-Offset überschritten",
  "50901.fault.gridMeter": "Netz-Zähler Kommunikationsfehler",
  "50901.Fault.gridMeterCommunicationAbnormality": "Netz-Zähler Kommunikation Anomal",
  "50901.Fault.gridMeterTypeError": "Netz-Zähler Typfehler",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange": "Inselspannung DC-Offset überschritten",
  "50901.fault.gridOverfrequency": "Netzfrequenz zu hoch / Überfrequenz",
  "50901.fault.gridOvervoltage": "Netzspannung zu hoch / Überspannung",
  "50901.fault.gridPortOvercurrent": "Netzanschluss Überstrom",
  "50901.fault.gridPowerOutage": "Netzausfall",
  "50901.fault.gridRelayProtection": "Netzrelais-Schutz",
  "50901.fault.gridUnderfrequency": "Netzfrequenz zu niedrig / Unterfrequenz",
  "50901.fault.gridUndervoltage": "Netzspannung zu niedrig / Unterspannung",
  "50901.fault.gridVoltageAbnormality": "Netzspannung anomal",
  "50901.Fault.hmidCommunicationAbnormality": "Hmi-Kommunikation Anomal",
  "50901.Fault.hmidMachineFault": "Hmi-Gerätefehler",
  "50901.fault.insulationFault": "Isolationsfehler",
  "50901.fault.interruptOverflow": "Interrupt-Überlauf",
  "50901.fault.inverterCanCommunicationFailed": "Wechselrichter Can-Kommunikationsfehler",
  "50901.fault.inverterCommunicationFailed": "Wechselrichter Kommunikationsfehler",
  "50901.fault.kmRelayFault": "Km-Relaisfehler",
  "50901.fault.lineToEarthFault": "Erdschluss (Phase-Erde)",
  "50901.fault.loadRelayAFault": "Last A Relaisfehler",
  "50901.fault.loadRelayBFault": "Last B Relaisfehler",
  "50901.fault.lowAmbientTemperature": "Umgebungstemperatur zu niedrig",
  "50901.Fault.lowDtuVersion": "Dtu-Version Zu Niedrig",
  "50901.fault.machineTypeMismatch": "Gerätemodell nicht passend",
  "50901.Fault.masterSlaveCommunicationAbnormality": "Master-Slave-Kommunikation Anomal",
  "50901.fault.meterWiringAbnormality": "Zählerverdrahtung anomal",
  "50901.fault.microelectronicFault": "Mikroelektronikfehler",
  "50901.fault.neutralWireNotConnected": "Neutralleiter nicht angeschlossen",
  "50901.fault.neutralWireToEarthFault": "Neutralleiter-Erde-Fehler",
  "50901.fault.overTemperature": "Übertemperatur",
  "50901.fault.overtemperatureAlarm": "Überhitzungsalarm",
  "50901.fault.pllLockFailed": "PLL-Synchronisationsfehler",
  "50901.fault.preSynchronizationFailed": "Fehler bei Vor-Synchronisation",
  "50901.fault.pvFault": "PV-Fehler",
  "50901.Fault.pvMeterCommunicationAbnormality": "Pv-Zähler Kommunikation Anomal",
  "50901.Fault.pvMeterTypeError": "Pv-Zähler Typfehler",
  "50901.fault.pvPortOvercurrent": "Pv-Anschluss Überstrom",
  "50901.fault.pvRelayAbFault": "Pv-Ab-Relaisfehler",
  "50901.fault.pvVoltageExceedingBusVoltage": "PV-Spannung überschreitet Zwischenkreisspannung",
  "50901.fault.rcdFault": "RCD-Fehler (Fehlerstromschutzschalter)",
  "50901.fault.rcdSelfTestFault": "RCD-Selbsttestfehler",
  "50901.fault.reconnectionFailed": "Wiederverbindungsfehler",
  "50901.fault.samplingBiasAbnormality": "Abtast-Offset anomal",
  "50901.fault.shutDown": "Systemabschaltung",
  "50901.Fault.slaveWrongBatteryConnection": "Slave-Batterie Anschlussfehler",
  "50901.fault.smartloadPortOvercurrent": "Smart-Load-Anschluss Überstrom",
  "50901.fault.spiCommunicationFault": "SPI-Kommunikationsfehler",
  "50901.Fault.sustainedNegativeLoad": "Anhaltende Negative Last",
  "50901.fault.temperatureAbnormality": "Temperatur anomal",
  "50901.fault.tenMinuteOvervoltage": "10-Minuten-Überspannung",
  "50901.fault.threePointThreeVoltPowerSupplyFault": "Fehler 3.3V-Stromversorgung",
  "50901.fault.twelveVoltPowerSupplyFault": "Fehler 12V-Stromversorgung",
  "50901.fault.versionMismatch": "Versionskonflikt / Version nicht passend",
  "50901.fault.wiringAbnormality": "Verdrahtung anomal",
  "50901.otaHttpUrl.otaHttpUrl": "Upgrade-Befehl",
  "50901.real_time.12vAuxiliaryVoltageSampling": "12V Hilfsspannungsabtastung",
  "50901.real_time.12vOutputVoltageSampling": "12V Ausgangsspannungsabtastung",
  "50901.real_time.3_3vAuxiliaryVoltageSampling": "3.3V Hilfsspannungsabtastung",
  "50901.real_time.5vAuxiliaryVoltageSampling": "5V Hilfsspannungsabtastung",
  "50901.real_time.ambientTemperatureSampling": "Umgebungstemperaturabtastung",
  "50901.real_time.appSoftwareVersion": "App-Softwareversion",
  "50901.real_time.batteryDailyChargeEnergy": "Batterie Tägliche Ladekapazität",
  "50901.real_time.batteryDailyDischargeEnergy": "Batterie Tägliche Entladekapazität",
  "50901.real_time.batteryModuleNum": "Batterie-Zellenanzahl (Reihenschaltung pro Modul)",
  "50901.real_time.batteryPowerWholeSystem": "Batterie-Gesamtleistung (Gesamtsystem)",
  "50901.real_time.batteryToLoadPower": "Batteriezufuhr zur Last / Batterie-zu-Last Leistung",
  "50901.real_time.bootSoftwareVersion": "Bootloader-Softwareversion",
  "50901.real_time.communicationStickHardwareVersion": "Kommunikationsstick Hardwareversion",
  "50901.real_time.communicationStickSn": "Kommunikationsstick Sn",
  "50901.real_time.communicationStickSoftwareVersion": "Kommunikationsstick Softwareversion",
  "50901.real_time.copy_dspVersionMainUVersion": "Dsp-Version (Haupt-U-Version)",
  "50901.real_time.dailyBatteryToLoadEnergy": "Heute Batterie-zu-Last Energie",
  "50901.real_time.dailyExportEnergyToGrid": "Heute Verkaufsenergie",
  "50901.real_time.dailyGridToLoadEnergy": "Heute Netz-zu-Last Energie",
  "50901.real_time.dailyImportEnergyFromGrid": "Heute Bezugsenergie",
  "50901.real_time.dailyPvToBatteryEnegry": "Heute PV-zu-Batterie Energie",
  "50901.real_time.dailyPvToGridEnegry": "Heute PV-zu-Netz Energie",
  "50901.real_time.dailyPvToLoadEnegry": "Heute PV-zu-Last Energie",
  "50901.real_time.dTSReset": "Daten-Stick-Reset",
  "50901.real_time.firmwareBuildTimeDateHour": "Firmware-Erstellungszeit (Tag/Stunde)",
  "50901.real_time.firmwareBuildTimeYearMonth": "Firmware-Erstellungszeit (Jahr & Monat)",
  "50901.real_time.firmwareCrc": "Firmware-Crc",
  "50901.real_time.firmwareEndAddressHigh": "Firmware-Endadresse (Hoch)",
  "50901.real_time.firmwareEndAddressLow": "Firmware-Endadresse (Niedrig)",
  "50901.real_time.firmwareInformationCrc": "Firmware-Info-Crc",
  "50901.real_time.firmwareStartAddressHigh": "Firmware-Startadresse (Hoch)",
  "50901.real_time.firmwareStartAddressLow": "Firmware-Startadresse (Niedrig)",
  "50901.real_time.generatorDailyYield": "Generator Tageserzeugung",
  "50901.real_time.generatorPower": "Generatorleistung",
  "50901.real_time.generatorPowerA": "Generator Phase A Leistung",
  "50901.real_time.generatorPowerB": "Generator Phase B Leistung",
  "50901.real_time.generatorPowerC": "Generator Phase C Leistung",
  "50901.real_time.gridMeasurementOfRadiatorTemperature": "Netzseite Kühlkörpertemperatur",
  "50901.real_time.gridMeterSerialNumber": "Netzseite Zähler Seriennummer",
  "50901.real_time.gridPowerWholeSystem": "Netz Gesamtleistung (Gesamtsystem)",
  "50901.real_time.hoymilesSerialNumber": "Hoymiles Serienummer",
  "50901.real_time.inverterHardwareVersion": "Wechselrichter Hardwareversion",
  "50901.real_time.inverterModelNumber": "Wechselrichter Modellnummer",
  "50901.real_time.loadEnergy": "Last Täglicher Energieverbrauch",
  "50901.real_time.loadPowerWholeSystem": "Last Gesamtleistung (Gesamtsystem)",
  "50901.real_time.macAddr": "Mac-Adresse",
  "50901.real_time.materType": "Zählertyp",
  "50901.real_time.maxCellSoc": "Maximaler Zellen-SOC",
  "50901.real_time.maxCellSocCellId": "Maximaler Zellen-SOC entsprechender Index",
  "50901.real_time.maxCellTemperature": "Maximale Zellentemperatur",
  "50901.real_time.maxCellTemperatureCellId": "Maximale Zellentemperatur entsprechender Index",
  "50901.real_time.maxCellVoltage": "Maximale Zellenspannung",
  "50901.real_time.maxCellVoltageCellId": "Maximale Zellenspannung entsprechender Index",
  "50901.real_time.minCellSoc": "Minimaler Zellen-SOC",
  "50901.real_time.minCellSocCellId": "Minimaler Zellen-SOC entsprechender Index",
  "50901.real_time.minCellTemperature": "Minimale Zellentemperatur",
  "50901.real_time.minCellTemperatureCellId": "Minimale Zellentemperatur entsprechender Index",
  "50901.real_time.minCellVoltage": "Minimale Zellenspannung",
  "50901.real_time.minCellVoltageCellId": "Minimale Zellenspannung entsprechender Index",
  "50901.real_time.numberOfChargingAndDischargingCyclesOfBatteryPack": "Batteriepaket Lade-/Entladezyklus Anzahl",
  "50901.real_time.oemModelName": "Oem Modellname",
  "50901.real_time.oemSerialNumber": "Oem Seriennummer",
  "50901.real_time.packCurrent": "Batteriepaket Strom",
  "50901.real_time.packPower": "Batteriepaket Leistung",
  "50901.real_time.packSoc": "Batteriepaket SOC",
  "50901.real_time.packSoh": "Batteriepaket SOH",
  "50901.real_time.packVoltage": "Batteriepaket Spannung",
  "50901.real_time.pv1RealTimePower": "PV1 Ist-Leistung",
  "50901.real_time.pv2RealTimePower": "PV2 Ist-Leistung",
  "50901.real_time.pv3RealTimePower": "PV3 Ist-Leistung",
  "50901.real_time.pv4RealTimePower": "PV4 Ist-Leistung",
  "50901.real_time.pvMeterSerialNumber": "Pv-Zähler Seriennummer",
  "50901.real_time.pvPower": "Pv-Leistung",
  "50901.real_time.pvPowerWholeSystem": "PV Gesamtleistung (Gesamtsystem)",
  "50901.real_time.pvToBatteryPower": "PV-zu-Batterie Leistung",
  "50901.real_time.pvToGridPower": "PV-zu-Netz Leistung",
  "50901.real_time.pvToLoadPower": "PV-zu-Last Leistung",
  "50901.real_time.relayStatus": "Relaisstatus",
  "50901.real_time.relaySupplyVoltageSampling": "Relais-Stromversorgungsspannungsabtastung",
  "50901.real_time.rssi": "Signalstärke",
  "50901.real_time.ssid": "Ssid",
  "50901.warning.batteryHighVoltageAlarm": "Batterie Überspannungsalarm",
  "50901.warning.batteryLowVoltageAlarm": "Batterie Unterspannung",
  "50901.warning.batteryPackChargeHighVoltageAlarm": "Batteriepaket Lade-Überspannungsalarm",
  "50901.warning.batteryPackDischargeLowVoltageAlarm": "Batteriepaket Entlade-Unterspannungsalarm",
  "50901.warning.canCommunicationTimeout": "CAN-Kommunikations-Timeout",
  "50901.warning.chargeHighTemperatureAlarm": "Lade-Hochtemperaturalarm",
  "50901.warning.chargeLowTemperatureAlarm": "Lade-Niedrigtemperaturalarm",
  "50901.warning.dischargeHighTemperatureAlarm": "Entlade-Hochtemperaturalarm",
  "50901.warning.dischargeLowTemperatureAlarm": "Entlade-Niedrigtemperaturalarm",
  "50901.warning.hardwareProtection": "Hardware-Schutz",
  "50901.warning.inputOvervoltageAlarm": "Eingangs-Überspannungsalarm",
  "50901.warning.lowBatteryEnergy": "Batteriekapazität zu niedrig",
  "50901.ctrl_Config.ClockSetting.ClockSetting": "Uhreinstellung",
  "50901.ctrl_Config.ClockSetting.clockSetting_day": "Uhreinstellung - Tag",
  "50901.ctrl_Config.ClockSetting.clockSetting_hour": "Uhreinstellung - Stunde",
  "50901.ctrl_Config.ClockSetting.clockSetting_minute": "Uhreinstellung - Minute",
  "50901.ctrl_Config.ClockSetting.clockSetting_month": "Uhreinstellung - Monat",
  "50901.ctrl_Config.ClockSetting.clockSetting_second": "Uhreinstellung - Sekunde",
  "50901.ctrl_Config.ClockSetting.clockSetting_weekday": "Uhreinstellung - Wochentag",
  "50901.ctrl_Config.ClockSetting.clockSetting_year": "Uhreinstellung - Jahr",
  "50901.ctrl_Config.Device.masterSlave": "Master/Slave",
  "50901.ctrl_Config.Gateway.ambientTemperatureThreshold": "Umgebungstemperatur-Schwelle",
  "50901.ctrl_Config.Gateway.boardAmbientTemperatureThreshold": "Leiterplatten-Umgebungstemperatur-Schwelle",
  "50901.ctrl_Config.Gateway.gatewayCommunicationAddress": "Gateway-Kommunikationsadresse",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndH": "Nutzungszeitraum 1 Ladeende - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndMin": "Nutzungszeitraum 1 Ladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgPower": "Ladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartMin": "Nutzungszeitraum 1 Ladestart - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStopSoc": "Lade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndH": "Nutzungszeitraum 1 Entladeende - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndMin": "Nutzungszeitraum 1 Entladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgPower": "Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartMin": "Nutzungszeitraum 1 Entladestart - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStopSoc": "Entlade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndH": "Nutzungszeitraum 2 Ladeende - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndMin": "Nutzungszeitraum 2 Ladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgPower": "Ladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartMin": "Nutzungszeitraum 2 Ladestart - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStopSoc": "Lade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndH": "Nutzungszeitraum 2 Entladeende - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndMin": "Nutzungszeitraum 2 Entladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgPower": "Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartMin": "Nutzungszeitraum 2 Entladestart - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStopSoc": "Entlade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndH": "Nutzungszeitraum 3 Ladeende - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndMin": "Nutzungszeitraum 3 Ladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgPower": "Ladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartMin": "Nutzungszeitraum 3 Ladestart - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStopSoc": "Lade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndH": "Nutzungszeitraum 3 Entladeende - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndMin": "Nutzungszeitraum 3 Entladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgPower": "Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartMin": "Nutzungszeitraum 3 Entladestart - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStopSoc": "Entlade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndH": "Nutzungszeitraum 4 Ladeende - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndMin": "Nutzungszeitraum 4 Ladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgPower": "Ladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartMin": "Nutzungszeitraum 4 Ladestart - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStopSoc": "Lade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndH": "Nutzungszeitraum 4 Entladeende - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndMin": "Nutzungszeitraum 4 Entladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgPower": "Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartMin": "Nutzungszeitraum 4 Entladestart - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStopSoc": "Entlade-Abschaltleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndH": "Nutzungszeitraum 5 Ladeende - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndMin": "Nutzungszeitraum 5 Ladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgPower": "Ladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartH": "Nutzungszeitraum 5 Ladestart - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartMin": "Nutzungszeitraum 5 Ladestart - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStopSoc": "Lade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndH": "Nutzungszeitraum 5 Entladeende - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndMin": "Nutzungszeitraum 5 Entladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgPower": "Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartH": "Nutzungszeitraum 5 Entladestart - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartMin": "Nutzungszeitraum 5 Entladestart - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStopSoc": "Entlade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndH": "Nutzungszeitraum 6 Ladeende - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndMin": "Nutzungszeitraum 6 Ladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgPower": "Ladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartH": "Nutzungszeitraum 6 Ladestart - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartMin": "Nutzungszeitraum 6 Ladestart - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStopSoc": "Lade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndH": "Nutzungszeitraum 6 Entladeende - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndMin": "Nutzungszeitraum 6 Entladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgPower": "Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartH": "Nutzungszeitraum 6 Entladestart - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartMin": "Nutzungszeitraum 6 Entladestart - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStopSoc": "Entlade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndH": "Nutzungszeitraum 7 Ladeende - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndMin": "Nutzungszeitraum 7 Ladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgPower": "Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartH": "Nutzungszeitraum 7 Ladestart - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartMin": "Nutzungszeitraum 7 Ladestart - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStopSoc": "Entlade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndH": "Nutzungszeitraum 7 Entladeende - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndMin": "Nutzungszeitraum 7 Entladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgPower": "Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartH": "Nutzungszeitraum 7 Entladestart - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartMin": "Nutzungszeitraum 7 Entladestart - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStopSoc": "Entlade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndH": "Nutzungszeitraum 8 Ladeende - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndMin": "Nutzungszeitraum 8 Ladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgPower": "Ladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartH": "Nutzungszeitraum 8 Ladestart - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartMin": "Nutzungszeitraum 8 Ladestart - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStopSoc": "Lade-Abschaltkapazität",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndH": "Nutzungszeitraum 8 Entladeende - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndMin": "Nutzungszeitraum 8 Entladeende - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgPower": "Entladeleistung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartH": "Nutzungszeitraum 8 Entladestart - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartMin": "Nutzungszeitraum 8 Entladestart - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStopSoc": "Entlade-Abschaltkapazität",
  "50901.real_time.afciVersion": "Afci-Version",
  "50901.real_time.batteryChargePower": "Batterie Kumulierte Ladekapazität",
  "50901.real_time.batteryConnectionStatus": "Batterie-Anschlussstatus",
  "50901.real_time.batteryCurrent": "Batteriestrom",
  "50901.real_time.batteryDischargePower": "Batterie Kumulierte Entladekapazität",
  "50901.real_time.batteryPower": "Batterieleistung (Laden/Entladen)",
  "50901.real_time.batterySoc": "Batterie-Soc",
  "50901.real_time.batterytotCap": "Batterie Gesamtinstallierte Kapazität",
  "50901.real_time.batteryType_04": "Batterietyp",
  "50901.real_time.batteryVoltage": "Batteriespannung",
  "50901.real_time.batteryWorkingStatus": "Batteriestatus",
  "50901.real_time.bmsSoftwareVersion": "BMS-Version - Software",
  "50901.real_time.commAddress10Slave9": "Kommunikationsadresse 10 (Slave 9)",
  "50901.real_time.commAddress1Master": "Kommunikationsadresse 1 (Master)",
  "50901.real_time.commAddress2Slave1": "Kommunikationsadresse 2 (Slave 1)",
  "50901.real_time.commAddress3Slave2": "Kommunikationsadresse 3 (Slave 2)",
  "50901.real_time.commAddress3Slave3": "Kommunikationsadresse 4 (Slave 3)",
  "50901.real_time.commAddress4Slave4": "Kommunikationsadresse 5 (Slave 4)",
  "50901.real_time.commAddress6Slave6": "Kommunikationsadresse 6 (Slave 5)",
  "50901.real_time.commAddress7Slave6": "Kommunikationsadresse 7 (Slave 6)",
  "50901.real_time.commAddress8Slave7": "Kommunikationsadresse 8 (Slave 7)",
  "50901.real_time.commAddress9Slave8": "Kommunikationsadresse 9 (Slave 8)",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria": "Drm-Status (Für Australien/Deutschland/Österreich)",
  "50901.real_time.dspVersionAuxiliaryUVersion": "Dsp-Version (Hilfs-U-Version)",
  "50901.real_time.epsCurrentA": "Eps-Seite Phase A Strom",
  "50901.real_time.epsCurrentB": "Eps-Seite Phase B Strom",
  "50901.real_time.epsCurrentC": "Eps-Seite Phase C Strom",
  "50901.real_time.epsPower": "Eps-Seite Leistung",
  "50901.real_time.epsPowerA": "Eps-Seite Phase A Leistung",
  "50901.real_time.epsPowerB": "Eps-Seite Phase B Leistung",
  "50901.real_time.epsPowerC": "Eps-Seite Phase C Leistung",
  "50901.real_time.epsVoltageA": "Eps-Seite Phase A Spannung",
  "50901.real_time.epsVoltageB": "Eps-Seite Phase B Spannung",
  "50901.real_time.epsVoltageC": "Eps-Seite Phase C Spannung",
  "50901.real_time.essAccessPoint": "Ess-Zugangspunkt",
  "50901.real_time.externalFanSpeed1": "Äußere Lüfterdrehzahl 1",
  "50901.real_time.externalFanSpeed2": "Äußere Lüfterdrehzahl 2",
  "50901.real_time.externalFanSpeed3": "Äußere Lüfterdrehzahl 3",
  "50901.real_time.externalFanSpeed4": "Äußere Lüfterdrehzahl 4",
  "50901.real_time.generatorConnectionStatus": "Generator-Verbindungsstatus",
  "50901.real_time.generatorCurrentA": "Generator Phase A Strom",
  "50901.real_time.generatorCurrentB": "Generator Phase B Strom",
  "50901.real_time.generatorCurrentC": "Generator Phase C Strom",
  "50901.real_time.generatorTotalYield": "Generator kumulierte Erzeugung",
  "50901.real_time.generatorVoltageA": "Generator Phase A Spannung",
  "50901.real_time.generatorVoltageB": "Generator Phase B Spannung",
  "50901.real_time.generatorVoltageC": "Generator Phase C Spannung",
  "50901.real_time.gridBuyPower": "Kumulierte Bezugsenergie",
  "50901.real_time.gridCurrentA": "Netzseite Phase A Strom",
  "50901.real_time.gridCurrentB": "Netzseite Phase B Strom",
  "50901.real_time.gridCurrentC": "Netzseite Phase C Strom",
  "50901.real_time.gridPower": "Netzseite Leistung",
  "50901.real_time.gridPowerA": "Netzseite Phase A Leistung",
  "50901.real_time.gridPowerB": "Netzseite Phase B Leistung",
  "50901.real_time.gridPowerC": "Netzseite Phase C Leistung",
  "50901.real_time.gridPowerFactor": "Netzseite Leistungsfaktor",
  "50901.real_time.gridPowerFactorA": "Netzseite Phase A Leistungsfaktor",
  "50901.real_time.gridPowerFactorB": "Netzseite Phase B Leistungsfaktor",
  "50901.real_time.gridPowerFactorC": "Netzseite Phase C Leistungsfaktor",
  "50901.real_time.gridReactivePower": "Netzseite Blindleistung",
  "50901.real_time.gridReactivePowerA": "Netzseite Phase A Blindleistung",
  "50901.real_time.gridReactivePowerB": "Netzseite Phase B Blindleistung",
  "50901.real_time.gridReactivePowerC": "Netzseite Phase C Blindleistung",
  "50901.real_time.gridSellPower": "Kumulierte Verkaufsenergie",
  "50901.real_time.gridTotalFrequency": "Netzseite Frequenz",
  "50901.real_time.gridVoltageA": "Netzseite Phase A Spannung",
  "50901.real_time.gridVoltageB": "Netzseite Phase B Spannung",
  "50901.real_time.gridVoltageC": "Netzseite Phase C Spannung",
  "50901.real_time.internalFanSpeed1": "Innere Lüfterdrehzahl 1",
  "50901.real_time.internalFanSpeed2": "Innere Lüfterdrehzahl 2",
  "50901.real_time.internalFanSpeed3": "Innere Lüfterdrehzahl 3",
  "50901.real_time.invAcFrequency": "Wechselrichter AC-Ausgangsfrequenz",
  "50901.real_time.inverCombinedActivePower": "Wechselrichter AC-Ausgangsleistung",
  "50901.real_time.inverterSideRadiatorTemperature": "Wechselrichter Seite Kühlkörpertemperatur",
  "50901.real_time.inverterTemp": "Wechselrichter Innere Betriebstemperatur",
  "50901.real_time.invRatedPower": "Nennleistung",
  "50901.real_time.invRunningtime": "Inv-Betriebszeit (Hoymiles: Normale Betriebszeit)",
  "50901.real_time.machineSnMaster": "Master-Einheit Sn",
  "50901.real_time.machineSnSlave1": "Slave 1 Sn",
  "50901.real_time.machineSnSlave2": "Slave 2 Sn",
  "50901.real_time.machineSnSlave3": "Slave 3 Sn",
  "50901.real_time.machineSnSlave4": "Slave 4 Sn",
  "50901.real_time.machineSnSlave5": "Slave 5 Sn",
  "50901.real_time.machineSnSlave6": "Slave 6 Sn",
  "50901.real_time.machineSnSlave7": "Slave 7 Sn",
  "50901.real_time.machineSnSlave8": "Slave 8 Sn",
  "50901.real_time.machineSnSlave9": "Slave 9 Sn",
  "50901.real_time.MaxChargeCurrent": "Maximaler Ladestrom",
  "50901.real_time.MaxDisChargeCurrent": "Maximaler Entladestrom",
  "50901.real_time.meterFlag": "Zähler-Flag",
  "50901.real_time.mpptTemp": "Pv-Seite Kühlkörpertemperatur",
  "50901.real_time.numberOfUnits": "Einheitenanzahl",
  "50901.real_time.packNum": "Parallelanzahl (Anzahl Batteriepakete)",
  "50901.real_time.phaseAOfInverterActivePower": "Wechselrichter AC-Seite Phase A Leistung",
  "50901.real_time.phaseAOfInverterSideCurrent": "Wechselrichter AC-Seite Phase A Strom",
  "50901.real_time.phaseAOfInverterSideVoltage": "Wechselrichter AC-Seite Phase A Spannung",
  "50901.real_time.phaseBOfInverterActivePower": "Wechselrichter AC-Seite Phase B Leistung",
  "50901.real_time.phaseBOfInverterSideCurrent": "Wechselrichter AC-Seite Phase B Strom",
  "50901.real_time.phaseBOfInverterSideVoltage": "Wechselrichter AC-Seite Phase B Spannung",
  "50901.real_time.phaseCOfInverterActivePower": "Wechselrichter AC-Seite Phase C Leistung",
  "50901.real_time.phaseCOfInverterSideCurrent": "Wechselrichter AC-Seite Phase C Strom",
  "50901.real_time.phaseCOfInverterSideVoltage": "Wechselrichter AC-Seite Phase C Spannung",
  "50901.real_time.powerGeneration": "PV kumulierte Erzeugung",
  "50901.real_time.pv1Current": "Pv1 Strom",
  "50901.real_time.pv1Power": "Pv1 Leistung",
  "50901.real_time.pv1Voltage": "Pv1 Spannung",
  "50901.real_time.pv2Current": "Pv2 Strom",
  "50901.real_time.pv2Power": "Pv2 Leistung",
  "50901.real_time.pv2Voltage": "Pv2 Spannung",
  "50901.real_time.pv3Current": "Pv3 Strom",
  "50901.real_time.pv3Power": "Pv3 Leistung",
  "50901.real_time.pv3Voltage": "Pv3 Spannung",
  "50901.real_time.pv4Current": "Pv4 Strom",
  "50901.real_time.pv4Power": "Pv4 Leistung",
  "50901.real_time.pv4Voltage": "Pv4 Spannung",
  "50901.real_time.pvConnectionStatus": "Pv-Verbindungsstatus",
  "50901.real_time.pvDailyYield": "Pv Tageserzeugung",
  "50901.real_time.pvMeterConnectionStatus": "Pv-Zähler Verbindungsstatus",
  "50901.real_time.pvMeterCurrentA": "Pv-Zähler Phase A Strom",
  "50901.real_time.pvMeterCurrentB": "Pv-Zähler Phase B Strom",
  "50901.real_time.pvMeterCurrentC": "Pv-Zähler Phase C Strom",
  "50901.real_time.pvMeterDailyYield": "Externer Wechselrichter Tageserzeugung",
  "50901.real_time.pvMeterFrequency": "Pv-Zähler Frequenz",
  "50901.real_time.pvMeterPhaseAActivePower": "Pv-Zähler Phase A Wirkleistung",
  "50901.real_time.pvMeterPhaseAPowerFactor": "Pv-Zähler Phase A Leistungsfaktor",
  "50901.real_time.pvMeterPhaseAReactivePower": "Pv-Zähler Phase A Blindleistung",
  "50901.real_time.pvMeterPhaseBActivePower": "Pv-Zähler Phase B Wirkleistung",
  "50901.real_time.pvMeterPhaseBPowerFactor": "Pv-Zähler Phase B Leistungsfaktor",
  "50901.real_time.pvMeterPhaseBReactivePower": "Pv-Zähler Phase B Blindleistung",
  "50901.real_time.pvMeterPhaseCActivePower": "Pv-Zähler Phase C Wirkleistung",
  "50901.real_time.pvMeterPhaseCPowerFactor": "Pv-Zähler Phase C Leistungsfaktor",
  "50901.real_time.pvMeterPhaseCReactivePower": "Pv-Zähler Phase C Blindleistung",
  "50901.real_time.pvMeterPower": "Pv-Zähler Leistung",
  "50901.real_time.pvMeterPowerA": "Pv-Zähler Phase A Leistung",
  "50901.real_time.pvMeterPowerB": "Pv-Zähler Phase B Leistung",
  "50901.real_time.pvMeterPowerC": "Pv-Zähler Phase C Leistung",
  "50901.real_time.pvMeterTotalYield": "Externer Wechselrichter kumulierte Erzeugung",
  "50901.real_time.pvMeterVoltageA": "Pv-Zähler Phase A Spannung",
  "50901.real_time.pvMeterVoltageB": "Pv-Zähler Phase B Spannung",
  "50901.real_time.pvMeterVoltageC": "Pv-Zähler Phase C Spannung",
  "50901.real_time.serviceEntranceBreakerCurrent": "Stromeingangsspeisepunkt / Service Entrance Strom",
  "50901.real_time.soh": "Soh",
  "50901.real_time.totalBatteryToLoadEnergy": "Kumulierte Batterie-zu-Last Energie",
  "50901.real_time.totalGridToLoadEnergy": "Kumulierte Netz-zu-Last Energie",
  "50901.real_time.totalLoadEnergy": "Last kumulierter Energieverbrauch",
  "50901.real_time.totalPvToBatteryEnegry": "Kumulierte PV-zu-Batterie Energie",
  "50901.real_time.totalPvToGridEnegry": "Kumulierte PV-zu-Netz Energie",
  "50901.real_time.totalPvToLoadEnegry": "Kumulierte PV-zu-Last Energie",
  "50901.real_time.workStatus": "Betriebsstatus",
  "50901.ctrl_Config.Battery.absorptionVoltage": "Absorptionsspannung",
  "50901.ctrl_Config.Battery.batteryCapacity": "BMS-Kapazität",
  "50901.ctrl_Config.Battery.endChargeVoltage": "Ladeschlussspannung",
  "50901.ctrl_Config.Battery.endOfChargeCurrent": "Ladestromende",
  "50901.ctrl_Config.Battery.equalizationChargeTimeout": "Ausgleichsladung Timeout",
  "50901.ctrl_Config.Battery.equalizationEnable": "Ausgleich Aktivieren",
  "50901.ctrl_Config.Battery.equalizationIntervalDays": "Ausgleichsintervall Tage",
  "50901.ctrl_Config.Battery.equalizationTime": "Ausgleichszeit",
  "50901.ctrl_Config.Battery.equalizationVoltage": "Ausgleichsspannung",
  "50901.ctrl_Config.Battery.floatVoltage": "Erhaltungsspannung",
  "50901.ctrl_Config.Battery.initialResistance": "Anfangswiderstand",
  "50901.ctrl_Config.Battery.maximumChargeLimit": "Maximaler Ladestrom/-Leistung Grenzwert",
  "50901.ctrl_Config.Battery.maximumDischargeLimit": "Maximaler Entladestrom/-Leistung Grenzwert",
  "50901.ctrl_Config.Battery.temperatureCorrectionFactor": "Temperaturkorrekturkoeffizient",
  "50901.ctrl_Config.Connection.dtu_comm_enable": "Dtu-Kommunikation Aktivieren",
  "50901.ctrl_Config.Device.arcFaultClear": "Lichtbogenfehler löschen",
  "50901.ctrl_Config.Device.batActivate": "Batterieaktivierung",
  "50901.ctrl_Config.Device.batteryBalancing": "Batteriebalancierung",
  "50901.ctrl_Config.Device.clearFault": "Fehler löschen",
  "50901.ctrl_Config.Device.parallelNetworking": "Parallelbetrieb Netzwerk",
  "50901.ctrl_Config.Device.restartSystem": "Systemneustart",
  "50901.ctrl_Config.Device.restoreDefault": "Standardwerte Wiederherstellen",
  "50901.ctrl_Config.Device.selfTest": "Selbsttest",
  "50901.ctrl_Config.Device.systemPowerOnOff": "System Ein/Aus",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndH": "Generatorsteuerung - Ladeendezeit - H",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndMin": "Generatorsteuerung - Ladeendezeit - Minute",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartH": "Generatorsteuerung - Ladestartzeit - H",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartMin": "Generatorsteuerung - Ladestartzeit - Minute",
  "50901.ctrl_Dry_Contact.Generator.generatorCloseBatteryCapacity": "Generator-Abschalt-Batteriekapazität",
  "50901.ctrl_Dry_Contact.Generator.generatorMode": "Generatorbetriebsart / Modus",
  "50901.ctrl_Dry_Contact.Generator.generatorOpenBatteryCapacity": "Generator-Start-Batteriekapazität",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq": "Generator Übungsmodus Frequenz",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn": "Generator Übungsmodus",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeRunningTime": "Generator Übungsmodus Laufzeit",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartH": "Generator Übungsmodus Startzeit - Stunde",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartMin": "Generator Übungsmodus Startzeit - Minute",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek": "Generator Übungsmodus Startzeit",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndH": "Standby-Zeit 1 Ende - H",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndMin": "Standby-Zeit 1 Ende - Minute",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartH": "Standby-Zeit 1 Start - H",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartMin": "Standby-Zeit 1 Start - Minute",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndH": "Standby-Zeit 2 Ende - H",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndMin": "Standby-Zeit 2 Ende - Minute",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartH": "Standby-Zeit 2 Start - H",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartMin": "Standby-Zeit 2 Start - Minute",
  "50901.ctrl_Dry_Contact.Generator.quietTimeEnable": "Standby-Zeit Aktivieren",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode": "Laststeuerungsmodus",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1": "Laststeuerung Montag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2": "Laststeuerung Dienstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3": "Laststeuerung Mittwoch",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4": "Laststeuerung Donnerstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5": "Laststeuerung Freitag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6": "Laststeuerung Samstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7": "Laststeuerung Sonntag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch": "Manueller Modus Schalter",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnLoadPower": "Lastmodus Lastleistungsschwelle",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnTime": "Laststeuerung Mindesteinschaltdauer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.offGridProtectionSoc": "Inselmodus Schutz-Soc",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange1": "Zeitbereich 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20": "Montag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21": "Dienstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22": "Mittwoch",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23": "Donnerstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24": "Freitag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25": "Samstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26": "Sonntag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour": "Timer 1 Ende - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_2": "Timer 1 Ende_2 - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_3": "Zeitslot 1 Ende - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute": "Timer 1 Ende - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_2": "Timer 1 Ende_2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_3": "Zeitslot 1 Ende - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min": "Timer 1 Start - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_2": "Timer 1 Start_2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_3": "Zeitslot 1 Start - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour": "Timer 2 Ende - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_2": "Timer 2 Ende_2 - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_3": "Zeitslot 2 Ende - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes": "Timer 2 Ende - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_2": "Timer 2 Ende_2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_3": "Zeitslot 2 Ende - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes": "Timer 2 Start - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_2": "Timer 2 Start_2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_3": "Zeitslot 2 Start - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour": "Timer 1 Start - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_2": "Timer 1 Start_2 - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_3": "Zeitslot 1 Start - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour": "Timer 2 Start - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_2": "Timer 2 Start_2 - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_3": "Zeitslot 2 Start - Stunde",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1": "Montag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2": "Dienstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3": "Mittwoch",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4": "Donnerstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5": "Freitag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6": "Samstag",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7": "Sonntag",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode": "Trockenkontakt Arbeitsmodus",
  "50901.ctrl_ESS_Advanced_Config.Battery.batDischargePowerWhenPartialPeak": "Spitze Batterie Max. Entladeleistung",
  "50901.ctrl_ESS_Advanced_Config.Battery.batGridFeedPowerWhenPeak": "Spitze Netzeinspeiseleistung",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxChargePower": "Batterie Max. Ladeleistung",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxDischargePower": "Batterie Max. Entladeleistung",
  "50901.ctrl_ESS_Advanced_Config.Battery.leadAcidBatReplenishTime": "Blei-Säure-Batterie Wartungszeit",
  "50901.ctrl_ESS_Advanced_Config.Battery.maxSoc": "Maximaler Soc",
  "50901.ctrl_ESS_Advanced_Config.Battery.minSoc": "Minimaler Soc",
  "50901.ctrl_ESS_Advanced_Config.Battery.replenishPower": "Leistungskompensation",
  "50901.ctrl_ESS_Advanced_Config.Battery.rsvdReplenishPower": "Rsvd Reserveleistung",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable": "Bypass Deaktivieren",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode": "Eps-Modus",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn": "Pv-Modus Aktivieren",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_freq": "Generator Frequenzobergrenze",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_volt": "Generator Spannungsobergrenze",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_freq": "Generator Frequenzuntergrenze",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_volt": "Generator Spannungsuntergrenze",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_rated_power": "Generator-Zu-Batterie Ladeleistung Bei Mehrfach-Parallelbetrieb",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable": "Globale Scannen Aktivieren",
  "50901.ctrl_ESS_Advanced_Config.System.gridInPowerLimitationWhenValley": "Netzleistung Begrenzen",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable": "Dreiphasen-Ungleichgewicht Aktivieren",
  "50901.ctrl_Safety_GCF.gcfExportHardLimitRatio": "GCF Export-Hartlimit-Verhältnis",
  "50901.ctrl_WorkMode.Backup.backupSoc": "Reservierter Soc",
  "50901.ctrl_WorkMode.economic.economicModeSoc": "Wirtschaftsmodus Soc",
  "50901.ctrl_WorkMode.economic.economyModeDateNumber": "Wirtschaftsmodus Datumsindex",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour1": "Abschnitt 1 Spitzenstartzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour2": "Abschnitt 1 Spitzenstartzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute1": "Abschnitt 1 Spitzenstartzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute2": "Abschnitt 1 Spitzenstartzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour1": "Abschnitt 1 Spitzenstoppzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour2": "Abschnitt 1 Spitzenstoppzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute1": "Abschnitt 1 Spitzenstoppzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute2": "Abschnitt 1 Spitzenstoppzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section1StartDay": "Abschnitt 1 Starttag",
  "50901.ctrl_WorkMode.economic.section1StartMonth": "Abschnitt 1 Startmonat",
  "50901.ctrl_WorkMode.economic.section1StopDay": "Abschnitt 1 Stopptag",
  "50901.ctrl_WorkMode.economic.section1StopMonth": "Abschnitt 1 Stoppmonat",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour1": "Abschnitt 1 Nebenzeiten Startzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour2": "Abschnitt 1 Nebenzeiten Startzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute1": "Abschnitt 1 Nebenzeiten Startzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute2": "Abschnitt 1 Nebenzeiten Startzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour1": "Abschnitt 1 Nebenzeiten Stoppzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour2": "Abschnitt 1 Nebenzeiten Stoppzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute1": "Abschnitt 1 Nebenzeiten Stoppzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute2": "Abschnitt 1 Nebenzeiten Stoppzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section1WeekRange1": "Abschnitt 1 Wochenbereich 1",
  "50901.ctrl_WorkMode.economic.section1WeekRange2": "Abschnitt 1 Wochenbereich 2",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour1": "Abschnitt 2 Spitzenstartzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour2": "Abschnitt 2 Spitzenstartzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute1": "Abschnitt 2 Spitzenstartzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute2": "Abschnitt 2 Spitzenstartzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour1": "Abschnitt 2 Spitzenstoppzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour2": "Abschnitt 2 Spitzenstoppzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute1": "Abschnitt 2 Spitzenstoppzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute2": "Abschnitt 2 Spitzenstoppzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2StartDay": "Abschnitt 2 Starttag",
  "50901.ctrl_WorkMode.economic.section2StartMonth": "Abschnitt 2 Startmonat",
  "50901.ctrl_WorkMode.economic.section2StopDay": "Abschnitt 2 Stopptag",
  "50901.ctrl_WorkMode.economic.section2StopMonth": "Abschnitt 2 Stoppmonat",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour1": "Abschnitt 2 Nebenzeiten Startzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour2": "Abschnitt 2 Nebenzeiten Startzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute1": "Abschnitt 2 Nebenzeiten Startzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute2": "Abschnitt 2 Nebenzeiten Startzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour1": "Abschnitt 2 Nebenzeiten Stoppzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour2": "Abschnitt 2 Nebenzeiten Stoppzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute1": "Abschnitt 2 Nebenzeiten Stoppzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute2": "Abschnitt 2 Nebenzeiten Stoppzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2WeekRange1": "Abschnitt 2 Wochenbereich 1",
  "50901.ctrl_WorkMode.economic.section2WeekRange2": "Abschnitt 2 Wochenbereich 2",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour1": "Abschnitt 3 Spitzenstartzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour2": "Abschnitt 3 Spitzenstartzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute1": "Abschnitt 3 Spitzenstartzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute2": "Abschnitt 3 Spitzenstartzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour1": "Abschnitt 3 Spitzenstoppzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour2": "Abschnitt 3 Spitzenstoppzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute1": "Abschnitt 3 Spitzenstoppzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute2": "Abschnitt 3 Spitzenstoppzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section3StartDay": "Abschnitt 3 Starttag",
  "50901.ctrl_WorkMode.economic.section3StartMonth": "Abschnitt 3 Startmonat",
  "50901.ctrl_WorkMode.economic.section3StopDay": "Abschnitt 3 Stopptag",
  "50901.ctrl_WorkMode.economic.section3StopMonth": "Abschnitt 3 Stoppmonat",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour1": "Abschnitt 3 Nebenzeiten Startzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour2": "Abschnitt 3 Nebenzeiten Startzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute1": "Abschnitt 3 Nebenzeiten Startzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute2": "Abschnitt 3 Nebenzeiten Startzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour1": "Abschnitt 3 Nebenzeiten Stoppzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour2": "Abschnitt 3 Nebenzeiten Stoppzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute1": "Abschnitt 3 Nebenzeiten Stoppzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute2": "Abschnitt 3 Nebenzeiten Stoppzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section3WeekRange1": "Abschnitt 3 Wochenbereich 1",
  "50901.ctrl_WorkMode.economic.section3WeekRange2": "Abschnitt 3 Wochenbereich 2",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour1": "Abschnitt 4 Spitzenstartzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour2": "Abschnitt 4 Spitzenstartzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute1": "Abschnitt 4 Spitzenstartzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute2": "Abschnitt 4 Spitzenstartzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour1": "Abschnitt 4 Spitzenstoppzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour2": "Abschnitt 4 Spitzenstoppzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute1": "Abschnitt 4 Spitzenstoppzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute2": "Abschnitt 4 Spitzenstoppzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section4StartDay": "Abschnitt 4 Starttag",
  "50901.ctrl_WorkMode.economic.section4StartMonth": "Abschnitt 4 Startmonat",
  "50901.ctrl_WorkMode.economic.section4StopDay": "Abschnitt 4 Stopptag",
  "50901.ctrl_WorkMode.economic.section4StopMonth": "Abschnitt 4 Stoppmonat",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour1": "Abschnitt 4 Nebenzeiten Startzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour2": "Abschnitt 4 Nebenzeiten Startzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute1": "Abschnitt 4 Nebenzeiten Startzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute2": "Abschnitt 4 Nebenzeiten Startzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour1": "Abschnitt 4 Nebenzeiten Stoppzeit 1 - Stunde",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour2": "Abschnitt 4 Nebenzeiten Stoppzeit 2 - Stunde",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute1": "Abschnitt 4 Nebenzeiten Stoppzeit 1 - Minute",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute2": "Abschnitt 4 Nebenzeiten Stoppzeit 2 - Minute",
  "50901.ctrl_WorkMode.economic.section4WeekRange1": "Abschnitt 4 Wochenbereich 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange2": "Abschnitt 4 Wochenbereich 2",
  "50901.ctrl_WorkMode.forceCharge.forceChargeSoc": "Zwangslade-Soc",
  "50901.ctrl_WorkMode.forceCharge.maximumChargePower": "Maximale Ladeleistung",
  "50901.ctrl_WorkMode.forceDischarge.forceDischargeSoc": "Zwangsentladungs-Soc",
  "50901.ctrl_WorkMode.forceDischarge.maximumDischargePower": "Maximale Entladeleistung",
  "50901.ctrl_WorkMode.peakMeter.peakMeterPower": "Spitzenzähler Leistung",
  "50901.ctrl_WorkMode.peakMeter.peakMeterSoc": "Spitzenzähler Soc",
  "50901.ctrl_WorkMode.Selfuse.selfUsedSoc": "Eigenverbrauchs-Soc",
  "50901.ctrl_WorkMode.Switch.workMode": "Ems Arbeitsmodus / Betriebsmodus",
  "50901.ctrl_WorkMode.TOU.timeOfUseRange": "Tou-Modus Zeitbereich",
  "50901.real_time.BatteryModel": "Batteriemodell",
  "50901.real_time.cfgMultPcsBmsFlag": "BMS-Flag",
  "50901.real_time.inverterSn": "Wechselrichter Sn",
  "50901.ctrl_Config.Grid Profile.country": "Land/Netzanschlussstandard",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode": "Generatoranschluss-Modus",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position": "Generatorstandort",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_shutdown_delay": "Generator-Abschaltverzögerung",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_sync_time": "Generator-Synchronisationszeit",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type": "Generatortyp",
  "50901.ctrl_ESS_Advanced_Config.Generator.max_run_time": "Maximale Laufzeit",
  "50901.ctrl_ESS_Advanced_Config.Generator.min_run_time": "Minimale Laufzeit",
  "50901.ctrl_ESS_Advanced_Config.Generator.run_protect_threshold": "Betriebsschutzintervall",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model": "Zählermodell",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable": "Mid / Gateway Aktivieren",
  "50901.ctrl_Safety.DCI.dciEnable": "Dci Aktivieren",
  "50901.ctrl_Safety.DCI.lowerLimit": "Dci Unterer Grenzstrom",
  "50901.ctrl_Safety.DCI.lowerTime": "Dci Untere Grenzzeit",
  "50901.ctrl_Safety.DCI.upperLimit": "Dci Oberer Grenzstrom",
  "50901.ctrl_Safety.DCI.upperTime": "Dci Obere Grenzzeit",
  "50901.ctrl_Safety.FRT.frtFuncCode": "Frt-Funktionscode",
  "50901.ctrl_Safety.FRT.frtHighLimit1": "Frequenzobergrenze 1",
  "50901.ctrl_Safety.FRT.frtHighLimit1Time": "Frequenzobergrenze 1 Dauer",
  "50901.ctrl_Safety.FRT.frtHighLimit2": "Frequenzobergrenze 2",
  "50901.ctrl_Safety.FRT.frtHighLimit2Time": "Frequenzobergrenze 2 Dauer",
  "50901.ctrl_Safety.FRT.frtHighLimit3": "Frequenzobergrenze 3",
  "50901.ctrl_Safety.FRT.frtHighLimit3Time": "Frequenzobergrenze 3 Dauer",
  "50901.ctrl_Safety.FRT.frtLowLimit1": "Frequenzuntergrenze 1",
  "50901.ctrl_Safety.FRT.frtLowLimit1Time": "Frequenzuntergrenze 1 Dauer",
  "50901.ctrl_Safety.FRT.frtLowLimit2": "Frequenzuntergrenze 2",
  "50901.ctrl_Safety.FRT.frtLowLimit2Time": "Frequenzuntergrenze 2 Dauer",
  "50901.ctrl_Safety.FRT.frtLowLimit3": "Frequenzuntergrenze 3",
  "50901.ctrl_Safety.FRT.frtLowLimit3Time": "Frequenzuntergrenze 3 Dauer",
  "50901.ctrl_Safety.FW.fwDiffInBatMode": "Fw Batteriemodus Unterschied Aktivieren",
  "50901.ctrl_Safety.FW.fwEnable": "Fw Aktivieren",
  "50901.ctrl_Safety.FW.fwFuncCode": "Fw-Funktionscode",
  "50901.ctrl_Safety.FW.fwOverEndFreq": "Fw Überfrequenz Endfrequenz",
  "50901.ctrl_Safety.FW.fwOverStartFreq": "Fw Überfrequenz Startfrequenz",
  "50901.ctrl_Safety.FW.fwOverTransFreq": "Fw Überfrequenz Übergangsfrequenz",
  "50901.ctrl_Safety.FW.fwRecoveryLowerFrequency": "Fw Wiederherstellungsfrequenz Untere Grenze",
  "50901.ctrl_Safety.FW.fwRecoveryStableTime": "Fw Wiederherstellungs-Stabilisierungszeit",
  "50901.ctrl_Safety.FW.fwRecoveryUpperFrequency": "Fw Wiederherstellungsfrequenz Obere Grenze",
  "50901.ctrl_Safety.FW.fwTr": "Fw_Tr Zeit",
  "50901.ctrl_Safety.FW.fwUnderEndFreq": "Fw Unterfrequenz Endfrequenz",
  "50901.ctrl_Safety.FW.fwUnderStartFreq": "Fw Unterfrequenz Startfrequenz",
  "50901.ctrl_Safety.FW.fwUnderStopFreq": "Fw Unterfrequenz Stoppfrequenz",
  "50901.ctrl_Safety.RCD.continueLimitTime": "Rcd Dauerlimit Zeit",
  "50901.ctrl_Safety.RCD.continueLimitValue": "Rcd Dauerlimit Strom",
  "50901.ctrl_Safety.RCD.rcdEnable": "Rcd Aktivieren",
  "50901.ctrl_Safety.RCD.step1LimitTime": "Rcd Stufe 1 Limit Zeit",
  "50901.ctrl_Safety.RCD.step1LimitValue": "Rcd Stufe 1 Limit Strom",
  "50901.ctrl_Safety.RCD.step2LimitTime": "Rcd Stufe 2 Limit Zeit",
  "50901.ctrl_Safety.RCD.step2LimitValue": "Rcd Stufe 2 Limit Strom",
  "50901.ctrl_Safety.RCD.step3LimitTime": "Rcd Stufe 3 Limit Zeit",
  "50901.ctrl_Safety.RCD.step3LimitValue": "Rcd Stufe 3 Limit Strom",
  "50901.ctrl_Safety.RPC.gcfEn": "Gcf Aktivieren",
  "50901.ctrl_Safety.RPC.gcfFuncCode": "Gcf-Funktionscode",
  "50901.ctrl_Safety.RPC.rpcMode": "Rp-Modus",
  "50901.ctrl_Safety.RPC.rpcPf": "Rpc Leistungsfaktor Pf",
  "50901.ctrl_Safety.RPC.rpcReactPowerRatio": "Rpc Blindleistungsverhältnis",
  "50901.ctrl_Safety.RPC.rpcTr": "Rpc_Tr Zeit",
  "50901.ctrl_Safety.RPC.vvFuncCode": "Volt-Var-Funktionscode",
  "50901.ctrl_Safety.RPC.vvLockIn": "Vv Einschaltwert",
  "50901.ctrl_Safety.RPC.vvLockOut": "Vv Ausschaltwert",
  "50901.ctrl_Safety.RPC.vvQ1": "Blindleistungs-Sollwert_Q1",
  "50901.ctrl_Safety.RPC.vvQ2": "Blindleistungs-Sollwert_Q2",
  "50901.ctrl_Safety.RPC.vvQ3": "Blindleistungs-Sollwert_Q3",
  "50901.ctrl_Safety.RPC.vvQ4": "Blindleistungs-Sollwert_Q4",
  "50901.ctrl_Safety.RPC.vvV1": "Spannungs-Sollwert_V1",
  "50901.ctrl_Safety.RPC.vvV2": "Spannungs-Sollwert_V2",
  "50901.ctrl_Safety.RPC.vvV3": "Spannungs-Sollwert_V3",
  "50901.ctrl_Safety.RPC.vvV4": "Spannungs-Sollwert_V4",
  "50901.ctrl_Safety.RPC.vvVref": "Volt-Var Referenzwert (Vref)",
  "50901.ctrl_Safety.RPC.vvVrefTr": "Volt-Var Referenzwert Tr Zeit",
  "50901.ctrl_Safety.RPC.wpfFuncCode": "Wpf-Funktionscode",
  "50901.ctrl_Safety.RPC.wpfLockIn": "Wpf Einschaltwert",
  "50901.ctrl_Safety.RPC.wpfLockOut": "Wpf Ausschaltwert",
  "50901.ctrl_Safety.RPC.wpfMinPFOver": "Wpf Überlast Minimaler Pf",
  "50901.ctrl_Safety.RPC.wpfMinPFUnder": "Wpf Unterlast Minimaler Pf",
  "50901.ctrl_Safety.RPC.wpfPowerEndRatio": "Wpf Leistungsendeverhältnis",
  "50901.ctrl_Safety.RPC.wpfPowerStartRatio": "Wpf Leistungsstartverhältnis",
  "50901.ctrl_Safety.RR.rrFuncCode": "Rr-Funktionscode",
  "50901.ctrl_Safety.RR.rrRurNm": "Rr_Rur_Nm",
  "50901.ctrl_Safety.RR.rrRurSs": "Rr_Rur_Ss",
  "50901.ctrl_Safety.RT.rtFreqRecoveryHighValue": "Rt Frequenzwiederherstellung Oberer Grenzwert",
  "50901.ctrl_Safety.RT.rtFreqRecoveryLowValue": "Rt Frequenzwiederherstellung Unterer Grenzwert",
  "50901.ctrl_Safety.RT.rtFuncCode": "Rt-Funktionscode",
  "50901.ctrl_Safety.RT.rtNMTime": "Rt_Nm Zeit",
  "50901.ctrl_Safety.RT.rtSRTTime": "Rt_Srt Zeit",
  "50901.ctrl_Safety.RT.rtVoltRecoveryHighValue": "Rt Spannungswiederherstellung Oberer Grenzwert",
  "50901.ctrl_Safety.RT.rtVoltRecoveryLowValue": "Rt Spannungswiederherstellung Unterer Grenzwert",
  "50901.ctrl_Safety.VRT.vrt10MinAvgVoltage": "10-Minuten-Durchschnittsspannung",
  "50901.ctrl_Safety.VRT.vrtEn": "Vrt Aktivieren",
  "50901.ctrl_Safety.VRT.vrtFuncCode": "Vrt-Funktionscode",
  "50901.ctrl_Safety.VRT.vrtHighLimit": "Vrt Hochspannungsschwelle",
  "50901.ctrl_Safety.VRT.vrtLowLimit": "Vrt Niederspannungsschwelle",
  "50901.ctrl_Safety.VRT.vrtRecoveryStableTime": "Vrt Wiederherstellungs-Stabilisierungszeit",
  "50901.ctrl_Safety.VRT.vrtTransientOverTime": "Momentane Überspannungsdauer",
  "50901.ctrl_Safety.VRT.vrtTransientOverVoltage": "Momentane Überspannungsschwelle",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1": "Spannungsobergrenze 1",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1Time": "Spannungsobergrenze 1 Dauer",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2": "Spannungsobergrenze 2",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2Time": "Spannungsobergrenze 2 Dauer",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3": "Spannungsobergrenze 3",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3Time": "Spannungsobergrenze 3 Dauer",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1": "Spannungsuntergrenze 1",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1Time": "Spannungsuntergrenze 1 Dauer",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2": "Spannungsuntergrenze 2",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2Time": "Spannungsuntergrenze 2 Dauer",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3": "Spannungsuntergrenze 3",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3Time": "Spannungsuntergrenze 3 Dauer",
  "50901.ctrl_Safety.VW.vwDiffInBatMode": "Vw Batteriemodus Unterschied Aktivieren",
  "50901.ctrl_Safety.VW.vwEnable": "Vw Aktivieren",
  "50901.ctrl_Safety.VW.vwFuncCode": "Vw-Funktionscode",
  "50901.ctrl_Safety.VW.vwOverEndVolt": "Vw Überspannung Endspannung",
  "50901.ctrl_Safety.VW.vwOverKPVolt": "Vw Überspannung Kp-Spannung / Koeffizientenspannung",
  "50901.ctrl_Safety.VW.vwOverStartVolt": "Vw Überspannung Startspannung",
  "50901.ctrl_Safety.VW.vwRecoveryLowerVoltage": "Vw Wiederherstellungsspannung Untere Grenze",
  "50901.ctrl_Safety.VW.vwRecoveryStableTime": "Vw Wiederherstellungs-Stabilisierungszeit",
  "50901.ctrl_Safety.VW.vwRecoveryUpperVoltage": "Vw Wiederherstellungsspannung Obere Grenze",
  "50901.ctrl_Safety.VW.vwTr": "Vw_Tr Zeit",
  "50901.ctrl_Safety.VW.vwUnderEndVolt": "Vw Unterspannung Endspannung",
  "50901.ctrl_Safety.VW.vwUnderKPVolt": "Vw Unterspannung Kp-Spannung / Koeffizientenspannung",
  "50901.ctrl_Safety.VW.vwUnderStartVolt": "Vw Unterspannung Startspannung",
  "50901.ctrl_Safety_GCF.gcfExportSoftLimitRatio": "GCF Export-Weichlimit-Verhältnis",
  "50901.Selfuse": "Eigenverbrauch",
  "50901.TOU": "Zeitvariable Tarife",
  "50901.ctrl_Config.Device.meterConfiguration.desc": "Beschreibung Zählerkonfiguration",
  "50901.ctrl_Config.Grid Profile.country.desc": "Beschreibung Land/Netzanschlussstandard",
  "50901.ctrl_Config.Device.meterConfiguration.0": "Kein Zählertyp",
  "50901.ctrl_Config.Device.meterConfiguration.1": "Netzzähler Konfiguriert",
  "50901.ctrl_Config.Device.meterConfiguration.2": "Pv-Zähler Konfiguriert",
  "50901.ctrl_Config.Device.meterConfiguration.3": "Netz- + Pv-Zähler Konfiguriert",
  "50901.ctrl_WorkMode.Switch.workMode.0": "Eigenverbrauch",
  "50901.ctrl_WorkMode.Switch.workMode.1": "Wirtschaftsmodus / Ökonomischer Modus",
  "50901.ctrl_WorkMode.Switch.workMode.2": "Usv-Modus / Backup-Modus",
  "50901.ctrl_WorkMode.Switch.workMode.3": "Inselmodus",
  "50901.ctrl_WorkMode.Switch.workMode.4": "Zwangslademodus",
  "50901.ctrl_WorkMode.Switch.workMode.5": "Zwangsentladungsmodus",
  "50901.ctrl_WorkMode.Switch.workMode.6": "Spitzenlastkappungsmodus",
  "50901.ctrl_WorkMode.Switch.workMode.7": "TOU-Modus",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.0": "Deaktivieren",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.1": "Aktivieren",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.0": "Deaktivieren",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.1": "Aktivieren",
  "50901.ctrl_Config.Device.meterConfiguration": "Zählerkonfiguration",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable": "Netz Ct Rückwärts Aktivieren",
  "50901.ctrl_ESS_Advanced_Config.System.grid_meter_ratio": "Netz Ct Wandler Übersetzungsverhältnis Einstellung",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable": "Pv Ct Rückwärts Aktivieren",
  "50901.ctrl_ESS_Advanced_Config.System.pv_meter_ratio": "Pv Ct Wandler Übersetzungsverhältnis Einstellung",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartH": "Start Ladung Nutzungszeitraum 1 - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartH": "Start Entladung Nutzungszeitraum 1 - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartH": "Start Ladung Nutzungszeitraum 2 - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartH": "Start Entladung Nutzungszeitraum 2 - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartH": "Start Ladung Nutzungszeitraum 3 - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartH": "Start Entladung Nutzungszeitraum 3 - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartH": "Start Ladung Nutzungszeitraum 4 - Stunde",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartH": "Start Entladung Nutzungszeitraum 4 - Stunde",
  "50901.ctrl_Config.Grid Profile.country.0": "EU EN_EN50549",
  "50901.ctrl_Config.Grid Profile.country.10": "Australien AU AS 4777 AZ",
  "50901.ctrl_Config.Grid Profile.country.11": "Philippinen PH",
  "50901.ctrl_Config.Grid Profile.country.12": "Brasilien BR_Inmetro_220V",
  "50901.ctrl_Config.Grid Profile.country.13": "Pakistan PAK_EN 50549",
  "50901.ctrl_Config.Grid Profile.country.14": "Thailand THA-PEA",
  "50901.ctrl_Config.Grid Profile.country.15": "Italien IT_CEIO-21",
  "50901.ctrl_Config.Grid Profile.country.17": "Kolumbien CNO_1862_240V",
  "50901.ctrl_Config.Grid Profile.country.19": "Großbritannien UK_G98/G99",
  "50901.ctrl_Config.Grid Profile.country.2": "Australien AU_AS4777_A",
  "50901.ctrl_Config.Grid Profile.country.20": "Großbritannien UK_G98NI/G99NI",
  "50901.ctrl_Config.Grid Profile.country.21": "Ecuador EC_IEEE1547",
  "50901.ctrl_Config.Grid Profile.country.22": "Slowenien SI_EN 50549",
  "50901.ctrl_Config.Grid Profile.country.23": "Frankreich FR_VFR 2019",
  "50901.ctrl_Config.Grid Profile.country.24": "Spanien ES_RD1699",
  "50901.ctrl_Config.Grid Profile.country.25": "Spanien ES_RD647",
  "50901.ctrl_Config.Grid Profile.country.26": "Litauen LT_EN50549",
  "50901.ctrl_Config.Grid Profile.country.28": "Thailand THA-EMA",
  "50901.ctrl_Config.Grid Profile.country.3": "Österreich AT_TOR",
  "50901.ctrl_Config.Grid Profile.country.31": "Großbritannien UK_G98",
  "50901.ctrl_Config.Grid Profile.country.32": "Großbritannien UK_G99",
  "50901.ctrl_Config.Grid Profile.country.33": "Großbritannien UK_G98NI",
  "50901.ctrl_Config.Grid Profile.country.34": "Großbritannien UK_G99NI",
  "50901.ctrl_Config.Grid Profile.country.35": "Vietnam VN_CCDE",
  "50901.ctrl_Config.Grid Profile.country.36": "Panama PA_GRID_240V",
  "50901.ctrl_Config.Grid Profile.country.37": "Brasilien BR_Inmetro_220V_US",
  "50901.ctrl_Config.Grid Profile.country.38": "Puerto Rico LUMAPR-2024_208V",
  "50901.ctrl_Config.Grid Profile.country.39": "Puerto Rico LUMAPR-2024_240V",
  "50901.ctrl_Config.Grid Profile.country.4": "Polen PL_EN50549",
  "50901.ctrl_Config.Grid Profile.country.40": "Indien IND_IEC61727",
  "50901.ctrl_Config.Grid Profile.country.41": "Rumänien RO_Ordinul208_2018",
  "50901.ctrl_Config.Grid Profile.country.42": "China CN_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.43": "Irak IRAQ_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.46": "Saudi-Arabien SA_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.47": "Sri Lanka LK_IEC61727",
  "50901.ctrl_Config.Grid Profile.country.48": "Tschechien CZ_PPDS2020",
  "50901.ctrl_Config.Grid Profile.country.49": "Belgien BE_C10_26",
  "50901.ctrl_Config.Grid Profile.country.5": "Estland EE_EVS_EN50549",
  "50901.ctrl_Config.Grid Profile.country.50": "Niederlande NL_NEN_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.51": "Ukraine UA_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.52": "Kanada CA_IEEE1547_240V",
  "50901.ctrl_Config.Grid Profile.country.53": "Kanada CA_IEEE1547_208V",
  "50901.ctrl_Config.Grid Profile.country.54": "Malaysia MY_CODE",
  "50901.ctrl_Config.Grid Profile.country.55": "Indonesien ID_GRID_220V",
  "50901.ctrl_Config.Grid Profile.country.56": "Südafrika ZA_NRS097_2024",
  "50901.ctrl_Config.Grid Profile.country.57": "Schweden SE_SS-EN 50549",
  "50901.ctrl_Config.Grid Profile.country.58": "Griechenland GR_VDE0126",
  "50901.ctrl_Config.Grid Profile.country.59": "Luxemburg LU_EN50549",
  "50901.ctrl_Config.Grid Profile.country.6": "Ungarn HU_EN50549",
  "50901.ctrl_Config.Grid Profile.country.60": "Irland IE_EN50438",
  "50901.ctrl_Config.Grid Profile.country.61": "Sambia ZAM_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.62": "Generator GEN_GRID_50Hz",
  "50901.ctrl_Config.Grid Profile.country.63": "Generator GEN_GRID_60Hz",
  "50901.ctrl_Config.Grid Profile.country.64": "Saudi-Arabien SA_GRID_2025_265V",
  "50901.ctrl_Config.Grid Profile.country.65": "Serbien SRB_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.66": "Schweiz CH_NAEEA_NE7",
  "50901.ctrl_Config.Grid Profile.country.67": "Libanon LB_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.68": "Chile CL_GRID_220V",
  "50901.ctrl_Config.Grid Profile.country.69": "Syrien SYR_GRID_2026",
  "50901.ctrl_Config.Grid Profile.country.7": "Australien AU_AS4777_B",
  "50901.ctrl_Config.Grid Profile.country.8": "Australien AU_AS4777_C",
  "alarm.trigger.condition": "durch das Gerät ausgelöst",
  "alarm.iot": "IoT Alarm",
  "module.alarmInfo": "Alarm Info",
  "edit.failed": "Bearbeitung fehlgeschlagen",
  "50901.real_time.BatteryModel.1": "Haier HV",
  "tag_test_3": "tag_test_3",
  "Transit_Warehouse": "Transitlager",
  "bw_Param_strl_option_GridUseMeter": "Das Stromnetz verwendet Stromzähler",
  "bw_Param_strl_option_GridUseCT": "Das Stromnetz verwendet CT",
  "50901.fault.dSPSAFcomparatorFault": "Komparatorfehler",
  "50901.fault.dSPPWRfanFault": "Lüfterfehler",
  "50901.fault.dSPPWRgridRelayProtection": "Netzrelaischutz ausgelöst",
  "50901.fault.dSPPWRmachineTypeMismatch": "Maschinentyp Nicht Passend",
  "50901.fault.dSPSAFbatteryFault": "Batteriefehler",
  "50901.fault.dSPSAFfanFault": "Lüfterfehler",
  "50901.fault.dSPSAFgridRelayProtection": "Netzrelais-Schutz Ausgelöst",
  "50901.fault.dSPPWRbatteryFault": "Batterieseitenfehler",
  "50901.fault.dSPPWRcomparatorFault": "Komparatorfehler",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality": "Hilfsstromanomalie",
  "50901.fault.dSPSAFmachineTypeMismatch": "Maschinentyp Nicht Passend",
  "50901.fault.dSPSAFsamplingBiasAbnormality": "Abtastungs-Bias-Anomalie",
  "50901.fault.canCommunicationTimeout": "Can-Kommunikations-Timeout",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality": "Hilfsspannungsversorgung abnormal",
  "50901.fault.dSPSAFarmCommunicationFault": "Arm-Kommunikationsfehler",
  "50901.fault.dSPSAFspiCommunicationFault": "Spi-Kommunikationsfehler",
  "50901.fault.dSPSAFversionMismatch": "Versionskonflikt",
  "50901.fault.dSPPWRarmCommunicationFault": "Arm-Kommunikationsfehler",
  "50901.fault.dSPPWRsamplingBiasAbnormality": "Abtastungs-Bias-Anomalie",
  "50901.fault.dSPPWRspiCommunicationFault": "Spi-Kommunikationsfehler",
  "50901.fault.dSPPWRversionMismatch": "Versionskonflikt (Software-/Hardwareversion Nicht Konsistent)",
  "50901.fault.hardwareProtection": "Hardware-Schutz Ausgelöst",
  "50901.fault.lowBatteryEnergy": "Niedriger Batterieenergiestand",
  "50901.fault.dSPPWRgridRelayProtection.0": "Deaktivieren",
  "50901.fault.dSPPWRgridRelayProtection.1": "Aktivieren",
  "50901.fault.dSPPWRmachineTypeMismatch.0": "Deaktivieren",
  "50901.fault.dSPPWRmachineTypeMismatch.1": "Aktivieren",
  "50901.fault.dSPPWRsamplingBiasAbnormality.0": "Deaktivieren",
  "50901.fault.dSPPWRbatteryFault.1": "Aktivieren",
  "50901.fault.dSPPWRcomparatorFault.0": "Deaktivieren",
  "50901.fault.dSPPWRcomparatorFault.1": "Aktivieren",
  "50901.fault.dSPPWRfanFault.0": "Deaktivieren",
  "50901.fault.dSPPWRfanFault.1": "Aktivieren",
  "50901.fault.canCommunicationTimeout.1": "Aktivieren",
  "50901.fault.dSPPWRarmCommunicationFault.0": "Deaktivieren",
  "50901.fault.dSPPWRarmCommunicationFault.1": "Aktivieren",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality.0": "Deaktivieren",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality.1": "Aktivieren",
  "50901.fault.dSPPWRbatteryFault.0": "Deaktivieren",
  "50901.fault.canCommunicationTimeout.0": "Deaktivieren",
  "50901.fault.dSPPWRsamplingBiasAbnormality.1": "Aktivieren",
  "50901.fault.hardwareProtection.1": "Aktivieren",
  "50901.fault.lowBatteryEnergy.0": "Deaktivieren",
  "50901.fault.lowBatteryEnergy.1": "Aktivieren",
  "50901.fault.dSPSAFsamplingBiasAbnormality.1": "Aktivieren",
  "50901.fault.dSPSAFspiCommunicationFault.0": "Deaktivieren",
  "50901.fault.dSPSAFspiCommunicationFault.1": "Aktivieren",
  "50901.fault.dSPSAFversionMismatch.0": "Deaktivieren",
  "50901.fault.dSPSAFversionMismatch.1": "Aktivieren",
  "50901.fault.hardwareProtection.0": "Deaktivieren",
  "50901.fault.dSPSAFarmCommunicationFault.0": "Deaktivieren",
  "50901.fault.dSPSAFgridRelayProtection.1": "Aktivieren",
  "50901.fault.dSPSAFmachineTypeMismatch.0": "Deaktivieren",
  "50901.fault.dSPSAFmachineTypeMismatch.1": "Aktivieren",
  "50901.fault.dSPSAFsamplingBiasAbnormality.0": "Deaktivieren",
  "50901.fault.dSPSAFbatteryFault.0": "Deaktivieren",
  "50901.fault.dSPSAFbatteryFault.1": "Aktivieren",
  "50901.fault.dSPSAFcomparatorFault.0": "Deaktivieren",
  "50901.fault.dSPSAFcomparatorFault.1": "Aktivieren",
  "50901.fault.dSPSAFfanFault.0": "Deaktivieren",
  "50901.fault.dSPSAFfanFault.1": "Aktivieren",
  "50901.fault.dSPPWRversionMismatch.0": "Deaktivieren",
  "50901.fault.dSPPWRversionMismatch.1": "Aktivieren",
  "50901.fault.dSPSAFarmCommunicationFault.1": "Aktivieren",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality.0": "Deaktivieren",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality.1": "Aktivieren",
  "50901.fault.dSPPWRspiCommunicationFault.0": "Deaktivieren",
  "50901.fault.dSPPWRspiCommunicationFault.1": "Aktivieren",
  "50901.fault.dSPSAFgridRelayProtection.0": "Deaktivieren",
  "50901..数据分析_电网功率.tag": "Stromnetzleistung",
  "50901..数据分析_单体SOC.tag": "Einzelzellen-Soc",
  "50901..数据分析_发电机功率.tag": "Generator Leistung",
  "50901..数据分析_混逆光伏功率.tag": "Hybrid-Wechselrichter-Pv-Leistung",
  "50901..数据分析_电池包.tag": "Batteriepaket",
  "50901..数据分析_电网电压.tag": "Netzspannung",
  "50901..数据分析_电网电流.tag": "Stromnetzstrom",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.desc": "Soc-Freigabemodus Für Wärmepumpenbatterien 0: Deaktivieren 1: Aktivieren",
  "50901.ctrl_Dry_Contact.HeatPump.hpCloseSoc.desc": "Lesen, Schreiben, Melden",
  "50901.ctrl_Dry_Contact.HeatPump.hpDelayDetectTimeLmt.desc": "Lesen, Schreiben, Melden",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxFeedbackPower.desc": "Maximale Netzeinspeiseleistung Der Wärmepumpe",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxRunTimeOfOneDay.desc": "Lesen, Schreiben, Melden",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxTimeDetectEnable.desc": "Lesen, Schreiben, Melden",
  "50901.ctrl_Dry_Contact.HeatPump.hpMinRunTimeLmtOfOnce.desc": "Wenn Die Einmalige Betriebszeit Diesen Wert Erreicht, Wird Der Steuermodus Der Wärmepumpe Deaktiviert",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartPower.desc": "Lesen, Schreiben, Melden",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartSoc.desc": "Wenn Der Batterie-Soc Diesen Wert Erreicht, Wird Der Steuermodus Der Wärmepumpe Aktiviert",
  "50901.ctrl_Dry_Contact.HeatPump.hpSupplyPower.desc": "Lesen, Schreiben, Melden",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkTimeParts.desc": "Es Können Bis Zu 4 Betriebszeiträume Eingestellt Werden",
  "50901.Fault": "Fehler",
  "50901.Fault.arcFault.0": "Deaktivieren",
  "50901.Fault.arcFault.1": "Aktivieren",
  "50901.Fault.arcSelfTestFault.0": "Deaktivieren",
  "50901.Fault.arcSelfTestFault.1": "Aktivieren",
  "50901.Fault.batteryCapacityAbnormality.0": "Disable",
  "50901.Fault.batteryCapacityAbnormality.1": "enable",
  "50901.Fault.batteryForceChargeRequest.0": "disable",
  "50901.Fault.batteryForceChargeRequest.1": "enable",
  "50901.Fault.bmsCanCommunicationAbnormality.0": "Deaktivieren",
  "50901.Fault.bmsCanCommunicationAbnormality.1": "Aktivieren",
  "50901.Fault.busbarAbnormality.0": "Deaktivieren",
  "50901.Fault.busbarAbnormality.1": "Aktivieren",
  "50901.Fault.cmpssBiasCalculationError.0": "Deaktivieren",
  "50901.Fault.cmpssBiasCalculationError.1": "Aktivieren",
  "50901.Fault.driveAbnormality.0": "Deaktivieren",
  "50901.Fault.driveAbnormality.1": "Aktivieren",
  "50901.Fault.dspPwrCommunicationAbnormality.0": "disable",
  "50901.Fault.dspPwrCommunicationAbnormality.1": "Aktivieren",
  "50901.Fault.dspSafCommunicationAbnormality.0": "Disable",
  "50901.Fault.dspSafCommunicationAbnormality.1": "enable",
  "50901.Fault.dtsCommunicationAbnormality.0": "Deaktivieren",
  "50901.Fault.dtsCommunicationAbnormality.1": "Aktivieren",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.0": "Disable",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.1": "Enable",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.1": "Enable",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.0": "Disable",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.e2rpomFault.0": "Deaktivieren",
  "50901.Fault.e2rpomFault.1": "Aktivieren",
  "50901.Fault.epsOverload.0": "Deaktivieren",
  "50901.Fault.epsOverload.1": "Aktivieren",
  "50901.Fault.epsRelayProtection.0": "Deaktivieren",
  "50901.Fault.epsRelayProtection.1": "Aktivieren",
  "50901.Fault.epsVoltageAbnormality.0": "Deaktivieren",
  "50901.Fault.epsVoltageAbnormality.1": "Aktivieren",
  "50901.Fault.evCharger1CommunicationAbnormality.0": "Disable",
  "50901.Fault.evCharger1CommunicationAbnormality.1": "enable",
  "50901.Fault.evCharger1Fault.0": "disable",
  "50901.Fault.evCharger1Fault.1": "enable",
  "50901.Fault.evCharger2CommunicationAbnormality.0": "disable",
  "50901.Fault.evCharger2CommunicationAbnormality.1": "Enable",
  "50901.Fault.evCharger2Fault.0": "Disable",
  "50901.Fault.evCharger2Fault.1": "enable",
  "50901.Fault.fanSpeedAbnormality.0": "Deaktivieren",
  "50901.Fault.fanSpeedAbnormality.1": "Enable",
  "50901.Fault.flashCommunicationFault.0": "Deaktivieren",
  "50901.Fault.flashCommunicationFault.1": "Aktivieren",
  "50901.Fault.frequencyVariationRateOutOfRange.0": "Deaktivieren",
  "50901.Fault.frequencyVariationRateOutOfRange.1": "Aktivieren",
  "50901.Fault.genAbnormality.0": "Deaktivieren",
  "50901.Fault.genAbnormality.1": "Aktivieren",
  "50901.Fault.genOverload.0": "Deaktivieren",
  "50901.Fault.genOverload.1": "Aktivieren",
  "50901.fault.genRelayAFault.0": "disable",
  "50901.fault.genRelayAFault.1": "Enable",
  "50901.Fault.gridCurrentDcOffsetOutOfRange.0": "Deaktivieren",
  "50901.Fault.gridCurrentDcOffsetOutOfRange.1": "Aktivieren",
  "50901.Fault.gridMeterCommunicationAbnormality.0": "Disable",
  "50901.Fault.gridMeterCommunicationAbnormality.1": "Aktivieren",
  "50901.Fault.gridMeterTypeError.0": "disable",
  "50901.Fault.gridMeterTypeError.1": "Enable",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange.0": "Deaktivieren",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange.1": "Aktivieren",
  "50901.Fault.gridOverfrequency.0": "Deaktivieren",
  "50901.Fault.gridOverfrequency.1": "Aktivieren",
  "50901.Fault.gridOvervoltage.0": "Deaktivieren",
  "50901.Fault.gridOvervoltage.1": "Aktivieren",
  "50901.fault.gridPortOvercurrent.0": "Deaktivieren",
  "50901.fault.gridPortOvercurrent.1": "enable",
  "50901.Fault.gridPowerOutage.0": "Deaktivieren",
  "50901.Fault.gridPowerOutage.1": "Aktivieren",
  "50901.Fault.gridUnderfrequency.0": "Deaktivieren",
  "50901.Fault.gridUnderfrequency.1": "Aktivieren",
  "50901.Fault.gridUndervoltage.0": "Deaktivieren",
  "50901.Fault.gridUndervoltage.1": "Aktivieren",
  "50901.Fault.gridVoltageAbnormality.0": "Deaktivieren",
  "50901.Fault.gridVoltageAbnormality.1": "Aktivieren",
  "50901.Fault.hmidCommunicationAbnormality.0": "Disable",
  "50901.Fault.hmidCommunicationAbnormality.1": "enable",
  "50901.Fault.hmidMachineFault.0": "disable",
  "50901.Fault.hmidMachineFault.1": "Enable",
  "50901.Fault.insulationFault.0": "Deaktivieren",
  "50901.Fault.insulationFault.1": "Aktivieren",
  "50901.Fault.interruptOverflow.0": "Deaktivieren",
  "50901.Fault.interruptOverflow.1": "Aktivieren",
  "50901.fault.inverterCanCommunicationFailed.0": "Disable",
  "50901.fault.inverterCanCommunicationFailed.1": "enable",
  "50901.Fault.lineToEarthFault.0": "Deaktivieren",
  "50901.Fault.lineToEarthFault.1": "Aktivieren",
  "50901.fault.loadRelayAFault.0": "disable",
  "50901.fault.loadRelayAFault.1": "Aktivieren",
  "50901.fault.loadRelayBFault.0": "Disable",
  "50901.fault.loadRelayBFault.1": "enable",
  "50901.Fault.lowAmbientTemperature.0": "Deaktivieren",
  "50901.Fault.lowAmbientTemperature.1": "Aktivieren",
  "50901.Fault.lowDtuVersion.0": "Disable",
  "50901.Fault.lowDtuVersion.1": "Aktivieren",
  "50901.Fault.masterSlaveCommunicationAbnormality.0": "Disable",
  "50901.Fault.masterSlaveCommunicationAbnormality.1": "enable",
  "50901.Fault.meterWiringAbnormality.0": "Deaktivieren",
  "50901.Fault.meterWiringAbnormality.1": "Aktivieren",
  "50901.Fault.microelectronicFault.0": "Deaktivieren",
  "50901.Fault.microelectronicFault.1": "Aktivieren",
  "50901.Fault.neutralWireNotConnected.0": "Deaktivieren",
  "50901.Fault.neutralWireNotConnected.1": "Aktivieren",
  "50901.Fault.neutralWireToEarthFault.0": "Deaktivieren",
  "50901.Fault.neutralWireToEarthFault.1": "Aktivieren",
  "50901.Fault.overTemperature.0": "Deaktivieren",
  "50901.Fault.overTemperature.1": "Aktivieren",
  "50901.fault.overtemperatureAlarm.0": "disable",
  "50901.fault.overtemperatureAlarm.1": "Enable",
  "50901.Fault.pllLockFailed.0": "Deaktivieren",
  "50901.Fault.pllLockFailed.1": "Aktivieren",
  "50901.Fault.preSynchronizationFailed.0": "Deaktivieren",
  "50901.Fault.preSynchronizationFailed.1": "Aktivieren",
  "50901.Fault.pvFault.0": "Deaktivieren",
  "50901.Fault.pvFault.1": "Aktivieren",
  "50901.Fault.pvMeterCommunicationAbnormality.0": "Deaktivieren",
  "50901.Fault.pvMeterCommunicationAbnormality.1": "enable",
  "50901.Fault.pvMeterTypeError.0": "disable",
  "50901.Fault.pvMeterTypeError.1": "Enable",
  "50901.fault.pvRelayAbFault.0": "Disable",
  "50901.fault.pvRelayAbFault.1": "enable",
  "50901.Fault.pvVoltageExceedingBusVoltage.0": "Deaktivieren",
  "50901.Fault.pvVoltageExceedingBusVoltage.1": "Aktivieren",
  "50901.Fault.rcdFault.0": "Deaktivieren",
  "50901.Fault.rcdFault.1": "Aktivieren",
  "50901.Fault.rcdSelfTestFault.0": "Deaktivieren",
  "50901.Fault.rcdSelfTestFault.1": "Aktivieren",
  "50901.Fault.reconnectionFailed.0": "Deaktivieren",
  "50901.Fault.reconnectionFailed.1": "Aktivieren",
  "50901.Fault.shutDown.0": "Deaktivieren",
  "50901.Fault.shutDown.1": "Aktivieren",
  "50901.Fault.slaveWrongBatteryConnection.0": "Disable",
  "50901.Fault.slaveWrongBatteryConnection.1": "enable",
  "50901.fault.smartloadPortOvercurrent.0": "disable",
  "50901.fault.smartloadPortOvercurrent.1": "Enable",
  "50901.Fault.sustainedNegativeLoad.0": "Deaktivieren",
  "50901.Fault.sustainedNegativeLoad.1": "Aktivieren",
  "50901.Fault.temperatureAbnormality.0": "Deaktivieren",
  "50901.Fault.temperatureAbnormality.1": "Aktivieren",
  "50901.Fault.tenMinuteOvervoltage.0": "Deaktivieren",
  "50901.Fault.tenMinuteOvervoltage.1": "Aktivieren",
  "50901.fault.threePointThreeVoltPowerSupplyFault.0": "disable",
  "50901.fault.threePointThreeVoltPowerSupplyFault.1": "enable",
  "50901.Fault.wiringAbnormality.0": "Deaktivieren",
  "50901.Fault.wiringAbnormality.1": "Aktivieren",
  "50901.HeatPump": "Wärmepumpensteuerung",
  "50901.real_time": "Bedeutung Des Enumerationswerts 0",
  "50901.warning": "Wärmepumpensteuerung",
  "50901.warning.batteryHighVoltageAlarm.0": "Deaktivieren",
  "50901.warning.batteryHighVoltageAlarm.1": "Aktivieren",
  "50901.warning.batteryLowVoltageAlarm.0": "disable",
  "50901.warning.batteryLowVoltageAlarm.1": "Enable",
  "50901.warning.batteryPackChargeHighVoltageAlarm.0": "disable",
  "50901.warning.batteryPackChargeHighVoltageAlarm.1": "enable",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.0": "Deaktivieren",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.1": "enable",
  "50901.warning.chargeHighTemperatureAlarm.0": "disable",
  "50901.warning.chargeHighTemperatureAlarm.1": "Enable",
  "50901.warning.chargeLowTemperatureAlarm.0": "disable",
  "50901.warning.chargeLowTemperatureAlarm.1": "Enable",
  "50901.warning.dischargeHighTemperatureAlarm.0": "Deaktivieren",
  "50901.warning.dischargeHighTemperatureAlarm.1": "Enable",
  "50901.warning.dischargeLowTemperatureAlarm.0": "disable",
  "50901.warning.dischargeLowTemperatureAlarm.1": "enable",
  "50901.warning.inputOvervoltageAlarm.0": "disable",
  "50901.warning.inputOvervoltageAlarm.1": "Enable",
  "50901..cfgMultPcsBmsFlag.0": "Nein",
  "50901..cfgMultPcsBmsFlag.1": "Ja",
  "50901..hpTime2WeekRange1.0": "Deaktivieren",
  "50901..hpTime2WeekRange1.1": "enable",
  "50901..hpTime2WeekRange2.0": "disable",
  "50901..hpTime2WeekRange2.1": "Enable",
  "50901..hpTime2WeekRange3.0": "disable",
  "50901..hpTime2WeekRange3.1": "Aktivieren",
  "50901..hpTime2WeekRange4.0": "Deaktivieren",
  "50901..hpTime2WeekRange4.1": "Enable",
  "50901..hpTime2WeekRange5.0": "disable",
  "50901..hpTime2WeekRange5.1": "enable",
  "50901..hpTime2WeekRange6.0": "Disable",
  "50901..hpTime2WeekRange6.1": "Aktivieren",
  "50901..hpTime2WeekRange7.0": "Deaktivieren",
  "50901..hpTime2WeekRange7.1": "Enable",
  "50901..hpTime3WeekRange1.0": "disable",
  "50901..hpTime3WeekRange1.1": "enable",
  "50901..hpTime3WeekRange2.0": "Disable",
  "50901..hpTime3WeekRange2.1": "Aktivieren",
  "50901..hpTime3WeekRange3.0": "Deaktivieren",
  "50901..hpTime3WeekRange3.1": "Enable",
  "50901..hpTime3WeekRange4.0": "disable",
  "50901..hpTime3WeekRange4.1": "enable",
  "50901..hpTime3WeekRange5.0": "Disable",
  "50901..hpTime3WeekRange5.1": "Aktivieren",
  "50901..hpTime3WeekRange6.0": "Deaktivieren",
  "50901..hpTime3WeekRange6.1": "Enable",
  "50901..hpTime3WeekRange7.0": "disable",
  "50901..hpTime3WeekRange7.1": "Enable",
  "50901..hpTime4WeekRange1.0": "disable",
  "50901..hpTime4WeekRange1.1": "Aktivieren",
  "50901..hpTime4WeekRange2.0": "Deaktivieren",
  "50901..hpTime4WeekRange2.1": "Enable",
  "50901..hpTime4WeekRange3.0": "disable",
  "50901..hpTime4WeekRange3.1": "enable",
  "50901..hpTime4WeekRange4.0": "Disable",
  "50901..hpTime4WeekRange4.1": "Aktivieren",
  "50901..hpTime4WeekRange5.0": "Deaktivieren",
  "50901..hpTime4WeekRange5.1": "enable",
  "50901..hpTime4WeekRange6.0": "Disable",
  "50901..hpTime4WeekRange6.1": "enable",
  "50901..hpTime4WeekRange7.0": "Disable",
  "50901..hpTime4WeekRange7.1": "Aktivieren",
  "50901..materType.0": "Kein Netzseitiger Zähler",
  "50901..materType.1": "Thai Einzelfase",
  "50901..materType.2": "Chint Einphasig",
  "50901..materType.3": "Phase der Spaltung",
  "50901..materType.5": "Messmodul",
  "50901..materType.6": "Ankori Einzelstraße",
  "50901..materType.7": "Ankori Doppelweg",
  "50901..section1WeekRange1.0": "Montag",
  "50901..section1WeekRange1.1": "Dienstag",
  "50901..section1WeekRange1.2": "Mittwoch",
  "50901..section1WeekRange1.3": "Donnerstag",
  "50901..section1WeekRange1.4": "Freitag",
  "50901..section1WeekRange1.5": "Samstag",
  "50901..section1WeekRange1.6": "Sonntag",
  "50901..section1WeekRange2.0": "Bedeutung Des Enumerationswerts 0",
  "50901..section1WeekRange2.1": "Bedeutung Des Enumerationswerts 1",
  "50901..section2WeekRange1.0": "Bedeutung Des Enumerationswerts 0",
  "50901..section2WeekRange1.1": "Bedeutung Des Enumerationswerts 2",
  "50901..section3WeekRange1.0": "Bedeutung Des Enumerationswerts 0",
  "50901..section3WeekRange1.1": "Bedeutung Des Enumerationswerts 2",
  "50901..section4WeekRange1.0": "Bedeutung Des Enumerationswerts 0",
  "50901..section4WeekRange1.1": "Bedeutung des Wertes 2",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.0": "Nein",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.1": "Ja",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.0": "Nicht möglich",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.1": "ermöglichen",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.0": "Nicht möglich",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.1": "ermöglichen",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.0": "Nicht möglich",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.1": "ermöglichen",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.0": "Nicht möglich",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.1": "ermöglichen",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.0": "Nicht möglich",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.1": "ermöglichen",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.0": "Nein",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.1": "Ja",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.6": "Wärmepumpe Steuerung",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.0": "Nicht möglich",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section1WeekRange11.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section1WeekRange11.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section1WeekRange12.0": "Deaktivieren",
  "50901.ctrl_WorkMode.economic.section1WeekRange12.1": "Aktivieren",
  "50901.ctrl_WorkMode.economic.section1WeekRange13.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section1WeekRange13.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section1WeekRange14.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section1WeekRange14.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section1WeekRange15.0": "Deaktivieren",
  "50901.ctrl_WorkMode.economic.section1WeekRange15.1": "Aktivieren",
  "50901.ctrl_WorkMode.economic.section1WeekRange16.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section1WeekRange16.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section1WeekRange17.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section1WeekRange17.1": "Aktivieren",
  "50901.ctrl_WorkMode.economic.section1WeekRange21.0": "Deaktivieren",
  "50901.ctrl_WorkMode.economic.section1WeekRange21.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section1WeekRange22.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section1WeekRange22.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section1WeekRange23.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section1WeekRange23.1": "Aktivieren",
  "50901.ctrl_WorkMode.economic.section1WeekRange24.0": "Deaktivieren",
  "50901.ctrl_WorkMode.economic.section1WeekRange24.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section1WeekRange25.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section1WeekRange25.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section1WeekRange26.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section1WeekRange26.1": "Aktivieren",
  "50901.ctrl_WorkMode.economic.section1WeekRange27.0": "Deaktivieren",
  "50901.ctrl_WorkMode.economic.section1WeekRange27.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section2WeekRange11.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section2WeekRange11.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section2WeekRange12.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section2WeekRange12.1": "Aktivieren",
  "50901.ctrl_WorkMode.economic.section2WeekRange13.0": "Deaktivieren",
  "50901.ctrl_WorkMode.economic.section2WeekRange13.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section2WeekRange14.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section2WeekRange14.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section2WeekRange15.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section2WeekRange15.1": "Aktivieren",
  "50901.ctrl_WorkMode.economic.section2WeekRange16.0": "Deaktivieren",
  "50901.ctrl_WorkMode.economic.section2WeekRange16.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section2WeekRange17.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section2WeekRange17.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section2WeekRange21.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section2WeekRange21.1": "Aktivieren",
  "50901.ctrl_WorkMode.economic.section2WeekRange22.0": "Deaktivieren",
  "50901.ctrl_WorkMode.economic.section2WeekRange22.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section2WeekRange23.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section2WeekRange23.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section2WeekRange24.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section2WeekRange24.1": "Aktivieren",
  "50901.ctrl_WorkMode.economic.section2WeekRange25.0": "Deaktivieren",
  "50901.ctrl_WorkMode.economic.section2WeekRange25.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section2WeekRange26.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section2WeekRange26.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section2WeekRange27.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section2WeekRange27.1": "Aktivieren",
  "50901.ctrl_WorkMode.economic.section3WeekRange11.0": "Deaktivieren",
  "50901.ctrl_WorkMode.economic.section3WeekRange11.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section3WeekRange12.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section3WeekRange12.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section3WeekRange13.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section3WeekRange13.1": "Aktivieren",
  "50901.ctrl_WorkMode.economic.section3WeekRange14.0": "Deaktivieren",
  "50901.ctrl_WorkMode.economic.section3WeekRange14.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section3WeekRange15.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section3WeekRange15.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section3WeekRange16.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section3WeekRange16.1": "Aktivieren",
  "50901.ctrl_WorkMode.economic.section3WeekRange17.0": "Deaktivieren",
  "50901.ctrl_WorkMode.economic.section3WeekRange17.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.0": "Bedeutung des Wertes 0",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.1": "Bedeutung Des Enumerationswerts 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange11.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section4WeekRange11.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section4WeekRange12.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section4WeekRange12.1": "Aktivieren",
  "50901.ctrl_WorkMode.economic.section4WeekRange13.0": "Deaktivieren",
  "50901.ctrl_WorkMode.economic.section4WeekRange13.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section4WeekRange14.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section4WeekRange14.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section4WeekRange15.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section4WeekRange15.1": "Aktivieren",
  "50901.ctrl_WorkMode.economic.section4WeekRange16.0": "Deaktivieren",
  "50901.ctrl_WorkMode.economic.section4WeekRange16.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section4WeekRange17.0": "Nicht möglich",
  "50901.ctrl_WorkMode.economic.section4WeekRange17.1": "ermöglichen",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.0": "Bedeutung des Wertes 0",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.1": "Bedeutung Des Enumerationswerts 1",
  "50901.fault.emergencyStopSwitchStatus.0": "Disable",
  "50901.fault.emergencyStopSwitchStatus.1": "Aktivieren",
  "50901.fault.fiveVoltPowerSupplyFault.0": "Deaktivieren",
  "50901.fault.fiveVoltPowerSupplyFault.1": "enable",
  "50901.fault.genPortOvercurrent.0": "disable",
  "50901.fault.genPortOvercurrent.1": "Enable",
  "50901.fault.genRelayBFault.0": "disable",
  "50901.fault.genRelayBFault.1": "Aktivieren",
  "50901.fault.gridMeter.0": "Deaktivieren",
  "50901.fault.gridMeter.1": "enable",
  "50901.fault.inverterCommunicationFailed.0": "disable",
  "50901.fault.inverterCommunicationFailed.1": "Enable",
  "50901.fault.kmRelayFault.0": "disable",
  "50901.fault.kmRelayFault.1": "Aktivieren",
  "50901.fault.pvPortOvercurrent.0": "Deaktivieren",
  "50901.fault.pvPortOvercurrent.1": "enable",
  "50901.fault.twelveVoltPowerSupplyFault.0": "Disable",
  "50901.fault.twelveVoltPowerSupplyFault.1": "enable",
  "50901.real_time.batteryConnectionStatus.0": "Nein",
  "50901.real_time.batteryConnectionStatus.1": "Ja",
  "50901.real_time.batteryType_04.0": "Keine Batterie",
  "50901.real_time.batteryType_04.1": "Lithiumbatterie",
  "50901.real_time.batteryType_04.2": "Blei-Säure-Batterie",
  "50901.real_time.packNum.0": "0",
  "50901.real_time.packNum.1": "1",
  "50901.real_time.packNum.1023": "10",
  "50901.real_time.packNum.127": "7",
  "50901.real_time.packNum.15": "4",
  "50901.real_time.packNum.16383": "14",
  "50901.real_time.packNum.2047": "11",
  "50901.real_time.packNum.255": "8",
  "50901.real_time.packNum.3": "2",
  "50901.real_time.packNum.31": "5",
  "50901.real_time.packNum.32767": "15",
  "50901.real_time.packNum.4095": "12",
  "50901.real_time.packNum.511": "9",
  "50901.real_time.packNum.63": "6",
  "50901.real_time.packNum.65535": "16",
  "50901.real_time.packNum.7": "3",
  "50901.real_time.packNum.8191": "13",
  "50901..parallelNetworking.0": "Ungültig",
  "50901..parallelNetworking.1": "Vernetzung Im Gange",
  "50901..parallelNetworking.2": "Netzwerk Auflösen",
  "50901..phaseOrderInverseDisable.0": "disable",
  "50901..phaseOrderInverseDisable.1": "enable",
  "50901..relayU16NlineRlyTestDis.0": "Deaktivieren",
  "50901..relayU16NlineRlyTestDis.1": "enable",
  "50901.ctrl_Config.ClockSetting.clockSet": "Uhreinstellung",
  "50901.ctrl_Config.Device.arcfaultClear.0": "Nein",
  "50901.ctrl_Config.Device.arcfaultClear.1": "Ja",
  "50901.ctrl_Config.Device.clearfault.0": "Nein",
  "50901.ctrl_Config.Device.clearfault.1": "Ja",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeCharge": "Trockenknotengenerator Laden",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeWait1": "Trockenknotengeneratoren standby1",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeWait2": "Trockenkontakt-Generator Bereitschaft 2",
  "50901.ctrl_Dry_Contact.Generator.dryContactPracticeTime": "Startzeit des Generatorübungsmodus",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump1": "Wärmepumpezeit1",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump2": "Wärmepumpen Zeitraum 2",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump3": "Wärmepumpezeit3",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump4": "Wärmepumpezeit4",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact1Timer1": "Trockenkontakt-Timer 1 Zeitraum 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact1Timer2": "Trockenknoten Timing 1 Stunde 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact2Timer1": "Trockenknoten Timing 2 Stunden1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact2Timer2": "Trockenkontakt-Timer 2 Zeitraum 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContactTimer1": "Trockenknotenzeit 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContactTimer2": "Trockenknotenzeit 2",
  "50901.ctrl_Safety.RPC.rpcMode.0": "Deaktivieren",
  "50901.ctrl_Safety.RPC.rpcMode.1": "Fixed Power Factor, PF Mode",
  "50901.ctrl_Safety.RPC.rpcMode.2": "Fixed Reactive Power, Q Mode",
  "50901.ctrl_Safety.RPC.rpcMode.3": "Pf(P)-Kennlinie, Pf(P)-Modus",
  "50901.ctrl_Safety.RPC.rpcMode.4": "W",
  "50901.ctrl_Safety.RPC.rpcMode.5": "PQ",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Down1": "Modus-Knoten Zeitraum 1 Tal 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Down2": "Modus Knoten Zeit 1 Tief 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Peak1": "Modus Knoten Zeit 1 Spitze 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Peak2": "Modus-Knoten Zeitraum 1 Spitze 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Down1": "Modus Knoten Zeit 2 Tief 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Down2": "Modus Knoten Zeit 2 Tief 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Peak1": "Modus-Knoten Zeitraum 2 Spitze 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Peak2": "Modus Knoten Zeit 2 Spitze 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Down1": "Modus-Knoten Zeitraum 3 Tal 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Down2": "Modus Knoten Zeit 3 Tief 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Peak1": "Modus Knoten Zeit 3 Spitzen1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Peak2": "Modus-Knoten Zeitraum 3 Spitze 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Down1": "Modus Knoten Zeit 4 Tiefe 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Down2": "Modus-Knoten Zeitraum 4 Tal 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Peak1": "Modus Knoten Zeit 4 Spitzen1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Peak2": "Modus Knoten Zeit 4 Spitze 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer1": "Modus-Knoten Zeitraum 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer2": "Modus Knotenzeit2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer3": "Modus-Knoten Zeitraum 3",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer4": "Modus-Knotenzeit4",
  "50901.ctrl_WorkMode.TOU.dryContactTOU1Chag": "Zeitaufteilungsknoten1 Laden",
  "50901.ctrl_WorkMode.TOU.dryContactTOU1Out": "Zeitnutzungsknoten Zeitraum 1 Entladen",
  "50901.ctrl_WorkMode.TOU.dryContactTOU2Chag": "Zeitaufteilungsknoten Zeitabschnitt 2 Laden",
  "50901.ctrl_WorkMode.TOU.dryContactTOU2Out": "Zeitaufteilungsknoten Zeitabschnitt 2 Entladung",
  "50901.ctrl_WorkMode.TOU.dryContactTOU3Chag": "Zeitnutzungsknoten Zeitraum 3 Laden",
  "50901.ctrl_WorkMode.TOU.dryContactTOU3Out": "Zeitaufteilungsknoten Zeitabschnitt 3 Entladung",
  "50901.ctrl_WorkMode.TOU.dryContactTOU4Chag": "Zeitaufteilungsknoten Zeitabschnitt 4 Laden",
  "50901.ctrl_WorkMode.TOU.dryContactTOU4Out": "Zeitnutzungsknoten Zeitraum 4 Entladen",
  "50901.ctrl_WorkMode.TOU.dryContactTOU5Chag": "Zeitaufteilungsknoten Zeitspanne 5 Laden",
  "50901.ctrl_WorkMode.TOU.dryContactTOU5Out": "Zeitnutzungsknoten Zeitraum 5 Entladen",
  "50901.ctrl_WorkMode.TOU.dryContactTOU6Chag": "Zeitteilung Node Zeitspanne 6 Laden",
  "50901.ctrl_WorkMode.TOU.dryContactTOU6Out": "Zeitaufteilungsknoten Zeitabschnitt 6 Entladung",
  "50901.ctrl_WorkMode.TOU.dryContactTOU7Chag": "Zeitnutzungsknoten Zeitraum 7 Laden",
  "50901.ctrl_WorkMode.TOU.dryContactTOU7Out": "Zeitaufteilungsknoten Zeitabschnitt 7 Entladung",
  "50901.ctrl_WorkMode.TOU.dryContactTOU8Chag": "Zeitaufteilungsknoten Zeitabschnitt 8 Laden",
  "50901.ctrl_WorkMode.TOU.dryContactTOU8Out": "Zeitnutzungsknoten Zeitraum 8 Entladen",
  "50901.Fault.arcFault": "Lichtbogenfehler",
  "50901.Fault.arcSelfTestFault": "Lichtbogen-Selbsttestfehler",
  "50901.Fault.busbarAbnormality": "Dc-Zwischenkreis Anomal",
  "50901.Fault.cmpssBiasCalculationError": "Cmpss-Offset-Berechnungsfehler",
  "50901.Fault.driveAbnormality": "Ansteuerung Anomal",
  "50901.Fault.e2rpomFault": "Eeprom-Fehler",
  "50901.Fault.epsOverload": "Eps-Überlast",
  "50901.Fault.epsRelayProtection": "Eps-Relais-Schutz",
  "50901.Fault.epsVoltageAbnormality": "Eps-Spannung Anomal",
  "50901.Fault.flashCommunicationFault": "Flash-Speicher Kommunikationsfehler",
  "50901.Fault.frequencyVariationRateOutOfRange": "Frequenzänderungsrate Überschritten",
  "50901.Fault.genAbnormality": "Generator Anomal",
  "50901.Fault.genOverload": "Generatorüberlast",
  "50901.Fault.gridCurrentDcOffsetOutOfRange": "Netzstrom Dc-Offset Überschritten",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange": "Inselspannung Dc-Offset Überschritten",
  "50901.Fault.gridOverfrequency": "Netzfrequenz Zu Hoch / Überfrequenz",
  "50901.Fault.gridOvervoltage": "Netzspannung Zu Hoch / Überspannung",
  "50901.Fault.gridPowerOutage": "Netzausfall",
  "50901.Fault.gridUnderfrequency": "Netzfrequenz Zu Niedrig / Unterfrequenz",
  "50901.Fault.gridUndervoltage": "Netzspannung Zu Niedrig / Unterspannung",
  "50901.Fault.gridVoltageAbnormality": "Netzspannung Anomal",
  "50901.Fault.insulationFault": "Isolationsfehler",
  "50901.Fault.interruptOverflow": "Interrupt-Überlauf",
  "50901.Fault.lineToEarthFault": "Erdschluss (Phase-Erde)",
  "50901.Fault.lowAmbientTemperature": "Umgebungstemperatur Zu Niedrig",
  "50901.Fault.meterWiringAbnormality": "Zählerverdrahtung Anomal",
  "50901.Fault.microelectronicFault": "Mikroelektronikfehler",
  "50901.Fault.neutralWireNotConnected": "Neutralleiter Nicht Angeschlossen",
  "50901.Fault.neutralWireToEarthFault": "Neutralleiter-Erde-Fehler",
  "50901.Fault.overTemperature": "Übertemperatur",
  "50901.Fault.pllLockFailed": "Pll-Synchronisationsfehler",
  "50901.Fault.preSynchronizationFailed": "Fehler Bei Vor-Synchronisation",
  "50901.Fault.pvFault": "Pv-Fehler",
  "50901.Fault.pvVoltageExceedingBusVoltage": "Pv-Spannung Überschreitet Zwischenkreisspannung",
  "50901.Fault.rcdFault": "Rcd-Fehler (Fehlerstromschutzschalter)",
  "50901.Fault.rcdSelfTestFault": "Rcd-Selbsttestfehler",
  "50901.Fault.reconnectionFailed": "Wiederverbindungsfehler",
  "50901.Fault.shutDown": "Systemabschaltung",
  "50901.Fault.temperatureAbnormality": "Temperatur Anomal",
  "50901.Fault.tenMinuteOvervoltage": "10-Minuten-Überspannung",
  "50901.Fault.wiringAbnormality": "Verdrahtung Anomal",
  "50901.real_time.copy_communicationStickSoftwareVersion": "Kommunikationsstick-Software-Version",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode": "Wärmepumpe BattSoc Erkennungsmodus",
  "50901.ctrl_Dry_Contact.HeatPump.hpCloseSoc": "Wärmepumpe geschlossen Soc",
  "50901.ctrl_Dry_Contact.HeatPump.hpDelayDetectTimeLmt": "Wärmepumpen Verzögerungserkennungszeitlimit",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxFeedbackPower": "Maximale Rückkopplungsleistung der Wärmepumpe",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxRunTimeOfOneDay": "Maximale Betriebszeit der Wärmepumpe pro Tag",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxTimeDetectEnable": "Aktivierung Der Maximalzeit-Erkennung Der Wärmepumpe",
  "50901.ctrl_Dry_Contact.HeatPump.hpMinRunTimeLmtOfOnce": "Minimale Betriebszeit der Wärmepumpe",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartPower": "Wärmepumpen Startleistung",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartSoc": "Wärmepumpe starten Soc",
  "50901.ctrl_Dry_Contact.HeatPump.hpSupplyPower": "Wärmepumpe Stromversorgung",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndDay": "Wärmepumpen Zeit 1 Ende - Tag",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndMonth": "Wärmepumpe Zeit 1 Ende -",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartDay": "Wärmepumpen Zeit 1 Start - Tag",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartMonth": "Wärmepumpezeit 1 Start-Monat",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1": "Wärmepumpezeit 1 Woche1",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2": "Wärmepumpen Zeit 1 Woche 2",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3": "Wärmepumpezeit 1 Woche3",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4": "Wärmepumpezeit 1 Woche4",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5": "Wärmepumpen Zeit 1 Woche 5",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6": "Wärmepumpe 1 Woche 6",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7": "Wärmepumpezeit 1 Woche7",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode": "Betriebsmodus der Wärmepumpe",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkTimeParts": "Wärmepumpen Betriebszeit",
  "50901.ctrl_WorkMode.economic.section4WeekRange11": "Zeitraum 4 1. Gruppe Montag",
  "50901.ctrl_WorkMode.economic.section4WeekRange12": "Zeitraum 4 1. Gruppe Dienstag",
  "50901.ctrl_WorkMode.economic.section4WeekRange13": "Zeitraum 4 Gruppe 1 Mittwoch",
  "50901.ctrl_WorkMode.economic.section4WeekRange14": "Stufe 4 Gruppe 1 Donnerstag",
  "50901.ctrl_WorkMode.economic.section4WeekRange15": "Zeit 4 Gruppe 1 Freitag",
  "50901.ctrl_WorkMode.economic.section4WeekRange16": "Zeitraum 4 Gruppe 1 Samstag",
  "50901.ctrl_WorkMode.economic.section4WeekRange17": "Zeitraum 4 1. Gruppe Samstag",
  "50901.real_time.copy_bmsSoftwareVersion": "BMS-Version - Software",
  "50901.real_time.copy_controllerarmFirmwareVersion": "Wechselrichter Arm-Version",
  "50901.real_time.previous_gridPower": "Netzseitige Leistung",
  "50901.ctrl_Config.Device.arcfaultClear": "Lichtbogenfehlerbehebung",
  "50901.ctrl_Config.Device.clearfault": "Fehler Löschen",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27": "Sonntag",
  "50901.ctrl_Safety.RPC.gcfExportHardLimitRatio": "Harte Exportbegrenzungsverhältnis Gcf",
  "50901.ctrl_Safety.RPC.gcfExportSoftLimitRatio": "Weiche Exportbegrenzungsverhältnis Gcf",
  "50901.ctrl_WorkMode.economic.section1WeekRange11": "Zeitraum 1 Gruppe 1 Montag",
  "50901.ctrl_WorkMode.economic.section1WeekRange12": "Zeitraum 1 Gruppe 1 Dienstag",
  "50901.ctrl_WorkMode.economic.section1WeekRange13": "Zeitraum 1 Gruppe 1 Mittwoch",
  "50901.ctrl_WorkMode.economic.section1WeekRange14": "Zeitraum 1 Gruppe 1 Donnerstag",
  "50901.ctrl_WorkMode.economic.section1WeekRange15": "Zeitraum 1 Gruppe 1 Freitag",
  "50901.ctrl_WorkMode.economic.section1WeekRange16": "Zeitraum 1 Gruppe 1 Samstag",
  "50901.ctrl_WorkMode.economic.section1WeekRange17": "Zeitraum 1 Gruppe 1 Sonntag",
  "50901.ctrl_WorkMode.economic.section1WeekRange21": "Zeitraum 1 Gruppe 2 Montag",
  "50901.ctrl_WorkMode.economic.section1WeekRange22": "Zeitraum 1 Gruppe 2 Dienstag",
  "50901.ctrl_WorkMode.economic.section1WeekRange23": "Zeitraum 1 Gruppe 2 Mittwoch",
  "50901.ctrl_WorkMode.economic.section1WeekRange24": "Zeitraum 1 Gruppe 2 Donnerstag",
  "50901.ctrl_WorkMode.economic.section1WeekRange25": "Zeitraum 1 Gruppe 2 Freitag",
  "50901.ctrl_WorkMode.economic.section1WeekRange26": "Zeitraum 1 Gruppe 2 Samstag",
  "50901.ctrl_WorkMode.economic.section1WeekRange27": "Zeitraum 1 Gruppe 2 Sonntag",
  "50901.ctrl_WorkMode.economic.section2WeekRange11": "Zeitraum 2 Gruppe 1 Montag",
  "50901.ctrl_WorkMode.economic.section2WeekRange12": "Zeitraum 2 Gruppe 1 Dienstag",
  "50901.ctrl_WorkMode.economic.section2WeekRange13": "Zeitraum 2 Gruppe 1 Mittwoch",
  "50901.ctrl_WorkMode.economic.section2WeekRange14": "Zeitraum 2 Gruppe 1 Donnerstag",
  "50901.ctrl_WorkMode.economic.section2WeekRange15": "Zeitraum 2 Gruppe 1 Freitag",
  "50901.ctrl_WorkMode.economic.section2WeekRange16": "Zeitraum 2 Gruppe 1 Samstag",
  "50901.ctrl_WorkMode.economic.section2WeekRange17": "Zeitraum 2 Gruppe 1 Sonntag",
  "50901.ctrl_WorkMode.economic.section2WeekRange21": "Zeitraum 2 Gruppe 2 Montag",
  "50901.ctrl_WorkMode.economic.section2WeekRange22": "Zeitraum 2 Gruppe 2 Dienstag",
  "50901.ctrl_WorkMode.economic.section2WeekRange23": "Zeitraum 2 Gruppe 2 Mittwoch",
  "50901.ctrl_WorkMode.economic.section2WeekRange24": "Zeitraum 2 Gruppe 2 Donnerstag",
  "50901.ctrl_WorkMode.economic.section2WeekRange25": "Zeitraum 2 Gruppe 2 Freitag",
  "50901.ctrl_WorkMode.economic.section2WeekRange26": "Zeitraum 2 Gruppe 2 Samstag",
  "50901.ctrl_WorkMode.economic.section2WeekRange27": "Zeitraum 2 Gruppe 2 Sonntag",
  "50901.ctrl_WorkMode.economic.section3WeekRange11": "Zeitraum 3 Gruppe 1 Montag",
  "50901.ctrl_WorkMode.economic.section3WeekRange12": "Zeitraum 3 Gruppe 1 Dienstag",
  "50901.ctrl_WorkMode.economic.section3WeekRange13": "Zeitraum 3 Gruppe 1 Mittwoch",
  "50901.ctrl_WorkMode.economic.section3WeekRange14": "Zeitraum 3 Gruppe 1 Donnerstag",
  "50901.ctrl_WorkMode.economic.section3WeekRange15": "Zeitraum 3 Gruppe 1 Freitag",
  "50901.ctrl_WorkMode.economic.section3WeekRange16": "Zeitraum 3 Gruppe 1 Samstag",
  "50901.ctrl_WorkMode.economic.section3WeekRange17": "Zeitraum 3 Gruppe 1 Sonntag",
  "50901.real_time.batteryCapacity": "Installierte Batteriekapazität",
  "50901.real_time.batteryWorkingStatus.1": "Bereitschaft",
  "org.aiMessage.charge.fail": "",
  "org.aiMessage.charge.success": "",
  "org.aiMessage.discharge.fail": "",
  "org.aiMessage.discharge.success": "",
  "ai.message.charge.title.success": "Ladebefehl erfolgreich ausgeführt",
  "ai.message.charge.title.fail": "Ladebefehl fehlgeschlagen",
  "ai.message.charge.content.success": "Ladebefehl erfolgreich ausgeführt. KI-Strategie läuft normal.",
  "ai.message.charge.content.fail": "Ladebefehl fehlgeschlagen (3 autom. Versuche). KI wird es in späteren Zeiträumen erneut versuchen. Manuelle Steuerung nach Deaktivierung des KI-Modus möglich.",
  "ai.message.discharge.title.success": "Entladebefehl erfolgreich ausgeführt",
  "ai.message.discharge.title.fail": "Entladebefehl fehlgeschlagen",
  "ai.message.discharge.content.success": "Entladebefehl erfolgreich ausgeführt. KI-Strategie läuft normal.",
  "ai.message.discharge.content.fail": "Entladebefehl fehlgeschlagen (3 autom. Versuche). KI wird es in späteren Zeiträumen erneut versuchen. Manuelle Steuerung nach Deaktivierung des KI-Modus möglich.",
  "50901.fault.evCharger1CommunicationAbnormality": "Ev-Ladestation 1 Kommunikation Anomal",
  "50901.fault.bmsCanCommunicationAbnormality": "Bms-Can-Kommunikation Anomal",
  "50901.fault.dtu3Rs485CommunicationAbnormality": "Dtu3 Rs485-Kommunikation Anomal",
  "50901.fault.gridMeterTypeError": "Netz-Zähler Typfehler",
  "50901.fault.lowDtuVersion": "Dtu-Version Zu Niedrig",
  "50901.fault.gridMeterCommunicationAbnormality": "Netz-Zähler Kommunikation Anomal",
  "50901.fault.pvMeterTypeError": "Pv-Zähler Typfehler",
  "50901.fault.dspPwrCommunicationAbnormality": "Dsp-Stromversorgungskommunikation Anomal",
  "50901.fault.evCharger2CommunicationAbnormality": "Ev-Ladestation 2 Kommunikation Anomal",
  "50901.fault.dtu5Rs485CommunicationAbnormality": "Dtu5 Rs485-Kommunikation Anomal",
  "50901.fault.dtsCommunicationAbnormality": "Dts-Kommunikation Anomal",
  "50901.fault.dtu4Rs485CommunicationAbnormality": "Dtu4 Rs485-Kommunikation Anomal",
  "50901.fault.dtu1Rs485CommunicationAbnormality": "Dtu1 Rs485-Kommunikation Anomal",
  "50901.fault.pvMeterCommunicationAbnormality": "Pv-Zähler Kommunikation Anomal",
  "50901.fault.slaveWrongBatteryConnection": "Slave-Batterie Anschlussfehler",
  "50901.fault.dtu2Rs485CommunicationAbnormality": "Dtu2 Rs485-Kommunikation Anomal",
  "50901.fault.dspSafCommunicationAbnormality": "Dsp-Sicherheitskommunikation Anomal",
  "50901.fault.sustainedNegativeLoad": "Anhaltende Negative Last",
  "50901.fault.hmidMachineFault": "Hmi-Gerätefehler",
  "50901.fault.evCharger1Fault": "Fehler Ladestation 1",
  "50901.fault.evCharger2Fault": "Fehler Ladestation 2",
  "50901.fault.fanSpeedAbnormality": "Lüfterdrehzahl Anomal",
  "50901.fault.masterSlaveCommunicationAbnormality": "Master-Slave-Kommunikation Anomal",
  "50901.fault.batteryCapacityAbnormality": "Batteriekapazität Anomal",
  "50901.fault.batteryForceChargeRequest": "Batterie-Zwangsladeanforderung",
  "50901.fault.hmidCommunicationAbnormality": "Hmi-Kommunikation Anomal",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.desc": "Generator startet zu dieser Zeit regelmäßig",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.desc": "Generator startet zu dieser Zeit regelmäßig",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.desc": "Generator startet zu dieser Zeit regelmäßig",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.desc": "Generator startet zu dieser Zeit regelmäßig",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.desc": "Generator startet zu dieser Zeit regelmäßig",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.desc": "Generator startet zu dieser Zeit regelmäßig",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.desc": "Generator startet zu dieser Zeit regelmäßig",
  "50901.fault.loadRelayAfault.0": "Deaktivieren",
  "50901.fault.fiveVoltPowerSupplyfault.0": "Deaktivieren",
  "50901.fault.fiveVoltPowerSupplyfault.1": "Aktivieren",
  "50901.fault.genRelayAfault.0": "Deaktivieren",
  "50901.fault.genRelayAfault.1": "Aktivieren",
  "50901.fault.genRelayBfault.0": "Deaktivieren",
  "50901.fault.genRelayBfault.1": "Aktivieren",
  "50901.fault.kmRelayfault.0": "Deaktivieren",
  "50901.fault.kmRelayfault.1": "Aktivieren",
  "50901.fault.twelveVoltPowerSupplyfault.1": "Aktivieren",
  "50901.fault.loadRelayAfault.1": "Aktivieren",
  "50901.fault.loadRelayBfault.0": "Deaktivieren",
  "50901.fault.loadRelayBfault.1": "Aktivieren",
  "50901.fault.pvRelayAbfault.0": "Deaktivieren",
  "50901.fault.pvRelayAbfault.1": "Aktivieren",
  "50901.fault.threePointThreeVoltPowerSupplyfault.0": "Deaktivieren",
  "50901.fault.threePointThreeVoltPowerSupplyfault.1": "Aktivieren",
  "50901.fault.twelveVoltPowerSupplyfault.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.0": "Aktivieren",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.1": "Aktivieren",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.0": "Deaktivieren",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.1": "Aktivieren",
  "50901.fault.loadRelayAfault": "Last-A-Relaisfehler",
  "50901.fault.threePointThreeVoltPowerSupplyfault": "3,3V-Stromversorgungsfehler",
  "50901.fault.pvRelayAbfault": "PV AB Relaisfehler",
  "50901.fault.twelveVoltPowerSupplyfault": "12V-Stromversorgungsfehler",
  "50901.fault.loadRelayBfault": "Last-B-Relaisfehler",
  "50901.fault.kmRelayfault": "KM-Relaisfehler",
  "50901.fault.genRelayBfault": "Generator B Relaisfehler",
  "50901.fault.genRelayAfault": "Generator A Relaisfehler",
  "50901.fault.fiveVoltPowerSupplyfault": "5V-Stromversorgungsfehler",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4": "Startzeit des Generator-Übungsmodus Donnerstag",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3": "Startzeit des Generator-Übungsmodus Mittwoch",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5": "Startzeit des Generator-Übungsmodus Freitag",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6": "Startzeit des Generator-Übungsmodus Samstag",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2": "Startzeit des Generator-Übungsmodus Dienstag",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7": "Startzeit des Generator-Übungsmodus Sonntag",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1": "Startzeit des Generator-Übungsmodus Montag",
  "50901.fault.evCharger1CommunicationAbnormality.0": "Deaktivieren",
  "50901.fault.evCharger1CommunicationAbnormality.1": "Aktivieren",
  "50901.fault.bmsCanCommunicationAbnormality.0": "Deaktivieren",
  "50901.fault.bmsCanCommunicationAbnormality.1": "Aktivieren",
  "50901.fault.dtu3Rs485CommunicationAbnormality.0": "Deaktivieren",
  "50901.fault.dtu3Rs485CommunicationAbnormality.1": "Aktivieren",
  "50901.fault.gridMeterTypeError.0": "Deaktivieren",
  "50901.fault.gridMeterTypeError.1": "Aktivieren",
  "50901.fault.lowDtuVersion.0": "Deaktivieren",
  "50901.fault.lowDtuVersion.1": "Aktivieren",
  "50901.fault.gridMeterCommunicationAbnormality.0": "Deaktivieren",
  "50901.fault.gridMeterCommunicationAbnormality.1": "Aktivieren",
  "50901.fault.pvMeterTypeError.0": "Deaktivieren",
  "50901.fault.pvMeterTypeError.1": "Aktivieren",
  "50901.fault.dspPwrCommunicationAbnormality.0": "Deaktivieren",
  "50901.fault.dspPwrCommunicationAbnormality.1": "Aktivieren",
  "50901.fault.evCharger2CommunicationAbnormality.0": "Deaktivieren",
  "50901.fault.evCharger2CommunicationAbnormality.1": "Aktivieren",
  "50901.fault.dtu5Rs485CommunicationAbnormality.0": "Deaktivieren",
  "50901.fault.dtu5Rs485CommunicationAbnormality.1": "Aktivieren",
  "50901.fault.dtsCommunicationAbnormality.0": "Deaktivieren",
  "50901.fault.dtsCommunicationAbnormality.1": "Aktivieren",
  "50901.fault.dtu4Rs485CommunicationAbnormality.0": "Deaktivieren",
  "50901.fault.dtu4Rs485CommunicationAbnormality.1": "Aktivieren",
  "50901.fault.dtu1Rs485CommunicationAbnormality.0": "Deaktivieren",
  "50901.fault.dtu1Rs485CommunicationAbnormality.1": "Aktivieren",
  "50901.fault.pvMeterCommunicationAbnormality.0": "Deaktivieren",
  "50901.fault.pvMeterCommunicationAbnormality.1": "Aktivieren",
  "50901.fault.slaveWrongBatteryConnection.0": "Deaktivieren",
  "50901.fault.slaveWrongBatteryConnection.1": "Aktivieren",
  "50901.fault.dtu2Rs485CommunicationAbnormality.0": "Deaktivieren",
  "50901.fault.dtu2Rs485CommunicationAbnormality.1": "Aktivieren",
  "50901.fault.dspSafCommunicationAbnormality.0": "Deaktivieren",
  "50901.fault.dspSafCommunicationAbnormality.1": "Aktivieren",
  "50901.fault.sustainedNegativeLoad.0": "Deaktivieren",
  "50901.fault.sustainedNegativeLoad.1": "Aktivieren",
  "50901.fault.hmidMachineFault.0": "Deaktivieren",
  "50901.fault.hmidMachineFault.1": "Aktivieren",
  "50901.fault.evCharger1Fault.0": "Deaktivieren",
  "50901.fault.evCharger1Fault.1": "Aktivieren",
  "50901.fault.evCharger2Fault.0": "Deaktivieren",
  "50901.fault.evCharger2Fault.1": "Aktivieren",
  "50901.fault.fanSpeedAbnormality.0": "Deaktivieren",
  "50901.fault.fanSpeedAbnormality.1": "Aktivieren",
  "50901.fault.masterSlaveCommunicationAbnormality.0": "Deaktivieren",
  "50901.fault.masterSlaveCommunicationAbnormality.1": "Aktivieren",
  "50901.fault.batteryCapacityAbnormality.0": "Deaktivieren",
  "50901.fault.batteryCapacityAbnormality.1": "Aktivieren",
  "50901.fault.batteryForceChargeRequest.0": "Deaktivieren",
  "50901.fault.batteryForceChargeRequest.1": "Aktivieren",
  "50901.fault.hmidCommunicationAbnormality.0": "Deaktivieren",
  "50901.fault.hmidCommunicationAbnormality.1": "Aktivieren",
  "50901.fault.batteryFault": "Batteriefehler",
  "50901.fault.fanFault.0": "Deaktivieren",
  "50901.fault.armCommunicationFault.1": "Aktivieren",
  "50901.fault.batteryFault.0": "Deaktivieren",
  "50901.fault.batteryFault.1": "Aktivieren",
  "50901.fault.evCharger1CommunicationAbnormality.desc": "Beschreibung Ev-Ladestation 1 Kommunikation Anomal",
  "50901.fault.bmsCanCommunicationAbnormality.desc": "Beschreibung Bms-Can-Kommunikation Anomal",
  "50901.fault.dtu3Rs485CommunicationAbnormality.desc": "Beschreibung Dtu3 Rs485-Kommunikation Anomal",
  "50901.fault.gridMeterTypeError.desc": "Beschreibung Netz-Zähler Typfehler",
  "50901.fault.lowDtuVersion.desc": "Beschreibung Dtu-Version Zu Niedrig",
  "50901.fault.gridMeterCommunicationAbnormality.desc": "Beschreibung Netz-Zähler Kommunikation Anomal",
  "50901.fault.pvMeterTypeError.desc": "Beschreibung Pv-Zähler Typfehler",
  "50901.fault.dspPwrCommunicationAbnormality.desc": "Beschreibung Dsp-Stromversorgungskommunikation Anomal",
  "50901.fault.evCharger2CommunicationAbnormality.desc": "Beschreibung Ev-Ladestation 2 Kommunikation Anomal",
  "50901.fault.dtu5Rs485CommunicationAbnormality.desc": "Beschreibung Dtu5 Rs485-Kommunikation Anomal",
  "50901.fault.dtsCommunicationAbnormality.desc": "Beschreibung Dts-Kommunikation Anomal",
  "50901.fault.dtu4Rs485CommunicationAbnormality.desc": "Beschreibung Dtu4 Rs485-Kommunikation Anomal",
  "50901.fault.dtu1Rs485CommunicationAbnormality.desc": "Beschreibung Dtu1 Rs485-Kommunikation Anomal",
  "50901.fault.pvMeterCommunicationAbnormality.desc": "Beschreibung Pv-Zähler Kommunikation Anomal",
  "50901.fault.slaveWrongBatteryConnection.desc": "Beschreibung Slave-Batterie Anschlussfehler",
  "50901.fault.dtu2Rs485CommunicationAbnormality.desc": "Beschreibung Dtu2 Rs485-Kommunikation Anomal",
  "50901.fault.dspSafCommunicationAbnormality.desc": "Beschreibung Dsp-Sicherheitskommunikation Anomal",
  "50901.fault.sustainedNegativeLoad.desc": "Beschreibung Anhaltende Negative Last",
  "50901.fault.hmidMachineFault.desc": "Beschreibung Hmi-Gerätefehler",
  "50901.fault.evCharger1Fault.desc": "Beschreibung Fehler Ladestation 1",
  "50901.fault.evCharger2Fault.desc": "Beschreibung Fehler Ladestation 2",
  "50901.fault.fanSpeedAbnormality.desc": "Beschreibung Lüfterdrehzahl Anomal",
  "50901.fault.batteryFault.desc": "Beschreibung Batteriefehler",
  "50901.fault.masterSlaveCommunicationAbnormality.desc": "Beschreibung Master-Slave-Kommunikation Anomal",
  "50901.fault.batteryCapacityAbnormality.desc": "Beschreibung Batteriekapazität Anomal",
  "50901.fault.batteryForceChargeRequest.desc": "Beschreibung Batterie-Zwangsladeanforderung",
  "50901.fault.hmidCommunicationAbnormality.desc": "Beschreibung Hmi-Kommunikation Anomal",
  "50901.fault.evCharger1CommunicationAbnormality.00": "Deaktivieren",
  "50901.fault.evCharger1CommunicationAbnormality.01": "Aktivieren",
  "50901.fault.bmsCanCommunicationAbnormality.00": "Deaktivieren",
  "50901.fault.bmsCanCommunicationAbnormality.01": "Aktivieren",
  "50901.fault.dtu3Rs485CommunicationAbnormality.00": "Deaktivieren",
  "50901.fault.dtu3Rs485CommunicationAbnormality.01": "Aktivieren",
  "50901.fault.gridMeterTypeError.00": "Deaktivieren",
  "50901.fault.gridMeterTypeError.01": "Aktivieren",
  "50901.fault.lowDtuVersion.00": "Deaktivieren",
  "50901.fault.lowDtuVersion.01": "Aktivieren",
  "50901.fault.gridMeterCommunicationAbnormality.00": "Deaktivieren",
  "50901.fault.gridMeterCommunicationAbnormality.01": "Aktivieren",
  "50901.fault.pvMeterTypeError.00": "Deaktivieren",
  "50901.fault.pvMeterTypeError.01": "Aktivieren",
  "50901.fault.dspPwrCommunicationAbnormality.00": "Deaktivieren",
  "50901.fault.dspPwrCommunicationAbnormality.01": "Aktivieren",
  "50901.fault.evCharger2CommunicationAbnormality.00": "Deaktivieren",
  "50901.fault.evCharger2CommunicationAbnormality.01": "Aktivieren",
  "50901.fault.dtu5Rs485CommunicationAbnormality.00": "Deaktivieren",
  "50901.fault.dtu5Rs485CommunicationAbnormality.01": "Aktivieren",
  "50901.fault.dtsCommunicationAbnormality.00": "Deaktivieren",
  "50901.fault.dtsCommunicationAbnormality.01": "Aktivieren",
  "50901.fault.dtu4Rs485CommunicationAbnormality.00": "Deaktivieren",
  "50901.fault.dtu4Rs485CommunicationAbnormality.01": "Aktivieren",
  "50901.fault.dtu1Rs485CommunicationAbnormality.00": "Deaktivieren",
  "50901.fault.dtu1Rs485CommunicationAbnormality.01": "Aktivieren",
  "50901.fault.pvMeterCommunicationAbnormality.00": "Deaktivieren",
  "50901.fault.pvMeterCommunicationAbnormality.01": "Aktivieren",
  "50901.fault.slaveWrongBatteryConnection.00": "Deaktivieren",
  "50901.fault.slaveWrongBatteryConnection.01": "Aktivieren",
  "50901.fault.dtu2Rs485CommunicationAbnormality.00": "Deaktivieren",
  "50901.fault.dtu2Rs485CommunicationAbnormality.01": "Aktivieren",
  "50901.fault.dspSafCommunicationAbnormality.00": "Deaktivieren",
  "50901.fault.dspSafCommunicationAbnormality.01": "Aktivieren",
  "50901.fault.sustainedNegativeLoad.00": "Deaktivieren",
  "50901.fault.sustainedNegativeLoad.01": "Aktivieren",
  "50901.fault.hmidMachineFault.00": "Deaktivieren",
  "50901.fault.hmidMachineFault.01": "Aktivieren",
  "50901.fault.evCharger1Fault.00": "Deaktivieren",
  "50901.fault.evCharger1Fault.01": "Aktivieren",
  "50901.fault.evCharger2Fault.00": "Deaktivieren",
  "50901.fault.evCharger2Fault.01": "Aktivieren",
  "50901.fault.fanSpeedAbnormality.00": "Deaktivieren",
  "50901.fault.fanSpeedAbnormality.01": "Aktivieren",
  "50901.fault.batteryFault.00": "Deaktivieren",
  "50901.fault.batteryFault.01": "Aktivieren",
  "50901.fault.masterSlaveCommunicationAbnormality.00": "Deaktivieren",
  "50901.fault.masterSlaveCommunicationAbnormality.01": "Aktivieren",
  "50901.fault.batteryCapacityAbnormality.00": "Deaktivieren",
  "50901.fault.batteryCapacityAbnormality.01": "Aktivieren",
  "50901.fault.batteryForceChargeRequest.00": "Deaktivieren",
  "50901.fault.batteryForceChargeRequest.01": "Aktivieren",
  "50901.fault.hmidCommunicationAbnormality.00": "Deaktivieren",
  "50901.fault.hmidCommunicationAbnormality.01": "Aktivieren",
  "alarm.excDesc.2047494139783155712": "ARM-Kommunikationsfehler",
  "alarm.name.2047494139783155712": "ARM-Kommunikationsfehler",
  "plant.create.type.0": "Installateur",
  "plant.create.type.1": "Endbenutzer",
  "not.configured": "Nicht konfiguriert",
  "10001.quickset.note1": "1. Self-Use-Modus: Die empfohlene Einstellung ist der Self-Use-Modus. Dieser Modus maximiert die Nutzung der PV-Erzeugung für den Haushaltsstrom oder speichert sie in Batterien und nutzt sie für den Haushaltsstrom. 2. Einspeisevorrang-Modus: Dieser Modus kann bei gedecktem Lastbedarf vorrangig Strom ins Netz einspeisen und wird in Gebieten mit Vergütung für Netzeinspeisung verwendet. 3. Spitzenlastglättungs-Modus: Nach Einstellung des Self-Use- oder Einspeisevorrang-Modus kann die Netzspitzenlastglättung auch dann gewählt werden, wenn der lokale Netzbetreiber den Strompreis auf Basis der Spitzenleistung des Systems berechnet. Kunden können diese Spitzenlastglättung aktivieren, um die Spitzenbezugsleistung am Netzanschlusspunkt zu vermeiden. 4. Inselbetrieb-Modus: Dieser Modus wird nur für reinen Inselbetrieb verwendet und wird für Standard-Speichersysteme nicht empfohlen. Beachten Sie, dass bei Aktivierung dieses Modus im netzgekoppelten Zustand die Arbeitslogik des Geräts gestört wird und \"Inselbetrieb\" angezeigt wird. 5. Zeitnutzung: Wenn Sie unter dem Self-Use-, Einspeisevorrang- oder Spitzenlastglättungs-Modus das Laden und Entladen der Batterie manuell zeitsteuern müssen, verwenden Sie den Zeitnutzungsschalter und die folgenden Einstellpunkte. Die Option \"Netzladen erlauben\" sollte in diesen drei Modi aktiviert sein (wenn deaktiviert, lädt der Wechselrichter die Batterie nicht zwangsweise, und die Batterie könnte in den Ruhezustand fallen).",
  "10001.quickset.note2": "1. Selbstnutzungsmodus: Die empfohlene Einstellung ist der Selbstnutzungsmodus. Dieser Modus kann die Nutzung der PV-Stromerzeugung für Haushaltsstrom maximieren oder in Batterien speichern und für Haushaltsstrom verwenden;\n2. Einspeisung im Prioritätsmodus: Dieser Modus kann bevorzugt Strom an das Netz senden, wenn die Last erfüllt ist, und wird in Gebieten mit einer Subvention für Strom an das Netz verwendet;\n3. Peak-Shaving-Modus: Nach der Einstellung der Selbstnutzung oder der Einspeisung im Prioritätsmodus kann die Netzspitzenberechnung auch gewählt werden, wenn die lokale Netzgesellschaft den Strompreis auf der Grundlage des Spitzenstromverbrauchs des Systems berechnet. Kunden können diese Spitzenberechnung wählen, um die Spitzenverbrauchsleistung am Netzanschlusspunkt zu vermeiden;\n4. Off-Grid-Modus: Dieser Modus wird nur für reine Off-Grid-Systeme verwendet und wird nicht für Standardspeichersysteme empfohlen. Beachten Sie, dass, wenn dieser Modus im netzgekoppelten Zustand aktiviert ist, die Arbeitslogik der Maschine verwirrt wird und das \"Off-Grid\" angezeigt wird;\n5. Nutzungszeit: Wenn Sie das Laden und Entladen der Batterie manuell steuern müssen, in Bezug auf die Zeit im Selbstnutzungs- oder Vorrats- oder Spitzenrasiermodus, verwenden Sie bitte den Schalter für die Nutzungszeit und die folgenden Sollwerte. Und es wird empfohlen, das \"Netzladen zulassen\" in diesen 3 Modi einzuschalten (wenn es ausgeschaltet ist, lädt der Wechselrichter die Batterie nicht mit Gewalt auf, und die Batterie könnte möglicherweise in den Ruhezustand übergehen).",
  "10001.quickset.note3": "1. Selbstnutzungsmodus: Die empfohlene Einstellung ist der Selbstnutzungsmodus. Dieser Modus kann die Nutzung der PV-Stromerzeugung für Haushaltsstrom maximieren oder in Batterien speichern und für Haushaltsstrom verwenden;\n2. Einspeisung im Prioritätsmodus: Dieser Modus kann bevorzugt Strom an das Netz senden, wenn die Last erfüllt ist, und wird in Gebieten mit einer Subvention für Strom an das Netz verwendet;\n3. Off-Grid-Modus: Dieser Modus wird nur für reine Off-Grid-Systeme verwendet und wird nicht für Standardspeichersysteme empfohlen. Beachten Sie, dass, wenn dieser Modus im netzgekoppelten Zustand aktiviert ist, die Arbeitslogik der Maschine verwirrt wird und das \"Off-Grid\" angezeigt wird;\n4. Nutzungsdauer: Wenn Sie das Laden und Entladen der Batterie manuell steuern müssen, in Bezug auf die Zeit im Selbstnutzungs- oder Vorrats- oder Spitzenrasiermodus, verwenden Sie bitte den Schalter für die Nutzungszeit und die folgenden Sollwerte. Und es wird empfohlen, das \"Netzladen zulassen\" in diesen 3 Modi einzuschalten (wenn es ausgeschaltet ist, lädt der Wechselrichter die Batterie nicht mit Gewalt auf, und die Batterie könnte möglicherweise in den Ruhezustand übergehen).",
  "chinaAreas.Shandong": "Shandong",
  "country.China": "China",
  "json.50901.workmode.timeSection": "Zeitabschnitt",
  "json.device.dryWorking": "Trockenarbeit",
  "device.dryWorking": "Trockenarbeit",
  "51002.ctrl_antireverse": "Rückflussverhinderung",
  "51002.ctrl_inverter": "Steuerung",
  "51002.null.数据分析_实时监控_PV.tag": "Echtzeitüberwachung_PV",
  "51002.real_time": "Echtzeitüberwachung",
  "51002.real_time.Energy_PV1.desc": "PV1 Gesamtenergie",
  "51002.real_time.Energy_PV2.desc": "PV2 Gesamtenergie",
  "51002.real_time.Energy_PV3.desc": "PV3 Gesamtenergie",
  "51002.real_time.Energy_PV4.desc": "PV4 Gesamtenergie",
  "51002.real_time.gridTotalFrequency.desc": "Gesamtfrequenz des Stromnetzes",
  "51002.real_time.inverterTemp.desc": "Wechselrichtertemperatur",
  "51002.real_time.pvPower.desc": "PV-Leistung",
  "51002.real_time.stRelayoN.desc": "Status der Relaisverbindung",
  "51002.real_time.workStatus.desc": "Betriebsstatus",
  "51002.real_time.数据分析_实时监控_GRID.tag": "Netzdaten",
  "51002.real_time.数据分析_实时监控_P.tag": "PV-Leistung",
  "51002.real_time.数据分析_实时监控_PV.tag": "Photovoltaik",
  "51002.real_time.数据分析_实时监控_TP.tag": "Wechselrichtertemperatur",
  "51002.warning": "Alarm",
  "51002.warning.stAbnorm_Ris.desc": "Anormale Isolationsimpedanz",
  "51002.warning.stErrAccess_EEPROM.desc": "EEPROM-Zugriffsfehler",
  "51002.warning.stErrOP_Relay.desc": "Anormales Relais auf der Netzseite",
  "51002.warning.stHW_Fault.desc": "Hardware-Schutz des Wechselrichters",
  "51002.warning.stOV_Fgrid.desc": "Netzseitiger Überfrequenz-Spannungsschutz",
  "51002.warning.stOV_Temp.desc": "Übertemperaturschutz des Wechselrichters",
  "51002.warning.stOV_Vgrid.desc": "Netzseitiger Überspannungsschutz",
  "51002.warning.stPV1_OV.desc": "Überspannung am PV-Eingang 1",
  "51002.warning.stPV1_UV.desc": "Unterspannung am PV-Eingang 1",
  "51002.warning.stPV2_OV.desc": "Überspannung am PV-Eingang 2",
  "51002.warning.stPV2_UV.desc": "Unterspannung am PV-Eingang 2",
  "51002.warning.stPV3_OV.desc": "Überspannung am PV-Eingang 3",
  "51002.warning.stPV3_UV.desc": "Unterspannung am PV-Eingang 3",
  "51002.warning.stPV4_OV.desc": "Überspannung am PV-Eingang 4",
  "51002.warning.stPV4_UV.desc": "Unterspannung am PV-Eingang 4",
  "51002.warning.stUV_Fgrid.desc": "Netzseitiger Unterfrequenzschutz",
  "51002.warning.stUV_Vgrid.desc": "Netzseitiger Unterspannungsschutz",
  "51002..gridtype.desc": "Netzstandard",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT.0": "Deaktivieren",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT.1": "Aktivieren",
  "51002.ctrl_inverter.ena10mVs1Prot.0": "Deaktivieren",
  "51002.ctrl_inverter.ena10mVs1Prot.1": "Aktivieren",
  "51002.ctrl_inverter.enaAPP_PWSET.0": "Deaktivieren",
  "51002.ctrl_inverter.enaAPP_PWSET.1": "Aktivieren",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj.0": "Deaktivieren",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj.1": "Aktivieren",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT.0": "Deaktivieren",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT.1": "Aktivieren",
  "51002.ctrl_inverter.enaOVs1_powerdownadj.0": "Deaktivieren",
  "51002.ctrl_inverter.enaOVs1_powerdownadj.1": "Aktivieren",
  "51002.ctrl_inverter.enaRestoretodefault.0": "Deaktivieren",
  "51002.ctrl_inverter.enaRestoretodefault.1": "Aktivieren",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck.0": "Deaktivieren",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck.1": "Aktivieren",
  "51002.real_time.stRelayoN.0": "Deaktivieren",
  "51002.real_time.stRelayoN.1": "Aktivieren",
  "51002.real_time.workStatus.0": "Trennen",
  "51002.real_time.workStatus.1": "Schließen",
  "51002.warning.stAbnorm_Ris.0": "Normalbetrieb",
  "51002.warning.stAbnorm_Ris.1": "Alarm auslösen",
  "51002.warning.stErrAccess_EEPROM.0": "Normalbetrieb",
  "51002.warning.stErrAccess_EEPROM.1": "Alarm auslösen",
  "51002.warning.stErrOP_Relay.0": "Normalbetrieb",
  "51002.warning.stErrOP_Relay.1": "Alarm auslösen",
  "51002.warning.stHW_Fault.0": "Normalbetrieb",
  "51002.warning.stHW_Fault.1": "Alarm auslösen",
  "51002.warning.stOV_Fgrid.0": "Normalbetrieb",
  "51002.warning.stOV_Fgrid.1": "Alarm auslösen",
  "51002.warning.stOV_Temp.0": "Normalbetrieb",
  "51002.warning.stOV_Temp.1": "Alarm auslösen",
  "51002.warning.stOV_Vgrid.0": "Normalbetrieb",
  "51002.warning.stOV_Vgrid.1": "Alarm auslösen",
  "51002.warning.stPV1_OV.0": "Normalbetrieb",
  "51002.warning.stPV1_OV.1": "Alarm auslösen",
  "51002.warning.stPV1_UV.0": "Normalbetrieb",
  "51002.warning.stPV1_UV.1": "Alarm auslösen",
  "51002.warning.stPV2_OV.0": "Normalbetrieb",
  "51002.warning.stPV2_OV.1": "Alarm auslösen",
  "51002.warning.stPV2_UV.0": "Normalbetrieb",
  "51002.warning.stPV2_UV.1": "Alarm auslösen",
  "51002.warning.stPV3_OV.0": "Normalbetrieb",
  "51002.warning.stPV3_OV.1": "Alarm auslösen",
  "51002.warning.stPV3_UV.0": "Normalbetrieb",
  "51002.warning.stPV3_UV.1": "Alarm auslösen",
  "51002.warning.stPV4_OV.0": "Normalbetrieb",
  "51002.warning.stPV4_OV.1": "Alarm auslösen",
  "51002.warning.stPV4_UV.0": "Normalbetrieb",
  "51002.warning.stPV4_UV.1": "Alarm auslösen",
  "51002.warning.stUV_Fgrid.0": "Normalbetrieb",
  "51002.warning.stUV_Fgrid.1": "Alarm auslösen",
  "51002.warning.stUV_Vgrid.0": "Normalbetrieb",
  "51002.warning.stUV_Vgrid.1": "Alarm auslösen",
  "51002.ctrl_inverter.ena10mVs1Prot": "10-Minuten-Mittelwert der Netzspannung auf Stufe 1, Überspannungsschutz aktiviert",
  "51002.ctrl_inverter.enaINVTR.0": "Abschalten",
  "51002.ctrl_inverter.enaINVTR.1": "Einschalten",
  "51002.ctrl_inverter.enaOVTPWDN.0": "Deaktivieren",
  "51002.ctrl_inverter.enaOVTPWDN.1": "Aktivieren",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck": "Schalter für die Selbsttestfunktion der Systemschutzschnittstelle",
  "51002.real_time.Energy_PV1": "Gesamtstromerzeugung von PV1",
  "51002.real_time.Energy_PV2": "Gesamtstromerzeugung von PV2",
  "51002.real_time.Energy_PV3": "Gesamtstromerzeugung von PV3",
  "51002.real_time.Energy_PV4": "Gesamtstromerzeugung von PV4",
  "51002.real_time.Firmware_ver": "Firmware-Versionsnummer",
  "51002.real_time.Fn": "Nennfrequenz des Netzes",
  "51002.real_time.gridTotalFrequency": "Gesamtfrequenz",
  "51002.real_time.Iacrms": "Effektivwert des netzseitigen Stroms",
  "51002.real_time.inverterTemp": "Wechselrichtertemperatur",
  "51002.real_time.Ipv1": "Eingangsstrom PV1",
  "51002.real_time.Ipv2": "Eingangsstrom PV2",
  "51002.real_time.Ipv3": "Eingangsstrom PV3",
  "51002.real_time.Ipv4": "Eingangsstrom PV4",
  "51002.real_time.Ipvmax": "Maximaler PV-Eingangsstrom",
  "51002.real_time.Irmsmax": "Maximaler Effektivwert des Netzstroms",
  "51002.real_time.Pn": "Maximale Wirkleistung im Netz",
  "51002.real_time.powerGeneration": "Gesamtstromerzeugung",
  "51002.real_time.Powpvmax": "Maximale PV-Eingangsleistung",
  "51002.real_time.pvPower": "PV-Leistung",
  "51002.real_time.stRelayoN": "Status der Relaisverbindung",
  "51002.real_time.Tempmax": "Maximale Betriebstemperatur",
  "51002.real_time.Un": "Effektivwert der Nennspannung des Netzanschlusses",
  "51002.real_time.Vacrms": "Effektivwert der netzseitigen Spannung",
  "51002.real_time.Vmpptmax": "Maximale MPPT-Spannung",
  "51002.real_time.Vmpptmin": "Minimale MPPT-Spannung",
  "51002.real_time.Vpv1": "Eingangsspannung PV1",
  "51002.real_time.Vpv2": "Eingangsspannung PV2",
  "51002.real_time.Vpv3": "Eingangsspannung PV3",
  "51002.real_time.Vpv4": "Eingangsspannung PV4",
  "51002.real_time.workStatus": "Betriebsstatus",
  "51002.warning.stAbnorm_Ris": "Anormale Isolationsimpedanz",
  "51002.warning.stErrAccess_EEPROM": "EEPROM-Zugriffsfehler",
  "51002.warning.stErrOP_Relay": "Anormale Schutzfunktion des netzseitigen Relais",
  "51002.warning.stHW_Fault": "Hardware-Schutz des Wechselrichters",
  "51002.warning.stOV_Fgrid": "Netzseitiger Überfrequenz-Spannungsschutz",
  "51002.warning.stOV_Temp": "Übertemperaturschutz des Wechselrichters",
  "51002.warning.stOV_Vgrid": "Netzseitiger Überspannungsschutz",
  "51002.warning.stPV1_OV": "Überspannung am PV-Eingang 1",
  "51002.warning.stPV1_UV": "Unterspannung am PV-Eingang 1",
  "51002.warning.stPV2_OV": "Überspannung am PV-Eingang 2",
  "51002.warning.stPV2_UV": "Unterspannung am PV-Eingang 2",
  "51002.warning.stPV3_OV": "Überspannung am PV-Eingang 3",
  "51002.warning.stPV3_UV": "Unterspannung am PV-Eingang 3",
  "51002.warning.stPV4_OV": "Überspannung am PV-Eingang 4",
  "51002.warning.stPV4_UV": "Unterspannung am PV-Eingang 4",
  "51002.warning.stUV_Fgrid": "Netzseitiger Unterfrequenzschutz",
  "51002.warning.stUV_Vgrid": "Netzseitiger Unterspannungsschutz",
  "51002.ctrl_antireverse.dynamicPowerLimit": "Prozentwert für die Rückspeisungsbegrenzung",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT": "Rückspeisung aktivieren",
  "51002.ctrl_inverter.enaAPP_PWSET": "Benutzerdefinierte Leistungsbegrenzung aktivieren",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj": "Frequenzversatz-Leistungsanpassung aktivieren",
  "51002.ctrl_inverter.enaINVTR": "Fernschaltung von Wechselrichtern",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT": "Schutz bei abnormaler Isolationsimpedanz aktivieren",
  "51002.ctrl_inverter.enaOVs1_powerdownadj": "Überspannungs-Derating der Stufe 1 aktivieren",
  "51002.ctrl_inverter.enaOVTPWDN": "Übertemperatur-Derating aktivieren",
  "51002.ctrl_inverter.enaRestoretodefault": "Standardwerte für Schutzfunktionen und Funktionsschalter wiederherstellen",
  "51002.ctrl_inverter.powersetUserApp": "Prozentwert für die benutzerdefinierte Leistungsbegrenzung",
  "bw_param_ctrl_option_BackupMode": "Notstrommodus",
  "bw_param_ctrl_option_ Feed-inPriorityMode": "Netzeinspeisung bevorzugt",
  "51102.ctrl_WorkMode.Switch.ems_ctrl_work_mode.4": "asdsad",
  "50657.fault.comStatus": "Kommunikationsstatus",
  "50657.fault.comStatus.00": "Getrennt",
  "50657.fault.comStatus.01": "Verbunden",
  "50657.realtime.FADE": "Vorwärts-Tieftal-Wirkenergie",
  "50657.realtime.FAFE": "Vorwärts-Normal-Wirkenergie",
  "50657.realtime.FAFE_PSD": "Vorwärts-Normal-Wirkenergie (Vorheriger Abrechnungstag)",
  "50657.realtime.FAPE": "Vorwärts-Spitzen-Wirkenergie",
  "50657.realtime.FAPE_PSD": "Vorwärts-Spitzen-Wirkenergie (Vorheriger Abrechnungstag)",
  "50657.realtime.FAPVE": "Vorwärts-Spitzen-Tal-Wirkenergie",
  "50657.realtime.FAPVE_PSD": "Vorwärts-Spitzen-Tal-Wirkenergie (Vorheriger Abrechnungstag)",
  "50657.realtime.FASE": "Vorwärts-Hochspitzen-Wirkenergie",
  "50657.realtime.FASE_PSD": "Vorwärts-Hochspitzen-Wirkenergie (Vorheriger Abrechnungstag)",
  "50657.realtime.FAVE": "Vorwärts-Tal-Wirkenergie",
  "50657.realtime.FAVE_PSD": "Vorwärts-Tal-Wirkenergie (Vorheriger Abrechnungstag)",
  "50657.realtime.FTAE": "Gesamte Vorwärts-Wirkenergie",
  "50657.realtime.FTAE_PSD": "Gesamte Vorwärts-Wirkenergie (Vorheriger Abrechnungstag)",
  "50657.realtime.Fr": "Frequenz",
  "50657.realtime.Ia": "Strom Phase A",
  "50657.realtime.Ib": "Strom Phase B",
  "50657.realtime.Ic": "Strom Phase C",
  "50657.realtime.P": " Gesamtwirkleistung",
  "50657.realtime.Pa": "Gesamtwirkleistung Phase A",
  "50657.realtime.Pb": "Gesamtwirkleistung Phase B",
  "50657.realtime.Pc": "Gesamtwirkleistung Phase C",
  "50657.realtime.Pf": "Gesamtleistungsfaktor",
  "50657.realtime.Pfa": "Leistungsfaktor Phase A",
  "50657.realtime.Pfb": "Leistungsfaktor Phase B",
  "50657.realtime.Pfc": "Leistungsfaktor Phase C",
  "50657.realtime.Q": "Gesamtblindleistung",
  "50657.realtime.Qa": "Gesamtblindleistung Phase A",
  "50657.realtime.Qb": "Gesamtblindleistung Phase B",
  "50657.realtime.Qc": "Gesamtblindleistung Phase C",
  "50657.realtime.RADE": "Rückwärts-Tieftal-Wirkenergie",
  "50657.realtime.RAFE": "Rückwärts-Normal-Wirkenergie",
  "50657.realtime.RAPE": "Rückwärts-Spitzen-Wirkenergie",
  "50657.realtime.RASE": "Rückwärts-Hochspitzen-Wirkenergie",
  "50657.realtime.RAVE": "Rückwärts-Tal-Wirkenergie",
  "50657.realtime.RTAE": "Gesamte Rückwärts-Wirkenergie",
  "50657.realtime.S": "Gesamtscheinleistung",
  "50657.realtime.Sa": "Scheinleistung Phase A",
  "50657.realtime.Sb": "Scheinleistung Phase B",
  "50657.realtime.Sc": "Scheinleistung Phase C",
  "50657.realtime.T": "Temperatur",
  "50657.realtime.Ua": "Spannung Phase A",
  "50657.realtime.Uab": " Leitungsspannung AB",
  "50657.realtime.Ub": "Spannung Phase B",
  "50657.realtime.Ubc": " Leitungsspannung BC",
  "50657.realtime.Uc": "Spannung Phase C",
  "50657.realtime.Uca": "Leitungsspannung CA",
  "50657.realtime.Z0": "Nullsequenz-Impedanz",
  "50657.realtime.Zf": "Vorwärts-Impedanz",
  "bw_param_ctrl_note_DispatchActivepower": "Die Einstellung dieser Daten auf einen positiven Wert zeigt die Notwendigkeit der Entladung an, während die Einstellung auf einen negativen Wert die Notwendigkeit der Ladung anzeigt.",
  "bw_param_ctrl_option_Forcedcharginganddischarging": "Erzwungenes Laden/Entladen",
  "bw_param_ctrl_option_GridUseCT&PVUseMeter": "CT für Stromnetz, Stromzähler für Photovoltaik",
  "bw_param_ctrl_option_GridUseMeter&PVUseCT": "Stromzähler für Stromnetz, CT für Photovoltaik",
  "bw_param_ctrl_option_DisableTimePeriodControl": "Zeitraumsteuerung deaktivieren",
  "bw_param_ctrl_option_OnlyEnableChargeTimeperiodcontrol": "Nur Lade-Zeitraumsteuerung aktivieren",
  "bw_RTparam_name_TotalApparentPower_Grid": "Zähler-Scheinleistung (Gesamt)",
  "bw_param_ctrl_name_FactoryReset ": "Werksreset",
  "bw_param_ctrl_option_FactoryReset ": "Neustart",
  "bw_param_ctrl_note_DSPReset": "Wenn die Fehlerinformationen nicht mit der tatsächlichen Situation übereinstimmen, kann dies durch einen Neustart des DSP behoben werden. Wenn beispielsweise die APP einen Fehler \"Erdleitung unterbrochen\" anzeigt, die an den Wechselrichter angeschlossene Erdleitung jedoch nicht getrennt ist, kann das Problem durch einen Neustart des DSP behoben werden.",
  "bw_param_ctrl_note_EMSReset": "Wenn eine abnormale Datenerfassung auftritt, setzen Sie bitte das EMS zurück, um das System wiederherzustellen.",
  "bw_param_ctrl_note_FactoryReset": "Wenn Sie alle Parameter des Wechselrichters auf die Werkseinstellungen zurücksetzen möchten, können Sie diese Funktion verwenden.",
  "bw_param_ctrl_option_Grid&PVuseCT": "Netz & PV verwenden CT",
  "bw_param_outage_soc_setting": "SOC-Einstellung beim Ausschalten",
  "netherland.areas": "The Netherlands",
  "paramSet.grouping.safetySetting": "Sicherheitsvorschriften-Einstellungen",
  "tt1": "test",
  "ice.robot.strategy.type.int.str.sta.rev.pri": "Stationsrendite priorisieren",
  "networkEnum.code.1": "LAN",
  "networkEnum.code.2": "WiFi",
  "networkEnum.code.3": "2G",
  "networkEnum.code.63": "4G",
  "networkEnum.code.12": "WiFi + BLE",
  "networkEnum.code.23": "WiFi + 4G + BLE",
  "networkEnum.code.62": "LAN",
  "networkEnum.code.64": "WiFi + AP",
  "networkEnum.code.65": "4G + BLE",
  "networkEnum.code.12,62": "WiFi + BLE + LAN",
  "networkEnum.code.62,63": "LAN + 4G",
  "networkEnum.code.23,62": "WiFi + BLE + LAN + 4G",
  "isShowService.show": "show",
  "transfer.operation.success": "",
  "transfer.operation.fail": "",
  "transfer.operation.unbind": "",
  "transfer.operation.withdraw": "",
  "login.correctEmail": "Bitte geben sie die richtige e-mail-adresse ein",
  "login.passLength": "Die länge des codes muss zwischen 8 und 20 bits liegen",
  "login.passType": "Sie müssen mindestens drei arten Von zeichen wie zahlen, großbuchstaben, großbuchstaben und englisch enthalten",
  "placeholder.input": "Bitte geben Sie ein",
  "placeholder.startTime": "Startzeit",
  "placeholder.endTime": "Endzeit",
  "placeholder.startDate": "Startdatum",
  "placeholder.endDate": "Enddatum",
  "upload.imageDetail": "Bilddetails",
  "upload.seeOrigin": "Klicken Sie hier, um die Quelldatei anzuzeigen",
  "upload.needOpen": "Diese Datei muss möglicherweise heruntergeladen und angesehen werden",
  "upload.knowandSure": "Wissen und bestätigen",
  "upload.fail": "Hochladen fehlgeschlagen",
  "upload.uploadError": "Datei-Upload fehlgeschlagen, bitte kontaktieren Sie den Administrator",
  "upload.fielExceed": "Die Anzahl der Dateien überschreitet die Grenze",
  "upload.fileSizeExceed": "Die Größe des hochgeladenen Bildes darf nicht überschreiten",
  "upload.fileTypeError": "Bitte wählen Sie das richtige Dateiformat",
  "upload.image": "Bild",
  "validator.bank": "Bitte geben Sie die korrekte Bankkartennummer ein",
  "validator.phone": "Bitte geben Sie die richtige Handy- oder Festnetznummer ein",
  "validator.email": "Bitte geben Sie die korrekte E-Mail-Adresse ein",
  "validator.password": "Das Passwort sollte 8-20-Zeichen lang sein und mindestens drei Arten von Zeichen enthalten: Zahlen, Großbuchstaben, Kleinbuchstaben und englische Symbole",
  "validator.greater": "Bitte geben Sie eine Zahl größer als Null ein",
  "org.user": "Benutzer",
  "org.role": "Rolle",
  "org.email": "Postfach",
  "org.editorginfo": "Organisationsinformationen bearbeiten",
  "org.passwordResetTo": "Das Passwort wird zurückgesetzt auf",
  "org.pleaseChooseOrg": "Bitte wählen Sie zuerst eine Organisation aus",
  "org.addDept": "Abteilung hinzufügen",
  "org.editDept": "Redaktion",
  "org.passwordResetSuccess": "Passwort zurücksetzen erfolgreich",
  "org.passwordResetFail": "Zurücksetzen des Passworts fehlgeschlagen",
  "org.deleteTip": "Dieser Vorgang löscht die Abteilung. Möchten Sie fortfahren?",
  "org.deleteSuccess": "Löschen erfolgreich",
  "org.parent": "Superiore Organisation",
  "org.orgName": "Name der Organisation",
  "org.area": "Land/Region",
  "org.leader": "Verantwortliche Person",
  "org.leaderPhone": "Kontaktdaten des Verantwortlichen",
  "org.logo": "Organisationslogo",
  "org.namenick": "Name/Spitzname",
  "org.createTime": "Erstellungszeit",
  "org.status": "Zustand",
  "org.action": "Betrieb",
  "login.password.not.blank": "Login Passwort kann nicht leer sein",
  "token.invalid": "Token ungültig, bitte loggen Sie sich erneut ein",
  "token.empty": "Token kann nicht leer sein",
  "user.not.exist": "Benutzer existiert nicht",
  "user.mail.password.not.correct": "Die E-Mail-Adresse oder das Passwort des Benutzers ist falsch",
  "user.email.exist": "E-Mail wurde registriert!",
  "dept.suspend": "Abteilung ausgesetzt, keine neuen Ergänzungen erlaubt",
  "dept.not.exist": "Abteilungsinformationen existieren nicht",
  "email.code.valid": "Der Verifizierungscode ist falsch",
  "service.not.found": "Service nicht gefunden",
  "service.internal.error": "Interner Serverfehler",
  "login.email.length.error": "Die E-Mail-Länge darf 50 Zeichen nicht überschreiten.",
  "login.password.length.error": "Die Passwortlänge muss zwischen 8-20 Zeichen liegen",
  "menu.edit.exist": "Menü '% s' konnte nicht geändert werden, Menüname existiert bereits",
  "menu.add.exist": "Hinzufügen von Menü '% s' fehlgeschlagen, Menüname existiert bereits",
  "menu.edit.parent": "Menü '% s' konnte nicht geändert werden, das übergeordnete Menü kann sich nicht selbst auswählen",
  "menu.add.parent": "Menü '% s' konnte nicht hinzugefügt werden, das übergeordnete Menü kann sich nicht selbst auswählen",
  "menu.child.exist": "Es gibt ein Untermenü, das nicht gelöscht werden kann",
  "menu.assign.error": "Menü zugewiesen, Löschen nicht erlaubt",
  "password.reset.success": "Passwort zurücksetzen erfolgreich",
  "user.register.success": "erfolgreich registriert",
  "dept.add.exist": "Abteilung '% s' konnte nicht hinzugefügt werden, Abteilungsname existiert bereits",
  "dept.edit.exist": "Abteilung '% s' konnte nicht geändert werden, Abteilungsname existiert bereits",
  "menu.show.status": "Anzeige",
  "menu.hide.status": "Ausblenden",
  "menu.category.name": "Katalog",
  "menu.menu.name": "Menü",
  "menu.button.name": "Knopf",
  "menu.is.external": "ja",
  "menu.not.external": "nein",
  "dev.type.oem": "OEM",
  "dev.type.odm": "ODM",
  "dev.type.self": "Selbst entwickelt",
  "supplier.type.hr": "Haier",
  "supplier.type.jl": "Jinlang.",
  "supplier.type.nt": "Natongstar name",
  "device.category.inverter": "Wechselrichter",
  "device.category.pv": "Photovoltaik",
  "device.category.battery": "Batterie",
  "device.category.switch": "Schalter",
  "device.category.charging.pile": "Ladestation",
  "product.not.exist": "Das Produkt existiert nicht",
  "product.binding.error": "Das Produkt ist bereits gebunden und kann nicht gelöscht werden",
  "ship.import.empty": "Importdaten können nicht leer sein",
  "mdn.exist": "Die mdn-Materialnummer existiert bereits, fügen Sie sie nicht erneut hinzu",
  "ship.mdn.not.empty": "Mdn kann nicht leer sein",
  "ship.category.not.empty": "Kategorie kann nicht leer sein",
  "ship.hrSn.not.empty": "Haier Seriennummer kann nicht leer sein",
  "ship.devType.not.empty": "F&E-Typ kann nicht leer sein",
  "ship.supplierSn.not.empty": "Lieferantenseriennummer kann nicht leer sein",
  "ship.mdn.not.exist": "Das Produkt mdn existiert nicht",
  "ship.add.data.error": "Abnormale Hinzufügung von Sendungsverwaltungsdaten, wenden Sie sich bitte an den Administrator",
  "plant.InstallationPlan": "Installationsschema",
  "plant.owner": "Eigentümer",
  "plant.photovoltaicCapacity": "Photovoltaik-Kapazität (kWh)",
  "plant.batteryCapacity": "Batteriekapazität (kWh)",
  "plant.electricityConsumptionToday": "Strommenge heute",
  "plant.electricityConsumptionMonth": "Strommenge diesen Monat",
  "plant.electricityConsumptionTotal": "Kumulative Strommenge",
  "plant.runningState": "Betriebszustand",
  "plant.buildState": "Bauzustand",
  "plant.plantNum": "Anzahl Kraftwerke",
  "plant.totalPlantNum": "Gesamt",
  "plant.building": "Im Bau",
  "plant.delivered": "Ausgeliefert",
  "plant.electricEnergy": "Stromerzeugung",
  "plant.deleteSuccess": "Kraftwerk erfolgreich gelöscht",
  "plant.life": "Lebensdauer",
  "plant.operatingData": "Betriebsdaten",
  "plant.dataReportingTime": "Zeitpunkt der Datenübermittlung",
  "plant.energyBalance": "Energiebilanz (kWh)",
  "plant.onGridEnergy": "Einspeisung ins Netz",
  "plant.purchaseElectricity": "Gekaufter Strom",
  "plant.statisticalAnalysis": "Statistische Analyse",
  "plant.energyAnalysis": "Energieanalyse",
  "plant.powerAnalysis": "Leistungsanalyse",
  "plant.updateTime": "Aktualisierungszeit der Wetterdaten",
  "plant.stationInfo": "Kraftwerksinformationen",
  "plant.userInfo": "Benutzerinformationen",
  "plant.socialContribution": "Sozialer Beitrag",
  "plant.equivalentIncome": "Äquivalenter Ertrag",
  "plant.priceSet": "Strompreiseinstellungen",
  "plant.photovoltaicPowerGenerations": "Stromerzeugung durch Photovoltaik",
  "plant.weather": "Wetter",
  "plant.sunriseSunset": "Sonnenaufgang/Sonnenuntergang",
  "plant.temperature": "Temperatur(℃)",
  "plant.humidity": "Luftfeuchtigkeit",
  "plant.windSpeed": "Windgeschwindigkeit",
  "plant.windDirection": "Windrichtung",
  "plant.primaryUser": "Hauptbenutzer",
  "plant.receiveMode": "Empfangsart",
  "plant.dateOfReceipt": "Empfangsdatum",
  "plant.familyName": "Familienname",
  "plant.familyMembers": "Anzahl der Familienmitglieder",
  "plant.currency": "Währung",
  "plant.purchasePrice": "Kaufpreis",
  "plant.sellingPrice": "Stromverkaufspreis",
  "plant.noUserInfo": "Benutzer noch nicht ausgeliefert",
  "plant.noIncomeTip": "Um Ihren äquivalenten Ertrag besser zu berechnen, geben Sie bitte den Kauf- und Verkaufspreis für Strom ein",
  "subttile.week": "Woche",
  "shipment.spread": "Ausklappen",
  "shipment.packUp": "Einklappen",
  "device.empty": "Gerät nicht vorhanden",
  "deviceType.empty": "Gerätetyp nicht unterstützt",
  "collector.params.error": "Abnormale Lesung von Nicht-Sammlerparametern",
  "can.not.empty": "Darf nicht leer sein",
  "shipment.supplierSN": "Lieferanten-SN",
  "solis.10001.eToday": "Tägliche Stromerzeugung",
  "solis.10001.eMonth": "Monatliche Stromerzeugung",
  "solis.10001.eYear": "Jährliche Stromerzeugung",
  "solis.10001.eTotal": "Gesamte Stromerzeugung",
  "solis.10001.fAc": "Netzfrequenz",
  "solis.10001.pac": "Leistung in Echtzeit",
  "solis.10001.pacPec": "Leistung in Prozent",
  "solis.10001.fullHour": "Volle Leistungsstunden",
  "solis.10001.power": "Installierte Kapazität",
  "solis.10001.iAc1": "AC-seitiger Strom - R",
  "solis.10001.iAc2": "AC-seitiger Strom - S",
  "solis.10001.iAc3": "AC-seitiger Strom - T",
  "solis.10001.uAc1": "AC-seitige Spannung - R",
  "solis.10001.uAc2": "AC-seitige Spannung - S",
  "solis.10001.uAc3": "AC-seitige Spannung - T",
  "solis.10001.iPv1": "PV Strom-1",
  "solis.10001.iPv2": "PV Strom-2",
  "solis.10001.iPv3": "PV Strom-3",
  "solis.10001.iPv4": "PV Strom-4",
  "solis.10001.iPv5": "PV Strom-5",
  "solis.10001.iPv6": "PV Strom-6",
  "solis.10001.iPv7": "PV Strom-7",
  "solis.10001.iPv8": "PV Strom-8",
  "solis.10001.iPv9": "PV Strom-9",
  "solis.10001.iPv10": "PV Strom-10",
  "solis.10001.iPv11": "PV Strom-11",
  "solis.10001.iPv12": "PV Strom-12",
  "solis.10001.iPv13": "PV Strom-13",
  "solis.10001.iPv14": "PV Strom-14",
  "solis.10001.iPv15": "PV Strom-15",
  "solis.10001.iPv16": "PV Strom-16",
  "solis.10001.iPv17": "PV Strom-17",
  "solis.10001.iPv18": "PV Strom-18",
  "solis.10001.iPv19": "PV Strom-19",
  "solis.10001.iPv20": "PV Strom-20",
  "solis.10001.iPv21": "PV Strom-21",
  "solis.10001.iPv22": "PV Strom-22",
  "solis.10001.iPv23": "PV Strom-23",
  "solis.10001.iPv24": "PV Strom-24",
  "solis.10001.iPv25": "PV Strom-25",
  "solis.10001.iPv26": "PV Strom-26",
  "solis.10001.iPv27": "PV Strom-27",
  "solis.10001.iPv28": "PV Strom-28",
  "solis.10001.iPv29": "PV Strom-29",
  "solis.10001.iPv30": "PV Strom-30",
  "solis.10001.iPv31": "PV Strom-31",
  "solis.10001.iPv32": "PV Strom-32",
  "solis.10001.uPv1": "PV-Spannung-1",
  "solis.10001.uPv2": "PV-Spannung-2",
  "solis.10001.uPv3": "PV-Spannung-3",
  "solis.10001.uPv4": "PV-Spannung-4",
  "solis.10001.uPv5": "PV-Spannung-5",
  "solis.10001.uPv6": "PV-Spannung-6",
  "solis.10001.uPv7": "PV-Spannung-7",
  "solis.10001.uPv8": "PV-Spannung-8",
  "solis.10001.uPv9": "PV-Spannung-9",
  "solis.10001.uPv10": "PV-Spannung-10",
  "solis.10001.uPv11": "PV-Spannung-11",
  "solis.10001.uPv12": "PV-Spannung-12",
  "solis.10001.uPv13": "PV-Spannung-13",
  "solis.10001.uPv14": "PV-Spannung-14",
  "solis.10001.uPv15": "PV-Spannung-15",
  "solis.10001.uPv16": "PV-Spannung-16",
  "solis.10001.uPv17": "PV-Spannung-17",
  "solis.10001.uPv18": "PV-Spannung-18",
  "solis.10001.uPv19": "PV-Spannung-19",
  "solis.10001.uPv20": "PV-Spannung-20",
  "solis.10001.uPv21": "PV-Spannung-21",
  "solis.10001.uPv22": "PV-Spannung-22",
  "solis.10001.uPv23": "PV-Spannung-23",
  "solis.10001.uPv24": "PV-Spannung-24",
  "solis.10001.uPv25": "PV-Spannung-25",
  "solis.10001.uPv26": "PV-Spannung-26",
  "solis.10001.uPv27": "PV-Spannung-27",
  "solis.10001.uPv28": "PV-Spannung-28",
  "solis.10001.uPv29": "PV-Spannung-29",
  "solis.10001.uPv30": "PV-Spannung-30",
  "solis.10001.uPv31": "PV-Spannung-31",
  "solis.10001.uPv32": "PV-Spannung-32",
  "solis.10001.pow1": "PV Leistung-1",
  "solis.10001.pow2": "PV Leistung-2",
  "solis.10001.pow3": "PV Leistung-3",
  "solis.10001.pow4": "PV Leistung-4",
  "solis.10001.pow5": "PV Leistung-5",
  "solis.10001.pow6": "PV Leistung-6",
  "solis.10001.pow7": "PV Leistung-7",
  "solis.10001.pow8": "PV Leistung-8",
  "solis.10001.pow9": "PV Leistung-9",
  "solis.10001.pow10": "PV Leistung-10",
  "solis.10001.pow11": "PV Leistung-11",
  "solis.10001.pow12": "PV Leistung-12",
  "solis.10001.pow13": "PV Leistung-13",
  "solis.10001.pow14": "PV Leistung-14",
  "solis.10001.pow15": "PV Leistung-15",
  "solis.10001.pow16": "PV Leistung-16",
  "solis.10001.pow17": "PV Leistung-17",
  "solis.10001.pow18": "PV Leistung-18",
  "solis.10001.pow19": "PV Leistung-19",
  "solis.10001.pow20": "PV Leistung-20",
  "solis.10001.pow21": "PV Leistung-21",
  "solis.10001.pow22": "PV Leistung-22",
  "solis.10001.pow23": "PV Leistung-23",
  "solis.10001.pow24": "PV Leistung-24",
  "solis.10001.pow25": "PV Leistung-25",
  "solis.10001.pow26": "PV Leistung-26",
  "solis.10001.pow27": "PV Leistung-27",
  "solis.10001.pow28": "PV Leistung-28",
  "solis.10001.pow29": "PV Leistung-29",
  "solis.10001.pow30": "PV Leistung-30",
  "solis.10001.pow31": "PV Leistung-31",
  "solis.10001.pow32": "PV Leistung-32",
  "solis.10001.inverterTemperature": "Temperatur des Wechselrichters(℃)",
  "solis.10001.acOutputType": "AC-Ausgangspegel",
  "solis.10001.dcInputType": "Anzahl der DC-Eingangskanäle",
  "solis.10001.powerFactor": "Leistungsfaktor ",
  "solis.10001.batteryPower": "Leistung der Batterie",
  "solis.10001.batteryPowerPec": "Prozentsatz der Batterieleistung",
  "solis.10001.batteryCapacitySoc": "Batterie SOC",
  "solis.10001.batteryHealthSoh": "Batterie SOH",
  "solis.10001.socDischargeSet": "SOC Überentladung",
  "solis.10001.socChargingSet": "Leistungsstarkes Laden SOC",
  "solis.10001.batteryType": "Batteriemodell",
  "solis.10001.batteryVoltage": "Batteriespannung",
  "solis.10001.batteryCurrent": "Stromstärke der Batterie",
  "solis.10001.batteryTodayChargeEnergy": "Tägliche Batterieladekapazität",
  "solis.10001.batteryMonthChargeEnergy": "Monatliche Batterieladekapazität",
  "solis.10001.batteryYearChargeEnergy": "Jährliche Batterieladekapazität",
  "solis.10001.batteryTotalChargeEnergy": "Gesamtladekapazität der Batterie",
  "solis.10001.batteryTodayDischargeEnergy": "Tägliche Batterieentladekapazität",
  "solis.10001.batteryMonthDischargeEnergy": "Monatliche Batterieentladekapazität",
  "solis.10001.batteryYearDischargeEnergy": "Jährliche Batterieentladekapazität",
  "solis.10001.batteryTotalDischargeEnergy": "Gesamte Batterieentladung",
  "solis.10001.gridPurchasedTodayEnergy": "Täglicher Stromverbrauch aus dem Stromnetz",
  "solis.10001.gridPurchasedMonthEnergy": "Monatlicher Strombezug aus dem Stromnetz",
  "solis.10001.gridPurchasedYearEnergy": "Jährlicher Strombezug aus dem Stromnetz",
  "solis.10001.gridPurchasedTotalEnergy": "Gesamter Strombezug aus dem Stromnetz",
  "solis.10001.gridSellTodayEnergy": "Täglicher Stromverkauf des Stromnetzes",
  "solis.10001.gridSellMonthEnergy": "Monatlicher Stromverkauf des Stromnetzes",
  "solis.10001.gridSellYearEnergy": "Jährlicher Stromverkauf aus dem Stromnetz",
  "solis.10001.gridSellTotalEnergy": "Gesamter Stromverkauf des Stromnetzes",
  "solis.10001.familyLoadPower": "Haushaltslaststrom",
  "solis.10001.bypassLoadPower": "Bypass-Lastleistung",
  "solis.10001.pSum": "Gesamtwirkleistung des Stromnetzes",
  "solis.10001.psumPec": "Prozentualer Anteil an der Gesamtwirkleistung des Stromnetzes",
  "solis.10001.homeLoadTodayEnergy": "Last Tagesverbrauch",
  "solis.10001.homeLoadTotalEnergy": "Gesamtverbrauch der Last",
  "solis.10001.model": "Wechselrichter-Modell",
  "solis.10001.type": "Typ des Wechselrichters",
  "solis.10001.stateExceptionFlag": "Wechselrichter Offline-Status",
  "solis.10001.productModel": "Produktmodell",
  "solis.10001.nationalStandards": "Staatliche Netznormen",
  "solis.10001.version": "Software-Version des Wechselrichters",
  "solis.10001.reactivePower": "Wechselrichter-Blindleistung",
  "solis.10001.apparentPower": "Scheinleistung des Wechselrichters",
  "solis.10001.dcPac": "Gesamte DC-Eingangsleistung",
  "solis.10001.updateShelfEndTime": "Garantie-Endzeit",
  "solis.10001.iA": "Strom von Zählers A",
  "solis.10001.uA": "Spannung von Zähler A",
  "solis.10001.pA": "Leistung von Zähler A",
  "solis.10001.aLookedPower": "Scheinleistung von Zähler A",
  "solis.10001.aReactivePower": "Blindleistung des Zählers A",
  "solis.10001.aphasePowerFactor": "Wirkleistung des Zählers A",
  "solis.10001.averagePowerFactor": "Leistungsfaktor von Zähler A",
  "solis.10001.iB": "Strom von Zähler B",
  "solis.10001.uB": "Spannung von Zähler B",
  "solis.10001.pB": "Leistung des Stromzählers B",
  "solis.10001.bLookedPower": "Scheinleistung von Zähler B",
  "solis.10001.bReactivePower": "Blindleistung von Zähler B",
  "solis.10001.bphasePowerFactor": "Wirkleistung von Zähler B",
  "solis.10001.bveragePowerFactor": "Leistungsfaktor von Zähler B",
  "solis.10001.iC": "Elektrizitätszähler C Strom",
  "solis.10001.uC": "Spannung von Zähler C",
  "solis.10001.pC": "Leistung Stromzähler C",
  "solis.10001.cLookedPower": "Scheinleistung von Zähler C",
  "solis.10001.cReactivePower": "Blindleistung des Zählers C",
  "solis.10001.cphasePowerFactor": "Wirkleistung des Zählers C",
  "solis.10001.cveragePowerFactor": "Leistungsfaktor des Zählers C",
  "jl_param_ctrl_name_ChargeTimeSlot1Switch": "Ladezeitfenster 1 Schalter",
  "jl_param_ctrl_name_ChargeTimeSlot1": "Ladezeitfenster 1",
  "jl_param_ctrl_name_SOC1": "SOC 1",
  "jl_param_ctrl_name_ChargeCurrent1": "Ladestrom 1",
  "jl_param_ctrl_name_ChargeTimeSlot2Switch": "Ladezeit Slot 2 Schalter",
  "jl_param_ctrl_name_ChargeTimeSlot2": "Ladezeitfenster 2",
  "jl_param_ctrl_name_SOC2": "SOC 2",
  "jl_param_ctrl_name_ChargeCurrent2": "Ladestrom 2",
  "jl_param_ctrl_name_ChargeTimeSlot3Switch": "Ladezeit Slot 3 Schalter",
  "jl_param_ctrl_name_ChargeTimeSlot3": "Ladezeitfenster 3",
  "jl_param_ctrl_name_SOC3": "SOC 3",
  "jl_param_ctrl_name_ChargeCurrent3": "Ladestrom 3",
  "jl_param_ctrl_name_ChargeTimeSlot4Switch": "Ladezeit Slot 4 Schalter",
  "jl_param_ctrl_name_ChargeTimeSlot4": "Ladezeitfenster 4",
  "jl_param_ctrl_name_SOC4": "SOC 4",
  "jl_param_ctrl_name_ChargeCurrent4": "Ladestrom 4",
  "jl_param_ctrl_name_ChargeTimeSlot5Switch": "Ladezeitfenster 5 Schalter",
  "jl_param_ctrl_name_ChargeTimeSlot5": "Ladezeitfenster 5",
  "jl_param_ctrl_name_SOC5": "SOC 5",
  "jl_param_ctrl_name_ChargeCurrent5": "Ladestrom 5",
  "jl_param_ctrl_name_ChargeTimeSlot6Switch": "Ladezeit Slot 6 Schalter",
  "jl_param_ctrl_name_ChargeTimeSlot6": "Ladezeitfenster 6",
  "jl_param_ctrl_name_SOC6": "SOC 6",
  "jl_param_ctrl_name_ChargeCurrent6": "Ladestrom 6",
  "jl_param_ctrl_name_DischargeTimeSlot1Switch": "Entladezeit Slot 1 Schalter",
  "jl_param_ctrl_name_DischargeTimeSlot1": "Ablaufzeit 1",
  "jl_param_ctrl_name_DischargeCurrent1": "Entladestrom 1",
  "jl_param_ctrl_name_DischargeTimeSlot2Switch": "Entladezeit Slot 2 Schalter",
  "jl_param_ctrl_name_DischargeTimeSlot2": "Ablaufzeit 2",
  "jl_param_ctrl_name_DischargeCurrent2": "Entladestrom 2",
  "jl_param_ctrl_name_DischargeTimeSlot3Switch": "Entladezeit Slot 3 Schalter",
  "jl_param_ctrl_name_DischargeTimeSlot3": "Ablaufzeit 3",
  "jl_param_ctrl_name_DischargeCurrent3": "Entladestrom 3",
  "jl_param_ctrl_name_DischargeTimeSlot4Switch": "Entladezeit Slot 4 Schalter",
  "jl_param_ctrl_name_DischargeTimeSlot4": "Ablaufzeit 4",
  "jl_param_ctrl_name_DischargeCurrent4": "Entladestrom 4",
  "jl_param_ctrl_name_DischargeTimeSlot5Switch": "Entladezeit Slot 5 Schalter",
  "jl_param_ctrl_name_DischargeTimeSlot5": "Ablaufzeit 5",
  "jl_param_ctrl_name_DischargeCurrent5": "Entladestrom 5",
  "jl_param_ctrl_name_DischargeTimeSlot6Switch": "Entladezeit Slot 6 Schalter",
  "jl_param_ctrl_name_DischargeTimeSlot6": "Ablaufzeit 6",
  "jl_param_ctrl_name_DischargeCurrent6": "Entladestrom 6",
  "jl_param_ctrl_note_ChargeTimeSlot1": "Es sollte keine Überschneidung mit anderen starken Lade- und Entladezeiten geben",
  "jl_param_ctrl_note_SOC1": "Bereich: Über Entladung SOC~100%",
  "jl_param_ctrl_note_ChargeTimeSlot2": "Es sollte keine Überschneidung mit anderen starken Lade- und Entladezeiten geben",
  "jl_param_ctrl_note_SOC2": "Bereich: Über Entladung SOC~100%",
  "jl_param_ctrl_note_ChargeTimeSlot3": "Es sollte keine Überschneidung mit anderen starken Lade- und Entladezeiten geben",
  "jl_param_ctrl_note_SOC3": "Bereich: Über Entladung SOC~100%",
  "jl_param_ctrl_note_ChargeTimeSlot4": "Es sollte keine Überschneidung mit anderen starken Lade- und Entladezeiten geben",
  "jl_param_ctrl_note_SOC4": "Bereich: Über Entladung SOC~100%",
  "jl_param_ctrl_note_ChargeTimeSlot5": "Es sollte keine Überschneidung mit anderen starken Lade- und Entladezeiten geben",
  "jl_param_ctrl_note_SOC5": "Bereich: Über Entladung SOC~100%",
  "jl_param_ctrl_note_ChargeTimeSlot6": "Es sollte keine Überschneidung mit anderen starken Lade- und Entladezeiten geben",
  "jl_param_ctrl_note_SOC6": "Bereich: Über Entladung SOC~100%",
  "jl_param_ctrl_note_DischargeTimeSlot1": "Es sollte keine Überschneidung mit anderen starken Lade- und Entladezeiten geben",
  "jl_param_ctrl_note_DischargeTimeSlot2": "Es sollte keine Überschneidung mit anderen starken Lade- und Entladezeiten geben",
  "jl_param_ctrl_note_DischargeTimeSlot3": "Es sollte keine Überschneidung mit anderen starken Lade- und Entladezeiten geben",
  "jl_param_ctrl_note_DischargeTimeSlot4": "Es sollte keine Überschneidung mit anderen starken Lade- und Entladezeiten geben",
  "jl_param_ctrl_note_DischargeTimeSlot5": "Es sollte keine Überschneidung mit anderen starken Lade- und Entladezeiten geben",
  "jl_param_ctrl_note_DischargeTimeSlot6": "Es sollte keine Überschneidung mit anderen starken Lade- und Entladezeiten geben",
  "device.category.collecting.box": "Kombinationskasten",
  "device.category.energy.storage": "Gesamtstromspeichercontroller",
  "ywt.65323.runStatus": "Betriebszustand",
  "ywt.65323.faultStatus1": "Fehlerstatus 1",
  "ywt.65323.faultStatus2": "Fehlerstatus 2",
  "ywt.65323.warningStatus": "Alarmstatus",
  "ywt.65323.relayStatus": "Relaisstatus",
  "ywt.65323.inverterTemperature": "Wechselrichtertemperatur(℃)",
  "ywt.65323.dcTemperature": "Gleichstromtemperatur(℃)",
  "ywt.65323.drmStatus": "DRM-Status",
  "ywt.65323.mpptTemperature": "MPPT-Temperatur(℃)",
  "ywt.65323.gridVoltageAB": "Netzspannung AB",
  "ywt.65323.gridVoltageBC": "Netzspannung BC",
  "ywt.65323.gridVoltageCA": "Netzspannung CA",
  "ywt.65323.gridCurrentA": "Netzstrom A",
  "ywt.65323.gridCurrentB": "Netzstrom B",
  "ywt.65323.gridCurrentC": "Netzstrom C",
  "ywt.65323.gridFrequencyA": "Netzfrequenz A",
  "ywt.65323.gridFrequencyB": "Netzfrequenz B",
  "ywt.65323.gridFrequencyC": "Netzfrequenz C",
  "ywt.65323.gridActivePower": "Aktivstrom des Stromnetzes",
  "ywt.65323.gridAPhaseActivePower": "Aktivleistung der Phase A im Stromnetz",
  "ywt.65323.gridBPhaseActivePower": "Aktivleistung der Phase B im Stromnetz",
  "ywt.65323.gridCPhaseActivePower": "Aktivleistung der Phase C im Stromnetz",
  "ywt.65323.gridReactivePower": "Reaktivität des Stromnetzes",
  "ywt.65323.gridApparentPower": "Scheinbare Leistung des Stromnetzes",
  "ywt.65323.powerFactor": "Leistungsfaktor",
  "ywt.65323.dcComponentA": "Gleichstromkomponente A",
  "ywt.65323.dcComponentB": "Gleichstromkomponente B",
  "ywt.65323.dcComponentC": "Gleichstromkomponente C",
  "ywt.65323.phaseOrder": "Phasenfolge",
  "ywt.65323.leakageCurrent": "Leckstrom",
  "ywt.65323.clsStatus": "CLS zustand",
  "ywt.65323.clsLockNum": "CLS Sperrzeiten",
  "ywt.65323.clsLockTime": "CLS-Sperrzeit",
  "ywt.65323.returnFlowPortVoltageA": "Rücklaufanschlussspannung A",
  "ywt.65323.returnFlowPortVoltageB": "Rücklaufanschlussspannung B",
  "ywt.65323.returnFlowPortVoltageC": "Rücklaufanschlussspannung C",
  "ywt.65323.returnFlowPortCurrentA": "Port-Strom A zurückgeben",
  "ywt.65323.returnFlowPortCurrentB": "Port-Strom B zurückgeben",
  "ywt.65323.returnFlowPortCurrentC": "Port-Strom C zurückgeben",
  "ywt.65323.returnFlowPortTotalActivePower": "Gesamte aktive Leistung des Refluxports",
  "ywt.65323.returnFlowPortAPhaseActivePower": "Aktive Leistung der Phase A am Refluxport",
  "ywt.65323.returnFlowPortBPhaseActivePower": "Aktive Leistung der Phase B am Refluxport",
  "ywt.65323.returnFlowPortCPhaseActivePower": "Aktive Leistung der Phase C am Refluxport",
  "ywt.65323.returnFlowPortReactivePower": "Reaktivität des Refluxports",
  "ywt.65323.returnFlowPortApparentPower": "Scheinleistung des Rücklaufports",
  "ywt.65323.returnFlowPortFrequency": "Häufigkeit des Rücklaufports",
  "ywt.65323.returnFlowPortPowerFactor": "Leistungsfaktor des Refluxports",
  "ywt.65323.todayFeedInGridEnergy": "Tägliche Stromversorgung des Netzes",
  "ywt.65323.todayConsumeEnergy": "Täglicher Stromverbrauch",
  "ywt.65323.totalFeedInGridEnergy": "Akkumulierte Stromversorgung des Netzes",
  "ywt.65323.totalConsumeEnergy": "Akkumulierter Stromverbrauch",
  "ywt.65323.ctStatus": "Status des Stromzählers",
  "ywt.65323.ctVoltageA": "Stromzähler Spannung A",
  "ywt.65323.ctVoltageB": "Stromzähler Spannung B",
  "ywt.65323.ctVoltageC": "Stromzähler Spannung C",
  "ywt.65323.ctCurrentA": "Stromzähler Strömung A",
  "ywt.65323.ctCurrentB": "Stromzähler Strömung B",
  "ywt.65323.ctCurrentC": "Stromzähler Strömung C",
  "ywt.65323.ctTotalActivePower": "Gesamtleistung des Stromzählers",
  "ywt.65323.ctAPhaseActivePower": "Aktivleistung der Phase A des Stromzählers",
  "ywt.65323.ctBPhaseActivePower": "Aktivleistung der Phase B des Stromzählers",
  "ywt.65323.ctCPhaseActivePower": "Aktivleistung der Phase C des Stromzählers",
  "ywt.65323.ctReactivePower": "Reaktivität des Stromzählers",
  "ywt.65323.ctApparentPower": "Scheinbare Leistung des Stromzählers",
  "ywt.65323.ctFrequency": "Zählerfrequenz",
  "ywt.65323.ctPowerFactor": "Leistungsfaktor des elektrischen Zählers",
  "ywt.65323.loadVoltageA": "Lastspannung A",
  "ywt.65323.loadVoltageB": "Lastspannung B",
  "ywt.65323.loadVoltageC": "Lastspannung C",
  "ywt.65323.loadCurrentA": "Strom A laden",
  "ywt.65323.loadCurrentB": "Strom B laden",
  "ywt.65323.loadCurrentC": "Strom C laden",
  "ywt.65323.loadFrequency": "Lastfrequenz",
  "ywt.65323.loadActivePower": "Aktivleistung laden",
  "ywt.65323.loadAPhaseActivePower": "Aktive Leistung der Last A Phase",
  "ywt.65323.loadBPhaseActivePower": "Aktive Leistung der Last B Phase",
  "ywt.65323.loadCPhaseActivePower": "Aktive Leistung der Last C Phase",
  "ywt.65323.loadReactivePower": "Wirkkraft der Last",
  "ywt.65323.loadTodayConsumeEnergy": "Täglicher Stromverbrauch der Last",
  "ywt.65323.loadTotalConsumeEnergy": "Kumulierter Stromverbrauch der Last",
  "ywt.65323.pv1Voltage": "Photovoltaik 1-Spannung",
  "ywt.65323.pv2Voltage": "Photovoltaik 2-Spannung",
  "ywt.65323.pv3Voltage": "Photovoltaik 3-Spannung",
  "ywt.65323.pv4Voltage": "Photovoltaik 4-Spannung",
  "ywt.65323.pv5Voltage": "Photovoltaik 5-Spannung",
  "ywt.65323.pv6Voltage": "Photovoltaik 6-Spannung",
  "ywt.65323.pv1Current": "Photovoltaik 1-Strom",
  "ywt.65323.pv2Current": "Photovoltaik 2-Strom",
  "ywt.65323.pv3Current": "Photovoltaik 3-Strom",
  "ywt.65323.pv4Current": "Photovoltaik 4-Strom",
  "ywt.65323.pv5Current": "Photovoltaik 5-Strom",
  "ywt.65323.pv6Current": "Photovoltaik 6-Strom",
  "ywt.65323.pv1Power": "Photovoltaik 1-Leistung",
  "ywt.65323.pv2Power": "Photovoltaik 2-Leistung",
  "ywt.65323.pv3Power": "Photovoltaik 3-Leistung",
  "ywt.65323.pv4Power": "Photovoltaik 4-Leistung",
  "ywt.65323.pv5Power": "Photovoltaik 5-Leistung",
  "ywt.65323.pv6Power": "Photovoltaik 6-Leistung",
  "ywt.65323.pvTotalPower": "Photovoltaik insgesamt",
  "ywt.65323.busVoltage": "Busspannung",
  "ywt.65323.pvTodayEnergy": "Tägliche Photovoltaik-Stromerzeugung",
  "ywt.65323.pvMonthlyEnergy": "Monatliche Photovoltaik-Stromerzeugung",
  "ywt.65323.pvAnnualEnergy": "Jährliche Photovoltaik-Stromerzeugung",
  "ywt.65323.pvTotalEnergy": "Photovoltaik-Stromerzeugung insgesamt",
  "ywt.65323.negativeElectrodeInsulationImpedance": "Negative Isolationsimpedanz",
  "ywt.65323.positiveElectrodeInsulationImpedance1": "Positive Isolationsimpedanz 1",
  "ywt.65323.positiveElectrodeInsulationImpedance2": "Positive Isolationsimpedanz 2",
  "ywt.65323.positiveElectrodeInsulationImpedance3": "Positive Isolationsimpedanz 3",
  "ywt.65323.positiveElectrodeInsulationImpedance4": "Positive Isolationsimpedanz 4",
  "ywt.65323.positiveElectrodeInsulationImpedance5": "Positive Isolationsimpedanz 5",
  "ywt.65323.positiveElectrodeInsulationImpedance6": "Positive Isolationsimpedanz 6",
  "ywt.65323.batteryVoltage": "Batteriespannung",
  "ywt.65323.batteryCurrent": "Batteriestrom",
  "ywt.65323.batteryPower": "Batterieleistung",
  "ywt.65323.batterySOC": "Batterie SOC",
  "ywt.65323.batterySOH": "Batterie SOH",
  "ywt.65323.batteryStatus": "Batteriestatus",
  "ywt.65323.batChargeVoltage": "Ladespannung",
  "ywt.65323.bmsBatteryVoltage": "BMS Batteriespannung",
  "ywt.65323.bmsBatteryCurrent": "BMS Batteriestrom",
  "ywt.65323.bmsTemperature": "BMS-Temperatur(℃)",
  "ywt.65323.bmsChargeCurrentLimit": "BMS Ladestrombegrenzung",
  "ywt.65323.bmsDischargeCurrentLimit": "BMS Entladestrombegrenzung",
  "ywt.65323.batTodayChargeEnergy": "Tägliche Ladekapazität der Batterie",
  "ywt.65323.batTodayDischargeEnergy": "Tägliche Entladungskapazität der Batterie",
  "ywt.65323.batTotalChargeEnergy": "Akkumulierte Ladekapazität der Batterie",
  "ywt.65323.batTotalDischargeEnergy": "Akkumulierte Entladekapazität der Batterie",
  "ywt.65323.bmsMaxVoltage": "Höchstspannung des BMS",
  "ywt.65323.bmsMinVoltage": "Mindestspannung des BMS",
  "ywt.65323.batFaultFlag": "Batteriestörungsanzeige",
  "ywt.65323.batAlarmFlag": "Batteriewarnschild",
  "ywt.65323.bmsRequestFlag": "BMS-Anfrageflagge",
  "ywt.65323.generatorRelayStatus": "Status des Generatorrelais",
  "ywt.65323.load2GeneratorVoltageA": "Last 2/Generatorspannung A",
  "ywt.65323.load2GeneratorVoltageB": "Last 2/Generatorspannung B",
  "ywt.65323.load2GeneratorVoltageC": "Last 2/Generatorspannung C",
  "ywt.65323.load2GeneratorCurrentA": "Last 2/Generatorstrom A",
  "ywt.65323.load2GeneratorCurrentB": "Last 2/Generatorstrom B",
  "ywt.65323.load2GeneratorCurrentC": "Last 2/Generatorstrom C",
  "ywt.65323.load2GeneratorFrequency": "Last 2/Generatorfrequenz",
  "ywt.65323.load2GeneratorActivePower": "Last 2/aktive Leistung des Generators",
  "ywt.65323.load2GeneratorAPhaseActivePower": "Last 2/Generator A-Phase Aktivleistung",
  "ywt.65323.load2GeneratorBPhaseActivePower": "Last 2/Generator B-Phase Aktivleistung",
  "ywt.65323.load2GeneratorCPhaseActivePower": "Last 2/Generator C-Phase Aktivleistung",
  "ywt.65323.load2GeneratorReactivePower": "Last 2/Generator Blindleistung",
  "ywt.65323.load2GeneratorTodayConsumeEnergy": "Last 2/täglicher Stromverbrauch des Generators",
  "ywt.65323.load2GeneratorTotalConsumeEnergy": "Last 2/Kumulativer Stromverbrauch des Generators",
  "ywt.65323.load2GeneratorTodayGenerateEnergy": "Last 2/tägliche Stromerzeugung des Generators",
  "ywt.65323.load2GeneratorTotalGenerateEnergy": "Last 2/Kumulative Stromerzeugung des Generators",
  "ywt.65323.spiAutoTestResult": "Automatische SPI-Testergebnisse",
  "ywt.65323.spiAutoTestEndFlag": "SPI automatische Prüfende-Markierung",
  "ywt.65323.spiAutoTestThresholdAPhaseU1": "SPI automatische Prüfschwelle A-Phase U>>",
  "ywt.65323.spiAutoTestThresholdAPhaseU2": "SPI automatische Prüfschwelle A-Phase U>10min",
  "ywt.65323.spiAutoTestThresholdAPhaseU3": "SPI automatische Prüfschwelle A-Phase U<",
  "ywt.65323.spiAutoTestThresholdAPhaseU4": "SPI automatische Prüfschwelle A-Phase U<<",
  "ywt.65323.spiAutoTestThresholdBPhaseU1": "SPI automatische Prüfschwelle B-Phase U>>",
  "ywt.65323.spiAutoTestThresholdBPhaseU2": "SPI automatische Prüfschwelle B-Phase U>10min",
  "ywt.65323.spiAutoTestThresholdBPhaseU3": "SPI automatische Prüfschwelle B-Phase U<",
  "ywt.65323.spiAutoTestThresholdBPhaseU4": "SPI automatische Prüfschwelle B-Phase U<<",
  "ywt.65323.spiAutoTestThresholdCPhaseU1": "SPI automatische Prüfschwelle C-Phase U>>",
  "ywt.65323.spiAutoTestThresholdCPhaseU2": "SPI automatische Prüfschwelle C-Phase U>10min",
  "ywt.65323.spiAutoTestThresholdCPhaseU3": "SPI automatische Prüfschwelle C-Phase U<",
  "ywt.65323.spiAutoTestThresholdCPhaseU4": "SPI automatische Prüfschwelle C-Phase U<<",
  "ywt.65323.spiAutoTestThresholdF1": "SPI automatische Prüfschwelle F>>",
  "ywt.65323.spiAutoTestThresholdF2": "SPI automatische Prüfschwelle F>>",
  "ywt.65323.spiAutoTestThresholdF3": "Schwellenwert für automatische SPI-Prüfungen F<",
  "ywt.65323.spiAutoTestThresholdF4": "SPI automatische Prüfschwelle F<<",
  "ywt.65323.spiAutoTestTimeAPhaseU1": "SPI automatische Testzeit A Phase U>>",
  "ywt.65323.spiAutoTestTimeAPhaseU2": "SPI automatische Testzeit A Phase U>10 Minuten",
  "ywt.65323.spiAutoTestTimeAPhaseU3": "SPI automatische Testzeit A Phase U<",
  "ywt.65323.spiAutoTestTimeAPhaseU4": "SPI automatische Testzeit A Phase U<<",
  "ywt.65323.spiAutoTestTimeBPhaseU1": "SPI automatische Prüfzeit B Phase U>>",
  "ywt.65323.spiAutoTestTimeBPhaseU2": "SPI automatische Prüfzeit B Phase U>10 Minuten",
  "ywt.65323.spiAutoTestTimeBPhaseU3": "SPI automatische Prüfzeit B Phase U<",
  "ywt.65323.spiAutoTestTimeBPhaseU4": "SPI automatische Testzeit B Phase U<<",
  "ywt.65323.spiAutoTestTimeCPhaseU1": "SPI automatische Prüfzeit C Phase U>>",
  "ywt.65323.spiAutoTestTimeCPhaseU2": "SPI automatische Testzeit C Phase U>10min",
  "ywt.65323.spiAutoTestTimeCPhaseU3": "SPI automatische Prüfzeit C Phase U<",
  "ywt.65323.spiAutoTestTimeCPhaseU4": "SPI automatische Testzeit C Phase U<<",
  "ywt.65323.spiAutoTestTimeF1": "SPI automatische Prüfzeit F>>",
  "ywt.65323.spiAutoTestTimeF2": "SPI automatische Prüfzeit F>",
  "ywt.65323.spiAutoTestTimeF3": "SPI automatische Prüfzeit F<",
  "ywt.65323.spiAutoTestTimeF4": "SPI automatische Prüfzeit F<<",
  "mini.65290.stOV_Vgrid": "Netzseitiger Spannungsüberspannungsschutz",
  "mini.65290.stUV_Vgrid": "Netzseitiger Spannungsunterspannungsschutz",
  "mini.65290.stOV_Fgrid": "Überfrequenzschutz der netzseitigen Spannung",
  "mini.65290.stUV_Fgrid": "Unterfrequenzschutz der netzseitigen Spannung",
  "mini.65290.stOV_Temp": "Überhitzungsschutz für Wechselrichter",
  "mini.65290.stHW_Fault": "Schutz der Wechselrichterhardware",
  "mini.65290.stErrOP_Relay": "Abnormaler Schutz des netzseitigen Relais",
  "mini.65290.stErrAccess_EEPROM": "EEPROM-Zugangsausnahme",
  "mini.65290.stAbnorm_Ris": "Abnormale Isolationsimpedanz",
  "mini.65290.Vacrms": "Effektiver Wert der netzseitigen Spannung",
  "mini.65290.Iacrms": "Effektiver Wert des netzseitigen Stroms",
  "mini.65290.Fgrid": "Netzseitige Frequenz",
  "mini.65290.Temperature": "Betriebstemperatur des Wechselrichters(℃)",
  "mini.65290.stPV1_UV": "PV-Eingang 1 Unterspannung",
  "mini.65290.stPV1_OV": "PV-Eingang 1 Überspannung",
  "mini.65290.stRes1": "Reservezustand 1",
  "mini.65290.Vpv1": "PV1 Eingangsspannung",
  "mini.65290.Ipv1": "PV1 Eingangsstrom",
  "mini.65290.Energy_PV1": "PV1 kumulative Stromerzeugung",
  "mini.65290.stPV2_UV": "PV-Eingang 2 Unterspannung",
  "mini.65290.stPV2_OV": "PV-Eingang 2 Überspannung",
  "mini.65290.stRes2": "Reservestaat 2",
  "mini.65290.Vpv2": "PV2 Eingangsspannung",
  "mini.65290.Ipv2": "PV2 Eingangsstrom",
  "mini.65290.Energy_PV2": "PV2 kumulative Stromerzeugung",
  "mini.65290.stPV3_UV": "PV-Eingang 3 Unterspannung",
  "mini.65290.stPV3_OV": "PV-Eingang 3 Überspannung",
  "mini.65290.stRes3": "Reservezustand 3",
  "mini.65290.Vpv3": "PV3 Eingangsspannung",
  "mini.65290.Ipv3": "PV3 Eingangsstrom",
  "mini.65290.Energy_PV3": "PV3 kumulative Stromerzeugung",
  "mini.65290.stPV4_UV": "PV-Eingang 4 Unterspannung",
  "mini.65290.stPV4_OV": "PV-Eingang 4 Überspannung",
  "mini.65290.stRes4": "Reservezustand 4",
  "mini.65290.Vpv4": "PV4 Eingangsspannung",
  "mini.65290.Ipv4": "PV4 Eingangsstrom",
  "mini.65290.Energy_PV4": "PV4 kumulative Stromerzeugung",
  "mini.65290.stPV5_UV": "PV-Eingang 5 Unterspannung",
  "mini.65290.stPV5_OV": "PV-Eingang 5 Überspannung",
  "mini.65290.stRes5": "Reservezustand 5",
  "mini.65290.Vpv5": "PV5 Eingangsspannung",
  "mini.65290.Ipv5": "PV5 Eingangsstrom",
  "mini.65290.Energy_PV5": "PV5 kumulative Stromerzeugung",
  "mini.65290.stPV6_UV": "PV-Eingang 6 Unterspannung",
  "mini.65290.stPV6_OV": "PV Eingang 6 Überspannung",
  "mini.65290.stRes6": "Reservezustand 6",
  "mini.65290.Vpv6": "PV6 Eingangsspannung",
  "mini.65290.Ipv6": "PV6 Eingangsstrom",
  "mini.65290.Energy_PV6": "PV6 kumulative Stromerzeugung",
  "mini.65290.StINVTPOWERON": "Betriebsstatus des Wechselrichters",
  "mini.65290.stRelayoN": "Relais im Zustand",
  "mini.65290.activePower": "Wirkkraft",
  "mini.65290.Res10": "Behalten 10",
  "mini.65290.Res11": "Reservierung 11",
  "mini.65290.Res12": "Selbstbehalt 12",
  "mini.65290.Res13": "Selbstbehalt 13",
  "mini.65290.Res14": "Selbstbehalt 14",
  "mini.65290.Res15": "Selbstbehalt 15",
  "mini.65290.Res16": "Reservierung 16",
  "mini.65290.Res17": "Reservierung 17",
  "mini.65290.Res18": "Reservierung 18",
  "mini.65290.Res19": "Reservierung 19",
  "mini.65290.Res20": "Einbehaltung von 20",
  "mini.65290.Un": "Effektivwert der Nennspannung für netzgekoppeltes Stromnetz",
  "mini.65290.Fn": "Nennfrequenz für netzgekoppeltes Stromnetz",
  "mini.65290.Pn": "Maximale netzgekoppelte Wirkleistung",
  "mini.65290.Irmsmax": "Maximaler netzgekoppelter Strom-Effektivwert",
  "mini.65290.Vmpptmin": "Minimale mppt-Spannung",
  "mini.65290.Vmpptmax": "Maximale mppt-Spannung",
  "mini.65290.Powpvmax": "Maximale PV-Eingangsleistung",
  "mini.65290.Ipvmax": "Maximaler PV-Eingangsstrom",
  "mini.65290.Tempmax": "Maximale Betriebstemperatur(℃)",
  "mini.65290.Firmware_ver1": "Firmware Version 1",
  "mini.65290.Firmware_ver2": "Firmware Version 2",
  "mini.65290.Firmware_ver3": "Firmware Version 3",
  "mini.65290.UpdateProgress": "Fortschritt beim Upgrade",
  "mini.65290.DeviceID": "Seriennummer der Ausrüstung",
  "storage.v2.65284.pvInputVoltage": "Photovoltaik-Eingangsspannung",
  "storage.v2.65284.pvGenerartion": "Aktuelle Stromerzeugung aus Photovoltaik",
  "storage.v2.65284.pvEnergyDay": "Akkumulierte tägliche Photovoltaik-Stromerzeugung",
  "storage.v2.65284.pvEnergyTotal": "Akkumulierte Photovoltaik-Stromerzeugung",
  "storage.v2.65284.batteryVoltage": "Batteriespannung",
  "storage.v2.65284.batteryCurrent": "Lade- und Entladestrom der Batterie",
  "storage.v2.65284.dcOutputCurrent": "Gleichstrom-Ausgangsstrom",
  "storage.v2.65284.dcOutputPower": "Gleichstrom-Ausgangsleistung",
  "storage.v2.65284.ratedCapacity": "Nennkapazität der Batterie",
  "storage.v2.65284.batterySOC": "Restkapazität der Batterie SOC",
  "storage.v2.65284.cycleNumber": "Anzahl der Lade- und Entladezyklen",
  "storage.v2.65284.internalTemp": "Innentemperatur des Systems(℃)",
  "storage.v2.65284.heatsinkTemp": "Heizkörpertemperatur(℃)",
  "storage.v2.65284.batteryTemp1": "Batteriepacktemperatur 1(℃)",
  "storage.v2.65284.batteryTemp2": "Batteriepacktemperatur 2(℃)",
  "storage.v2.65284.BMSTemp": "BMS-Temperatur(℃)",
  "storage.v2.65284.cellVoltage1": "Spannung der Zelle 1",
  "storage.v2.65284.cellVoltage2": "Spannung der Zelle 2",
  "storage.v2.65284.cellVoltage3": "Spannung der Zelle 3",
  "storage.v2.65284.cellVoltage4": "Spannung der Zelle 4",
  "storage.v2.65284.cellVoltage5": "Spannung der Zelle 5",
  "storage.v2.65284.cellVoltage6": "Spannung der Zelle 6",
  "storage.v2.65284.cellVoltage7": "Spannung der Zelle 7",
  "storage.v2.65284.cellVoltage8": "Spannung der Zelle 8",
  "storage.v2.65284.cellVoltage9": "Spannung der Zelle 9",
  "storage.v2.65284.cellVoltage10": "Spannung der Zelle 10",
  "storage.v2.65284.cellVoltage11": "Spannung der Zelle 11",
  "storage.v2.65284.cellVoltage12": "Spannung der Zelle 12",
  "storage.v2.65284.cellVoltage13": "Spannung der Zelle 13",
  "storage.v2.65284.cellVoltage14": "Spannung der Zelle 14",
  "storage.v2.65284.cellVoltage15": "Spannung der Zelle 15",
  "storage.v2.65284.cellVoltage16": "Spannung der Zelle 16",
  "storage.v2.65284.BMSWorkingStatus": "Arbeitsstatus des BMS",
  "storage.v2.65284.runningStatus": "Der Betriebszustand des Geräts",
  "storage.v2.65284.time": "Ausrüstung Zeit",
  "storage.v2.65284.invPower": "Mikro-Rückwärtsleistung",
  "storage.s3.65292.batVoltage": "Batteriestrom",
  "storage.s3.65292.batCurrent": "Batteriespannung",
  "storage.s3.65292.batChargePower": "Batterieladestrom",
  "storage.s3.65292.mainsChargeCurrent": "Kommunaler Ladestrom",
  "storage.s3.65292.pvChargeCurrent": "PV-Ladestrom",
  "storage.s3.65292.pv1Voltage": "Spannung des ersten Photovoltaikmoduls",
  "storage.s3.65292.pv1Current": "Stromstärke des ersten Photovoltaikmoduls",
  "storage.s3.65292.pv1Power": "Ausgangsleistung des ersten Fotovoltaikmoduls",
  "storage.s3.65292.pv2Voltage": "Spannung des zweiten Fotovoltaikmoduls",
  "storage.s3.65292.pv2Current": "Strom des zweiten Fotovoltaikmoduls",
  "storage.s3.65292.pv2Power": "Ausgangsleistung des zweiten Fotovoltaikmoduls",
  "storage.s3.65292.aPhaseVoltage": "A-Phasen-Ausgangsspannung",
  "storage.s3.65292.aPhaseCurrent": "A-Phasen-Ausgangsstrom",
  "storage.s3.65292.aPhaseActivePower": "A-Phasen-Ausgangs-Wirkleistung",
  "storage.s3.65292.aPhaseApparentPower": "A-Phasen-Ausgangsscheinleistung",
  "storage.s3.65292.bPhaseVoltage": "B-Phasen-Ausgangsspannung",
  "storage.s3.65292.bPhaseCurrent": "B-Phasen-Ausgangsstrom",
  "storage.s3.65292.bPhaseActivePower": "B-Phasen-Ausgangs-Wirkleistung",
  "storage.s3.65292.bPhaseApparentPower": "B-Phasen-Ausgangsscheinleistung",
  "storage.s3.65292.cPhaseVoltage": "C-Phasen-Ausgangsspannung",
  "storage.s3.65292.cPhaseCurrent": "C-Phasen-Ausgangsstrom",
  "storage.s3.65292.cPhaseActivePower": "C-Phasen-Ausgangs-Wirkleistung",
  "storage.s3.65292.cPhaseApparentPower": "C-Phasen-Ausgangsscheinleistung",
  "storage.s3.65292.allActivePower": "Ausgangswirkleistung der gesamten Maschine",
  "storage.s3.65292.allApparentPower": "Gesamtausgangsscheinleistung",
  "storage.s3.65292.aChargeActivePower": "Wirkleistung der A-Phasen-Stromerzeugung",
  "storage.s3.65292.bChargeActivePower": "Wirkleistung der B-Phasen-Stromerzeugung",
  "storage.s3.65292.cChargeActivePower": "Wirkleistung der C-Phasen-Stromerzeugung",
  "storage.s3.65292.mainsApVoltage": "Spannung der Versorgungsphase A",
  "storage.s3.65292.mainsApCurrent": "Versorgungsphase B Strom",
  "storage.s3.65292.mainsBpVoltage": "Spannung der Versorgungsphase B",
  "storage.s3.65292.mainsBpCurrent": "Versorgungsphase B Strom",
  "storage.s3.65292.mainsCpVoltage": "Spannung der Versorgungsphase C",
  "storage.s3.65292.mainsCpCurrent": "Versorgungsphase C Strom",
  "storage.s3.65292.mainsApPower": "Versorgungsphase A Leistung",
  "storage.s3.65292.mainsBpPower": "Versorgungsphase B Leistung",
  "storage.s3.65292.mainsCpPower": "Versorgungsphase C Leistung",
  "storage.s3.65292.onGridActivePower": "Netzgebundene Wirkleistung",
  "storage.s3.65292.homeLoadPower": "Leistung der Haushaltslast",
  "storage.s3.65292.afterLoadPower": "Backend-Lastleistung",
  "storage.s3.65292.totalLoadPower": "Gesamtlast",
  "storage.s3.65292.batPower": "Leistung der Batterie",
  "storage.s3.65292.girdDisplayPower": "Leistung der netzseitigen Anzeige",
  "storage.s3.65292.invPower": "Leistung des Wechselrichters",
  "storage.s3.65292.beforeLoadMarker": "Flagge für Lastfluss am vorderen Ende",
  "storage.s3.65292.gridMarker": "Indikator für den Energiefluss im Stromnetz",
  "storage.s3.65292.mainsMarker": "Zeichen des Marktleistungsflusses",
  "storage.s3.65292.machineOnStatus": "Status der Maschineninbetriebnahme",
  "storage.s3.65292.chargeStatus": "Ladestatus",
  "storage.s3.65292.outputStatus": "Status der Leistung",
  "storage.s3.65292.acTodayEnergy": "Tägliche AC-Stromerzeugung",
  "storage.s3.65292.batTodayChargeEnergy": "Der Ladezustand der Batterie am selben Tag",
  "storage.s3.65292.batTodayDischargeEnergy": "Entladezustand der Batterie am selben Tag",
  "storage.s3.65292.pvTodayEnergy": "PV-Stromerzeugung am selben Tag",
  "storage.s3.65292.loadTodayEnergy": "Elektrizitätsverbrauch am Tag der Belastung",
  "storage.s3.65292.mainsTodayChargeEnergy": "Ladekapazität des Stromnetzes am selben Tag",
  "storage.s3.65292.loadTodayUseMainsEnergy": "Stromverbrauch aus dem Stromnetz am Tag der Belastung",
  "storage.s3.65292.batTotalChargeEnergy": "Kumulierte Ladekapazität der Batterie",
  "storage.s3.65292.batTotalDischargeEnergy": "Kumulierte Entladekapazität der Batterie",
  "storage.s3.65292.pvTotalEnergy": "Kumulierte PV-Stromerzeugung",
  "storage.s3.65292.loadTotalEnergy": "Kumulierter Stromverbrauch der Last",
  "storage.s3.65292.mainsTotalChargeEnergy": "Kumulierte Ladekapazität des Netzstroms",
  "storage.s3.65292.loadTotalUseMainsEnergy": "Kumulierter Laststromverbrauch aus dem Stromnetz",
  "storage.s3.65292.acTotalEnergy": "Kumulierte AC-Stromerzeugung",
  "storage.s3.65292.mainsChargeTimerSet": "Zeitgesteuerte Netzladefreigabe",
  "storage.s3.65292.batChargeTimerSet": "Zeitgesteuerte Batteriefreigabe",
  "storage.s3.65292.softWareVersion3": "Software Versionsnummer 3",
  "storage.s3.65292.aPhaseOnGridPower": "Auf der A-Phasen-Netzseite ist Strom vorhanden",
  "storage.s3.65292.bPhaseOnGridPower": "Auf der B-Phasen-Netzseite ist Strom vorhanden",
  "storage.s3.65292.cPhaseOnGridPower": "Auf der C-Phasen-Netzseite ist Strom vorhanden",
  "storage.s3.65292.aPhaseOnGridCurrent": "Strom auf der A-Phasen-Netzseite",
  "storage.s3.65292.bPhaseOnGridCurrent": "Strom auf der B-Phasen-Netzseite",
  "storage.s3.65292.cPhaseOnGridCurrent": "Strom auf der C-Phasen-Netzseite",
  "storage.s3.65292.batTemp": "Batterietemperatur(℃)",
  "storage.s3.65292.softWareVersion1": "Inverter Version",
  "storage.s3.65292.softWareVersion2": "BMS Version",
  "storage.s3.65292.softWareVersion4": "Controller Version",
  "storage.s3.65292.batChargeCur": "Batterieanforderung Ladestrom",
  "storage.s3.65292.batSurplusCapacity": "Verbleibende Batteriekapazität",
  "storage.s3.65292.batRatedCapacity": "Nennkapazität der Batterie",
  "storage.s3.65292.batMaxPressure": "Maximale Druckdifferenz der einzelnen Batterie",
  "storage.s3.65292.batSoh": "SOH",
  "storage.s3.65292.batChargeLimitVol": "Grenzwert der Batterieladespannung",
  "storage.s3.65292.bat1CellVol": "Zellenspannung 1",
  "storage.s3.65292.bat2CellVol": "Zellenspannung 2",
  "storage.s3.65292.bat3CellVol": "Zellenspannung 3",
  "storage.s3.65292.bat4CellVol": "Zellenspannung 4",
  "storage.s3.65292.bat5CellVol": "Zellenspannung 5",
  "storage.s3.65292.bat6CellVol": "Zellenspannung 6",
  "storage.s3.65292.bat7CellVol": "Zellenspannung 7",
  "storage.s3.65292.bat8CellVol": "Zellenspannung 8",
  "storage.s3.65292.bat9CellVol": "Zellenspannung 9",
  "storage.s3.65292.bat10CellVol": "Zellenspannung 10",
  "storage.s3.65292.bat11CellVol": "Zellenspannung 11",
  "storage.s3.65292.bat12CellVol": "Zellenspannung 12",
  "storage.s3.65292.bat13CellVol": "Zellenspannung 13",
  "storage.s3.65292.bat14CellVol": "Zellenspannung 14",
  "storage.s3.65292.bat15CellVol": "Zellenspannung 15",
  "storage.s3.65292.bat16CellVol": "Zellenspannung 16",
  "storage.s3.65292.batStatus": "Zustand der Batterie",
  "storage.s3.65292.pvVoltageLevel": "Offline-Alarm",
  "storage.s3.65292.pvRadiatorTemp": "PV-Strahlertemperatur(℃)",
  "storage.s3.65292.invTemp": "Temperatur des Wechselrichters(℃)",
  "storage.s3.65292.transformerTemp": "Temperatur des Transformators(℃)",
  "storage.s3.65292.cellTemp1": "Zellentemperatur 1(℃)",
  "storage.s3.65292.cellTemp2": "Zellentemperatur 2(℃)",
  "storage.s3.65292.cellTemp3": "Zellentemperatur 3(℃)",
  "storage.s3.65292.cellTemp4": "Zellentemperatur 4(℃)",
  "storage.s3.65292.mosTemp": "MOS-Temperatur(℃)",
  "storage.s3.65292.mcuTemp": "MCU-Temperatur(℃)",
  "storage.s3.65292.msAvgTemp": "Durchschnittstemperatur von Master- und Slave-Maschinen(℃)",
  "storage.s3.65292.batSOC": "Verbleibende Batteriekapazität SOC",
  "storage.s3.65292.invSubBoardVersion": "Versionsnummer der bidirektionalen Wechselrichterplatine",
  "storage.s3.65292.batDischargeCur": "Entladestrom der Batterie",
  "storage.s3.65292.batWorkStatus": "Status des Batterieschalters",
  "storage.s3.65292.ctWorkStatus": "Status des drahtlosen CT-Schalters",
  "storage.s3.65292.socketPower1": "Steckdosenleistung 1",
  "storage.s3.65292.socketPower2": "Steckdosenleistung 2",
  "storage.s3.65292.socketPower3": "Steckdosenleistung 3",
  "storage.s3.65292.socketPower4": "Steckdosenleistung 4",
  "storage.s3.65292.socketPower5": "Steckdosenleistung 5",
  "storage.s3.65292.socketPower6": "Steckdosenleistung 6",
  "storage.s3.65292.socketPower7": "Steckdosenleistung 7",
  "storage.s3.65292.socketPower8": "Steckdosenleistung 8",
  "storage.s3.65292.socketPower9": "Steckdosenleistung 9",
  "storage.s3.65292.socketPower10": "Steckdosenleistung 10",
  "storage.s3.65292.socketPower11": "Steckdosenleistung 11",
  "storage.s3.65292.socketPower12": "Steckdosenleistung 12",
  "storage.s3.65292.socketPower13": "Steckdosenleistung 13",
  "storage.s3.65292.socketPower14": "Steckdosenleistung 14",
  "storage.s3.65292.socketPower15": "Steckdosenleistung 15",
  "storage.s3.65292.socketPower16": "Steckdosenleistung 16",
  "storage.s3.65292.outPutFreq": "Ausgangsfrequenz",
  "storage.s3.65292.mainsFreq": "Netzfrequenz",
  "storage.s3.65292.socketWorkStatus": "Anzahl der Steckdosen",
  "storage.s3.65292.time": "Ausrüstung Zeit",
  "datalog.sn": "Datenlogger SN",
  "storage.s3.65292.offlineAlarm": "Offline-Alarm",
  "storage.s3.65292.pvPower": "Photovoltaik-Leistung",
  "storage.s3.65292.deviceSn": "Seriennummer der Ausrüstung",
  "hipment.devType": "Entwicklungstyp",
  "device.voltageV": "Gerätespannung V",
  "device.electric.currentA": "Gerätestrom A",
  "device.return.port": "Port retro",
  "device.a.phase": "Läufer A",
  "device.b.phase": "Läufer B",
  "device.c.phase": "Läufer C",
  "device.electic.meter.data": "Angaben der tabelle",
  "device.voltage": "Spannung",
  "device.electric.current": "Elektrizität",
  "unc.65323.runStatus": "Betriebszustand",
  "bw_RTparam_name_TotalPower": "Gesamtleistung",
  "bw_RTparam_name_TotalYield": "Gesamtertrag",
  "bw_RTparam_name_TotalRuntime": "Gesamtbetriebszeit (PV)",
  "bw_RTparam_name_PV1Voltage": "PV1-Echtzeitspannung",
  "bw_RTparam_name_PV1Current": "PV1-Echtzeitstrom",
  "bw_RTparam_name_PV1Power": "PV1-Echtzeitleistung",
  "bw_RTparam_name_PV2Voltage": "PV2-Echtzeitspannung",
  "bw_RTparam_name_PV2Current": "PV2-Echtzeitstrom",
  "bw_RTparam_name_PV2Power": "PV2-Echtzeitleistung",
  "bw_RTparam_name_PV3Voltage": "PV3-Echtzeitspannung",
  "bw_RTparam_name_PV3Current": "PV3-Echtzeitstrom",
  "bw_RTparam_name_PV3Power": "PV3-Echtzeitleistung",
  "bw_RTparam_name_GridVoltageL1": "Netzspannung L1",
  "bw_RTparam_name_GridVoltageL2": "Netzspannung L2",
  "bw_RTparam_name_GridVoltageL3": "Netzspannung L3",
  "bw_RTparam_name_GridCurrentL1": "Netzstrom L1",
  "bw_RTparam_name_GridCurrentL2": "Netzstrom L2",
  "bw_RTparam_name_GridCurrentL3": "Netzstrom L3",
  "bw_RTparam_name_GridPowerL1": "Netz-Wirkleistung L1",
  "bw_RTparam_name_GridPowerL2": "Netz-Wirkleistung L2",
  "bw_RTparam_name_GridPowerL3": "Netz-Wirkleistung L3",
  "bw_RTparam_name_GridTotalActivePower": "Gesamte Netz-Wirkleistung",
  "bw_RTparam_name_GridFrequency": "Netzfrequenz",
  "bw_RTparam_name_ApparentPOAP_Grid": "Scheinleistung Phase A (Netz)",
  "bw_RTparam_name_ApparentPOBP_Grid": "Scheinleistung Phase B (Netz)",
  "bw_RTparam_name_ApparentPOCP_Grid": "Scheinleistung Phase C (Netz)",
  "bw_RTparam_name_ReactivePOAP_Grid": "Blindleistung Phase A (Netz)",
  "bw_RTparam_name_ReactivePOBP_Grid": "Blindleistung Phase B (Netz)",
  "bw_RTparam_name_ReactivePOCP_Grid": "Blindleistung Phase C (Netz)",
  "bw_RTparam_name_PFOA_Grid": "Leistungsfaktor Phase A (Netz)",
  "bw_RTparam_name_PFOB_Grid": "Leistungsfaktor Phase B (Netz)",
  "bw_RTparam_name_PFOC_Grid": "Leistungsfaktor Phase C (Netz)",
  "bw_RTparam_name_DailyEnergytoGrid": "Tägliche Einspeisungsenergie",
  "bw_RTparam_name_TotalEnergytoGrid": "Kumulierte Einspeisungsenergie",
  "bw_RTparam_name_DailyEnergyfromGrid": "Tägliche Bezugsenergie",
  "bw_RTparam_name_TotalEnergyfromGrid": "Kumulierte Bezugsenergie",
  "bw_RTparam_name_BatteryVoltage": "Batteriespannung",
  "bw_RTparam_name_BatteryCurrent": "Batteriestrom",
  "bw_RTparam_name_BatteryPower": "Batterieleistung",
  "bw_RTparam_name_TotalConsumption": "Gesamtverbrauch",
  "bw_RTparam_name_TotalEnergyfromBattery": "Kumulierte Entladungsenergie",
  "bw_RTparam_name_BatteryChargeFromGrid_Every": "Batterieladung aus dem Netz",
  "bw_RTparam_name_BatterySOC": "Batterie-Ladezustand (SOC)",
  "bw_RTparam_name_BatterySOH": "Batteriezustandsindex (SOH)",
  "bw_RTparam_name_Maximumtemperatureofbattery": "Maximale Batterietemperatur",
  "bw_RTparam_name_Minimumtemperatureofbattery": "Minimale Batterietemperatur",
  "bw_RTparam_name_Maximumcellvoltage": "Maximale Zellspannung",
  "bw_RTparam_name_Minimumcellvoltage": "Minimale Zellspannung",
  "bw_RTparam_name_TotalConsumptionPower": "Gesamtverbrauchsleistung",
  "bw_RTparam_name_TodayConsumption": "Tagesverbrauch",
  "bw_RTparam_name_TotalConsumptionEnergy": "Gesamter Energieverbrauch",
  "bw_RTparam_name_TotalEnergyFeedToGrid_PV": "Gesamteinspeisung ins Netz (PV)",
  "bw_RTparam_name_TotalEnergyConsumeFormGrid_PV": "Gesamtbezug aus dem Netz (PV)",
  "bw_RTparam_name_VoltageOfAPhase_PV": "Spannung Phase A (PV)",
  "bw_RTparam_name_VoltageOfBPhase_PV": "Spannung der B-Phase (PV)",
  "bw_RTparam_name_VoltageOfCPhase_PV": "Spannung der C-Phase (PV)",
  "bw_RTparam_name_CurrentOfAPhase_PV": "Strom der Phase A (PV)",
  "bw_RTparam_name_CurrentOfBPhase_PV": "Strom der B-Phase (PV)",
  "bw_RTparam_name_CurrentOfCPhase_PV": "Strom Phase C (PV)",
  "bw_RTparam_name_Frequent_PV": "Frequenz (PV)",
  "bw_RTparam_name_TotalApparentPower_PV": "Gesamtscheinleistung (PV)",
  "bw_RTparam_name_TotalActivePower_PV": "Gesamtwirkleistung (PV)",
  "bw_RTparam_name_TotalReactivePower_PV": "Gesamtblindleistung (PV)",
  "bw_RTparam_name_TotalPowerFactor_PV": "Gesamtleistungsfaktor (PV)",
  "bw_RTparam_group_Inverter": "Wechselrichter",
  "bw_RTparam_group_Grid": "Netz",
  "bw_RTparam_group_Battery": "Batterie",
  "bw_RTparam_group_Load": "Last",
  "bw_RTparam_group_PVMeter": "PV-Seitenzähler",
  "common.50100.pv1Voltage": "PV1 Spannung",
  "common.50100.pv1Current": "PV1 Strom",
  "common.50100.pv1Power": "PV1 Leistung",
  "common.50100.pv2Voltage": "PV2 Spannung",
  "common.50100.pv2Current": "PV2 Strom",
  "common.50100.pv2Power": "PV2 Leistung",
  "common.50100.pv3Voltage": "PV3 Spannung",
  "common.50100.pv3Current": "PV3 Strom",
  "common.50100.pv3Power": "PV3 Leistung",
  "common.50100.pv4Voltage": "PV4 Spannung",
  "common.50100.pv4Current": "PV4 Strom",
  "common.50100.pv4Power": "PV4 Leistung",
  "common.50100.temperature": "Temperatur(℃)",
  "common.50100.outputGridVoltage": "Ausgangsnetzspannung",
  "common.50100.outputGridCurrent": "Ausgangsnetzstrom",
  "common.50100.outputGridPower": "Ausgang Netzleistung",
  "common.50100.pv1CumulativePowerGeneration": "PV1 Kumulative Stromerzeugung",
  "common.50100.pv2CumulativePowerGeneration": "PV2 Kumulative Stromerzeugung",
  "common.50100.pv3CumulativePowerGeneration": "PV3 Kumulative Stromerzeugung",
  "common.50100.pv4CumulativePowerGeneration": "PV4 Kumulative Stromerzeugung",
  "common.50100.totalPowerGeneration": "Gesamte Stromerzeugung",
  "common.50100.wnSn": "Datenlogger Sn",
  "common.50100.wnWifiVersion": "Datenlogger Wifi Version",
  "common.50100.wnHardwareVersion": "Datenlogger Hardware Version",
  "common.50100.wnSoftwareVersion": "Datenlogger Software Version",
  "ltwn_RTparam_group_Inverter": "Wechselrichter",
  "\nbw_param_ctrl_option_OnlyEnableDischargeTimePeriodControl": "Nur Entladezeitsteuerung aktivieren",
  "plant.already.deliver": "Das Kraftwerk wurde übergeben",
  "common.50100.totalPvEnergy": "Gesamte Stromerzeugung",
  "ltcg_RTparam_name_name": "Name des Geräts",
  "ltcg_RTparam_name_out_pac": "Stromerzeugung (kW)",
  "ltcg_RTparam_name_eday": "Stromerzeugung heute (kWh)",
  "ltcg_RTparam_name_etotal": "Kumulative Stromerzeugung (kWh)",
  "ltcg_RTparam_name_status": "Staat",
  "ltcg_RTparam_name_turnon_time": "Zugriffszeit",
  "ltcg_RTparam_name_type": "Art der Ausrüstung",
  "ltcg_RTparam_name_capacity": "Leistung kw",
  "ltcg_RTparam_name_tempperature": "Temperatur",
  "ltcg_RTparam_name_creationDate": "Daten letzte Uhrzeit",
  "ltcg_RTparam_name_pac": "Stromerzeugung",
  "ltcg_RTparam_name_hTotal": "Kumulative Stromerzeugungsstunden",
  "ltcg_RTparam_name_vpv1": "Gleichspannung 1",
  "ltcg_RTparam_name_vpv2": "Gleichspannung 2",
  "ltcg_RTparam_name_vpv3": "Gleichspannung 3",
  "ltcg_RTparam_name_vpv4": "Gleichspannung 4",
  "ltcg_RTparam_name_vpv5": "Gleichspannung 5",
  "ltcg_RTparam_name_vpv6": "Gleichspannung 6",
  "ltcg_RTparam_name_vpv7": "Gleichspannung 7",
  "ltcg_RTparam_name_vpv8": "Gleichspannung 8",
  "ltcg_RTparam_name_vpv9": "Gleichspannung 9",
  "ltcg_RTparam_name_vpv10": "Gleichspannung 10",
  "ltcg_RTparam_name_vpv11": "Gleichspannung 11",
  "ltcg_RTparam_name_vpv12": "Gleichspannung 12",
  "ltcg_RTparam_name_ipv1": "Gleichstrom 1",
  "ltcg_RTparam_name_ipv2": "Gleichstrom 2",
  "ltcg_RTparam_name_ipv3": "Gleichstrom 3",
  "ltcg_RTparam_name_ipv4": "Gleichstrom 4",
  "ltcg_RTparam_name_ipv5": "Gleichstrom 5",
  "ltcg_RTparam_name_ipv6": "Gleichstrom 6",
  "ltcg_RTparam_name_ipv7": "Gleichstrom 7",
  "ltcg_RTparam_name_ipv8": "Gleichstrom 8",
  "ltcg_RTparam_name_ipv9": "Gleichstrom 9",
  "ltcg_RTparam_name_ipv10": "Gleichstrom 10",
  "ltcg_RTparam_name_ipv11": "Gleichstrom 11",
  "ltcg_RTparam_name_ipv12": "Gleichstrom 12",
  "ltcg_RTparam_name_vac1": "Wechselspannung 1",
  "ltcg_RTparam_name_vac2": "Wechselspannung 2",
  "ltcg_RTparam_name_vac3": "Wechselspannung 3",
  "ltcg_RTparam_name_iac1": "Wechselstrom 1",
  "ltcg_RTparam_name_iac2": "Wechselstrom 2",
  "ltcg_RTparam_name_iac3": "Wechselstrom 3",
  "ltcg_RTparam_name_fac1": "AC-Frequenz 1",
  "ltcg_RTparam_name_fac2": "AC-Frequenz 2",
  "ltcg_RTparam_name_fac3": "AC-Frequenz 3",
  "ltcg_RTparam_name_istr1": "String aktuell 1",
  "ltcg_RTparam_name_istr2": "String aktuell 2",
  "ltcg_RTparam_name_istr3": "String aktuell 3",
  "ltcg_RTparam_name_istr4": "String aktuell 4",
  "ltcg_RTparam_name_istr5": "String aktuell 5",
  "ltcg_RTparam_name_istr6": "String aktuell 6",
  "ltcg_RTparam_name_istr7": "String aktuell 7",
  "ltcg_RTparam_name_istr8": "String aktuell 8",
  "ltcg_RTparam_name_istr9": "String aktuell 9",
  "ltcg_RTparam_name_istr10": "String aktuell 10",
  "ltcg_RTparam_name_istr11": "String aktuell 11",
  "ltcg_RTparam_name_istr12": "String aktuell 12",
  "ltcg_RTparam_name_istr13": "String aktuell 13",
  "ltcg_RTparam_name_istr14": "String aktuell 14",
  "ltcg_RTparam_name_istr15": "String aktuell 15",
  "ltcg_RTparam_name_istr16": "String aktuell 16",
  "ltcg_RTparam_name_istr17": "String aktuell 17",
  "ltcg_RTparam_name_istr18": "String aktuell 18",
  "ltcg_RTparam_name_istr19": "String aktuell 19",
  "ltcg_RTparam_name_istr20": "String aktuell 20",
  "ltcg_RTparam_name_istr21": "String aktuell 21",
  "ltcg_RTparam_name_istr22": "String aktuell 22",
  "ltcg_RTparam_name_istr23": "String aktuell 23",
  "ltcg_RTparam_name_istr24": "String aktuell 24",
  "ltcg_RTparam_group_Inverter": "Wechselrichter",
  "city.not.exist": "Stadt existiert nicht",
  "bw_RTparam_name_BatterySN1": "Batterie1 SN",
  "bw_RTparam_name_BatterySN2": "Batterie2 SN",
  "bw_RTparam_name_BatterySN3": "Batterie3 SN",
  "bw_RTparam_name_BatterySN4": "Batterie4 SN",
  "bw_RTparam_name_BatterySN5": "Batterie5 SN",
  "bw_RTparam_name_BatterySN6": "Batterie6 SN",
  "supplier.type.tb": "Besondere Vielfalt",
  "common.50300.sn": "Seriennummer des Geräts",
  "common.50300.name": "Name des Geräts",
  "common.50300.out_pac": "Stromerzeugung (kW)",
  "common.50300.eday": "Stromerzeugung heute (kWh)",
  "common.50300.etotal": "Kumulative Stromerzeugung (kWh)",
  "common.50300.status": "Staat",
  "common.50300.turnon_time": "Zugriffszeit",
  "common.50300.type": "Art der Ausrüstung",
  "common.50300.capacity": "Leistung kw",
  "common.50300.tempperature": "Temperatur(℃)",
  "common.50300.creationDate": "Daten letzte Uhrzeit",
  "common.50300.pac": "Stromerzeugung",
  "common.50300.hTotal": "Kumulative Stromerzeugungsstunden",
  "common.50300.vpv1": "Gleichspannung 1",
  "common.50300.vpv2": "Gleichspannung 2",
  "common.50300.vpv3": "Gleichspannung 3",
  "common.50300.vpv4": "Gleichspannung 4",
  "common.50300.vpv5": "Gleichspannung 5",
  "common.50300.vpv6": "Gleichspannung 6",
  "common.50300.vpv7": "Gleichspannung 7",
  "common.50300.vpv8": "Gleichspannung 8",
  "common.50300.vpv9": "Gleichspannung 9",
  "common.50300.vpv10": "Gleichspannung 10",
  "common.50300.vpv11": "Gleichspannung 11",
  "common.50300.vpv12": "Gleichspannung 12",
  "common.50300.ipv1": "Gleichstrom 1",
  "common.50300.ipv2": "Gleichstrom 2",
  "common.50300.ipv3": "Gleichstrom 3",
  "common.50300.ipv4": "Gleichstrom 4",
  "common.50300.ipv5": "Gleichstrom 5",
  "common.50300.ipv6": "Gleichstrom 6",
  "common.50300.ipv7": "Gleichstrom 7",
  "common.50300.ipv8": "Gleichstrom 8",
  "common.50300.ipv9": "Gleichstrom 9",
  "common.50300.ipv10": "Gleichstrom 10",
  "common.50300.ipv11": "Gleichstrom 11",
  "common.50300.ipv12": "Gleichstrom 12",
  "common.50300.vac1": "Wechselspannung 1",
  "common.50300.vac2": "Wechselspannung 2",
  "common.50300.vac3": "Wechselspannung 3",
  "common.50300.iac1": "Wechselstrom 1",
  "common.50300.iac2": "Wechselstrom 2",
  "common.50300.iac3": "Wechselstrom 3",
  "common.50300.fac1": "AC-Frequenz 1",
  "common.50300.fac2": "AC-Frequenz 2",
  "common.50300.fac3": "AC-Frequenz 3",
  "common.50300.istr1": "String aktuell 1",
  "common.50300.istr2": "String aktuell 2",
  "common.50300.istr3": "String aktuell 3",
  "common.50300.istr4": "String aktuell 4",
  "common.50300.istr5": "String aktuell 5",
  "common.50300.istr6": "String aktuell 6",
  "common.50300.istr7": "String aktuell 7",
  "common.50300.istr8": "String aktuell 8",
  "common.50300.istr9": "String aktuell 9",
  "common.50300.istr10": "String aktuell 10",
  "common.50300.istr11": "String aktuell 11",
  "common.50300.istr12": "String aktuell 12",
  "common.50300.istr13": "String aktuell 13",
  "common.50300.istr14": "String aktuell 14",
  "common.50300.istr15": "String aktuell 15",
  "common.50300.istr16": "String aktuell 16",
  "common.50300.istr17": "String aktuell 17",
  "common.50300.istr18": "String aktuell 18",
  "common.50300.istr19": "String aktuell 19",
  "common.50300.istr20": "String aktuell 20",
  "common.50300.istr21": "String aktuell 21",
  "common.50300.istr22": "String aktuell 22",
  "common.50300.istr23": "String aktuell 23",
  "common.50300.istr24": "String aktuell 24",
  "common.50402.sn": "Wechselrichter SN",
  "common.50402.ID": "Wechselrichter-ID",
  "common.50402.STATION_ID": "Kraftwerk-ID",
  "common.50402.INV_EG_DAY": "Tägliche Stromerzeugung",
  "common.50402.INV_EG_TOTAL": "Kumulative Stromerzeugung des Wechselrichters",
  "common.50402.INV_I_AC": "Wechselrichterstrom",
  "common.50402.INV_U_AC": "Wechselrichterspannung",
  "common.50402.PV1_I": "PV1 Strom",
  "common.50402.PV2_I": "PV2-Strom",
  "common.50402.PV3_I": "PV3-Strom",
  "common.50402.PV4_I": "PV4 Strom",
  "common.50402.PV5_I": "PV5 Strom",
  "common.50402.PV6_I": "PV6 Strom",
  "common.50402.PV7_I": "PV7 Strom",
  "common.50402.PV8_I": "PV8 Strom",
  "common.50402.PV9_I": "PV9 Strom",
  "common.50402.PV10_I": "PV10 Strom",
  "common.50402.PV11_I": "PV11 Strom",
  "common.50402.PV12_I": "PV12 Strom",
  "common.50402.PV13_I": "PV13 Strom",
  "common.50402.PV14_I": "PV14 Strom",
  "common.50402.PV15_I": "PV15 Strom",
  "common.50402.PV16_I": "PV16 Strom",
  "common.50402.PV17_I": "PV17 Strom",
  "common.50402.PV18_I": "PV18 Strom",
  "common.50402.PV19_I": "PV19 Strom",
  "common.50402.PV20_I": "PV20 Strom",
  "common.50402.PV21_I": "PV21 Strom",
  "common.50402.PV22_I": "PV22 Strom",
  "common.50402.PV23_I": "PV23 Strom",
  "common.50402.PV24_I": "PV24 Strom",
  "common.50402.PV25_I": "PV25 Strom",
  "common.50402.PV26_I": "PV26 Strom",
  "common.50402.PV27_I": "PV27 Strom",
  "common.50402.PV28_I": "PV28 Strom",
  "common.50402.PV29_I": "PV29 Strom",
  "common.50402.PV30_I": "PV30 Strom",
  "common.50402.PV1_V": "PV1-Spannung",
  "common.50402.PV2_V": "PV2-Spannung",
  "common.50402.PV3_V": "PV3-Spannung",
  "common.50402.PV4_V": "PV4-Spannung",
  "common.50402.PV5_V": "PV5-Spannung",
  "common.50402.PV6_V": "PV6-Spannung",
  "common.50402.PV7_V": "PV7-Spannung",
  "common.50402.PV8_V": "PV8-Spannung",
  "common.50402.PV9_V": "PV9-Spannung",
  "common.50402.PV10_V": "PV10 Spannung",
  "common.50402.PV11_V": "PV11 Spannung",
  "common.50402.PV12_V": "PV12-Spannung",
  "common.50402.PV13_V": "PV13 Spannung",
  "common.50402.PV14_V": "PV14 Spannung",
  "common.50402.PV15_V": "PV15 Spannung",
  "common.50402.PV16_V": "PV16 Spannung",
  "common.50402.PV17_V": "PV17 Spannung",
  "common.50402.PV18_V": "PV18 Spannung",
  "common.50402.PV19_V": "PV19 Spannung",
  "common.50402.PV20_V": "PV20 Spannung",
  "common.50402.PV21_V": "PV21 Spannung",
  "common.50402.PV22_V": "PV22 Spannung",
  "common.50402.PV23_V": "PV23 Spannung",
  "common.50402.PV24_V": "PV24 Spannung",
  "common.50402.PV25_V": "PV25 Spannung",
  "common.50402.PV26_V": "PV26 Spannung",
  "common.50402.PV27_V": "PV27 Spannung",
  "common.50402.PV28_V": "PV28 Spannung",
  "common.50402.PV29_V": "PV29 Spannung",
  "common.50402.PV30_V": "PV30 Spannung",
  "common.50402.INV_P_AC": "Wechselrichter Wirkleistung",
  "common.50402.CAPACITY": "Kapazität kw",
  "common.50402.INV_RUN_STATE": "Betriebszustand des Wechselrichters",
  "common.50402.DATA_TIME": "Daten Zeit",
  "common.50402.name": "Der Name des Geräts",
  "common.50402.out_pac": "Stromerzeugung (kW)",
  "common.50402.eday": "Heutige Stromerzeugung (kWh)",
  "common.50402.etotal": "Kumulierte Stromerzeugung (kWh)",
  "common.50402.status": "Zustand",
  "common.50402.turnon_time": "Zugriffszeit",
  "common.50402.type": "Gerätetyp",
  "common.50402.tempperature": "Temperatur(℃)",
  "common.50402.creationDate": "Der Zeitpunkt, zu dem die Daten aktuell waren",
  "common.50402.pac": "Stromerzeugung",
  "common.50402.hTotal": "Kumulierte Stromerzeugungsstunden",
  "common.50402.vpv1": "Gleichspannung 1",
  "common.50402.vpv2": "Gleichspannung 2",
  "common.50402.vpv3": "Gleichspannung 3",
  "common.50402.vpv4": "Gleichspannung 4",
  "common.50402.vpv5": "Gleichspannung 5",
  "common.50402.vpv6": "Gleichspannung 6",
  "common.50402.vpv7": "Gleichspannung 7",
  "common.50402.vpv8": "Gleichspannung 8",
  "common.50402.vpv9": "Gleichspannung 9",
  "common.50402.vpv10": "Gleichspannung 10",
  "common.50402.vpv11": "Gleichspannung 11",
  "common.50402.vpv12": "Gleichspannung 12",
  "common.50402.ipv1": "Gleichstrom 1",
  "common.50402.ipv2": "Gleichstrom 2",
  "common.50402.ipv3": "Gleichstrom 3",
  "common.50402.ipv4": "Gleichstrom 4",
  "common.50402.ipv5": "Gleichstrom 5",
  "common.50402.ipv6": "Gleichstrom 6",
  "common.50402.ipv7": "Gleichstrom 7",
  "common.50402.ipv8": "Gleichstrom 8",
  "common.50402.ipv9": "Gleichstrom 9",
  "common.50402.ipv10": "Gleichstrom 10",
  "common.50402.ipv11": "Gleichstrom 11",
  "common.50402.ipv12": "Gleichstrom 12",
  "common.50402.vac1": "Wechselspannung 1",
  "common.50402.vac2": "Wechselspannung 2",
  "common.50402.vac3": "Wechselspannung 3",
  "common.50402.iac1": "Wechselstrom 1",
  "common.50402.iac2": "Wechselstrom 2",
  "common.50402.iac3": "Wechselstrom 3",
  "common.50402.fac1": "AC-Frequenz 1",
  "common.50402.fac2": "AC-Frequenz 2",
  "common.50402.fac3": "AC-Frequenz 3",
  "common.50402.istr1": "String-Strom 1",
  "common.50402.istr2": "String-Strom 2",
  "common.50402.istr3": "String-Strom 3",
  "common.50402.istr4": "Strom der Saite 4",
  "common.50402.istr5": "String Strom 5",
  "common.50402.istr6": "String-Strom 6",
  "common.50402.istr7": "String-Strom 7",
  "common.50402.istr8": "String Strom 8",
  "common.50402.istr9": "Strom der Saite 9",
  "common.50402.istr10": "String-Strom 10",
  "common.50402.istr11": "String-Strom 11",
  "common.50402.istr12": "String-Strom 12",
  "common.50402.istr13": "String-Strom 13",
  "common.50402.istr14": "String-Strom 14",
  "common.50402.istr15": "String-Strom 15",
  "common.50402.istr16": "String-Strom 16",
  "common.50402.istr17": "Strom der Saite 17",
  "common.50402.istr18": "String-Strom 18",
  "common.50402.istr19": "String-Strom 19",
  "common.50402.istr20": "String-Strom 20",
  "common.50402.istr21": "String-Strom 21",
  "common.50402.istr22": "String-Strom 22",
  "common.50402.istr23": "String-Strom 23",
  "common.50402.istr24": "String-Strom 24",
  "bw_RTparam_group_ Dongle": "Dongle",
  "bw_RTparam_name_DongleRssi": "RSSI",
  "bw_RTparam_group_Dongle": "Dongle",
  "common.50500.xnl_RTparam_name_FV_P": "Leistungsfaktorwert",
  "common.50500.xnl_RTparam_name_GVL": "Netzgekoppelter Spannungspegel",
  "common.50500.xnl_RTparam_name_RS_D": "Laufender Status (Standard)",
  "common.50500.xnl_RTparam_name_Etdy_ge1": "Tägliche Stromerzeugung (aktiv)",
  "common.50500.xnl_RTparam_name_A_R_P_D": "AC-Blindenergie am Tag",
  "common.50500.xnl_RTparam_name_GEN_P_D": "Tägliche Erzeugungsleistung des Generators",
  "common.50500.xnl_RTparam_name_Et_ge0": "Kumulativ erzeugte Elektrizität (aktiv) ",
  "common.50500.xnl_RTparam_name_Emon1": "Monatliche Stromerzeugung (aktiv)",
  "common.50500.xnl_RTparam_name_Etdy_use2": "Monatlicher Stromverbrauch",
  "common.50500.xnl_RTparam_name_t_gc_tdy2": "Monatliche netzgekoppelte Kapazität",
  "common.50500.xnl_RTparam_name_Eyr1": "Jährliche Stromerzeugung (aktiv)",
  "common.50500.xnl_RTparam_name_Etdy_cg1": "Das heutige Ladevolumen",
  "common.50500.xnl_RTparam_name_Etdy_dcg1": "Der heutige Entlastungsbetrag",
  "common.50500.xnl_RTparam_name_t_cg_n1": "Kumulative Ladekapazität ",
  "common.50500.xnl_RTparam_name_t_dcg_n1": "Kumulative Entladung ",
  "common.50500.xnl_RTparam_name_E_B_D": "Tägliches Stromeinkaufsvolumen",
  "common.50500.xnl_RTparam_name_GRID_C_D": "Netzanschlusskapazität des Stromnetzes am Tag ",
  "common.50500.xnl_RTparam_name_E_B_TO": "Gekaufte Elektrizität insgesamt",
  "common.50500.xnl_RTparam_name_PG_F1": "Netzfrequenz",
  "common.50500.xnl_RTparam_name_t_gc1": "Kumulative netzgekoppelte Kapazität ",
  "common.50500.xnl_RTparam_name_GDOH": "Tägliche Arbeitszeiten des Generators ",
  "common.50500.xnl_RTparam_name_Etdy_use1": "Der Stromverbrauch von heute",
  "common.50500.xnl_RTparam_name_Et_use1": "Kumulierter Stromverbrauch ",
  "common.50500.xnl_RTparam_name_Etdy_use3": "Jährlicher Stromverbrauch ",
  "common.50500.xnl_RTparam_name_T_TFM1": "Transformator Temperatur",
  "common.50500.xnl_RTparam_name_T_RDT1": "Heizkörpertemperatur ",
  "common.50500.xnl_RTparam_name_EG_t_ge1": "Gesamte Stromerzeugung des Generators",
  "common.50500.xnl_RTparam_name_E_PVhis_ge1": "Historische PV-Stromerzeugung",
  "common.50500.xnl_RTparam_name_t_gc_tdy3": "Jährliche netzgekoppelte Kapazität ",
  "common.50500.xnl_RTparam_name_LCD": "LCD-Test-Flaggenbit",
  "common.50500.xnl_RTparam_name_CBAC": "Kapazität nach Batteriekalibrierung",
  "common.50500.xnl_RTparam_name_PVDE": "Tägliche PV-Stromerzeugung",
  "common.50500.xnl_RTparam_name_DV1": "Gleichspannung PV1",
  "common.50500.xnl_RTparam_name_DC1": "Gleichstrom PV1",
  "common.50500.xnl_RTparam_name_DV2": "Gleichspannung PV2",
  "common.50500.xnl_RTparam_name_DC2": "Gleichstrom PV2",
  "common.50500.xnl_RTparam_name_DV3": "Gleichspannung PV3",
  "common.50500.xnl_RTparam_name_DC3": "Gleichstrom PV3",
  "common.50500.xnl_RTparam_name_DV4": "Gleichspannung PV4",
  "common.50500.xnl_RTparam_name_DC4": "Gleichstrom PV4",
  "common.50500.xnl_RTparam_name_INV_DSP_D_1": "INV DSP Debug Informationen 1",
  "common.50500.xnl_RTparam_name_INV_DSP_D_2": "INV DSP Debug Informationen 2",
  "common.50500.xnl_RTparam_name_INV_DSP_D_3": "INV DSP Debug-Informationen 3",
  "common.50500.xnl_RTparam_name_INV_DSP_D_4": "INV DSP Debug Informationen 4",
  "common.50500.xnl_RTparam_name_INV_DSP_D_5": "INV DSP Debug-Informationen 5",
  "common.50500.xnl_RTparam_name_INV_DSP_D_6": "INV DSP Debug Informationen 6",
  "common.50500.xnl_RTparam_name_INV_DSP_D_7": "INV DSP Debug Informationen 7",
  "common.50500.xnl_RTparam_name_INV_DSP_D_8": "INV DSP Debug-Informationen 8",
  "common.50500.xnl_RTparam_name_INV_DSP_D_9": "INV DSP Debug-Informationen 9",
  "common.50500.xnl_RTparam_name_INV_DSP_D_10": "INV DSP Debug-Informationen 10",
  "common.50500.xnl_RTparam_name_INV_DSP_D_11": "INV DSP Debug-Informationen 11",
  "common.50500.xnl_RTparam_name_INV_DSP_D_12": "INV DSP Debug-Informationen 12",
  "common.50500.xnl_RTparam_name_INV_DSP_D_13": "INV DSP Debug-Informationen 13",
  "common.50500.xnl_RTparam_name_INV_DSP_D_14": "INV DSP Debug-Informationen 14",
  "common.50500.xnl_RTparam_name_INV_DSP_D_15": "INV DSP Debug-Informationen 15",
  "common.50500.xnl_RTparam_name_INV_DSP_D_16": "INV DSP Debug-Informationen 16",
  "common.50500.xnl_RTparam_name_INV_DSP_D_17": "INV DSP Debug-Informationen 17",
  "common.50500.xnl_RTparam_name_INV_DSP_D_18": "INV DSP Debug-Informationen 18",
  "common.50500.xnl_RTparam_name_INV_DSP_D_19": "INV DSP Debug-Informationen 19",
  "common.50500.xnl_RTparam_name_INV_DSP_D_20": "INV DSP Debug-Informationen 20",
  "common.50500.xnl_RTparam_name_INV_DSP_D_21": "INV DSP Debug-Informationen 21",
  "common.50500.xnl_RTparam_name_INV_DSP_D_22": "INV DSP Debug Informationen 22",
  "common.50500.xnl_RTparam_name_INV_DSP_D_23": "INV DSP Debug-Informationen 23",
  "common.50500.xnl_RTparam_name_INV_DSP_D_24": "INV DSP Debug Informationen 24",
  "common.50500.xnl_RTparam_name_INV_DSP_D_25": "INV DSP Debug-Informationen 25",
  "common.50500.xnl_RTparam_name_INV_DSP_D_26": "INV DSP Debug-Informationen 26",
  "common.50500.xnl_RTparam_name_INV_DSP_D_27": "INV DSP Debug-Informationen 27",
  "common.50500.xnl_RTparam_name_INV_DSP_D_28": "INV DSP Debug-Informationen 28",
  "common.50500.xnl_RTparam_name_G_V_L1_N": "Netzseitige Spannung L1-N ",
  "common.50500.xnl_RTparam_name_G_V_L2_N": "Netzseitige Spannung L2-N ",
  "common.50500.xnl_RTparam_name_G_V_L1_L2": "Netzseitige Spannung L1-L2 ",
  "common.50500.xnl_RTparam_name_R_I_V_L1_L2": "Relais Zwischenspannung L1-L2 ",
  "common.50500.xnl_RTparam_name_AV1": "Wechselspannung R / U / A",
  "common.50500.xnl_RTparam_name_AV2": "Wechselspannung S / V / B",
  "common.50500.xnl_RTparam_name_INV_O_P_L1_L2": "Wechselrichter-Ausgangsspannung L1-L2  ",
  "common.50500.xnl_RTparam_name_C_V_L1": "Lastspannung L1",
  "common.50500.xnl_RTparam_name_C_V_L2": "Lastspannung L2",
  "common.50500.xnl_RTparam_name_I_O_F2": "Wechselrichter-Ausgangsfrequenz L2 ",
  "common.50500.xnl_RTparam_name_G_C_L1": "Netzstrom L1",
  "common.50500.xnl_RTparam_name_G_C_L2": "Netzstrom L2",
  "common.50500.xnl_RTparam_name_G_C_A": "Netzstrom A",
  "common.50500.xnl_RTparam_name_G_C_B": "Netzstrom B",
  "common.50500.xnl_RTparam_name_AC1": "Wechselstrom R / U / A",
  "common.50500.xnl_RTparam_name_AC2": "Wechselstrom S / V / B",
  "common.50500.xnl_RTparam_name_GEN_P_T": "Gesamtleistung des Generators",
  "common.50500.xnl_RTparam_name_G_P_L1": "Netzleistung L1",
  "common.50500.xnl_RTparam_name_G_P_L2": "Netzleistung L2",
  "common.50500.xnl_RTparam_name_PG_Pt1": "Gesamte Netzleistung",
  "common.50500.xnl_RTparam_name_E_CT_P1": "Externe CT1-Stromversorgung",
  "common.50500.xnl_RTparam_name_E_CT_P2": "Externe CT2-Stromversorgung",
  "common.50500.xnl_RTparam_name_CT_P_T": "Gesamtleistung des Netz-CT",
  "common.50500.xnl_RTparam_name_INV_O_P_L1": "Wechselrichter-Ausgangsleistung L1  ",
  "common.50500.xnl_RTparam_name_INV_O_P_L2": "Wechselrichter-Ausgangsleistung L2  ",
  "common.50500.xnl_RTparam_name_I_O_P_LN": "Wechselrichter-Ausgangsleistung L / N ",
  "common.50500.xnl_RTparam_name_C_P_L1": "Lastleistung L1",
  "common.50500.xnl_RTparam_name_C_P_L2": "Lastleistung L2",
  "common.50500.xnl_RTparam_name_E_Puse_t1": "Gesamte elektrische Leistungsaufnahme",
  "common.50500.xnl_RTparam_name_E_Cuse1": "Elektrischer Strom R / U / A",
  "common.50500.xnl_RTparam_name_E_Cuse2": "Elektrischer Strom S / V / B ",
  "common.50500.xnl_RTparam_name_PVGP_A": "Phasenspannung A des Gen-Ports",
  "common.50500.xnl_RTparam_name_B_T1": "Batterie Temperatur ",
  "common.50500.xnl_RTparam_name_B_V1": "Batteriespannung ",
  "common.50500.xnl_RTparam_name_B_R_C": "verbleibende Batteriekapazität",
  "common.50500.xnl_RTparam_name_LF2": "Lastfrequenz L2",
  "common.50500.xnl_RTparam_name_DP1": "Gleichstrom PV1",
  "common.50500.xnl_RTparam_name_DP2": "Gleichstrom PV2",
  "common.50500.xnl_RTparam_name_DP3": "Gleichstrom PV3",
  "common.50500.xnl_RTparam_name_DP4": "Gleichstrom PV4",
  "common.50500.xnl_RTparam_name_B_Pdcg1": "Entladeleistung der Batterie ",
  "common.50500.xnl_RTparam_name_B_C1": "Batterie Strom ",
  "common.50500.xnl_RTparam_name_LF1": "Lastfrequenz L1",
  "common.50500.xnl_RTparam_name_I_O_F1": "Wechselrichter-Ausgangsfrequenz L1 ",
  "common.50500.xnl_RTparam_name_GRID_RELAY_ST1": "Status des Netzrelais",
  "common.50500.xnl_RTparam_name_ST_EG_RELAY1": "Status des generatorseitigen Relais ",
  "common.50500.xnl_RTparam_name_EG_F1": "Generatorfrequenz",
  "common.50500.xnl_RTparam_name_BUS_VOL": "Bus Spannung",
  "common.50500.xnl_RTparam_name_H_B_V": "Halbe Sammelschienenspannung",
  "common.50500.xnl_RTparam_name_B_B_C": "Ausgewogener Brückenstrom",
  "common.50500.xnl_RTparam_name_I_EARipa1": "Parallele Masseimpedanz",
  "common.50500.xnl_RTparam_name_LBVN": "Lithium-Batterie Versionsnummer ",
  "common.50500.xnl_RTparam_name_M_P": "Gesamtleistung des Stromzählers",
  "common.50500.xnl_RTparam_name_M_P_A": "Stromzähler Leistung A",
  "common.50500.xnl_RTparam_name_M_P_B": "Stromzähler Leistung B",
  "common.50500.xnl_RTparam_name_M_P_C": "Stromzähler Leistung C",
  "common.50500.xnl_RTparam_name_t_gc_tdy1": "Die heutige netzgekoppelte Kapazität",
  "common.50500.xnl_RTparam_name_Etdy_pu1": "Das heutige Stromeinkaufsvolumen",
  "common.50500.xnl_RTparam_name_Et_pu1": "Kumulativer eingekaufter Strom ",
  "common.50500.xnl_RTparam_name_Vtr1_BAP1": "Gesamtspannung des Akkupacks 1",
  "common.50500.xnl_RTparam_name_Cr1_BAP1": "Akku-Pack 1 Strom ",
  "common.50500.xnl_RTparam_name_T_BAP1": "Akkupack 1 Temperatur ",
  "common.50500.xnl_RTparam_name_SOC_BAP1": "Akku-Pack 1 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP1": "Verbleibende Kapazität des Akkupacks 1",
  "common.50500.xnl_RTparam_name_T_cap_BAP1": "Gesamtkapazität des Akkupacks 1",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg1": "Akku-Pack 1 Ladeanforderung Spannung ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg1": "Ladeanforderungsstrom des Akkupacks 1 ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg1": "Akkupack 1 Entladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_Max_V_BAP1": "Maximale Spannung des Akkupacks 1",
  "common.50500.xnl_RTparam_name_MIN_V_BAP1": "Mindestspannung der Batterie im Akkupack 1",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP1": "Anzahl der Zyklen des Akkupacks 1",
  "common.50500.xnl_RTparam_name_Warn_BAP1": "Akkupack 1 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP1": "Akku-Pack 1 Fehler ",
  "common.50500.xnl_RTparam_name_Vtr_BAP2": "Gesamtspannung des Akkupacks 2",
  "common.50500.xnl_RTparam_name_Cr_BAP2": "Akku-Pack 2 Strom ",
  "common.50500.xnl_RTparam_name_T_BAP2": "Akkupack 2 Temperatur ",
  "common.50500.xnl_RTparam_name_SOC_BAP2": "Akku-Pack 2 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP2": "Verbleibende Kapazität des Akkupacks 2",
  "common.50500.xnl_RTparam_name_T_cap_BAP2": "Gesamtkapazität des Akkupacks 2",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg2": "Akku-Pack 2 Ladeanforderung Spannung ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg2": "Akku-Pack 2 Ladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg2": "Akkupack 2 Entladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_Max_V_BAP2": "Maximale Spannung der Batterie 2 im Akkupack ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP2": "Mindestspannung der Batterie 2 im Akkupack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP2": "Akkupack 2 Zykluszahl ",
  "common.50500.xnl_RTparam_name_Warn_BAP2": "Akku-Pack 2 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP2": "Ausfall des Akkupacks 2 ",
  "common.50500.xnl_RTparam_name_Vtr_BAP3": "Gesamtspannung des Akkupacks 3",
  "common.50500.xnl_RTparam_name_Cr_BAP3": "Akku-Pack 3 Strom ",
  "common.50500.xnl_RTparam_name_T_BAP3": "Akkupack 3 Temperatur ",
  "common.50500.xnl_RTparam_name_SOC_BAP3": "Akku-Pack 3 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP3": "Verbleibende Kapazität des Akkupacks 3",
  "common.50500.xnl_RTparam_name_T_cap_BAP3": "Gesamtkapazität des Akkupacks 3",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg3": "Akku-Pack 3 Ladeanforderungsspannung ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg3": "Akku-Pack 3 Ladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg3": "Akkupack 3 Entladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_Max_V_BAP3": "Maximale Spannung der Batterie 3 im Akkupack ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP3": "Mindestspannung der Batterie 3 im Akkupack ",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP3": "Anzahl der Zyklen des Akkupacks 3",
  "common.50500.xnl_RTparam_name_Warn_BAP3": "Akku-Pack 3 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP3": "Akkupack 3 Fehlfunktion ",
  "common.50500.xnl_RTparam_name_Vtr_BAP4": "Gesamtspannung des Akkupacks 4",
  "common.50500.xnl_RTparam_name_Cr_BAP4": "Akku-Pack 4 Strom ",
  "common.50500.xnl_RTparam_name_T_BAP4": "Akku-Pack 4 Temperatur ",
  "common.50500.xnl_RTparam_name_SOC_BAP4": "Akku-Pack 4 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP4": "Verbleibende Kapazität des Akkupacks 4",
  "common.50500.xnl_RTparam_name_T_cap_BAP4": "Gesamtkapazität des Akkupacks 4",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg4": "Akku-Pack 4 Ladeanforderung Spannung ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg4": "Akku-Pack 4 Ladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg4": "Akku-Pack 4 Entladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_Max_V_BAP4": "Maximale Spannung der Batterie 4 im Akkupack ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP4": "Mindestspannung der Batterie 4 im Akkupack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP4": "Akku-Pack 4 Zykluszahl ",
  "common.50500.xnl_RTparam_name_Warn_BAP4": "Akku-Pack 4 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP4": "Ausfall des Akkupacks 4 ",
  "common.50500.xnl_RTparam_name_Vtr5_BAP5": "Gesamtspannung des Akkupacks 5",
  "common.50500.xnl_RTparam_name_Cr5_BAP5": "Akkupack 5 Strom ",
  "common.50500.xnl_RTparam_name_T_BAP5": "Akkupack 5 Temperatur ",
  "common.50500.xnl_RTparam_name_SOC_BAP5": "Akku-Pack 5 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP5": "Verbleibende Kapazität des Akkupacks 5",
  "common.50500.xnl_RTparam_name_T_cap_BAP5": "Gesamtkapazität des Akkupacks 5",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg5": "Akku-Pack 5 Ladeanforderungsspannung ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg5": "Akku-Pack 5 Ladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg5": "Akkupack 5 Entladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_Max_V_BAP5": "Maximale Spannung von Batterie 5 im Akkupack",
  "common.50500.xnl_RTparam_name_MIN_V_BAP5": "Mindestspannung von Batterie 5 im Akkupack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP5": "Akkupack 5 Zykluszahl ",
  "common.50500.xnl_RTparam_name_Warn_BAP5": "Akkupack 5 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP5": "Ausfall des Akkupacks 5 ",
  "common.50500.xnl_RTparam_name_Vtr6_BAP6": "Gesamtspannung des Akkupacks 6",
  "common.50500.xnl_RTparam_name_Cr6_BAP6": "Akku-Pack 6 Strom ",
  "common.50500.xnl_RTparam_name_T_BAP6": "Akkupack 6 Temperatur ",
  "common.50500.xnl_RTparam_name_SOC_BAP6": "Akku-Pack 6 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP6": "Verbleibende Kapazität des Akkupacks 6",
  "common.50500.xnl_RTparam_name_T_cap_BAP6": "Gesamtkapazität des Akkupacks 6",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg6": "Akku 6 Ladeanforderungsspannung ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg6": "Akkupack 6 Ladeanforderungsstrom ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg6": "Akkupack 6 Entladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_Max_V_BAP6": "Batteriepack 6 Batterie Maximale Spannung ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP6": "Mindestspannung der Batterie 6 im Akkupack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP6": "Akkupack 6 Zykluszahl ",
  "common.50500.xnl_RTparam_name_Warn_BAP6": "Akkupack 6 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP6": "Ausfall des Akkupacks 6 ",
  "common.50500.xnl_RTparam_name_Vtr7_BAP7": "Gesamtspannung des Akkupacks 7",
  "common.50500.xnl_RTparam_name_Cr7_BAP7": "Akku-Pack 7 Strom ",
  "common.50500.xnl_RTparam_name_T_BAP7": "Akkupack 7 Temperatur ",
  "common.50500.xnl_RTparam_name_SOC_BAP7": "Akku-Pack 7 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP7": "Verbleibende Kapazität des Akkupacks 7",
  "common.50500.xnl_RTparam_name_T_cap_BAP7": "Gesamtkapazität des Akkupacks 7",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg7": "Akku-Pack 7 Ladeanforderung Spannung ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg7": "Akku-Pack 7 Ladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg7": "Akkupack 7 Entladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_Max_V_BAP7": "Batteriepack 7 Batterie Maximale Spannung ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP7": "Mindestspannung der Batterie 7 im Akkupack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP7": "Akku-Pack 7 Zykluszahl ",
  "common.50500.xnl_RTparam_name_Warn_BAP7": "Akkupack 7 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP7": "Ausfall des Akkupacks 7 ",
  "common.50500.xnl_RTparam_name_Vtr8_BAP8": "Gesamtspannung des Akkupacks 8",
  "common.50500.xnl_RTparam_name_Cr8_BAP8": "Akku-Pack 8 Strom ",
  "common.50500.xnl_RTparam_name_T_BAP8": "Akkupack 8 Temperatur ",
  "common.50500.xnl_RTparam_name_SOC_BAP8": "Akku-Pack 8 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP8": "Verbleibende Kapazität des Akkupacks 8",
  "common.50500.xnl_RTparam_name_T_cap_BAP8": "Gesamtkapazität des Akkupacks 8",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg8": "Akku-Pack 8 Ladeanforderungsspannung ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg8": "Akku-Pack 8 Ladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg8": "Akkupack 8 Entladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_Max_V_BAP8": "Maximale Spannung der Batterie 8 im Akkupack",
  "common.50500.xnl_RTparam_name_MIN_V_BAP8": "Mindestspannung der Batterie 8 im Akkupack ",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP8": "Akku-Pack 8 Zykluszahl ",
  "common.50500.xnl_RTparam_name_Warn_BAP8": "Akku-Pack 8 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP8": "Ausfall des Akkupacks 8 ",
  "common.50500.xnl_RTparam_name_Vtr9_BAP9": "Gesamtspannung des Akkupacks 9",
  "common.50500.xnl_RTparam_name_Cr9_BAP9": "Akku-Pack 9 Strom ",
  "common.50500.xnl_RTparam_name_T_BAP9": "Akkupack 9 Temperatur ",
  "common.50500.xnl_RTparam_name_SOC_BAP9": "Akku 9 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP9": "Verbleibende Kapazität des Akkupacks 9",
  "common.50500.xnl_RTparam_name_T_cap_BAP9": "Gesamtkapazität des Akkupacks 9",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg9": "Akku 9 Ladeanforderungsspannung ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg9": "Akkupack 9 Ladeanforderungsstrom ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg9": "Akkupack 9 Entladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_Max_V_BAP9": "Batteriepack 9 Batterie Maximale Spannung ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP9": "Mindestspannung der Batterie 9 im Akkupack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP9": "Akkupack 9 Zykluszahl ",
  "common.50500.xnl_RTparam_name_Warn_BAP9": "Akkupack 9 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP9": "Ausfall des Akkupacks 9 ",
  "common.50500.xnl_RTparam_name_Vtr10_BAP10": "Gesamtspannung des Akkupacks 10",
  "common.50500.xnl_RTparam_name_Cr10_BAP10": "Akku-Pack 10 Strom ",
  "common.50500.xnl_RTparam_name_T_BAP10": "Akku-Pack 10 Temperatur ",
  "common.50500.xnl_RTparam_name_SOC_BAP10": "Akku-Pack 10 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP10": "Verbleibende Kapazität des Akkupacks 10",
  "common.50500.xnl_RTparam_name_T_cap_BAP10": "Gesamtkapazität des Akkupacks 10",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg10": "Akku-Pack 10 Ladeanforderungsspannung ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg10": "Ladeanforderungsstrom des Akkupacks 10 ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg10": "Entladeanforderungsstrom des Akkupacks 10 ",
  "common.50500.xnl_RTparam_name_Max_V_BAP10": "Maximale Spannung der Batterie 10 im Akkupack",
  "common.50500.xnl_RTparam_name_MIN_V_BAP10": "Mindestspannung der Batterie 10 im Akkupack ",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP10": "Anzahl der Zyklen des Akkupacks 10",
  "common.50500.xnl_RTparam_name_Warn_BAP10": "Akku-Pack 10 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP10": "Ausfall des Akkupacks 10 ",
  "common.50500.xnl_RTparam_name_Vtr11_BAP11": "Gesamtspannung des Akkupacks 11",
  "common.50500.xnl_RTparam_name_Cr11_BAP11": "Akku-Pack 11 Strom ",
  "common.50500.xnl_RTparam_name_T_BAP11": "Akkupack 11 Temperatur ",
  "common.50500.xnl_RTparam_name_SOC_BAP11": "Akku-Pack 11 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP11": "Verbleibende Kapazität des Akkupacks 11",
  "common.50500.xnl_RTparam_name_T_cap_BAP11": "Gesamtkapazität des Akkupacks 11",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg11": "Akku-Pack 11 Ladeanforderung Spannung ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg11": "Akku-Pack 11 Ladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg11": "Entladeanforderungsstrom des Akkupacks 11 ",
  "common.50500.xnl_RTparam_name_Max_V_BAP11": "Maximale Spannung des Batteriepacks 11 Batterien",
  "common.50500.xnl_RTparam_name_MIN_V_BAP11": "Mindestspannung der Batterie 11 im Akkupack ",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP11": "Anzahl der Zyklen des Akkupacks 11",
  "common.50500.xnl_RTparam_name_Warn_BAP11": "Akkupack 11 Alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP11": "Akkupack 11 Fehlfunktion ",
  "common.50500.xnl_RTparam_name_Vtr12_BAP12": "Gesamtspannung des Akkupacks 12",
  "common.50500.xnl_RTparam_name_Cr12_BAP12": "Akku-Pack 12 Strom ",
  "common.50500.xnl_RTparam_name_T_BAP12": "Akkupack 12 Temperatur ",
  "common.50500.xnl_RTparam_name_SOC_BAP12": "Akku-Pack 12 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP12": "Verbleibende Kapazität des Akkupacks 12",
  "common.50500.xnl_RTparam_name_T_cap_BAP12": "Gesamtkapazität des Akkupacks 12",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg12": "Akkupack 12 Ladeanforderungsspannung ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg12": "Akku-Pack 12 Ladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg12": "Akkupack 12 Entladeanforderung Strom ",
  "common.50500.xnl_RTparam_name_Max_V_BAP12": "Maximale Spannung der Batterie 12 im Akkupack",
  "common.50500.xnl_RTparam_name_MIN_V_BAP12": "Mindestspannung der Batterie 12 im Akkupack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP12": "Number of cycles of battery pack 12",
  "common.50500.xnl_RTparam_name_Warn_BAP12": "Battery pack 12 alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP12": "Battery pack 12 failure ",
  "common.50500.xnl_RTparam_name_Vtr13_BAP13": "Total Voltage of Battery Pack 13",
  "common.50500.xnl_RTparam_name_Cr13_BAP13": "Battery Pack 13 Current ",
  "common.50500.xnl_RTparam_name_T_BAP13": "Battery Pack 13 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP13": "Battery Pack 13 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP13": "Remaining capacity of battery pack 13",
  "common.50500.xnl_RTparam_name_T_cap_BAP13": "Total capacity of battery pack 13",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg13": "Battery pack 13 charging request voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg13": "Battery pack 13 charging request current ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg13": "Discharge Request Current of Battery Pack 13 ",
  "common.50500.xnl_RTparam_name_Max_V_BAP13": "Maximum Voltage of Battery 13 in Battery Pack",
  "common.50500.xnl_RTparam_name_MIN_V_BAP13": "Minimum voltage of battery 13 in the battery pack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP13": "Number of cycles of battery pack 13",
  "common.50500.xnl_RTparam_name_Warn_BAP13": "Battery pack 13 alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP13": "Battery pack 13 malfunction ",
  "common.50500.xnl_RTparam_name_Vtr14_BAP14": "Total voltage of battery pack 14",
  "common.50500.xnl_RTparam_name_Cr14_BAP14": "Battery Pack 14 Current ",
  "common.50500.xnl_RTparam_name_T_BAP14": "Battery Pack 14 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP14": "Battery Pack 14 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP14": "Remaining capacity of battery pack 14",
  "common.50500.xnl_RTparam_name_T_cap_BAP14": "Total capacity of battery pack 14",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg14": "Battery Pack 14 Charging Request Voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg14": "Battery pack 14 charging request current ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg14": "Discharge Request Current of Battery Pack 14 ",
  "common.50500.xnl_RTparam_name_Max_V_BAP14": "Maximum Voltage of Battery 14 in Battery Pack ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP14": "Minimum voltage of battery 14 in the battery pack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP14": "Number of cycles of battery pack 14",
  "common.50500.xnl_RTparam_name_Warn_BAP14": "Battery pack 14 alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP14": "Battery pack 14 malfunction ",
  "common.50500.xnl_RTparam_name_Vtr15_BAP15": "Total Voltage of Battery Pack 15",
  "common.50500.xnl_RTparam_name_Cr15_BAP15": "Battery Pack 15 Current ",
  "common.50500.xnl_RTparam_name_T_BAP15": "Battery Pack 15 Temperature ",
  "common.50500.xnl_RTparam_name_SOC_BAP15": "Battery Pack 15 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP15": "Remaining capacity of battery pack 15",
  "common.50500.xnl_RTparam_name_T_cap_BAP15": "Total Capacity of Battery Pack 15",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg15": "Battery Pack 15 Charging Request Voltage ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg15": "Battery pack 15 charging request current ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg15": "Battery pack 15 discharge request current ",
  "common.50500.xnl_RTparam_name_Max_V_BAP15": "Maximum Voltage of Battery 15 in Battery Pack ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP15": "Minimum voltage of battery 15 in the battery pack",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP15": "Number of cycles of battery pack 15",
  "common.50500.xnl_RTparam_name_Warn_BAP15": "Battery pack 15 alarm ",
  "common.50500.xnl_RTparam_name_Fault_BAP15": "Battery pack 15 malfunction ",
  "common.50500.xnl_RTparam_name_yr1": "Year",
  "common.50500.xnl_RTparam_name_mon1": "Month",
  "common.50500.xnl_RTparam_name_tdy1": "Day",
  "common.50500.xnl_RTparam_name_hou1": "when ",
  "common.50500.xnl_RTparam_name_min1": "points ",
  "common.50500.xnl_RTparam_name_sec1": "seconds ",
  "common.50500.xnl_RTparam_name_BMS_D_V": "BMS Discharge Voltage",
  "common.50500.xnl_RTparam_name_BMS_B_Ccg_thd1": "BMS battery charging limit viewership of",
  "common.50500.xnl_RTparam_name_BMS_B_Cdcg_thd1": "BMS battery discharge limit viewership of",
  "common.50500.xnl_RTparam_name_B_R_P": "BMS remaining power ",
  "common.50500.xnl_RTparam_name_BMS_B_V1": "BMS Battery Voltage",
  "common.50500.xnl_RTparam_name_BMS_B_C1": "BMS Battery Current",
  "common.50500.xnl_RTparam_name_BMST": "BMS Temperature",
  "common.50500.xnl_RTparam_name_BCT": "Battery Type ",
  "common.50500.xnl_RTparam_name_HF_1": "Historical Fault 1",
  "common.50500.xnl_RTparam_name_HF_2": "Historical Fault 2",
  "common.50500.xnl_RTparam_name_HF_3": "Historical Fault 3",
  "common.50500.xnl_RTparam_name_HF_4": "Historical Fault 4",
  "common.50500.xnl_RTparam_name_HF_5": "Historical Fault 5",
  "common.50500.xnl_RTparam_name_HF_6": "Historical Fault 6",
  "common.50500.xnl_RTparam_name_HF_7": "Historical Fault 7",
  "common.50500.xnl_RTparam_name_HF_8": "Historical Fault 8",
  "common.50500.xnl_RTparam_name_HF_9": "Historical Fault 9",
  "common.50500.xnl_RTparam_name_HF_10": "Historical Fault 10",
  "common.50500.xnl_RTparam_name_HF_11": "Historical Fault 11",
  "common.50500.xnl_RTparam_name_HF_12": "Historical Fault 12",
  "common.50500.xnl_RTparam_name_HF_13": "Historical Fault 13",
  "common.50500.xnl_RTparam_name_G_V_L3": "Grid Voltage L3",
  "common.50500.xnl_RTparam_name_G_V_L1_L3": "Grid-side voltage L1-L3 ",
  "common.50500.xnl_RTparam_name_G_V_L2_L3": "Grid-side voltage L2-L3 ",
  "common.50500.xnl_RTparam_name_AV3": "AC Voltage T/W/C",
  "common.50500.xnl_RTparam_name_INV_O_P_L1_L3": "Inverter output voltage L1-L3 ",
  "common.50500.xnl_RTparam_name_INV_O_P_L2_L3": "Inverter output voltage L2-L3 ",
  "common.50500.xnl_RTparam_name_C_V_L3": "Load Voltage L3",
  "common.50500.xnl_RTparam_name_NA": "NA",
  "common.50500.xnl_RTparam_name_I_O_F3": "Inverter Output Frequency L3 ",
  "common.50500.xnl_RTparam_name_G_C_L3": "Grid current L3",
  "common.50500.xnl_RTparam_name_G_C_C": "Grid current C",
  "common.50500.xnl_RTparam_name_AC3": "Alternating Current T/W/C",
  "common.50500.xnl_RTparam_name_G_P_L3": "Grid Power L3",
  "common.50500.xnl_RTparam_name_CT3_P_E": "External Power CT3",
  "common.50500.xnl_RTparam_name_INV_O_P_L3": "Inverter Output Power L3  ",
  "common.50500.xnl_RTparam_name_C_P_L3": "Load Power L3",
  "common.50500.xnl_RTparam_name_C_C_L3": "Load current L3",
  "common.50500.xnl_RTparam_name_BMS_C_V": "BMS Charging Voltage",
  "common.50500.xnl_RTparam_name_INV_ADDR": "Adresse des Wechselrichters",
  "bw_RTparam_name_online": "online",
  "bw_RTparam_name_offline": "offline",
  "bw_RTparam_name_buy": "Strom kaufen",
  "bw_RTparam_name_sell": "Strom verkaufen",
  "bw_RTparam_name_dontBuy": "Nicht kaufen, nicht verkaufen",
  "bw_RTparam_name_noCharging": "Kein Laden und kein Entladen",
  "bw_RTparam_name_forbidden": "Es ist verboten, zu laden und zu entladen",
  "bw_RTparam_name_charging": "Aufladen und Auslösen verbieten",
  "bw_RTparam_name_allowCharged": "Aufladen und Freigeben zulassen",
  "bw_RTparam_name_forcedCharging": "Zwangsladung und Verbot",
  "bw_RTparam_name_forcedCharge": "Erzwungenes Laden und Entladen",
  "bw_RTparam_name_photovoltaics": "CT wird für Stromnetze und Photovoltaik eingesetzt",
  "bw_RTparam_name_gridCT": "Das Netz verwendet Stromwandler und die Photovoltaik Zähler",
  "bw_RTparam_name_electricity": "Stromzähler werden für Stromnetze eingesetzt, Stromwandler für Photovoltaik",
  "bw_RTparam_name_grid": "Netz- und Photovoltaik-Zähler",
  "bw_RTparam_name_forced": "Zwangsladen und -entladen",
  "bw_RTparam_name_charge": "Die Lade-/Entladefunktion ist nicht aktiviert",
  "common.50100.Inverter": "Wechselrichter",
  "supplier.type.tuobang": "Tuobao",
  "supplier.type.gd": "GOODWE",
  "Ajouterbar.plant": "Pflanze hinzufügen",
  "ASNZ4777-N": "Australia_ASNZ4777-N",
  "CEI 0-21": "Italy_CEI 0-21",
  "custom50": "User defined_Custom50",
  "custom60": "User defined_Custom60",
  "EN50438L": "Cyprus,Finland,Czech,Slovenia,Jamaica_EN50438 L",
  "G83/1-A": "UK_G83/1-A",
  "G83/3": "UK_G83/3",
  "General50": "User defined_General 50",
  "General60": "User defined_General 60",
  "GN300V": "China_GN300V",
  "GNB": "China_GNB",
  "GNC": "China_GNC",
  "ISONE208": "USA_ISONE208",
  "ISONE208A": "USA_ISONE208A",
  "ISONE240": "USA_ISONE240",
  "ISONE240A": "USA_ISONE240A",
  "JAM-230": "Jamaica_JAM-230",
  "MEX": "China_MEX",
  "MEX-A": "Mexico_MEX-A",
  "MEX-N": "MEX-N_MEX-N",
  "NA-EEA-A": "Switzerland_NA-EEA-A",
  "R14-208": "USA_R14-208",
  "R14-208A": "USA_R14-208A",
  "R14-240": "USA_R14-240",
  "R14-240A": "USA_R14-240A",
  "R14H-208": "USA_R14H-208",
  "R14H-240": "USA_R14H-240",
  "R21-208": "USA_R21-208",
  "R21-240": "USA_R21-240",
  "R21P3-208": "USA_R21P3-208",
  "R21P3-20A": "USA_R21P3-20A",
  "R21P3-240": "USA_R21P3-240",
  "R21P3-24A": "USA_R21P3-24A",
  "UL-208V-13": "USA_UL-208V-13",
  "UL-208V-18": "USA_UL-208V-18",
  "UL-208V-A": "USA_UL-208V-A",
  "UL240-13": "USA_UL240-13",
  "UL-240V-18": "USA_UL-240V-18",
  "common.50402.Derating": "Derating",
  "common.50402.dispatch": "Versand",
  "common.50402.fault": "Fehler",
  "common.50402.outages": "Stromrationierung und Stromausf盲lle",
  "common.50402.generation": "Netzgekoppelte Stromerzeugung",
  "common.50402.Standby": "Reserve",
  "common.50402.Planned": "Geplante Ausf盲lle",
  "common.50300.offline": "offline",
  "common.50300.Standby": "Reserve",
  "common.50300.online": "online",
  "common.50300.fault": "Fehler",
  "device.category.fox": "Fox",
  "bw_RTparam_name_TotalPowerFactor_PV1": "Gesamtleistungsfaktor (PV)1",
  "CEI0-21": "Italy_CEI 0-21",
  "common.50700.xnl_RTparam_group_Load": "Last",
  "common.50700.xnl_RTparam_group_Inverter": "Wechselrichter",
  "common.50700.xnl_RTparam_group_Grid": "Stromnetz",
  "common.50700.170": "Illegal",
  "common.50700.169": "Werkstest",
  "common.50700.168": "Im Upgrade",
  "common.50700.167": "Standby",
  "common.50700.166": "Permanente Störung",
  "common.50700.165": "Fehler",
  "common.50700.164": "Netztrennung",
  "common.50700.163": "Netzanschluss",
  "common.50700.162": "Prüfung",
  "common.50700.161": "Warten",
  "common.50700.160": "Selbsttest",
  "common.50700.TFreq": "T-Phasenfrequenz",
  "common.50700.TCurrent": "T-Phasenstrom",
  "common.50700.SVolt": "S-Phasenspannung",
  "common.50700.SPower": "S-Phasenleistung",
  "common.50700.SOH": "SOH",
  "common.50700.SoC": "SOC",
  "common.50700.SFreq": "S-Phasenfrequenz",
  "common.50700.SCurrent": "S-Phasenstrom",
  "common.50700.RVolt": "R-Phasenspannung",
  "common.50700.runningState": "Betriebszustand",
  "common.50700.RPower": "R-Phasenleistung",
  "common.50700.RFreq": "R-Phasenfrequenz",
  "common.50700.ResidualEnergy": "Batterierestladung",
  "common.50700.ReactivePower": "Blindleistung",
  "common.50700.RCurrent": "R-Phasenstrom",
  "common.50700.pvPower": "PV-Leistung",
  "common.50700.pv9Volt": "PV9-Spannung",
  "common.50700.pv9Power": "PV9-Leistung",
  "common.50700.pv9Current": "PV9-Strom",
  "common.50700.pv8Volt": "PV8-Spannung",
  "common.50700.pv8Power": "PV8-Leistung",
  "common.50700.pv8Current": "PV8-Strom",
  "common.50700.pv7Volt": "PV7-Spannung",
  "common.50700.pv7Power": "PV7-Leistung",
  "common.50700.pv7Current": "PV7-Strom",
  "common.50700.pv6Volt": "PV6-Spannung",
  "common.50700.pv6Power": "PV6-Leistung",
  "common.50700.pv6Current": "PV6-Strom",
  "common.50700.pv5Volt": "PV5-Spannung",
  "common.50700.pv5Power": "PV5-Leistung",
  "common.50700.pv5Current": "PV5-Strom",
  "common.50700.pv4Volt": "PV4-Spannung",
  "common.50700.pv4Power": "PV4-Leistung",
  "common.50700.pv4Current": "PV4-Strom",
  "common.50700.pv3Volt": "PV3-Spannung",
  "common.50700.pv3Power": "PV3-Leistung",
  "common.50700.pv3Current": "PV3-Strom",
  "common.50700.pv2Volt": "PV2-Spannung",
  "common.50700.pv2Power": "PV2-Leistung",
  "common.50700.pv2Current": "PV2-Strom",
  "common.50700.pv1Volt": "PV1-Spannung",
  "common.50700.pv1Power": "PV1-Leistung",
  "common.50700.pv1Current": "PV1 Strom",
  "common.50700.pv18Volt": "PV18-Spannung",
  "common.50700.pv18Power": "PV18-Leistung",
  "common.50700.pv18Current": "PV18-Strom",
  "common.50700.pv17Volt": "PV17-Spannung",
  "common.50700.pv17Power": "PV17-Leistung",
  "common.50700.pv17Current": "PV17-Strom",
  "common.50700.pv16Volt": "PV16-Spannung",
  "common.50700.pv16Power": "PV16-Leistung",
  "common.50700.pv16Current": "PV16-Strom",
  "common.50700.pv15Volt": "PV15-Spannung",
  "common.50700.pv15Power": "PV15-Leistung",
  "common.50700.pv15Current": "PV15-Strom",
  "common.50700.pv14Volt": "PV14-Spannung",
  "common.50700.pv14Power": "PV14-Leistung",
  "common.50700.pv14Current": "PV14-Strom",
  "common.50700.pv13Volt": "PV13-Spannung",
  "common.50700.pv13Power": "PV13-Leistung",
  "common.50700.pv13Current": "PV13-Strom",
  "common.50700.pv12Volt": "PV12-Spannung",
  "common.50700.pv12Power": "PV12-Leistung",
  "common.50700.pv12Current": "PV12-Strom",
  "common.50700.pv11Volt": "PV11-Spannung",
  "common.50700.pv11Power": "PV11-Leistung",
  "common.50700.pv11Current": "PV11-Strom",
  "common.50700.pv10Volt": "PV10-Spannung",
  "common.50700.pv10Power": "PV10-Leistung",
  "common.50700.pv10Current": "PV10-Strom",
  "common.50700.PowerFactor": "Leistungsfaktor",
  "common.50700.meterPowerT": "Zählerleistung T",
  "common.50700.meterPowerS": "Zählerleistung S",
  "common.50700.meterPowerR": "Zählerleistung R",
  "common.50700.meterPower2": "Zähler2-Leistung",
  "common.50700.meterPower": "Zählerleistung",
  "common.50700.loadsPowerT": "Last-T-Phasenleistung",
  "common.50700.loadsPowerS": "Last-S-Phasenleistung",
  "common.50700.loadsPowerR": "Last-R-Phasenleistung",
  "common.50700.loadsPower": "Lastleistung",
  "common.50700.loads": "Laststromverbrauch",
  "common.50700.invTemperation": "Invertertemperatur",
  "common.50700.invBatVolt": "Inverter-Seite Batteriespannung",
  "common.50700.invBatPower": "Inverter-Seite Batterieleistung",
  "common.50700.invBatCurrent": "Inverter-Seite Batteriestrom",
  "common.50700.gridConsumptionPower": "Netzverlustleistung",
  "common.50700.gridConsumption": "Gesamtnetzstromverbrauch",
  "common.50700.generationPower": "Erzeugungsleistung",
  "common.50700.generation": "Gesamtstromerzeugung",
  "common.50700.feedinPower": "Netzleistung",
  "common.50700.feedin": "Gesamtnetzeinspeisung",
  "common.50700.epsVoltT": "EPS-T-Phasenspannung",
  "common.50700.epsVoltS": "EPS-S-Phasenspannung",
  "common.50700.epsVoltR": "EPS-R-Phasenspannung",
  "common.50700.epsPowerT": "EPS-T-Phasenleistung",
  "common.50700.epsPowerS": "EPS-S-Phasenleistung",
  "common.50700.epsPowerR": "EPS-R-Phasenleistung",
  "common.50700.epsPower": "EPS-Leistung",
  "common.50700.epsCurrentT": "EPS-T-Phasenstrom",
  "common.50700.epsCurrentS": "EPS-S-Phasenstrom",
  "common.50700.epsCurrentR": "EPS-R-Phasenstrom",
  "common.50700.energyThroughput": "Batteriedurchsatz",
  "common.50700.dspTemperature": "DSP-Temperatur",
  "common.50700.dischargeEnergyToTal": "Gesamtentlademenge",
  "common.50700.chargeTemperature": "Ladetemperatur",
  "common.50700.chargeEnergyToTal": "Gesamtlademenge",
  "common.50700.boostTemperation": "Ladegerätetemperatur",
  "common.50700.batVolt": "Batteriespannung",
  "common.50700.batTemperature": "Batterietemperatur",
  "common.50700.batStatusV2": "Batteriezustand",
  "common.50700.batStatus": "Batteriezustand",
  "common.50700.batDischargePower": "Batterieentladeleistung",
  "common.50700.batCurrent": "Batteriestrom",
  "common.50700.batChargePower": "Batterieladeleistung",
  "common.50700.ambientTemperation": "Umgebungstemperatur",
  "common.50700.xnl_RTparam_group_Battery": "Batterie",
  "common.50702.xnl_RTparam_group_Battery": "Batterie",
  "common.50698.TVolt": "Phasenspannung T",
  "common.50700.TPower": "Phasenleistung T",
  "common.50700.TVolt": "Phasenspannung T",
  "supplier.type.ankerui": "ankerui",
  "subtype.collector.4g.meters": "4G-Messgerät",
  "param_set.xnl_inverter_Factoryresetenable": "Werkseinstellung",
  "param_set.xnl_inverter_GridMode": "Netzgekoppelter Standard",
  "param_set.xnl_inverter_GridType": "Einstellung des Rastertyps",
  "param_set.xnl_inverter_GridFrequency": "Einstellung der Netzfrequenz",
  "param_set.xnl_inverter_Restoreconnectiontime": "Wiederherstellung der Netzanschlusszeit",
  "param_set.xnl_inverter_PF": "Einstellung des Ausgangs-PF-Wertes",
  "param_set.xnl_inverter_GridFrequencyOver": "Hochfrequenz-Schutzpunkt",
  "param_set.xnl_inverter_GridFrequencyUnder": "Netzfrequenz niedriger Schutzpunkt",
  "param_set.xnl_inverter_GridVoltageOver": "Überspannungsschutzpunkt des Stromnetzes",
  "param_set.xnl_inverter_GridVoltageUnder": "Unterspannungsschutzpunkt des Stromnetzes",
  "param_set.xnl_inverter_Q(V)": "Kalifornien CA _ QV Aktivieren",
  "param_set.xnl_inverter_V1": "CA _ QV _ V1",
  "param_set.xnl_inverter_V2": "CA _ QV _ V2",
  "param_set.xnl_inverter_V3": "CA _ QV _ V3",
  "param_set.xnl_inverter_V4": "CA _ QV _ V4",
  "param_set.xnl_inverter_Q1": "CA _ QV _ Q1",
  "param_set.xnl_inverter_Q2": "CA _ QV _ Q2",
  "param_set.xnl_inverter_Q3": "CA _ QV _ Q3",
  "param_set.xnl_inverter_Q4": "CA _ QV _ Q4",
  "param_set.xnl_inverter_FW": "Kalifornien CA _ FW Aktivieren",
  "param_set.xnl_inverter_Fstart": "CA _ Fstart",
  "param_set.xnl_inverter_Fstop": "CA _ Fstop",
  "param_set.xnl_inverter_VW": "Kalifornien CA _ VW Aktivieren",
  "param_set.xnl_inverter_Vstart": "CA _ Vstart",
  "param_set.xnl_inverter_Vstop": "CA _ Vstop",
  "param_set.xnl_inverter_Normalupwardslope": "Normale Steigung",
  "param_set.xnl_inverter_Softstartriserate": "Sanftanlauf-Anstiegsrate",
  "param_set.xnl_inverter_LHVRT": "Kalifornien Niederdruck-Hochdruckübergang ermöglichen",
  "param_set.xnl_inverter_HV2": "CA _ HV2",
  "param_set.xnl_inverter_HV1": "CA _ HV1",
  "param_set.xnl_inverter_LV1": "CA _ LV1",
  "param_set.xnl_inverter_LV2": "CA _ LV2",
  "param_set.xnl_inverter_LV3": "CA _ LV3",
  "param_set.xnl_inverter_CA_HV2_Time": "CA _ HV2 _ Zeit",
  "param_set.xnl_inverter_CA_HV1_Time": "CA _ HV1 _ Zeit",
  "param_set.xnl_inverter_CA_LV1_Time": "CA _ LV1 _ Zeit",
  "param_set.xnl_inverter_CA_LV2_Time": "CA _ LV2 _ Zeit",
  "param_set.xnl_inverter_CA_LV3_Time": "CA _ LV3 _ Zeit",
  "param_set.xnl_inverter_CA_LHFRT": "Kalifornien Niederfrequenz-Hochfrequenzüberquerung CA _ LHFRT Aktivieren",
  "param_set.xnl_inverter_CA_HF2": "CA _ HF2",
  "param_set.xnl_inverter_CA_HF1": "CA _ HF1",
  "param_set.xnl_inverter_CA_LF1": "CA _ LF1",
  "param_set.xnl_inverter_CA_LF2": "CA _ LF2",
  "param_set.xnl_inverter_CA_HF2_Time": "CA _ HF2 _ Zeit",
  "param_set.xnl_inverter_CA_HF1_Time": "CA _ HF1 _ Zeit",
  "param_set.xnl_inverter_CA_LF1_Time": "CA _ LF1 _ Zeit",
  "param_set.xnl_inverter_CA_LF2_Time": "CA _ LF2 _ Zeit",
  "param_set.xnl_inverter_GeneratorInputRatedPower": "Generator-Nenneingangsleistung",
  "param_set.xnl_inverter_GENConnectToGridInput": "Der Generator ist an das Stromnetz angeschlossen",
  "param_set.xnl_inverter_SmartLoadOutput": "Leistung unter Last",
  "param_set.xnl_inverter_OnGridAlwayson00": "Netzbedingungen einschalten",
  "param_set.xnl_inverter_OFF1": "SmartLoad OFF Batteriespannung",
  "param_set.xnl_inverter_ON1": "SmartLoad ON Batteriespannung",
  "param_set.xnl_inverter_OFF2": "SmartLoad OFF Akkuladung",
  "param_set.xnl_inverter_ON2": "SmartLoad ON Akku",
  "param_set.xnl_inverter_Battery_Type": "Batterietyp",
  "param_set.xnl_inverter_Battery_Mode": "Batterie-Modus",
  "param_set.xnl_inverter_Activate Battery": "Weckflagge für Lithiumbatterien",
  "param_set.xnl_inverter_Batt Capacity": "Batteriekapazität",
  "param_set.xnl_inverter_MaxACharge": "Maximaler Ladestrom der Batterie",
  "param_set.xnl_inverter_MaxAdischarge": "Maximaler Entladestrom der Batterie",
  "param_set.xnl_inverter_GenCharge1": "Aufladen des Generators aktiviert",
  "param_set.xnl_inverter_GenSignal1": "Gen-Signal",
  "param_set.xnl_inverter_GenStartingCapacityPoint2": "Startkapazität des Generators",
  "param_set.xnl_inverter_GenMainsPowerBattery2": "Generator-Ladestrom zur Batterie",
  "param_set.xnl_inverter_MaxRunTime": "Maximale Laufzeit des Generators",
  "param_set.xnl_inverter_CoolingTime": "Abkühlung des Generators",
  "param_set.xnl_inverter_GridCharge": "Netzladung aktivieren",
  "param_set.xnl_inverter_GridSignal": "Netzsignal",
  "param_set.xnl_inverter_StartVoltageMainsPowerCharge1": "Netzladestartkapazitätspunkt",
  "param_set.xnl_inverter_ChargeCurrentBatteryMains1": "Netzladestrom für Akku",
  "param_set.xnl_inverter_Lithium Protocol": "Kommunikationsoptionen für Lithiumbatterien",
  "param_set.xnl_inverter_ShutDown": "Batterie aus",
  "param_set.xnl_inverter_Restart": "Neustart der Batterie",
  "param_set.xnl_inverter_LowBatt": "Batterie Niederspannung",
  "param_set.xnl_inverter_GenSignal ": "Netzsignal",
  "param_set.xnl_inverter_GenStartVoltageMainsPowerCharge": "Startspannungspunkt des Generators",
  "param_set.xnl_inverter_StartVoltageMainsPowerCharge": "Startspannungspunkt der Netzladung",
  "param_set.xnl_inverter_FloatVoltage": "Erhaltungsspannung",
  "param_set.xnl_inverter_AbsorptionVoltage": "Absorptionsspannung",
  "param_set.xnl_inverter_EqualizationVoltage": "Gleiche Ladespannung",
  "param_set.xnl_inverter_EqualizationdayS": "Ausgewogene Ladung wird alle paar Tage ausgeführt",
  "param_set.xnl_inverter_TEMPCO": "Temperaturkompensationswert",
  "param_set.xnl_inverter_Equalizationhours": "Ausführungszeit der Gleichgewichtsladung",
  "param_set.xnl_inverter_batteryresistancevalue": "Innenwiderstandswert der Batterie",
  "param_set.xnl_inverter_GenStartingCapacityPoint": "Startkapazität des Generators",
  "param_set.xnl_inverter_SellingFirst": "Priorität des Stromverkaufs",
  "param_set.xnl_inverter_Solarsell": "Photovoltaische Leistung",
  "param_set.xnl_inverter_MaxSolarPower": "Maximale photovoltaische Leistung",
  "param_set.xnl_inverter_MaxSellPower": "Netzgekoppelte maximale Leistung",
  "param_set.xnl_inverter_Zero-Exportpower": "Mindestbetriebsleistung",
  "param_set.xnl_inverter_EnergyPattern": "Energiemanagementmodell",
  "param_set.xnl_inverter_GridPeakShavingPower": "Spitzenrasierung des Stromnetzes",
  "param_set.xnl_inverter_GridGen10": "Netzladung aktivieren 1",
  "param_set.xnl_inverter_GridGen20": "Netzladung aktivieren 2",
  "param_set.xnl_inverter_GridGen30": "Netzladung aktivieren 3",
  "param_set.xnl_inverter_GridGen40": "Netzladung aktivieren 4",
  "param_set.xnl_inverter_GridGen50": "Netzladung aktivieren 5",
  "param_set.xnl_inverter_GridGen60": "Netzladung aktivieren 6",
  "param_set.xnl_inverter_Time1": "Zeitraum 1",
  "param_set.xnl_inverter_Time2": "Zeitraum 2",
  "param_set.xnl_inverter_Time3": "Zeitraum 3",
  "param_set.xnl_inverter_Time4": "Zeitraum 4",
  "param_set.xnl_inverter_Time5": "Zeitraum 5",
  "param_set.xnl_inverter_Time6": "Zeitraum 6",
  "param_set.xnl_inverter_Power1": "Leistung",
  "param_set.xnl_inverter_Power2": "Leistung 2",
  "param_set.xnl_inverter_Power3": "Leistung 3",
  "param_set.xnl_inverter_Power4": "Leistung 4",
  "param_set.xnl_inverter_Power5": "Leistung 5",
  "param_set.xnl_inverter_Power6": "Leistung 6",
  "param_set.xnl_inverter_BattV1": "Batteriespannung 1 ",
  "param_set.xnl_inverter_BattV2": "Batteriespannung 2 ",
  "param_set.xnl_inverter_BattV3": "Batteriespannung 3 ",
  "param_set.xnl_inverter_BattV4": "Batteriespannung 4 ",
  "param_set.xnl_inverter_BattV5": "Batteriespannung 5 ",
  "param_set.xnl_inverter_BattV6": "Batteriespannung 6 ",
  "param_set.xnl_inverter_Batt1": "Batterie 1",
  "param_set.xnl_inverter_Batt2": "Batterie 2",
  "param_set.xnl_inverter_Batt3": "Batterie 3",
  "param_set.xnl_inverter_Batt4": "Batterie 4",
  "param_set.xnl_inverter_Batt5": "Batterie 5",
  "param_set.xnl_inverter_Batt6": "Batterie 6",
  "param_set.xnl_inverter_SolarArcFaultON": "Lichtbogenfehler-Modus",
  "param_set.xnl_inverter_CTRatio": "CT-Transformationsverhältnis",
  "param_set.xnl_inverter_BackupDelay": "Ups _ Zeit",
  "param_set.xnl_inverter_Parallel1": "Parallel",
  "param_set.xnl_inverter_3P1": "Dreiphasig parallel - Messgerät CT aktivieren",
  "param_set.xnl_inverter_GenCharge": "Aufladen des Generators aktiviert",
  "param_set.xnl_inverter_GenChargeCurrentBatterMains": "Generator-Ladestrom zur Batterie",
  "param_set.xnl_inverter_Down Time": "Abkühlung des Generators",
  "param_set.xnl_inverter_Grid Charge": "Netzladung aktivieren",
  "param_set.xnl_inverter_ChargeCurrentBatterMains": "Netzladestrom für Akku",
  "param_set.xnl_inverter_GenMainsPowerBattery": "Generator-Ladestrom zur Batterie",
  "param_set.xnl_inverter_DownTime": "Abkühlung des Generators",
  "param_set.xnl_inverter_StartingCapacityPoint": "Netzladestartkapazitätspunkt",
  "param_set.xnl_inverter_MainsPowerBattery": "Netzladestrom für Akku",
  "param_set.xnl_inverter_Equalizationtime": "Ausführungszeit der Gleichgewichtsladung",
  "param_set.xnl_inverter_Parallel2": "Meister",
  "param_set.xnl_inverter_Parallel3": "Phase",
  "param_set.xnl_inverter_Parallel4": "Modbus SN",
  "param_set.xnl_inverter_3P2": "Dreiphasige Parallel-A-Phasen-Aktivierung",
  "param_set.xnl_inverter_3P3": "Dreiphasige Parallel-B-Phasen-Aktivierung",
  "param_set.xnl_inverter_3P4": "Dreiphasige Parallel-C-Phasen-Aktivierung",
  "param_set.xnl_inverter_GridGen11": "Kraftstoff / Ladefreigabe 1",
  "param_set.xnl_inverter_GridGen21": "Chaifa-Ladefreigabe 2",
  "param_set.xnl_inverter_GridGen31": "Chaifa-Ladefreigabe 3",
  "param_set.xnl_inverter_GridGen41": "Chaifa-Ladefreigabe 4",
  "param_set.xnl_inverter_GridGen51": "Chaifa-Ladefreigabe 5",
  "param_set.xnl_inverter_GridGen61": "Chaifa-Ladefreigabe 6",
  "param_set.xnl_inverter_OnGridAlwayson04": "Einschalten der Netzbedingungen - Generatorspitzen",
  "param_set.xnl_inverter_OnGridAlwayson08": "Einschalten der Netzbedingungen - Raster Peak Shaving",
  "param_set.xnl_inverter_OnGridAlwayson12": "On Grid Zustand - On Grid immer an",
  "param_set.xnl_inverter_OnGridAlwayson13": "Netzzustand einschalten - externes Relais",
  "param_set.xnl_inverter_OnGridAlwayson14": "Schalten Sie den Netzzustand ein - die Lithiumbatterie ist verloren gegangen und der Fehler wird gemeldet. Bit aktivieren",
  "param_set.xnl_inverter_OnGridAlwayson15": "Netzzustand einschalten - DRM-Freigabebit",
  "param_set.xnl_inverterGroup_BasicSettings": "Grundeinstellungen",
  "param_set.xnl_inverterGroup_GridSettings": "Netzeinstellungen",
  "param_set.xnl_inverterGroup_GeneratorSettings": "Generator-Einstellungen",
  "param_set.xnl_inverterGroup_BatterySettings": "Batterieeinstellungen",
  "param_set.xnl_inverterGroup_SystemOperatingMode": "Systembetriebsmodus",
  "param_set.xnl_inverterGroup_AdvancedSettings": "Erweiterte Einstellungen",
  "param_set.xnl_inverter_GenSignal_fdj": "Generator-Signal",
  "param_set.xnl_inverter_GenSignal_charge": "Netzsignal",
  "param_set.xnl_inverter_GenSignal_fdj_1": "Generator-Signal1",
  "param_set.xnl_inverter_GenSignal_charge_1": "Netzsignal1",
  "param_set.xnl_inverter_GenSignal_fdj_2": "Generator-Signal2",
  "param_set.xnl_inverter_GenSignal_charge_2": "Netzsignal2",
  "param_set.xnl_inverter_TimeOfUse": "Time of Use",
  "param_set.xnl_inverter_GenPortUsedFor": "Generatoranschluss, der verwendet wird für",
  "bw_RTparam_name_InverterMasterSoftwareVersion": "Inverter Master Software Version",
  "bw_RTparam_name_TotalReactivePower_Grid": "Reaktive Gesamtleistung (Netz)",
  "bw_RTparam_name_TotalApparent Power_Grid": "Scheinleistung (Netz)",
  "bw_RTparam_name_TotalPowerFactor_Grid": "Total Power Factor (Grid)",
  "bw_RTparam_name_BatteryRelayStatus": "Status des Batterie-Relais",
  "bw_RTparam_name_BatWarnningPack": "Bat Warnning Pack",
  "bw_RTparam_name_PvBoostTemperature": "Pv-Boost-Temperatur",
  "bw_RTparam_name_InvModuleTemperature": "Inv-Modultemperatur",
  "bw_RTparam_name_PowerBoardTemperature": "Leistungsplatztemperatur",
  "bw_RTparam_name_InvApparentPower": "Inv Scheinleistung",
  "bw_RTparam_name_InvActivePower": "Inv Aktive Leistung",
  "bw_RTparam_name_InvReactivePower": "Inv Reaktive Leistung",
  "bw_RTparam_name_InvPowerFactor": "Inv Leistungsfaktor",
  "bw_RTparam_name_BackupFrequency": "Backup-Frequenz",
  "bw_RTparam_name_InvCurrentR": "Inv Aktuelle R",
  "bw_RTparam_name_InvCurrentS": "Inv Aktuell S",
  "bw_RTparam_name_InvCurrentT": "Inv Aktuelle T",
  "bw_RTparam_name_BatteryMaxChargePower": "Maximale Ladeleistung der Batterie",
  "bw_RTparam_name_BatteryMaxDischargePower": "Maximale Batterieentladungsleistung",
  "bw_RTparam_name_TotalEnergyInvInput": "Total Energy Inv Input",
  "bw_RTparam_name_BackupVoltageR": "Backup Spannung R",
  "bw_RTparam_name_BackupVoltageS": "Backup Spannung S",
  "bw_RTparam_name_BackupVoltageT": "Backup Spannung T",
  "bw_RTparam_name_BackupCurrentR": "Backup Current R",
  "bw_RTparam_name_BackupCurrentS": "Backup Current S",
  "bw_RTparam_name_BackupCurrentT": "Backup Current T",
  "bw_RTparam_name_BackupPower": "Notstrom",
  "common.50300.Ia": "Strom der Phase A",
  "common.50300.Pa": "Wirkleistung der Phase A",
  "common.50300.Ib": "Strom der Phase B",
  "common.50300.Pb": "Wirkleistung der Phase B",
  "common.50300.Ic": "Strom der Phase C",
  "common.50300.Pc": "Wirkleistung der Phase C",
  "common.50300.ctTotalActivePower": "Gesamte Wirkleistung",
  "bw_value_ChargeDischargeRelaysAreDisconnected": "Die Lade- und Entladerelais sind getrennt",
  "bw_value_OnlyDischargeRelayIsClosed": "Nur der Entlade-Relais ist geschlossen",
  "bw_value_OnlyChargeRelayIsClosed": "Nur der Lade-Relais ist geschlossen",
  "bw_value_ChargeAndDischargeRelaysAreClosed": "Die Lade- und Entladerelais sind geschlossen",
  "bw_value_Single-Phase5KwModel": "Einphasiges 5-kW-Modell",
  "bw_value_SinglePhaseEnergyStorage5KwModel": "Einphasige Energiespeicherung 5Kw Modell",
  "bw_value_Single-PhaseEnergyStorage3KwModel": "Einphasige Energiespeicherung 3Kw Modell",
  "bw_value_Single-PhaseEnergyStorage6KwModel": "Einphasige Energiespeicherung 6Kw-Modell",
  "bw_value_SinglePhaseEnergyStorage8KwModel": "Einphasige Energiespeicherung 8Kw Modell",
  "bw_value_Three-Phase4KwModel": "Dreiphasiges 4-kW-Modell",
  "bw_value_Three-Phase5KwModel": "Dreiphasiges 5-kW-Modell",
  "bw_value_Three-Phase6KwModel": "Modell mit 6 kW Dreiphasenstrom",
  "bw_value_Three-Phase8KwModel": "Dreiphasiges 8-kW-Modell",
  "bw_value_ThreePhase10KwModel": "Dreiphasiges 10-kW-Modell",
  "bw_RTparam_name_TheSystemTotalPVEnergy": "Gesamte PV-Energie des Systems (einschließlich PV-Meter-Energie)",
  "bw_RTparam_name_GridFrequencyINV": "Rasterfrequenz (Form INV)",
  "device.category.heatpump": "Wärmepumpe",
  "device.category.collector": "Dongle",
  "jl_RTparam_name_powerAmmeter2": "Leistung von Zähler 2",
  "jl_RTparam_name_dayEnergyAmmeter2": "Tägliche Elektrizitätsmenge von Zähler 2",
  "jl_RTparam_name_monthEnergyAmmeter2": "Monatliche Elektrizitätsmenge von Zähler 2",
  "jl_RTparam_name_yearEnergyAmmeter2": "Jährliche Elektrizitätsmenge von Zähler 2",
  "jl_RTparam_name_totalEnergyAmmeter2": "Kumulierte Elektrizitätsmenge von Zähler 2",
  "jl_RTparam_group_Ammeter": "tromzähler",
  "ai.robot.manage.family": "Hallo, AI-Roboter verwaltet Ihren Haushaltsstromverbrauch.",
  "ai.robot.predicted.price": "Der Strompreis für heute wurde ermittelt, die heutige Erzeugung wird mit {###}kWh prognostiziert.",
  "ai.robot.regulating.heat.pump": "Die Wärmepumpe wird bei Bedarf angepasst.",
  "bw_RTparam_name_PV_ActivePowerOfAPhase": "A-Phasen-Aktivleistung (PV)",
  "bw_RTparam_name_PV_ActivePowerOfBPhase": "aktive Leistung der Phase B (PV)",
  "bw_RTparam_name_PV_ActivePowerOfCPhase": "Leistung der C-Phase (PV)",
  "bw_RTparam_name_PV_ApparentPowerOfAPhase": "Scheinleistung der Phase A (PV)",
  "bw_RTparam_name_PV_ApparentPowerOfBPhase": "Scheinleistung der Phase B (PV)",
  "bw_RTparam_name_PV_ApparentPowerOfCPhase": "Scheinleistung der C-Phase (PV)",
  "bw_RTparam_name_PV_ReactivePowerOfAPhase": "Blindleistung der Phase A (PV)",
  "bw_RTparam_name_PV_ReactivePowerOfBPhase": "Blindleistung der Phase B (PV)",
  "bw_RTparam_name_PV_ReactivePowerOfCPhase": "Blindleistung der C-Phase (PV)",
  "bw_RTparam_name_PV_PowerFactorOfAPhase": "Leistungsfaktor der Phase A (PV)",
  "bw_RTparam_name_PV_PowerFactorOfBPhase": "Leistungsfaktor der B-Phase (PV)",
  "bw_RTparam_name_PV_PowerFactorOfCPhase": "Leistungsfaktor der C-Phase (PV)",
  "bw_RTparam_name_PVConnectState": "Arbeitsbetriebsstatus",
  "bw_RTparam_name_PVMeterNegate": "PV-Zähler-Zugriffsrichtung",
  "bw_RTparam_Option_NoPV": "Keine PV",
  "bw_RTparam_Option_HasPV": "Hat PV",
  "bw_RTparam_Option_PVMeterNormal": "PV-Zähler Normal",
  "bw_RTparam_Option_PVMeterReversed": "PV-Zähler umgekehrt",
  "bw_RTparam_name_TotalPVEnergy_includePVMeter": "Gesamte PV-Erzeugung (Inside+outside INV)",
  "bw_RTparam_name_TodayYield": "INV tägliche PV-Generation",
  "bw_RTparam_name_TotalDevicePower": "Gesamte PV-Leistung",
  "bw_RTparam_name_DailyDeviceEnergy": "Totale tägliche PV-Erzeugung",
  "device.category.module": "Komponente",
  "bw_RTparam_name_TotalEnergyInvOutput": "Gesamte Energie INV Leistung",
  "common.device.check.tab.collector": "Stromnetz",
  "common.device.check.tab.grid": "Stromzählerauswahl",
  "common.device.check.tab.meterselect": "Verbindungszustand des Stromzählers",
  "common.device.check.tab.meterYes": "Verbindungszustand des Stromzählers",
  "common.device.check.tab.gridmeter": "PV-seitiger Stromzähler",
  "common.device.check.tab.pvmeter": "Batterie",
  "common.device.check.tab.battery": "SN des Kommunikationsstabs",
  "common.check.field.collectorSn": "Signalstärke",
  "common.check.field.dongleRSSI": "Hardwareversion des Kommunikationsstabs",
  "common.check.field.inverterHardwareVersion": "Softwareversion des Kommunikationsstabs",
  "common.check.field.dongleSoftwareVersion": "Netzspannung Phase R",
  "common.check.field.gridVoltageR": "Netzspannung Phase S",
  "common.check.field.gridVoltageS": "Netzspannung Phase T",
  "common.check.field.gridVoltageT": "Verbindungszustand des Stromzählers (Verbunden/Nicht verbunden)",
  "common.check.field.meterCTSelect": "Spannung Phase A des Stromzählers",
  "common.check.field.gridVoltageOfAPhase": "Strom Phase A des Stromzählers",
  "common.check.field.gridCurrentOfAPhaseV2": "Spannung Phase B des Stromzählers",
  "common.check.field.gridVoltageOfBPhase": "Strom Phase B des Stromzählers",
  "common.check.field.gridCurrentOfBPhaseV2": "Spannung Phase C des Stromzählers",
  "common.check.field.gridVoltageOfCPhase": "Strom Phase C des Stromzählers",
  "common.check.field.gridCurrentOfCPhaseV2": "Frequenz des Stromzählers",
  "common.check.field.gridFrequent": "Spannung Phase A des Stromzählers",
  "common.check.field.pvVoltageOfAPhase": "Strom Phase A des Stromzählers",
  "common.check.field.pvCurrentOfAPhase": "Spannung Phase B des Stromzählers",
  "common.check.field.pvVoltageOfBPhase": "Strom Phase B des Stromzählers",
  "common.check.field.pvCurrentOfBPhase": "Spannung Phase C des Stromzählers",
  "common.check.field.pvVoltageOfCPhase": "Strom Phase C des Stromzählers",
  "common.check.field.pvCurrentOfCPhase": "Frequenz des Stromzählers",
  "common.check.field.pvFrequent": "Scheinleistung des Stromzählers (Gesamt)",
  "common.check.field.pvTotalApparentPower": "Wirkleistung des Stromzählers (Gesamt)",
  "common.check.field.pvMeterTotalActivePower": "Blindleistung des Stromzählers (Gesamt)",
  "common.check.field.pvTotalReactivePower": "Leistungsfaktor des Stromzählers (Gesamt)",
  "common.check.field.pvTotalPowerFactor": "Effektiver Verbindungszustand der Batterie (Verbunden/Nicht verbunden)",
  "50000_0X561-M-12": "Rasterphase ist inkonsistent",
  "50000_0X561-M-13": "DCV-Probe abnormal",
  "50000_0X561-M-14": "Blackbox Flash Fehler",
  "50000_0X561-M-15": "RTC Fehler",
  "bw.content.alarm.0X55E-M-60": "Rasterphase ist inkonsistent",
  "bw.content.alarm.0X55E-M-61": "DCV-Probe abnormal",
  "bw.content.alarm.0X55E-M-62": "Blackbox Flash Fehler",
  "bw.content.alarm.0X55E-M-63": "RTC Fehler",
  "plant.deliver.type.zj": "Haier Smart Home",
  "deliver.type.energy": "Haier Energy",
  "deliver.type.smart": "Haier Smart Home",
  "VDE0126-50Hz": "France--VDE0126-50Hz",
  "VDE4105/11.18": "Germany--VDE4105/11.18",
  "AS4777.2": "Australia--AS4777.2",
  "G83_2": "G83_2",
  "C10/C11": "Belgium--C10/C11",
  "TOR Erzeuger": "Austria--TOR Erzeuger",
  "EN50549-NL": "Netherlands--EN50549-NL",
  "EN50549-DK": "EN50549-DK",
  "CEB": "CEB",
  "CEI-021": "Italy--CEI-021",
  "NRS097-2-1": "South Africa--NRS097-2-1",
  "EN50549-GR": "EN50549-GR",
  "UTE_C15_712": "UTE_C15_712",
  "IEC61727": "IEC61727",
  "G59_3": "G59_3",
  "RD1699": "Spain--RD1699",
  "G99": "UK--G99",
  "NA": "NA",
  "VDE0126-60Hz": "VDE0126-60Hz",
  "AS4777.2-SA": "Australia--AS4777.2-SA",
  "G98": "UK--G98",
  "EN50549-CZ": "EN50549-CZ",
  "PEA": "Thailand--PEA",
  "MEA": "Thailand--MEA",
  "BISI": "BISI",
  "JET-GR Series": "JET-GR Series",
  "50Hz Default": "50Hz Default",
  "60Hz Default": "60Hz Default",
  "WAREHOUSE": "WAREHOUSE",
  "AS4777.2-NZ": "Australia--AS4777.2-NZ",
  "Korea": "Korea",
  "G98/G99-IE": "UK--G98/G99-IE",
  "NCRfg": "NCRfg",
  "UL1741": "UL1741",
  "UL1741-Rule21": "UL1741-Rule21",
  "UL1741-Hawaiian": "UL1741-Hawaiian",
  "EN50549": "EU--EN50549",
  "common.50800.defrosting": "Abtauen",
  "common.50800.antiFreezing": "Frostschutz",
  "common.50800.sterilization": "Sterilisation",
  "common.50800.antiRust": "Rostschutz",
  "common.50800.auto": "automatisch",
  "common.50800.cool": "Kühlung",
  "common.50800.heat": "Heizung",
  "common.50800.dhw": "Warmwasser",
  "common.50800.pool": "Schwimmbad",
  "common.50800.heat+pool": "Heizung + Schwimmbad",
  "common.50800.auto+dhw": "automatisch + Warmwasser",
  "common.50800.cool+dhw": "Kühlung + Warmwasser",
  "common.50800.heat+dhw": "Heizung + Warmwasser",
  "bw_RTparam_name_deviceRunningState": "Arbeitsbetriebsstatus",
  "person.confirmPassword": "Passwort bestätigen",
  "supplier.type.lg": "LIGOO",
  "plant.not.delivered": "Das Kraftwerk wurde nicht geliefert",
  "plant.not.exist": "Das Kraftwerk existiert nicht",
  "device.agent.admin.can.operate": "You do not have permission to retract the delivery",
  "plant.pure.light": "Zero-Carbon Home - Reines Licht",
  "ywt.60419.meterTPower\n": "Leistung des Stromzählers Phase T",
  "ywt.60419.loadPower\n": "Lastleistung",
  "param_set.lg_inverterGroup_LithiumBattery": "Lithiumbatterie",
  "param_set.lg_inverterGroup_AdvancedSettings": "ErweiterteEinstellungen",
  "param_set.lg_inverterGroup_SystemOperationMode": "Systemarbeitsmodus",
  "param_set.lg_inverterGroup_GeneratorSettings": "Generatoreinstellungen",
  "param_set.lg_inverterGroup_ParallelOperationSettings": "ParalleleGeräteeinstellungen",
  "param_set.lg_inverterGroup_PeakShavingandValleyFillingSettings": "EinstellungenfürLastspitzenkappungundTalauffüllung",
  "param_set.lg_inverterGroup_GeneratorInputEnable": "Generator-Eingangaktivieren",
  "param_set.lg_inverterGroup_SmartLoadEnable": "IntelligenteLastaktivieren",
  "param_set.lg_inverterGroup_MicroinverterEnable": "Mikrowechselrichteraktivieren",
  "param_set.lg_inverterGroup_Battery(Shared)": "Batterie(gemeinsam)",
  "param_set.lg_inverterGroup_Lead-AcidBattery": "Bleisäurebatterie",
  "param_set.lg_inverter_SystemOn": "Systemein-/ausschaltung",
  "param_set.lg_inverter_ClearFault": "Störungenlöschen",
  "param_set.lg_inverter_ManualActivation": "ManuelleAktivierung",
  "param_set.lg_inverter_InverterRated（%）": "WechselrichterleistunginProzenteinstellen",
  "param_set.lg_inverter_PVActivePowerSetting": "PVWirkleistungseinstellung(%)",
  "param_set.lg_inverter_PVConnectorMode": "PV-Verbindungseinstellungen",
  "param_set.lg_inverter_PVStarupEnable": "Einzel-PV-Startaktivieren",
  "param_set.lg_inverter_ZeroGroundVoltFaultDetectionEnable": "Null-Erde-Spannungsfehlererkennungaktivieren",
  "param_set.lg_inverter_GFCIEnable": "Fehlerstromerkennungaktivieren",
  "param_set.lg_inverter_AllowGridCharging": "Netzladungerlauben",
  "param_set.lg_inverter_PVISOEnable": "PV-Isolationsprüfungaktivieren",
  "param_set.lg_inverter_CT/MeterOptional": "CT-ZählerAktivierungsbit",
  "param_set.lg_inverter_PhaseType": "Phasenfolgetyp",
  "param_set.lg_inverter_CTRatio": "CT-Verhältnis",
  "param_set.lg_inverter_PVOperationMode": "PV-Betriebsmodus",
  "param_set.lg_inverter_CVT1CurrentLimit": "CVT1-Strombegrenzung",
  "param_set.lg_inverter_CVT2CurrentLimit": "CVT2-Strombegrenzung",
  "param_set.lg_inverter_ChargingCurrent": "Ladestrom",
  "param_set.lg_inverter_DischargingCurrent": "Entladestrom",
  "param_set.lg_inverter_FloatChargingVoltage": "Ladeschlussspannung",
  "param_set.lg_inverter_EqualChargingVoltage": "Ausgleichsladespannung",
  "param_set.lg_inverter_CT/MeterAccessDirection": "CT/Zähler-Anschlussrichtung",
  "param_set.lg_inverter_HomeloadUnbalancedCurrentEnable": "UngleichstromverteilungHauslastaktivieren",
  "param_set.lg_inverter_BMSClearFault": "BMS-Störunglöschen",
  "param_set.lg_inverter_AFCIReset": "AFCI-Rücksetzung",
  "param_set.lg_inverter_HMIBrightness": "HMI-Helligkeit",
  "param_set.lg_inverter_HMIRestTime": "HMI-Bildschirm-Ausschaltzeit",
  "param_set.lg_inverter_StatisticClear": "Statistikenlöschen",
  "param_set.lg_inverter_EnergyPattern": "Energiemanagementmodus",
  "param_set.lg_inverter_SyncTimeEnable": "Zeitsynchronisationaktivieren",
  "param_set.lg_inverter_RSDEnable": "RSDaktivieren",
  "param_set.lg_inverter_Startuptimesetbytheinstaller": "InstallateureingestellteStartzeit",
  "param_set.lg_inverter_DynamicPassword": "DynamischesPasswort",
  "param_set.lg_inverter_ACType": "AC-Typ",
  "param_set.lg_inverter_ChargingPriorityMode": "Ladeprioritätsmodus",
  "param_set.lg_inverter_SellPowerLimit": "MaximaleEinspeiseleistungbegrenzen",
  "param_set.lg_inverter_BuzzerEnable": "Summer",
  "param_set.lg_inverter_MeterType": "Zählertyp",
  "param_set.lg_inverter_Specialfeatures": "Sonderfunktionen",
  "param_set.lg_inverter_NLineNotGrounded": "N-Leiternichtgeerdet",
  "param_set.lg_inverter_AFCIEnable": "Lichtbogenerkennungaktivieren",
  "param_set.lg_inverter_FactoryReset": "Werkeinstellungenwiederherstellen",
  "param_set.lg_inverter_AsymmetricPhaseFeeding": "AsymmetrischePhaseneinspeisung",
  "param_set.lg_inverter_ParamsChangeLock": "Parameteränderungssperre",
  "param_set.lg_inverter_SystemWorkMode": "Systemarbeitsmodus",
  "param_set.lg_inverter_SolarSell": "PV-Einspeisung",
  "param_set.lg_inverter_SignalIslandMode": "Inselnetz-Signaleingang",
  "param_set.lg_inverter_GridTOUEnable": "Netz-LastspitzenkappungZeitfensteraktivieren",
  "param_set.lg_inverter_AutoRunEnable": "AutomatischerBetriebaktivieren",
  "param_set.lg_inverter_DRMEnable": "DRMaktivieren",
  "param_set.lg_inverter_Password": "Standardpasswort",
  "param_set.lg_inverter_PasswordValidityTime": "Passwort-Gültigkeitsdauer",
  "param_set.lg_inverter_GeneratorStartMode": "Generatorstartmodus",
  "param_set.lg_inverter_GeneratorManualStartMode": "ManuellerGeneratorstart",
  "param_set.lg_inverter_Generatorpriority": "Generator-Priorität",
  "param_set.lg_inverter_GeneratorInputPort": "Generator-Eingangsanschluss",
  "param_set.lg_inverter_GeneratorPower": "Generatorleistung",
  "param_set.lg_inverter_GeneratorStartupVoltage": "Generator-Startspannung",
  "param_set.lg_inverter_GeneratorShutdownVoltage": "Generator-Stopspannung",
  "param_set.lg_inverter_GeneratorStartupSOC": "GeneratorStart-SOC",
  "param_set.lg_inverter_GeneratorShutdownSOC": "GeneratorStop-SOC(Autostart-Modus)",
  "param_set.lg_inverter_GeneratorStartSignal": "Generatorstartsignal",
  "param_set.lg_inverter_GeneratorChargeCurrent": "Generatorladestrom",
  "param_set.lg_inverter_GeneratorOperatingTimeLimit": "MaximaleGeneratorlaufzeit",
  "param_set.lg_inverter_GeneratorCutOffTime": "Generator-Abschaltzeit",
  "param_set.lg_inverter_GeneratorTOUEnable": "Generator-Lastspitzenkappungaktivieren",
  "param_set.lg_inverter_ParallelEnable": "Parallelbetriebaktivieren",
  "param_set.lg_inverter_ParallelAddress": "ParalleleGeräteadresse",
  "param_set.lg_inverter_ParallelNumber": "AnzahlparallelerGeräte",
  "param_set.lg_inverter_ParallelBatterySharingEnable": "GemeinsameBatterienutzungimParallelbetriebaktivieren",
  "param_set.lg_inverter_ParallelPhase": "PhasenfolgeparallelerGeräte",
  "param_set.lg_inverter_ParallelMode": "Parallelmodus",
  "param_set.lg_inverter_Year/Month": "Jahr/Monat",
  "param_set.lg_inverter_Day/Reserve": "Tag/Reserviert",
  "param_set.lg_inverter_Hour/Minute": "Stunde/Minute",
  "param_set.lg_inverter_Second/Week": "Sekunde/Woche",
  "param_set.lg_inverter_TOUStartTime1": "Lade-/Entlade-Startzeit1fürLastspitzenkappung/Talauffüllung",
  "param_set.lg_inverter_TOUEndTime1": "Lade-/Entlade-Endzeit1fürLastspitzenkappung/Talauffüllung",
  "param_set.lg_inverter_Time1TOUPower": "Netzlade-/entladeleistungZeit1",
  "param_set.lg_inverter_TOUStartTime2": "Lade-/Entlade-Startzeit2fürLastspitzenkappung/Talauffüllung",
  "param_set.lg_inverter_TOUEndTime2": "Lade-/Entlade-Endzeit2fürLastspitzenkappung/Talauffüllung",
  "param_set.lg_inverter_Time2TOUPower": "Netzlade-/entladeleistungZeit2",
  "param_set.lg_inverter_TOUStartTime3": "Lade-/Entlade-Startzeit3fürLastspitzenkappung/Talauffüllung",
  "param_set.lg_inverter_TOUEndTime3": "Lade-/Entlade-Endzeit3fürLastspitzenkappung/Talauffüllung",
  "param_set.lg_inverter_Time3TOUPower": "Netzlade-/entladeleistungZeit3",
  "param_set.lg_inverter_TOUStartTime4": "Lade-/Entlade-Startzeit4fürLastspitzenkappung/Talauffüllung",
  "param_set.lg_inverter_TOUEndTime4": "Lade-/Entlade-Endzeit4fürLastspitzenkappung/Talauffüllung",
  "param_set.lg_inverter_Time4TOUPower": "Netzlade-/entladeleistungZeit4",
  "param_set.lg_inverter_TOUStartTime5": "Lade-/Entlade-Startzeit5fürLastspitzenkappung/Talauffüllung",
  "param_set.lg_inverter_TOUEndTime5": "Lade-/Entlade-Endzeit5fürLastspitzenkappung/Talauffüllung",
  "param_set.lg_inverter_Time5TOUPower": "Netzlade-/entladeleistungZeit5",
  "param_set.lg_inverter_TOUStartTime6": "Lade-/Entlade-Startzeit6fürLastspitzenkappung/Talauffüllung",
  "param_set.lg_inverter_TOUEndTime6": "Lade-/Entlade-Endzeit6fürLastspitzenkappung/Talauffüllung",
  "param_set.lg_inverter_Time6TOUPower": "Netzlade-/entladeleistungZeit5",
  "param_set.lg_inverter_Time1TOUSOC": "Batterie-SOCZeit1fürLastspitzenkappung",
  "param_set.lg_inverter_Time2TOUSOC": "Batterie-SOCZeit2fürLastspitzenkappung",
  "param_set.lg_inverter_Time3TOUSOC": "Batterie-SOCZeit3fürLastspitzenkappung",
  "param_set.lg_inverter_Time4TOUSOC": "Batterie-SOCZeit4fürLastspitzenkappung",
  "param_set.lg_inverter_Time5TOUSOC": "Batterie-SOCZeit5fürLastspitzenkappung",
  "param_set.lg_inverter_Time6TOUSOC": "Batterie-SOCZeit6fürLastspitzenkappung",
  "param_set.lg_inverter_Time1TOUVoltage": "LastspitzenkappungSpannungZeit1",
  "param_set.lg_inverter_Time2TOUVoltage": "LastspitzenkappungSpannungZeit2",
  "param_set.lg_inverter_Time3TOUVoltage": "LastspitzenkappungSpannungZeit3",
  "param_set.lg_inverter_Time4TOUVoltage": "LastspitzenkappungSpannungZeit4",
  "param_set.lg_inverter_Time5TOUVoltage": "LastspitzenkappungSpannungZeit5",
  "param_set.lg_inverter_Time6TOUVoltage": "LastspitzenkappungSpannungZeit6",
  "param_set.lg_inverter_TOUWeek": "LastspitzenkappungWochenparameter",
  "param_set.lg_inverter_GENTOUEnable": "Generator-LastspitzenkappungZeitfensteraktivieren",
  "param_set.lg_inverter_SmartLoadSetting": "SmartLoadEinstellungen",
  "param_set.lg_inverter_SmartLoadStopVoltage": "IntelligenteLastAbschaltspannung",
  "param_set.lg_inverter_GeneratorLinktoInput": "GeneratormitNetzeingangverbunden",
  "param_set.lg_inverter_MicroINVLinkLoad": "MikrowechselrichtermitLastseiteverbunden",
  "param_set.lg_inverter_MicroINVLinkGrid": "MikrowechselrichtermitNetzseiteverbunden",
  "param_set.lg_inverter_SolarPower": "Solarleistung",
  "param_set.lg_inverter_GridAlwaysOn": "Netzimmereingeschaltet",
  "param_set.lg_inverter_OffGridDisconnection": "Inselnetzsoforttrennen",
  "param_set.lg_inverter_SmartLoadONSOC": "IntelligenteLastStart-SOC",
  "param_set.lg_inverter_SmartLoadOFFSOC": "IntelligenteLastStopp-SOC",
  "param_set.lg_inverter_ACCoupleFreqUpperLimit": "ACCoupleFrequenzobergrenzeeinstellen",
  "param_set.lg_inverter_MicroINVOutputtoGrid": "MikrowechselrichterEinspeisunginsNetzabschalten",
  "param_set.lg_inverter_MicroINVOFFSOC": "MikrowechselrichterAbschalt-SOC",
  "param_set.lg_inverter_MicroINVONSOC": "MikrowechselrichterStart-SOC",
  "param_set.lg_inverter_SmartLoadStartVoltage": "IntelligenteLastEinschaltspannung",
  "param_set.lg_inverter_SmartLoadDuration": "IntelligenteLastEinschaltdauer",
  "param_set.lg_inverter_SmartLoadStartTime": "IntelligenteLastStartzeit",
  "param_set.lg_inverter_SmartLoadEndTime": "IntelligenteLastEndzeit",
  "param_set.lg_inverter_BatteryType": "Batterietyp",
  "param_set.lg_inverter_BatteryInputMode": "Batterieanschlussmodus",
  "param_set.lg_inverter_BatteryFailureShutdown": "Batterie-KommunikationsfehlerAbschaltung",
  "param_set.lg_inverter_GridChargeEnable": "Netzladungaktivieren",
  "param_set.lg_inverter_GridSignal": "Netzsignal",
  "param_set.lg_inverter_GridChargeCurrent": "Netzladestrom",
  "param_set.lg_inverter_GridStartupSOC": "NetzStart-SOC",
  "param_set.lg_inverter_BatteryLowCostMode": "Batterie-Sparmodus",
  "param_set.lg_inverter_LowNoiseMode": "Batterie-Leisemodus",
  "param_set.lg_inverter_StrongchargeSOC": "SOC-PunktfürZwangsladung",
  "param_set.lg_inverter_StrongchargeStopSOC": "SOC-PunktfürZwangsladungsende",
  "param_set.lg_inverter_StrongchargeSOCEN": "SOCfürZwangsladungaktivieren",
  "param_set.lg_inverter_LithiumBatteryManufacturers": "Lithiumbatterie-Hersteller",
  "param_set.lg_inverter_ChargingVoltage": "Ladespannung",
  "param_set.lg_inverter_ChargingCurrentLimit": "MaximalerLadestrom",
  "param_set.lg_inverter_DischargingCurrentLimit": "MaximalerEntladestrom",
  "param_set.lg_inverter_DischargingShutdownVoltage": "Batterie-Entladeschlussspannung",
  "param_set.lg_inverter_BatteryLowVoltage": "Batterie-Entlade-Niederspannungspunkt",
  "param_set.lg_inverter_DischargingShutdownSOC": "Batterie-Entladeschluss-SOC",
  "param_set.lg_inverter_ChargingEndSOC": "Batterie-Ladeschluss-SOC",
  "param_set.lg_inverter_BatteryLowSOC": "Batterie-Niedrigenergie-SOC",
  "param_set.lg_inverter_BatteryRestartSOC": "Batterie-Neustart-SOC",
  "param_set.lg_inverter_AutoForced-chargeEnable": "AutomatischeZwangsladungaktivieren",
  "param_set.lg_inverter_AutoActivationEnable": "AutomatischeBatterieaktivierungaktivieren",
  "param_set.lg_inverter_BatteryTriggerVoltage": "Batterieaktivierungsspannung",
  "param_set.lg_inverter_BatteryTriggerTime": "Batterieaktivierungsdauer",
  "param_set.lg_inverter_DisableFloatCharge": "Ladeschlussdeaktivieren",
  "param_set.lg_inverter_CV-CCChargingTime": "CV-zu-CC-Ladezeit",
  "param_set.lg_inverter_CC-CVChargingTime": "CC-zu-CV-Ladezeit",
  "param_set.lg_inverter_CC-FCChargingTime": "Ausgleichs-zu-Ladeschluss-Ladezeit",
  "param_set.lg_inverter_LeadAcidOvervolt": "Bleisäure-Überspannungspunkt",
  "param_set.lg_inverter_LeadAcidBatteryType": "Bleisäure-Batterietyp",
  "param_set.lg_inverter_BatteryRatedCapacity": "Batterienennkapazität",
  "param_set.lg_inverter_BatteryOverTempVoltage": "Batterie-Übertemperaturschutzpunkt",
  "param_set.lg_inverter_TempCompensationFactor": "Batterie-Temperaturkompensationskoeffizient",
  "param_set.lg_inverter_BatteryRestartVoltage": "Batterie-Wiederherstellungsspannung",
  "param_set.lg_inverter_EC-FCChargeCurrent": "Ausgleichs-zu-Ladeschluss-Ladestrom",
  "param_set.lg_inverter_FC-ECChargeCurrent": "Ladeschluss-zu-Ausgleichsladestrom",
  "param_set.lg_inverter_CCChargingTimeLimit": "MaximaleKonstantstrom-Ausgleichsladezeit",
  "param_set.lg_inverter_CVChargingTimeLimit": "MaximaleKonstantspannungs-Ausgleichsladezeit",
  "status.enable": "enable",
  "status.disable": "disable",
  "end.app": "app",
  "end.backend": "backend",
  "module.product_management": "Produktmanagement",
  "module.plant_management": "Anlagenverwaltung",
  "module.shipment_management": "Versandmanagement",
  "module.device_management": "Geräteverwaltung",
  "module.device_detail": "Gerätedetail",
  "module.org_management": "Organisationsmanagement",
  "module.login_register": "Login Registrieren",
  "module.user_management": "Benutzerverwaltung",
  "module.family_management": "Familienmanagement",
  "module.physical_model": "Physikalisches Modell",
  "module.dictionary_value": "Wörterbuchswert",
  "param.name.dongle.reset.returnTip": "Dongle erfolgreich zurückgesetzt. Bitte verbinden Sie es erneut.",
  "bw_RTparam_name_AFCI_Version": "AFCI-Versionsnummer",
  "bw_RTparam_name_BB_Version": "Backup Box-Versionsnummer",
  "test.code": "",
  "test.code1": "",
  "test.code3": "",
  "test.code.222": "",
  "dict.sttaus.not.normal": "de",
  "dict.status.normal": "de",
  "rr": "222",
  "dict..status.not.normal": "de",
  "org.keyFilter": "Geben Sie ein Stichwort zur Filterung ein",
  "dict.status.not.normal": "de-normal",
  "test": "",
  "role.status.abnormal": "Ungewöhnlich",
  "filter.all.blank.null": "Alle Übersetzungsversionen sind leer.",
  "shipment.confirmDownload": "Liste herunterladen",
  "shipment.updateCustomer": "Versandkunden aktualisieren",
  "shipment.invalidEquipmentList": "Möchten Sie die Liste der Geräte herunterladen, die die Validierung nicht bestanden haben? (Gültig für 10 Minuten) Anzahl ungültiger Geräte:",
  "plant.smart.investment": "Zero-Carbon Smart Investment",
  "module.oversea": "Ticketverwaltung",
  "published": "veröffentlicht",
  "income.unit.cny.pkr": "PKR",
  "alarmInfo.time": "Temps d'alerte",
  "alarmInfo.duration": "Durée de l'alerte",
  "alarmInfo.level": "Niveau d'alerte",
  "alarmInfo.triggerCondition": "Conditions de déclenchement",
  "alarmInfo.reason": "Raisons de l'alerte",
  "alarmInfo.handleTime": "Temps de traitement",
  "alarmInfo.handleType": "Type de traitement",
  "common.maintain": "Bitte zuerst pflegen",
  "device.robotChannel": "Roboter",
  "device.communicationChannel": "Kommunikationsstab",
  "device.channelType": "Kommunikationskanal",
  "device.switchChannelFailed": "Kommunikationskanal konnte nicht gewechselt werden",
  "test.chuneng": "chuneng",
  "filter.th_th.blank.null": "Thailändische Übersetzungsversionen sind leer.",
  "filter.adsf": "Thailändische Übersetzungsversionen",
  "filter.tyu": "Thailändische Übersetzungsversionen",
  "Manual": "Manuell",
  "System": "System",
  "Photovoltaic": "aaaaaaaaaa",
  "Processed": "Verarbeitet",
  "Critical": "Kritisch",
  "Urgent": "Dringend",
  "Severe": "Schwerwiegend",
  "General": "Allgemein",
  "Reminder": "Erinnerung",
  "common.cropper": "Bildzuschnitt",
  "common.confirmCropper": "Bestätigen Sie das Zuschneiden",
  "welcome": "",
  "device.operatingDataInfoTip": "Hinweis: Wenn dieses Feld leer ist, wenden Sie sich bitte an den IoT-Plattformadministrator zur Konfiguration.",
  "dynamic.price.not.exist": "Dynamischer Strompreis konnte nicht abgerufen werden",
  "product.pleaseUploadAtLeastOneImage": "Bitte laden Sie mindestens ein Bild hoch.",
  "device.importTemplateDownload": "Importvorlage herunterladen",
  "device.snNumber": "SN-Nummer",
  "device.enterSnCode": "Bitte geben Sie den SN-Code ein",
  "device.enterSupplierSN": "Bitte geben Sie die Lieferanten-SN ein",
  "device.deviceModelLabel": "Gerätemodell",
  "device.importTip": "Bitte importieren Sie den entsprechenden Kraftwerkscode, Gerätenamen, SN-Nummer und MDM-Code",
  "device.importTip2": "Bitte importieren Sie den entsprechenden Gerätenamen, SN-Nummer und MDM-Code",
  "device.keepAtLeastOneRow": "Mindestens eine Zeile behalten",
  "device.importSuccessWithCount": "{count} Gerätedatensätze erfolgreich importiert",
  "device.fillAllRequiredFields": "Bitte füllen Sie alle Pflichtfelder vollständig aus",
  "device.enterPlantCode": "Bitte geben Sie den Kraftwerkscode ein",
  "device.plantCodeLabel": "Kraftwerkscode",
  "device.supplierSNLabel": "Lieferanten-SN",
  "device.importTemplateEmpty": "Importvorlage ist leer",
  "plant.plantCategory": "Type de station électrique",
  "plant.plantCode": "Codage de la station",
  "plant.energyStorageCapacity": "Capacité de stockage d'énergie",
  "plant.energyStoragePower": "Energiespeicherleistung",
  "plant.gridConnectionMode": "Moyens de surfer sur Internet",
  "plant.img": "Photos de la station",
  "device.realTimeMonitoring": "Surveillance en temps réel",
  "device.propertyName": "Nom de la propriété",
  "device.issueCommand": "Posté en bas",
  "device.history": "histoire",
  "device.properName": "nom",
  "device.daterange": "personnalisé",
  "device.near24h": "Près de 24 heures",
  "device.date": "Aujourd'hui",
  "device.near3d": "Près de 3 jours",
  "device.chartModule": "Module de diagramme",
  "device.lineChart": "graphique",
  "device.barChart": "Diagramme des colonnes",
  "device.dateRangeDayError": "La plage de dates doit être dans {scope} jours",
  "device.SOCHistoryData": "données historiques",
  "device.paramSave": "Posté sous paramètres",
  "common.deleteTip": "Confirmer supprimer {scope}?",
  "product.deleteConfirm": "Möchten Sie das Produkt {productName} wirklich löschen?",
  "upgrade.upgradeSN": "SN aktualisieren",
  "upgrade.datalogSN": "Datenprotokoll SN",
  "upgrade.upgradeType": "Typ des Upgrades",
  "upgrade.fileAddress": "Dateiadresse",
  "upgrade.plantTime": "Kraftwerkszeit",
  "upgrade.timeUTC8": "Zeit (UTC+8)",
  "upgrade.timeServer": "Zeit (Server)",
  "upgrade.content": "Inhalt",
  "upgrade.account": "Konto",
  "upgrade.devicesSN": "Geräte SN",
  "firmware.secretType": "Geheime Art",
  "product.ratedPowerOnTheACSide": "Nennleistung auf der AC-Seite (kW)",
  "product.ratedPowerOnTheDCSide": "Nennleistung auf der DC-Seite (kW)",
  "product.energyStoragePower": "Energiespeicherleistung (kW)",
  "product.energyStorageCapacity": "Energiespeicherkapazität (kWh)",
  "iot.device.register.failed": "Registrierung des IoT-Geräts fehlgeschlagen",
  "common.title": "Einstellungen für Spaltenanzeige",
  "common.fixedLeft": "Links fixiert",
  "common.fixedRight": "Rechts fixiert",
  "common.notFixed": "Nicht fixiert",
  "common.unfix": "Fixierung aufheben",
  "common.resetSuccess": "Spalteneinstellungen erfolgreich zurückgesetzt",
  "alarmInfo.exceptionDesc": "Fehlerbeschreibung",
  "alarmInfo.suggestion": "Handlungsempfehlung",
  "language.syncIot": "IoT-Alarm synchronisieren",
  "language.syncSuccess": "Qingluo IoT Alarmkonfiguration erfolgreich synchronisiert",
  "plant.saveTimezoneTip": "Eine Änderung der Zeitzone kann Folgendes verursachen:\nLücken oder Überschneidungen in den Gerätedaten-Diagrammen (dauert mehrere Stunden)\nLokale Geräteaufgaben können durcheinandergeraten und kurzzeitig offline gehen",
  "plant.deviceCount": "Anzahl installierter Geräte",
  "common.rangeErrorTip": "{scope} Bereich falsch, bitte bestätigen",
  "expired": "abgelaufen",
  "due.today": "heute fällig",
  "sidebar.bulletinBoard": "Installation",
  "sidebar.dataQuery": "Datenabfrage",
  "plant.electrovalence": "Configuration des Tarifs",
  "plant.energy_management": "Gestion de l'énergie",
  "plant.energy_todayStrategy": "Stratégie du jour",
  "plant.energy_PeakShavingAndValleyFilling": "Lissage de charge (Effacement des pics / Remplissage des creux)",
  "plant.energy_ValidTime": "Période valide",
  "plant.energy_Charging": "Charge",
  "plant.energy_Discharging": "Décharge",
  "plant.energy_SelectStartTime": "Choisir l'heure de début",
  "plant.energy_StrategyName": "Nom de la stratégie",
  "plant.energy_StrategyType": "Type de stratégie",
  "plant.energy_Status": "Statut",
  "plant.energy_No": "N°",
  "plant.energy_StartDate": "Date de début",
  "plant.energy_EndDate": "Date de fin",
  "plant.energy_AddStrategy": "Ajouter une stratégie",
  "plant.energy_EffectiveTime": "Heure d'effet",
  "plant.energy_SelectStrategy": "Choisir une stratégie",
  "plant.energy_SelectCorrespondingStrategy": "Choisir la stratégie correspondante",
  "plant.energy_ConfirmAndDeploy": "Confirmer et déployer",
  "plant.energy_PleaseConfirmSaveAndDeployTheStrategy": "Veuillez confirmer, sauvegarder et déployer la stratégie.",
  "plant.energy_Cancel": "Annuler",
  "plant.energy_PleaseConfirmStrategyDeletion": "Veuillez confirmer la suppression de la stratégie.",
  "plant.energy_IfNoOtherStrategyExistsExecuteManualStrategy": "S'il n'y a pas d'autre stratégie, exécutez la stratégie manuelle.",
  "plant.energy_PriorityChargingTime": "Période de charge prioritaire",
  "plant.energy_PriorityDischargingTime": "Période de décharge prioritaire",
  "plant.energy_PVConsumptionPeriod": "Période de consommation PV",
  "plant.energy_StartTime": "Heure de début",
  "plant.energy_EndTime": "Heure de fin",
  "plant.energy_ChargingPower": "Puissance de charge",
  "plant.energy_DischargingPower": "Puissance de décharge",
  "plant.energy_SOCUpperLimit": "Limite supérieure de SOC",
  "plant.energy_SOCLowerLimit": "Limite inférieure de SOC",
  "plant.energy_Action": "Action",
  "plant.energy_AddTimePeriod": "Ajouter une période",
  "plant.energy_ChargingStatus": "État de charge",
  "plant.energy_DischargingPower_kW": "Puissance de décharge (kW)",
  "plant.energy_copyStrategy": "Copier la stratégie",
  "plant.energy_examine": "Voir",
  "plant.energy_delete": "Supprimer",
  "plant.energy_edit": "Modifier",
  "plant.energy_basicInfo": "Informations de base",
  "plant.energy_PriorityChargingDischargingTime": "Période de charge et décharge prioritaires",
  "plant.energy_PeakShavingAtLeastOne": "Conservez au moins une entrée.",
  "plant.energy_overlapTime": "Ne chevauchez pas les périodes.",
  "plant.energy_cover24hour": "Les périodes doivent couvrir 24 heures.",
  "plant.energy_PleaseConfirmStrategyModification": "Veuillez confirmer la modification de la stratégie.",
  "plant.energy_Strategy": "Stratégie",
  "plant.energy_cutOff_SOC": "SOC d‘arrêt",
  "plant.energy_EditStrategy": "Modifier la stratégie",
  "plant.energy_ExamineStrategy": "Voir la stratégie",
  "plant.energy_photovoltaic_storage_peak_valley_explain1": "1) Période de charge prioritaire : Charge la batterie avec l‘excédent d’énergie PV et l‘électricité du réseau (heures creuses) pour atteindre la valeur SOC définie ; la batterie ne se décharge pas.",
  "plant.energy_photovoltaic_storage_peak_valley_explain2": "2) Période de décharge prioritaire : L‘excédent PV charge la batterie. En cas d’insuffisance PV, la batterie se décharge en priorité jusqu‘à la limite SOC définie ; l’alimentation par le réseau est secondaire.",
  "plant.energy_photovoltaic_storage_peak_valley_explain3": "3) Période de consommation PV : L‘énergie PV est prioritairement utilisée pour la charge, puis pour charger la batterie (jusqu’à la limite supérieure de SOC), et enfin, le surplus est limité ou injecté au réseau. En cas d‘insuffisance PV, la batterie se décharge d’abord (jusqu‘à la limite inférieure de SOC), puis l’alimentation par le réseau prend le relais.",
  "plant.energy_photovoltaic_storage_peak_valley_explain4": "4) Autres périodes : L‘énergie PV est prioritairement utilisée pour la charge, puis pour charger la batterie (jusqu’à la limite supérieure de SOC), et enfin, le surplus est limité ou injecté au réseau. La batterie ne se décharge pas.",
  "plant.energy_peak_shaving_valley_filling_explain": "Stratégie qui planifie la charge/décharge de la batterie pour réduire la charge de pointe et combler la demande en période creuse, afin d‘atteindre une utilisation équilibrée des ressources.",
  "plant.energy_photovoltaic_consumption_self_consumption_explain": "L‘énergie PV est prioritairement utilisée pour la charge, puis consommée par la batterie, et enfin, la production PV est limitée pour éviter tout retour vers le réseau. En cas d’insuffisance PV, la batterie se décharge en priorité, puis l‘alimentation par le réseau prend le relais. ",
  "plant.energy_photovoltaic_consumptionsurplus_power_grid_feed_in_explain": "L‘énergie PV est prioritairement utilisée pour la charge, puis consommée par la batterie, et enfin, le surplus est injecté au réseau. En cas d’insuffisance PV, la batterie se décharge en priorité, puis l‘alimentation par le réseau prend le relais.",
  "plant.energy_smart_strategy_station_profit_priority_explain": "Intègre des objectifs multidimensionnels tels que les tarifs en heures pleines/creuses, la consommation PV, l‘arbitrage pointe-creux, la prévision PV et de charge, et la gestion de la demande. Sous prétexte d’assurer un fonctionnement stable du micro-réseau, un robot IA calcule et résout intelligemment la planification optimale pour le stockage d‘énergie et les charges ajustables, maximisant ainsi les revenus globaux du site.",
  "plant.energy_manual_mode_explain": "Actuellement, il n’y a pas de stratégie de répartition pour le PV et le stockage. Veuillez aller sur la page des appareils pour une opération manuelle.",
  "plant.energy_SOCUpperLowerLimits": "SOC-Ober- und Untergrenzen",
  "plant.energy_ChargeDischargePower": "Lade- und Entladeleistung",
  "plant.energy_ChargeDischargeStatus": "Lade- und Entladestatus",
  "system.physicalModels": "Dingmodell-Verwaltung",
  "subtitle.physicalModelsDetail": "Dingmodell-Details",
  "physicalModels.functionSet": "Funktionssatz",
  "physicalModels.minItemsTip": "Mindestens {scope} Element(e) müssen erhalten bleiben",
  "physicalModels.conflictTip": "Konfliktzeitraum: {scope}",
  "physicalModels.name": "Konfigurationsname",
  "physicalModels.jsonCorrect": "JSON-Format ist korrekt",
  "physicalModels.jsonCorrectTip": "JSON-Format ist korrekt (Validierungsdienst nicht verbunden)",
  "physicalModels.jsonInCorrect": "JSON-Format ist falsch",
  "physicalModels.deleteFailed": "Löschen fehlgeschlagen",
  "physicalModels.loadPreviewFailed": "Laden der Vorschaukonfiguration fehlgeschlagen",
  "physicalModels.configEditor": "Konfigurationseditor",
  "physicalModels.selectTemplate": "Voreingestellte Vorlage auswählen",
  "physicalModels.jsonConfig": "JSON-Konfiguration",
  "physicalModels.realTimePreview": "Echtzeit-Vorschau",
  "physicalModels.checkJsonFormat": "Bitte überprüfen Sie, ob das JSON-Format korrekt ist",
  "physicalModels.readDataStructure": "Datenstruktur lesen",
  "physicalModels.userBehaviorData": "Rohdaten des Benutzerverhaltens",
  "physicalModels.actualDataData": "Tatsächlich übermittelte Daten",
  "physicalModels.ready": "Bereit",
  "physicalModels.previewConfigLoaded": "Vorschaukonfiguration geladen",
  "physicalModels.pasteFromClipboard": "Aus Zwischenablage eingefügt",
  "physicalModels.pasteFromClipboardTip": "Bitte hängen Sie die Geräte-SN an den Browserpfad an, zum Beispiel:",
  "physicalModels.error": "Fehler",
  "plant.createType": "Erstellt von",
  "physicalModels.jsonComplete": "JSON-Vervollständigung",
  "physicalModels.jsonCompleteTip": "Wenn das JSON gespeichert wurde, kann eine erneute Vervollständigung zu Produktionsproblemen führen. Bitte gehen Sie vorsichtig vor.",
  "physicalModels.maxItemsTip": "Maximal {scope} Element(e) sind zulässig",
  "physicalModels.Empty": "{scope} darf nicht leer sein",
  "Setting.timeSet": "",
  "plantScreen.singleSiteScree.PVPower": "PV-Leistung",
  "plantScreen.singleSiteScree.GridImportPower": "Netzbezugsleistung",
  "plantScreen.singleSiteScree.GridExportPower": "Netzeinspeiseleistung",
  "plantScreen.singleSiteScree.ChargingPower": "Ladeleistung",
  "plantScreen.singleSiteScree.DischargingPower": "Entladeleistung",
  "plantScreen.singleSiteScree.LoadPower": "Lastleistung",
  "plantScreen.singleSiteScree.SelfConsumptionRate": "Eigenverbrauchsquote",
  "plantScreen.ChartSet.GenerationPower": "Erzeugungsleistung",
  "plantScreen.ChartSet.DayAheadForecast": "Day-Ahead-Prognose",
  "plantScreen.ChartSet.RealTimeForecast": "Echtzeitprognose",
  "plantScreen.ChartSet.RealTimeScheduling": "Echtzeit-Einsatzplanung",
  "plantScreen.ChartSet.DayAheadScheduling": "Day-Ahead-Einsatzplanung",
  "plantScreen.PlantInfo": "Kraftwerksinformationen",
  "plantScreen.PhotovoltaicCapacity": "PV-installierte Leistung",
  "plantScreen.StorageCapacity": "Batteriekapazität",
  "plantScreen.EnergyDispatch": "Energieeinsatzplanung",
  "plantScreen.SelfGenerationRate": "Eigenstromquote",
  "plantScreen.DailyStorageCharging": "Täglich geladene Energie",
  "plantScreen.DailyStorageDischarging": "Täglich entladene Energie",
  "plantScreen.DailyElectricitySold2": "Täglich verkaufter Strom",
  "plantScreen.ChartSet.Storage": "Energiespeicher",
  "plantScreen.ChartSet.Solar": "PV",
  "plantScreen.ChartSet.Load": "Last",
  "plantScreen.ChartSet.ChargeDischargePower": "Lade-/Entladeleistung",
  "plantScreen.coal": "Kohle",
  "physicalModels.missingIoTIdTip": "Fehlende IoTId oder virtualId, bitte überprüfen",
  "org.authCompanyName": "Zertifizierter Firmenname",
  "org.serviceAddress": "Serviceadresse",
  "org.servicePhone": "Servicetelefon",
  "org.serviceEmail": "Service-E-Mail",
  "org.companyLogo": "Firmenlogo",
  "org.websiteUrl": "Website-URL",
  "org.partnerId": "Partner-ID",
  "org.serviceAgreement": "Dienstleistungsvereinbarung",
  "org.serviceCertificate": "Zertifikat",
  "physicalModels.slotId": "Werbe-ID",
  "report.dataQuery.maxDevicesWarning": "Es können höchstens 10 Geräte ausgewählt werden",
  "report.dataQuery.maxParamsWarning": "Es können höchstens 10 Parameter ausgewählt werden",
  "report.dataQuery.selectDeviceAndParamsFirst": "Bitte wählen Sie zuerst Geräte und Parameter",
  "report.dataQuery.chartTitle": "Trendvergleich mehrerer Betriebsdaten",
  "report.dataQuery.selectDevice": "Gerät auswählen",
  "report.dataQuery.placeholderSelectDevice": "Bitte Gerät auswählen",
  "report.dataQuery.tabByModel": "Nach Modell",
  "report.dataQuery.tabByStation": "Nach Anlage",
  "report.dataQuery.modelGroupName": "Modellname",
  "report.dataQuery.noMore": "Nichts weiteres",
  "report.dataQuery.selectedDevicesFooter": "Ausgewählt {current} / 10 Geräte",
  "report.dataQuery.selectedDevicesShort": "Ausgewählte Geräte",
  "report.dataQuery.clear": "Leeren",
  "report.dataQuery.noDeviceSelectedYet": "Noch kein Gerät ausgewählt",
  "report.dataQuery.selectParamsTitle": "Parameter auswählen (max. 10)",
  "report.dataQuery.maxParamsHint": "Bis zu 10 Parameter gleichzeitig",
  "report.dataQuery.searchParamsPlaceholder": "Parameter suchen",
  "report.dataQuery.noMatchingParams": "Keine passenden Parameter",
  "report.dataQuery.selectDeviceFirst": "Bitte zuerst ein Gerät auswählen",
  "report.dataQuery.placeholderDeviceSn": "Geräteseriennummer eingeben",
  "report.dataQuery.placeholderModelName": "Modellname eingeben",
  "report.dataQuery.placeholderStationName": "Anlagenname eingeben",
  "report.dataQuery.selectedDevicesSummary": "{count} Geräte ausgewählt",
  "report.dataQuery.startAnalysis": "Analyse starten",
  "report.dataQuery.emptyGuide": "Klicken Sie oben links auf „Gerät auswählen“, wählen Sie bis zu 10 Geräte zur Analyse, dann Parameter und einen Zeitraum, um zu starten",
  "report.dataQuery.noDataHint": "Für die aktuelle Abfrage liegen keine anzeigbaren Daten vor. Passen Sie Geräte, Parameter oder den Zeitraum an und versuchen Sie es erneut",
  "report.dataQuery.tableTitle": "Betriebsdatenvergleich mehrerer Geräte",
  "report.dataQuery.peakLabel": "Maximum:",
  "report.dataQuery.peakColor": "Rot",
  "report.dataQuery.valleyLabel": "Minimum:",
  "report.dataQuery.valleyColor": "Blau",
  "report.dataQuery.timeByDay": "Pro Tag",
  "report.dataQuery.timeByWeek": "Pro Woche",
  "report.dataQuery.timeByMonth": "Pro Monat",
  "report.dataQuery.timeByCustom": "Benutzerdefiniert",
  "report.dataQuery.highlightNone": "Keine Hervorhebung",
  "report.dataQuery.highlightCol": "Spalten-Differenz hervorheben",
  "report.dataQuery.highlightRow": "Zeilen-Differenz hervorheben",
  "report.dataQuery.weekdayMon": "Mo",
  "report.dataQuery.weekdayTue": "Di",
  "report.dataQuery.weekdayWed": "Mi",
  "report.dataQuery.weekdayThu": "Do",
  "report.dataQuery.weekdayFri": "Fr",
  "report.dataQuery.weekdaySat": "Sa",
  "report.dataQuery.weekdaySun": "So",
  "report.dataQuery.axisMonthDay": "Tag {n}",
  "plant.statisticalCycle": "Statistikzyklus",
  "plant.stationTopology": "Stations-Topologie",
  "plant.topologyConfig": "Topologie-Konfiguration",
  "plant.projectName": "Projektname",
  "plant.topologyUrl": "Topologie-URL",
  "plant.topologyMap": "Topologie-Karte",
  "plant.topologyPlaceholder": "Bitte geben Sie die Topologie-URL ein",
  "plant.addScopeSuccess": "{scope} erfolgreich hinzugefügt",
  "plant.updateScopeSuccess": "{scope} erfolgreich bearbeitet",
  "plant.topologyUrlFormatError": "Fehler im Format der Topologie-URL",
  "report.dataQuery.maxCurvesWarning": "Die Auswahl überschreitet 10 Kurven",
  "report.dataQuery.maxCurvesLimitHint": "Es können höchstens 10 Kurven ausgewählt werden",
  "report.dataQuery.selectParamsHeading": "Parameter auswählen",
  "ota.don.upgrade": "Dongle-Upgrade",
  "device.ota.tip.newversion": "Die aktuelle Version ist die neueste und benötigt kein Update.",
  "device.button.cancel": "OK",
  "org.accountNumber": "Benutzerkontonummer",
  "org.accountName": "Benutzerkontoname",
  "org.description": "Beschreibung des Stromnutzers",
  "org.creditCode": "Sozialkreditcode",
  "plant.deptName": "Organisationsname",
  "plant.businessScope": "Gewerblich",
  "plant.withdrawBusinessDeliveryTip": "Nach dem Zurückziehen der Lieferung können {scope} Benutzer diese Station nicht mehr verwalten. Bitte gehen Sie vorsichtig vor.",
  "mapScreen.RevenueInfo": "Einnahmeninformationen",
  "mapScreen.MonthlyRevenue": "Monatliche Einnahmen",
  "mapScreen.YearlyRevenue": "Jährliche Einnahmen",
  "mapScreen.CumulativeRevenue": "Kumulierte Einnahmen",
  "mapScreen.CarbonIndicator": "CO2-Indikatoren",
  "mapScreen.StorageInfo": "Speicherinformationen",
  "mapScreen.MonthlyChargeDischarge": "Monatliche Ladung/Entladung",
  "mapScreen.YearlyChargeDischarge": "Jährliche Ladung/Entladung",
  "mapScreen.TotalPlants": "Anzahl der Kraftwerke",
  "mapScreen.PvInstalledCapacity": "PV-Installierte Kapazität",
  "mapScreen.StorageInstalledCapacity": "Speicher-Installierte Kapazität",
  "mapScreen.ChargingPileCapacity": "Ladesäulen-Kapazität",
  "mapScreen.Residential": "Privathaushalte",
  "mapScreen.Commercial": "Gewerbe",
  "mapScreen.PlantCount": "Gesamt {count} Kraftwerke",
  "mapScreen.NewEnergyPower": "Erneuerbare-Energien-Leistung",
  "mapScreen.GenerationInfo": "Erzeugungsinformationen",
  "mapScreen.MonthlyGeneration": "Monatliche Erzeugung",
  "mapScreen.YearlyGeneration": "Jährliche Erzeugung",
  "mapScreen.ChargingPileInfo": "Ladesäuleninformationen",
  "mapScreen.MonthlyConsumption": "Monatlicher Verbrauch",
  "mapScreen.YearlyConsumption": "Jährlicher Verbrauch",
  "mapScreen.GridConnectionInfo": "Netzanschlussinformationen",
  "mapScreen.MonthlyPurchaseFeedin": "Monatlicher Bezug/Einspeisung",
  "mapScreen.YearlyPurchaseFeedin": "Jährlicher Bezug/Einspeisung",
  "mapScreen.CO2Reduction": "CO2-Reduktion",
  "mapScreen.SaveCoal": "Eingesparte Kohle",
  "mapScreen.TreePlanting": "Gepflanzte Bäume",
  "mapScreen.SelectCountry": "Land auswählen",
  "mapScreen.BackToPrev": "Zurück zur vorherigen Ebene",
  "mapScreen.Revenue": "Einnahmen",
  "mapScreen.ChargeAmount": "Lademenge",
  "mapScreen.DischargeAmount": "Entlademenge",
  "mapScreen.GenerationAmount": "Erzeugungsmenge",
  "mapScreen.ConsumptionAmount": "Verbrauchsmenge",
  "mapScreen.PowerGeneration": "Erzeugungsleistung",
  "mapScreen.PurchaseAmount": "Bezugsmenge",
  "mapScreen.GridSellAmount": "Einspeisemenge",
  "mapScreen.title": "Plattform für Energiemanagement",
  "mapScreen.PlantMonthlyRevenue": "Monatliche Einnahmen",
  "mapScreen.PlantYearlyRevenue": "Jährliche Einnahmen",
  "mapScreen.PlantCumulativeRevenue": "Kumulierte Einnahmen",
  "physicalModels.tagGroup": "Tag-Gruppe",
  "device.expandAll": "Alle erweitern",
  "device.collapseAll": "Alle einklappen",
  "common.deleteSuccess": "Erfolgreich gelöscht",
  "device.systemTime": "Systemzeit",
  "device.traceId": "Trace-ID",
  "device.collectorSn": "Collector-SN",
  "device.functionCode": "Funktionscode",
  "device.encryptedStr": "Verschlüsselte Nachricht",
  "device.decryptedStr": "Entschlüsselte Nachricht",
  "device.dateRangeErrorScope": "Der Datumsbereich sollte innerhalb von {scope} Tagen liegen",
  "common.noMore": "Nicht mehr",
  "common.unloginOrExpired": "Nicht angemeldet oder Anmeldung abgelaufen",
  "common.serverError": "Serverfehler, bitte später erneut versuchen",
  "common.requestFailed": "Anfrage fehlgeschlagen",
  "common.backendError": "Fehler bei der Verbindung zum Backend-Interface",
  "common.timeout": "System-Interface-Anfrage-Timeout",
  "common.systemInterface": "System-Interface",
  "common.contains": "Enthält",
  "common.columnSetting": "Spalteneinstellungen",
  "product.skipShipmentCheck": "Versandprüfung überspringen",
  "system.mapScreen": "Panoramabildschirm",
  "settingDrawer.title": "Layouteinstellungen",
  "settingDrawer.themeMode": "Themenmodus",
  "settingDrawer.darkTheme": "Dunkles Thema",
  "settingDrawer.lightTheme": "Helles Thema",
  "settingDrawer.themeColor": "Themenfarbe",
  "settingDrawer.navMode": "Navigationsmodus",
  "settingDrawer.sideMenu": "Seitenmenü-Layout",
  "settingDrawer.topMenu": "Oberes Menü-Layout",
  "settingDrawer.mixMenu": "Gemischtes Layout",
  "settingDrawer.columnMenu": "Spaltenlayout",
  "settingDrawer.drawerMenu": "Schubladen-Layout",
  "settingDrawer.layoutSetting": "Layouteinstellungen",
  "settingDrawer.contentWidth": "Inhaltsbreite",
  "settingDrawer.contentWidthFixed": "Fixiert",
  "settingDrawer.contentWidthFluid": "Fließend",
  "settingDrawer.fixedHeader": "Fixierter Header",
  "settingDrawer.fixedSidebar": "Fixierte Seitenleiste",
  "settingDrawer.hideFooter": "Fußzeile ausblenden",
  "settingDrawer.multiTab": "Multitab-Modus",
  "settingDrawer.sidebarColorfulIcon": "Farbige Seitenleistensymbole",
  "settingDrawer.searchMode": "Suchkomponenten-Modus",
  "settingDrawer.searchModeHeader": "Neue Version",
  "settingDrawer.searchModeForm": "Alte Version",
  "settingDrawer.systemConfig": "Systemkonfiguration",
  "settingDrawer.systemTitle": "Systemtitel",
  "settingDrawer.systemCopyright": "Urheberrechtsinformationen",
  "settingDrawer.systemVersion": "Systemversion",
  "settingDrawer.systemVersionPlaceholder": "Versionsnummer",
  "settingDrawer.tableStyle": "Tabellenstil",
  "settingDrawer.tableSize": "Tabellengröße",
  "settingDrawer.tableSizeDefault": "Standard",
  "settingDrawer.tableSizeMiddle": "Mittel",
  "settingDrawer.tableSizeSmall": "Kompakt",
  "settingDrawer.tableBordered": "Rahmen anzeigen",
  "settingDrawer.tableFixHeader": "Kopfzeile fixieren",
  "settingDrawer.tableHeaderBold": "Fette Kopfzeile",
  "settingDrawer.tableResizable": "Spaltenbreite anpassbar",
  "settingDrawer.tableRowSelection": "Zeilenauswahl",
  "settingDrawer.tableHeaderBgColor": "Hintergrundfarbe der Kopfzeile",
  "settingDrawer.tableHeight": "Tabellenhöhe",
  "settingDrawer.pageSize": "Seitengröße",
  "settingDrawer.pageSizeUnit": "Einträge/Seite",
  "settingDrawer.showTotal": "Gesamtanzahl anzeigen",
  "settingDrawer.showSizeChanger": "Seitengrößenauswahl anzeigen",
  "settingDrawer.showQuickJumper": "Schnellsprung anzeigen",
  "settingDrawer.tableStripe": "Zebrastreifen",
  "settingDrawer.tableShowHeader": "Kopfzeile anzeigen",
  "settingDrawer.saveTableConfig": "Tabellenkonfiguration speichern",
  "settingDrawer.reset": "Zurücksetzen",
  "settingDrawer.configManagement": "Konfigurationsverwaltung",
  "settingDrawer.saveAll": "Alle Konfigurationen speichern",
  "settingDrawer.exportConfig": "Konfiguration exportieren",
  "settingDrawer.importConfig": "Konfiguration importieren",
  "settingDrawer.resetAll": "Alle Konfigurationen zurücksetzen",
  "settingDrawer.msg.initFail": "Systeminitialisierung fehlgeschlagen, bitte Seite aktualisieren und erneut versuchen",
  "settingDrawer.msg.configInitFail": "Konfigurationsinitialisierung fehlgeschlagen",
  "settingDrawer.msg.themeChangeFail": "Themenwechsel fehlgeschlagen",
  "settingDrawer.msg.colorChangeFail": "Farbwechsel fehlgeschlagen",
  "settingDrawer.msg.searchModeSwitched": "Zu {mode}-Suche gewechselt",
  "settingDrawer.msg.searchModeSwitchFail": "Wechsel der Suchkomponente fehlgeschlagen",
  "settingDrawer.msg.navModeSwitched": "Zu {mode}-Modus gewechselt",
  "settingDrawer.msg.navSide": "Seitenleiste",
  "settingDrawer.msg.navTop": "Oberes Menü",
  "settingDrawer.msg.navMix": "Gemischt",
  "settingDrawer.msg.navModeSwitchFail": "Navigationsmoduswechsel fehlgeschlagen",
  "settingDrawer.msg.layoutSwitchFail": "Layoutwechsel fehlgeschlagen",
  "settingDrawer.msg.settingUpdateFail": "Einstellungsaktualisierung fehlgeschlagen",
  "settingDrawer.msg.tableStoreNotInit": "Tabellenkonfigurationsspeicher nicht initialisiert",
  "settingDrawer.msg.tableConfigSaved": "Tabellenkonfiguration gespeichert",
  "settingDrawer.msg.tableConfigSaveFail": "Speichern der Tabellenkonfiguration fehlgeschlagen",
  "settingDrawer.msg.tableConfigReset": "Tabellenkonfiguration zurückgesetzt",
  "settingDrawer.msg.tableConfigResetFail": "Zurücksetzen der Tabellenkonfiguration fehlgeschlagen",
  "settingDrawer.msg.systemConfigUpdated": "Systemkonfiguration aktualisiert",
  "settingDrawer.msg.systemConfigUpdateFailStore": "Systemkonfigurationsaktualisierung fehlgeschlagen: Store nicht initialisiert",
  "settingDrawer.msg.systemConfigUpdateFail": "Systemkonfigurationsaktualisierung fehlgeschlagen",
  "settingDrawer.msg.allConfigSaved": "Alle Konfigurationen gespeichert",
  "settingDrawer.msg.configSaveFail": "Konfiguration speichern fehlgeschlagen",
  "settingDrawer.msg.configExported": "Konfiguration exportiert",
  "settingDrawer.msg.configExportFail": "Konfiguration exportieren fehlgeschlagen",
  "settingDrawer.msg.configImportConfirmTitle": "Konfigurationsimport bestätigen",
  "settingDrawer.msg.configImportConfirmContent": "Der Import der Konfiguration überschreibt alle aktuellen Einstellungen. Fortfahren?",
  "settingDrawer.msg.confirm": "Bestätigen",
  "settingDrawer.msg.cancel": "Abbrechen",
  "settingDrawer.msg.configImported": "Konfiguration erfolgreich importiert",
  "settingDrawer.msg.configFileInvalid": "Ungültiges Konfigurationsdateiformat",
  "settingDrawer.msg.resetConfirmTitle": "Reset bestätigen",
  "settingDrawer.msg.resetConfirmContent": "Das Zurücksetzen löscht alle benutzerdefinierten Konfigurationen und stellt den Standardzustand wieder her. Fortfahren?",
  "settingDrawer.msg.allConfigReset": "Alle Konfigurationen zurückgesetzt"
}
